var ut = function(t, e) {
  return ut = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, ut(t, e);
};
function Q(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  ut(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var S = function() {
  return S = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, S.apply(this, arguments);
};
function lt(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function _(t, e, n, r) {
  function i(s) {
    return s instanceof n ? s : new n(function(o) {
      o(s);
    });
  }
  return new (n || (n = Promise))(function(s, o) {
    function u(l) {
      try {
        a(r.next(l));
      } catch (p) {
        o(p);
      }
    }
    function c(l) {
      try {
        a(r.throw(l));
      } catch (p) {
        o(p);
      }
    }
    function a(l) {
      l.done ? s(l.value) : i(l.value).then(u, c);
    }
    a((r = r.apply(t, e || [])).next());
  });
}
function C(t, e) {
  var n = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, r, i, s, o;
  return o = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function u(a) {
    return function(l) {
      return c([a, l]);
    };
  }
  function c(a) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, a[0] && (n = 0)), n; ) try {
      if (r = 1, i && (s = a[0] & 2 ? i.return : a[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, a[1])).done) return s;
      switch (i = 0, s && (a = [a[0] & 2, s.value]), a[0]) {
        case 0:
        case 1:
          s = a;
          break;
        case 4:
          return n.label++, { value: a[1], done: !1 };
        case 5:
          n.label++, i = a[1], a = [0];
          continue;
        case 7:
          a = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (s = n.trys, !(s = s.length > 0 && s[s.length - 1]) && (a[0] === 6 || a[0] === 2)) {
            n = 0;
            continue;
          }
          if (a[0] === 3 && (!s || a[1] > s[0] && a[1] < s[3])) {
            n.label = a[1];
            break;
          }
          if (a[0] === 6 && n.label < s[1]) {
            n.label = s[1], s = a;
            break;
          }
          if (s && n.label < s[2]) {
            n.label = s[2], n.ops.push(a);
            break;
          }
          s[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      a = e.call(t, n);
    } catch (l) {
      a = [6, l], i = 0;
    } finally {
      r = s = 0;
    }
    if (a[0] & 5) throw a[1];
    return { value: a[0] ? a[1] : void 0, done: !0 };
  }
}
function B(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function O(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; ) s.push(i.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}
function H(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, i = e.length, s; r < i; r++)
    (s || !(r in e)) && (s || (s = Array.prototype.slice.call(e, 0, r)), s[r] = e[r]);
  return t.concat(s || Array.prototype.slice.call(e));
}
function pe(t) {
  return this instanceof pe ? (this.v = t, this) : new pe(t);
}
function gr(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(t, e || []), i, s = [];
  return i = {}, o("next"), o("throw"), o("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function o(d) {
    r[d] && (i[d] = function(f) {
      return new Promise(function(y, m) {
        s.push([d, f, y, m]) > 1 || u(d, f);
      });
    });
  }
  function u(d, f) {
    try {
      c(r[d](f));
    } catch (y) {
      p(s[0][3], y);
    }
  }
  function c(d) {
    d.value instanceof pe ? Promise.resolve(d.value.v).then(a, l) : p(s[0][2], d);
  }
  function a(d) {
    u("next", d);
  }
  function l(d) {
    u("throw", d);
  }
  function p(d, f) {
    d(f), s.shift(), s.length && u(s[0][0], s[0][1]);
  }
}
function fr(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof B == "function" ? B(t) : t[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(s) {
    n[s] = t[s] && function(o) {
      return new Promise(function(u, c) {
        o = t[s](o), i(u, c, o.done, o.value);
      });
    };
  }
  function i(s, o, u, c) {
    Promise.resolve(c).then(function(a) {
      s({ value: a, done: u });
    }, o);
  }
}
var yr = "Event tracked successfully", Cr = "Unexpected error occurred", _r = "Event rejected due to exceeded retry count", kr = "Event skipped due to optOut config", mr = "Event rejected due to missing API key", wr = "Invalid API key", Sr = "Client not initialized", U;
(function(t) {
  t.Unknown = "unknown", t.Skipped = "skipped", t.Success = "success", t.RateLimit = "rate_limit", t.PayloadTooLarge = "payload_too_large", t.Invalid = "invalid", t.Failed = "failed", t.Timeout = "Timeout", t.SystemError = "SystemError";
})(U || (U = {}));
var ve = function(t, e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = U.Unknown), { event: t, code: e, message: n };
}, ge = function(t) {
  return t ? (
    // a random number from 0 to 15
    (t ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    t / 4).toString(16)
  ) : (
    // or otherwise a concatenated string:
    (String(1e7) + // 10000000 +
    String(-1e3) + // -1000 +
    String(-4e3) + // -4000 +
    String(-8e3) + // -80000000 +
    String(-1e11)).replace(
      // replacing
      /[018]/g,
      // zeroes, ones, and eights with
      ge
    )
  );
}, br = (
  /** @class */
  (function() {
    function t(e) {
      this.client = e, this.queue = [], this.applying = !1, this.plugins = [];
    }
    return t.prototype.register = function(e, n) {
      var r, i;
      return _(this, void 0, void 0, function() {
        return C(this, function(s) {
          switch (s.label) {
            case 0:
              return this.plugins.some(function(o) {
                return o.name === e.name;
              }) ? (n.loggerProvider.warn("Plugin with name ".concat(e.name, " already exists, skipping registration")), [
                2
                /*return*/
              ]) : (e.name === void 0 && (e.name = ge(), n.loggerProvider.warn(`Plugin name is undefined. 
      Generating a random UUID for plugin name: `.concat(e.name, `. 
      Set a name for the plugin to prevent it from being added multiple times.`))), e.type = (r = e.type) !== null && r !== void 0 ? r : "enrichment", [4, (i = e.setup) === null || i === void 0 ? void 0 : i.call(e, n, this.client)]);
            case 1:
              return s.sent(), this.plugins.push(e), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.deregister = function(e, n) {
      var r;
      return _(this, void 0, void 0, function() {
        var i, s;
        return C(this, function(o) {
          switch (o.label) {
            case 0:
              return i = this.plugins.findIndex(function(u) {
                return u.name === e;
              }), i === -1 ? (n.loggerProvider.warn("Plugin with name ".concat(e, " does not exist, skipping deregistration")), [
                2
                /*return*/
              ]) : (s = this.plugins[i], this.plugins.splice(i, 1), [4, (r = s.teardown) === null || r === void 0 ? void 0 : r.call(s)]);
            case 1:
              return o.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.reset = function(e) {
      this.applying = !1;
      var n = this.plugins;
      n.map(function(r) {
        var i;
        return (i = r.teardown) === null || i === void 0 ? void 0 : i.call(r);
      }), this.plugins = [], this.client = e;
    }, t.prototype.push = function(e) {
      var n = this;
      return new Promise(function(r) {
        n.queue.push([e, r]), n.scheduleApply(0);
      });
    }, t.prototype.scheduleApply = function(e) {
      var n = this;
      this.applying || (this.applying = !0, setTimeout(function() {
        n.apply(n.queue.shift()).then(function() {
          n.applying = !1, n.queue.length > 0 && n.scheduleApply(0);
        });
      }, e));
    }, t.prototype.apply = function(e) {
      return _(this, void 0, void 0, function() {
        var n, r, i, s, o, u, c, f, y, a, l, p, d, f, y, m, w, v, h, g, k, b;
        return C(this, function(I) {
          switch (I.label) {
            case 0:
              if (!e)
                return [
                  2
                  /*return*/
                ];
              n = O(e, 1), r = n[0], i = O(e, 2), s = i[1], o = this.plugins.filter(function(T) {
                return T.type === "before";
              }), I.label = 1;
            case 1:
              I.trys.push([1, 6, 7, 8]), u = B(o), c = u.next(), I.label = 2;
            case 2:
              return c.done ? [3, 5] : (f = c.value, f.execute ? [4, f.execute(S({}, r))] : [3, 4]);
            case 3:
              if (y = I.sent(), y === null)
                return s({ event: r, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              r = y, I.label = 4;
            case 4:
              return c = u.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return a = I.sent(), h = { error: a }, [3, 8];
            case 7:
              try {
                c && !c.done && (g = u.return) && g.call(u);
              } finally {
                if (h) throw h.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              l = this.plugins.filter(function(T) {
                return T.type === "enrichment" || T.type === void 0;
              }), I.label = 9;
            case 9:
              I.trys.push([9, 14, 15, 16]), p = B(l), d = p.next(), I.label = 10;
            case 10:
              return d.done ? [3, 13] : (f = d.value, f.execute ? [4, f.execute(S({}, r))] : [3, 12]);
            case 11:
              if (y = I.sent(), y === null)
                return s({ event: r, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              r = y, I.label = 12;
            case 12:
              return d = p.next(), [3, 10];
            case 13:
              return [3, 16];
            case 14:
              return m = I.sent(), k = { error: m }, [3, 16];
            case 15:
              try {
                d && !d.done && (b = p.return) && b.call(p);
              } finally {
                if (k) throw k.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 16:
              return w = this.plugins.filter(function(T) {
                return T.type === "destination";
              }), v = w.map(function(T) {
                var E = S({}, r);
                return T.execute(E).catch(function(P) {
                  return ve(E, 0, String(P));
                });
              }), Promise.all(v).then(function(T) {
                var E = O(T, 1), P = E[0], W = P || ve(r, 100, "Event not tracked, no destination plugins on the instance");
                s(W);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.flush = function() {
      return _(this, void 0, void 0, function() {
        var e, n, r, i = this;
        return C(this, function(s) {
          switch (s.label) {
            case 0:
              return e = this.queue, this.queue = [], [4, Promise.all(e.map(function(o) {
                return i.apply(o);
              }))];
            case 1:
              return s.sent(), n = this.plugins.filter(function(o) {
                return o.type === "destination";
              }), r = n.map(function(o) {
                return o.flush && o.flush();
              }), [4, Promise.all(r)];
            case 2:
              return s.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  })()
), Tt = "-", He = "AMP", Ir = "".concat(He, "_unsent"), Cn = "https://api2.amplitude.com/2/httpapi", Ar = "https://api.eu.amplitude.com/2/httpapi", Tr = "https://api2.amplitude.com/batch", Er = "https://api.eu.amplitude.com/batch", Pr = 1e3, dt = function(t) {
  if (Object.keys(t).length > Pr)
    return !1;
  for (var e in t) {
    var n = t[e];
    if (!_n(e, n))
      return !1;
  }
  return !0;
}, _n = function(t, e) {
  var n, r;
  if (typeof t != "string")
    return !1;
  if (Array.isArray(e)) {
    var i = !0;
    try {
      for (var s = B(e), o = s.next(); !o.done; o = s.next()) {
        var u = o.value;
        if (Array.isArray(u))
          return !1;
        if (typeof u == "object")
          i = i && dt(u);
        else if (!["number", "string"].includes(typeof u))
          return !1;
        if (!i)
          return !1;
      }
    } catch (c) {
      n = { error: c };
    } finally {
      try {
        o && !o.done && (r = s.return) && r.call(s);
      } finally {
        if (n) throw n.error;
      }
    }
  } else {
    if (e == null)
      return !1;
    if (typeof e == "object")
      return dt(e);
    if (!["number", "string", "boolean"].includes(typeof e))
      return !1;
  }
  return !0;
}, he = (
  /** @class */
  (function() {
    function t() {
      this._propertySet = /* @__PURE__ */ new Set(), this._properties = {};
    }
    return t.prototype.getUserProperties = function() {
      return S({}, this._properties);
    }, t.prototype.set = function(e, n) {
      return this._safeSet(V.SET, e, n), this;
    }, t.prototype.setOnce = function(e, n) {
      return this._safeSet(V.SET_ONCE, e, n), this;
    }, t.prototype.append = function(e, n) {
      return this._safeSet(V.APPEND, e, n), this;
    }, t.prototype.prepend = function(e, n) {
      return this._safeSet(V.PREPEND, e, n), this;
    }, t.prototype.postInsert = function(e, n) {
      return this._safeSet(V.POSTINSERT, e, n), this;
    }, t.prototype.preInsert = function(e, n) {
      return this._safeSet(V.PREINSERT, e, n), this;
    }, t.prototype.remove = function(e, n) {
      return this._safeSet(V.REMOVE, e, n), this;
    }, t.prototype.add = function(e, n) {
      return this._safeSet(V.ADD, e, n), this;
    }, t.prototype.unset = function(e) {
      return this._safeSet(V.UNSET, e, Tt), this;
    }, t.prototype.clearAll = function() {
      return this._properties = {}, this._properties[V.CLEAR_ALL] = Tt, this;
    }, t.prototype._safeSet = function(e, n, r) {
      if (this._validate(e, n, r)) {
        var i = this._properties[e];
        return i === void 0 && (i = {}, this._properties[e] = i), i[n] = r, this._propertySet.add(n), !0;
      }
      return !1;
    }, t.prototype._validate = function(e, n, r) {
      return this._properties[V.CLEAR_ALL] !== void 0 || this._propertySet.has(n) ? !1 : e === V.ADD ? typeof r == "number" : e !== V.UNSET && e !== V.REMOVE ? _n(n, r) : !0;
    }, t;
  })()
), V;
(function(t) {
  t.SET = "$set", t.SET_ONCE = "$setOnce", t.ADD = "$add", t.APPEND = "$append", t.PREPEND = "$prepend", t.REMOVE = "$remove", t.PREINSERT = "$preInsert", t.POSTINSERT = "$postInsert", t.UNSET = "$unset", t.CLEAR_ALL = "$clearAll";
})(V || (V = {}));
var pt;
(function(t) {
  t.SET = "$set", t.SET_ONCE = "$setOnce", t.ADD = "$add", t.APPEND = "$append", t.PREPEND = "$prepend", t.REMOVE = "$remove", t.PREINSERT = "$preInsert", t.POSTINSERT = "$postInsert", t.UNSET = "$unset", t.CLEAR_ALL = "$clearAll";
})(pt || (pt = {}));
var ce;
(function(t) {
  t.IDENTIFY = "$identify", t.GROUP_IDENTIFY = "$groupidentify", t.REVENUE = "revenue_amount";
})(ce || (ce = {}));
var Or = function(t, e, n) {
  var r = typeof t == "string" ? { event_type: t } : t;
  return S(S(S({}, r), n), e && { event_properties: e });
}, kn = function(t, e) {
  var n = S(S({}, e), { event_type: ce.IDENTIFY, user_properties: t.getUserProperties() });
  return n;
}, Rr = function(t, e, n, r) {
  var i, s = S(S({}, r), { event_type: ce.GROUP_IDENTIFY, group_properties: n.getUserProperties(), groups: (i = {}, i[t] = e, i) });
  return s;
}, Fr = function(t, e, n) {
  var r, i = new he();
  i.set(t, e);
  var s = S(S({}, n), { event_type: ce.IDENTIFY, user_properties: i.getUserProperties(), groups: (r = {}, r[t] = e, r) });
  return s;
}, Dr = function(t, e) {
  return S(S({}, e), { event_type: ce.REVENUE, event_properties: t.getEventProperties() });
}, G = function(t) {
  return {
    promise: t || Promise.resolve()
  };
}, Mr = (
  /** @class */
  (function() {
    function t(e) {
      e === void 0 && (e = "$default"), this.initializing = !1, this.isReady = !1, this.q = [], this.dispatchQ = [], this.logEvent = this.track.bind(this), this.timeline = new br(this), this.name = e;
    }
    return t.prototype._init = function(e) {
      return _(this, void 0, void 0, function() {
        return C(this, function(n) {
          switch (n.label) {
            case 0:
              return this.config = e, this.timeline.reset(this), [4, this.runQueuedFunctions("q")];
            case 1:
              return n.sent(), this.isReady = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.runQueuedFunctions = function(e) {
      return _(this, void 0, void 0, function() {
        var n, r, i, s, o, u, c, a;
        return C(this, function(l) {
          switch (l.label) {
            case 0:
              n = this[e], this[e] = [], l.label = 1;
            case 1:
              l.trys.push([1, 8, 9, 10]), r = B(n), i = r.next(), l.label = 2;
            case 2:
              return i.done ? [3, 7] : (s = i.value, o = s(), o && "promise" in o ? [4, o.promise] : [3, 4]);
            case 3:
              return l.sent(), [3, 6];
            case 4:
              return [4, o];
            case 5:
              l.sent(), l.label = 6;
            case 6:
              return i = r.next(), [3, 2];
            case 7:
              return [3, 10];
            case 8:
              return u = l.sent(), c = { error: u }, [3, 10];
            case 9:
              try {
                i && !i.done && (a = r.return) && a.call(r);
              } finally {
                if (c) throw c.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 10:
              return this[e].length ? [4, this.runQueuedFunctions(e)] : [3, 12];
            case 11:
              l.sent(), l.label = 12;
            case 12:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.track = function(e, n, r) {
      var i = Or(e, n, r);
      return G(this.dispatch(i));
    }, t.prototype.identify = function(e, n) {
      var r = kn(e, n);
      return G(this.dispatch(r));
    }, t.prototype.groupIdentify = function(e, n, r, i) {
      var s = Rr(e, n, r, i);
      return G(this.dispatch(s));
    }, t.prototype.setGroup = function(e, n, r) {
      var i = Fr(e, n, r);
      return G(this.dispatch(i));
    }, t.prototype.revenue = function(e, n) {
      var r = Dr(e, n);
      return G(this.dispatch(r));
    }, t.prototype.add = function(e) {
      return this.isReady ? this._addPlugin(e) : (this.q.push(this._addPlugin.bind(this, e)), G());
    }, t.prototype._addPlugin = function(e) {
      return G(this.timeline.register(e, this.config));
    }, t.prototype.remove = function(e) {
      return this.isReady ? this._removePlugin(e) : (this.q.push(this._removePlugin.bind(this, e)), G());
    }, t.prototype._removePlugin = function(e) {
      return G(this.timeline.deregister(e, this.config));
    }, t.prototype.dispatchWithCallback = function(e, n) {
      if (!this.isReady)
        return n(ve(e, 0, Sr));
      this.process(e).then(n);
    }, t.prototype.dispatch = function(e) {
      return _(this, void 0, void 0, function() {
        var n = this;
        return C(this, function(r) {
          return this.isReady ? [2, this.process(e)] : [2, new Promise(function(i) {
            n.dispatchQ.push(n.dispatchWithCallback.bind(n, e, i));
          })];
        });
      });
    }, t.prototype.process = function(e) {
      return _(this, void 0, void 0, function() {
        var i, n, r, i;
        return C(this, function(s) {
          switch (s.label) {
            case 0:
              return s.trys.push([0, 2, , 3]), this.config.optOut ? [2, ve(e, 0, kr)] : [4, this.timeline.push(e)];
            case 1:
              return i = s.sent(), i.code === 200 ? this.config.loggerProvider.log(i.message) : i.code === 100 ? this.config.loggerProvider.warn(i.message) : this.config.loggerProvider.error(i.message), [2, i];
            case 2:
              return n = s.sent(), r = String(n), this.config.loggerProvider.error(r), i = ve(e, 0, r), [2, i];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setOptOut = function(e) {
      if (!this.isReady) {
        this.q.push(this._setOptOut.bind(this, !!e));
        return;
      }
      this._setOptOut(e);
    }, t.prototype._setOptOut = function(e) {
      this.config.optOut = !!e;
    }, t.prototype.flush = function() {
      return G(this.timeline.flush());
    }, t;
  })()
), Ur = (
  /** @class */
  (function() {
    function t() {
      this.productId = "", this.quantity = 1, this.price = 0;
    }
    return t.prototype.setProductId = function(e) {
      return this.productId = e, this;
    }, t.prototype.setQuantity = function(e) {
      return e > 0 && (this.quantity = e), this;
    }, t.prototype.setPrice = function(e) {
      return this.price = e, this;
    }, t.prototype.setRevenueType = function(e) {
      return this.revenueType = e, this;
    }, t.prototype.setCurrency = function(e) {
      return this.currency = e, this;
    }, t.prototype.setRevenue = function(e) {
      return this.revenue = e, this;
    }, t.prototype.setReceipt = function(e) {
      return this.receipt = e, this;
    }, t.prototype.setReceiptSig = function(e) {
      return this.receiptSig = e, this;
    }, t.prototype.setEventProperties = function(e) {
      return dt(e) && (this.properties = e), this;
    }, t.prototype.getEventProperties = function() {
      var e = this.properties ? S({}, this.properties) : {};
      return e[J.REVENUE_PRODUCT_ID] = this.productId, e[J.REVENUE_QUANTITY] = this.quantity, e[J.REVENUE_PRICE] = this.price, e[J.REVENUE_TYPE] = this.revenueType, e[J.REVENUE_CURRENCY] = this.currency, e[J.REVENUE] = this.revenue, e[J.RECEIPT] = this.receipt, e[J.RECEIPT_SIG] = this.receiptSig, e;
    }, t;
  })()
), J;
(function(t) {
  t.REVENUE_PRODUCT_ID = "$productId", t.REVENUE_QUANTITY = "$quantity", t.REVENUE_PRICE = "$price", t.REVENUE_TYPE = "$revenueType", t.REVENUE_CURRENCY = "$currency", t.REVENUE = "$revenue", t.RECEIPT = "$receipt", t.RECEIPT_SIG = "$receiptSig";
})(J || (J = {}));
var Lr = function(t, e) {
  var n = Math.max(e, 1);
  return t.reduce(function(r, i, s) {
    var o = Math.floor(s / n);
    return r[o] || (r[o] = []), r[o].push(i), r;
  }, []);
}, q;
(function(t) {
  t[t.None = 0] = "None", t[t.Error = 1] = "Error", t[t.Warn = 2] = "Warn", t[t.Verbose = 3] = "Verbose", t[t.Debug = 4] = "Debug";
})(q || (q = {}));
var Ie = "Amplitude Logger ", mn = (
  /** @class */
  (function() {
    function t() {
      this.logLevel = q.None;
    }
    return t.prototype.disable = function() {
      this.logLevel = q.None;
    }, t.prototype.enable = function(e) {
      e === void 0 && (e = q.Warn), this.logLevel = e;
    }, t.prototype.log = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      this.logLevel < q.Verbose || console.log("".concat(Ie, "[Log]: ").concat(e.join(" ")));
    }, t.prototype.warn = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      this.logLevel < q.Warn || console.warn("".concat(Ie, "[Warn]: ").concat(e.join(" ")));
    }, t.prototype.error = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      this.logLevel < q.Error || console.error("".concat(Ie, "[Error]: ").concat(e.join(" ")));
    }, t.prototype.debug = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      this.logLevel < q.Debug || console.log("".concat(Ie, "[Debug]: ").concat(e.join(" ")));
    }, t;
  })()
), Oe = function() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 1e4,
    instanceName: "$default_instance",
    logLevel: q.Warn,
    loggerProvider: new mn(),
    offline: !1,
    optOut: !1,
    serverUrl: Cn,
    serverZone: "US",
    useBatch: !1
  };
}, Nr = (
  /** @class */
  (function() {
    function t(e) {
      var n, r, i, s;
      this._optOut = !1;
      var o = Oe();
      this.apiKey = e.apiKey, this.flushIntervalMillis = (n = e.flushIntervalMillis) !== null && n !== void 0 ? n : o.flushIntervalMillis, this.flushMaxRetries = e.flushMaxRetries || o.flushMaxRetries, this.flushQueueSize = e.flushQueueSize || o.flushQueueSize, this.instanceName = e.instanceName || o.instanceName, this.loggerProvider = e.loggerProvider || o.loggerProvider, this.logLevel = (r = e.logLevel) !== null && r !== void 0 ? r : o.logLevel, this.minIdLength = e.minIdLength, this.plan = e.plan, this.ingestionMetadata = e.ingestionMetadata, this.offline = e.offline !== void 0 ? e.offline : o.offline, this.optOut = (i = e.optOut) !== null && i !== void 0 ? i : o.optOut, this.serverUrl = e.serverUrl, this.serverZone = e.serverZone || o.serverZone, this.storageProvider = e.storageProvider, this.transportProvider = e.transportProvider, this.useBatch = (s = e.useBatch) !== null && s !== void 0 ? s : o.useBatch, this.loggerProvider.enable(this.logLevel);
      var u = wn(e.serverUrl, e.serverZone, e.useBatch);
      this.serverZone = u.serverZone, this.serverUrl = u.serverUrl;
    }
    return Object.defineProperty(t.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(e) {
        this._optOut = e;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  })()
), Vr = function(t, e) {
  return t === "EU" ? e ? Er : Ar : e ? Tr : Cn;
}, wn = function(t, e, n) {
  if (t === void 0 && (t = ""), e === void 0 && (e = Oe().serverZone), n === void 0 && (n = Oe().useBatch), t)
    return { serverUrl: t, serverZone: void 0 };
  var r = ["US", "EU"].includes(e) ? e : Oe().serverZone;
  return {
    serverZone: r,
    serverUrl: Vr(r, n)
  };
}, Sn = (
  /** @class */
  (function() {
    function t() {
      this.sdk = {
        metrics: {
          histogram: {}
        }
      };
    }
    return t.prototype.recordHistogram = function(e, n) {
      this.sdk.metrics.histogram[e] = n;
    }, t;
  })()
);
function Br(t) {
  return t instanceof Error ? t.message : String(t);
}
function Ae(t) {
  var e = "";
  try {
    "body" in t && (e = JSON.stringify(t.body, null, 2));
  } catch {
  }
  return e;
}
var Wr = (
  /** @class */
  (function() {
    function t() {
      this.name = "amplitude", this.type = "destination", this.retryTimeout = 1e3, this.throttleTimeout = 3e4, this.storageKey = "", this.scheduleId = null, this.scheduledTimeout = 0, this.flushId = null, this.queue = [];
    }
    return t.prototype.setup = function(e) {
      var n;
      return _(this, void 0, void 0, function() {
        var r, i = this;
        return C(this, function(s) {
          switch (s.label) {
            case 0:
              return this.config = e, this.storageKey = "".concat(Ir, "_").concat(this.config.apiKey.substring(0, 10)), [4, (n = this.config.storageProvider) === null || n === void 0 ? void 0 : n.get(this.storageKey)];
            case 1:
              return r = s.sent(), r && r.length > 0 && Promise.all(r.map(function(o) {
                return i.execute(o);
              })).catch(), [2, Promise.resolve(void 0)];
          }
        });
      });
    }, t.prototype.execute = function(e) {
      var n = this;
      return e.insert_id || (e.insert_id = ge()), new Promise(function(r) {
        var i = {
          event: e,
          attempts: 0,
          callback: function(s) {
            return r(s);
          },
          timeout: 0
        };
        n.queue.push(i), n.schedule(n.config.flushIntervalMillis), n.saveEvents();
      });
    }, t.prototype.removeEventsExceedFlushMaxRetries = function(e) {
      var n = this;
      return e.filter(function(r) {
        return r.attempts += 1, r.attempts < n.config.flushMaxRetries ? !0 : (n.fulfillRequest([r], 500, _r), !1);
      });
    }, t.prototype.scheduleEvents = function(e) {
      var n = this;
      e.forEach(function(r) {
        n.schedule(r.timeout === 0 ? n.config.flushIntervalMillis : r.timeout);
      });
    }, t.prototype.schedule = function(e) {
      var n = this;
      if (!this.config.offline && (this.scheduleId === null || this.scheduleId && e > this.scheduledTimeout)) {
        this.scheduleId && clearTimeout(this.scheduleId), this.scheduledTimeout = e, this.scheduleId = setTimeout(function() {
          n.queue = n.queue.map(function(r) {
            return r.timeout = 0, r;
          }), n.flush(!0);
        }, e);
        return;
      }
    }, t.prototype.resetSchedule = function() {
      this.scheduleId = null, this.scheduledTimeout = 0;
    }, t.prototype.flush = function(e) {
      return e === void 0 && (e = !1), _(this, void 0, void 0, function() {
        var n, r, i, s = this;
        return C(this, function(o) {
          switch (o.label) {
            case 0:
              return this.config.offline ? (this.resetSchedule(), this.config.loggerProvider.debug("Skipping flush while offline."), [
                2
                /*return*/
              ]) : this.flushId ? (this.resetSchedule(), this.config.loggerProvider.debug("Skipping flush because previous flush has not resolved."), [
                2
                /*return*/
              ]) : (this.flushId = this.scheduleId, this.resetSchedule(), n = [], r = [], this.queue.forEach(function(u) {
                return u.timeout === 0 ? n.push(u) : r.push(u);
              }), i = Lr(n, this.config.flushQueueSize), [4, i.reduce(function(u, c) {
                return _(s, void 0, void 0, function() {
                  return C(this, function(a) {
                    switch (a.label) {
                      case 0:
                        return [4, u];
                      case 1:
                        return a.sent(), [4, this.send(c, e)];
                      case 2:
                        return [2, a.sent()];
                    }
                  });
                });
              }, Promise.resolve())]);
            case 1:
              return o.sent(), this.flushId = null, this.scheduleEvents(this.queue), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.send = function(e, n) {
      return n === void 0 && (n = !0), _(this, void 0, void 0, function() {
        var r, i, s, o, u;
        return C(this, function(c) {
          switch (c.label) {
            case 0:
              if (!this.config.apiKey)
                return [2, this.fulfillRequest(e, 400, mr)];
              r = {
                api_key: this.config.apiKey,
                events: e.map(function(a) {
                  var l = a.event;
                  l.extra;
                  var p = lt(l, ["extra"]);
                  return p;
                }),
                options: {
                  min_id_length: this.config.minIdLength
                },
                client_upload_time: (/* @__PURE__ */ new Date()).toISOString(),
                request_metadata: this.config.requestMetadata
              }, this.config.requestMetadata = new Sn(), c.label = 1;
            case 1:
              return c.trys.push([1, 3, , 4]), i = wn(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl, [4, this.config.transportProvider.send(i, r)];
            case 2:
              return s = c.sent(), s === null ? (this.fulfillRequest(e, 0, Cr), [
                2
                /*return*/
              ]) : n ? (this.handleResponse(s, e), [3, 4]) : ("body" in s ? this.fulfillRequest(e, s.statusCode, "".concat(s.status, ": ").concat(Ae(s))) : this.fulfillRequest(e, s.statusCode, s.status), [
                2
                /*return*/
              ]);
            case 3:
              return o = c.sent(), u = Br(o), this.config.loggerProvider.error(u), this.handleResponse({ status: U.Failed, statusCode: 0 }, e), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.handleResponse = function(e, n) {
      var r = e.status;
      switch (r) {
        case U.Success: {
          this.handleSuccessResponse(e, n);
          break;
        }
        case U.Invalid: {
          this.handleInvalidResponse(e, n);
          break;
        }
        case U.PayloadTooLarge: {
          this.handlePayloadTooLargeResponse(e, n);
          break;
        }
        case U.RateLimit: {
          this.handleRateLimitResponse(e, n);
          break;
        }
        default: {
          this.config.loggerProvider.warn(`{code: 0, error: "Status '`.concat(r, "' provided for ").concat(n.length, ' events"}')), this.handleOtherResponse(n);
          break;
        }
      }
    }, t.prototype.handleSuccessResponse = function(e, n) {
      this.fulfillRequest(n, e.statusCode, yr);
    }, t.prototype.handleInvalidResponse = function(e, n) {
      var r = this;
      if (e.body.missingField || e.body.error.startsWith(wr)) {
        this.fulfillRequest(n, e.statusCode, e.body.error);
        return;
      }
      var i = H(H(H(H([], O(Object.values(e.body.eventsWithInvalidFields)), !1), O(Object.values(e.body.eventsWithMissingFields)), !1), O(Object.values(e.body.eventsWithInvalidIdLengths)), !1), O(e.body.silencedEvents), !1).flat(), s = new Set(i), o = n.filter(function(c, a) {
        if (s.has(a)) {
          r.fulfillRequest([c], e.statusCode, e.body.error);
          return;
        }
        return !0;
      });
      o.length > 0 && this.config.loggerProvider.warn(Ae(e));
      var u = this.removeEventsExceedFlushMaxRetries(o);
      this.scheduleEvents(u);
    }, t.prototype.handlePayloadTooLargeResponse = function(e, n) {
      if (n.length === 1) {
        this.fulfillRequest(n, e.statusCode, e.body.error);
        return;
      }
      this.config.loggerProvider.warn(Ae(e)), this.config.flushQueueSize /= 2;
      var r = this.removeEventsExceedFlushMaxRetries(n);
      this.scheduleEvents(r);
    }, t.prototype.handleRateLimitResponse = function(e, n) {
      var r = this, i = Object.keys(e.body.exceededDailyQuotaUsers), s = Object.keys(e.body.exceededDailyQuotaDevices), o = e.body.throttledEvents, u = new Set(i), c = new Set(s), a = new Set(o), l = n.filter(function(d, f) {
        if (d.event.user_id && u.has(d.event.user_id) || d.event.device_id && c.has(d.event.device_id)) {
          r.fulfillRequest([d], e.statusCode, e.body.error);
          return;
        }
        return a.has(f) && (d.timeout = r.throttleTimeout), !0;
      });
      l.length > 0 && this.config.loggerProvider.warn(Ae(e));
      var p = this.removeEventsExceedFlushMaxRetries(l);
      this.scheduleEvents(p);
    }, t.prototype.handleOtherResponse = function(e) {
      var n = this, r = e.map(function(s) {
        return s.timeout = s.attempts * n.retryTimeout, s;
      }), i = this.removeEventsExceedFlushMaxRetries(r);
      this.scheduleEvents(i);
    }, t.prototype.fulfillRequest = function(e, n, r) {
      this.removeEvents(e), e.forEach(function(i) {
        return i.callback(ve(i.event, n, r));
      });
    }, t.prototype.saveEvents = function() {
      if (this.config.storageProvider) {
        var e = this.queue.map(function(n) {
          return n.event;
        });
        this.config.storageProvider.set(this.storageKey, e);
      }
    }, t.prototype.removeEvents = function(e) {
      this.queue = this.queue.filter(function(n) {
        return !e.some(function(r) {
          return r.event.insert_id === n.event.insert_id;
        });
      }), this.saveEvents();
    }, t;
  })()
), Hr = (
  /** @class */
  (function() {
    function t() {
    }
    return t.prototype.getApplicationContext = function() {
      return {
        versionName: this.versionName,
        language: xr(),
        platform: "Web",
        os: void 0,
        deviceModel: void 0
      };
    }, t;
  })()
), xr = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, Qr = (
  /** @class */
  (function() {
    function t() {
      this.queue = [];
    }
    return t.prototype.logEvent = function(e) {
      this.receiver ? this.receiver(e) : this.queue.length < 512 && this.queue.push(e);
    }, t.prototype.setEventReceiver = function(e) {
      this.receiver = e, this.queue.length > 0 && (this.queue.forEach(function(n) {
        e(n);
      }), this.queue = []);
    }, t;
  })()
), ne = function() {
  return ne = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, ne.apply(this, arguments);
}, Re = function(t, e) {
  var n = ["string", "number", "boolean", "undefined"], r = typeof t, i = typeof e;
  if (r !== i)
    return !1;
  for (var s = 0, o = n; s < o.length; s++) {
    var u = o[s];
    if (u === r)
      return t === e;
  }
  if (t == null && e == null)
    return !0;
  if (t == null || e == null || t.length !== e.length)
    return !1;
  var c = Array.isArray(t), a = Array.isArray(e);
  if (c !== a)
    return !1;
  if (c && a) {
    for (var l = 0; l < t.length; l++)
      if (!Re(t[l], e[l]))
        return !1;
  } else {
    var p = Object.keys(t).sort(), d = Object.keys(e).sort();
    if (!Re(p, d))
      return !1;
    var f = !0;
    return Object.keys(t).forEach(function(y) {
      Re(t[y], e[y]) || (f = !1);
    }), f;
  }
  return !0;
}, Kr = "$set", Gr = "$unset", qr = "$clearAll";
Object.entries || (Object.entries = function(t) {
  for (var e = Object.keys(t), n = e.length, r = new Array(n); n--; )
    r[n] = [e[n], t[e[n]]];
  return r;
});
var zr = (
  /** @class */
  (function() {
    function t() {
      this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
    }
    return t.prototype.editIdentity = function() {
      var e = this, n = ne({}, this.identity.userProperties), r = ne(ne({}, this.identity), { userProperties: n });
      return {
        setUserId: function(i) {
          return r.userId = i, this;
        },
        setDeviceId: function(i) {
          return r.deviceId = i, this;
        },
        setUserProperties: function(i) {
          return r.userProperties = i, this;
        },
        setOptOut: function(i) {
          return r.optOut = i, this;
        },
        updateUserProperties: function(i) {
          for (var s = r.userProperties || {}, o = 0, u = Object.entries(i); o < u.length; o++) {
            var c = u[o], a = c[0], l = c[1];
            switch (a) {
              case Kr:
                for (var p = 0, d = Object.entries(l); p < d.length; p++) {
                  var f = d[p], y = f[0], m = f[1];
                  s[y] = m;
                }
                break;
              case Gr:
                for (var w = 0, v = Object.keys(l); w < v.length; w++) {
                  var y = v[w];
                  delete s[y];
                }
                break;
              case qr:
                s = {};
                break;
            }
          }
          return r.userProperties = s, this;
        },
        commit: function() {
          return e.setIdentity(r), this;
        }
      };
    }, t.prototype.getIdentity = function() {
      return ne({}, this.identity);
    }, t.prototype.setIdentity = function(e) {
      var n = ne({}, this.identity);
      this.identity = ne({}, e), Re(n, this.identity) || this.listeners.forEach(function(r) {
        r(e);
      });
    }, t.prototype.addIdentityListener = function(e) {
      this.listeners.add(e);
    }, t.prototype.removeIdentityListener = function(e) {
      this.listeners.delete(e);
    }, t;
  })()
), Ce = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : self, $r = (
  /** @class */
  (function() {
    function t() {
      this.identityStore = new zr(), this.eventBridge = new Qr(), this.applicationContextProvider = new Hr();
    }
    return t.getInstance = function(e) {
      return Ce.analyticsConnectorInstances || (Ce.analyticsConnectorInstances = {}), Ce.analyticsConnectorInstances[e] || (Ce.analyticsConnectorInstances[e] = new t()), Ce.analyticsConnectorInstances[e];
    }, t;
  })()
), me = function(t) {
  return t === void 0 && (t = "$default_instance"), $r.getInstance(t);
}, jr = function(t, e) {
  me(e).identityStore.editIdentity().setUserId(t).commit();
}, Jr = function(t, e) {
  me(e).identityStore.editIdentity().setDeviceId(t).commit();
}, Yr = (
  /** @class */
  (function() {
    function t() {
      this.name = "identity", this.type = "before", this.identityStore = me().identityStore;
    }
    return t.prototype.execute = function(e) {
      return _(this, void 0, void 0, function() {
        var n;
        return C(this, function(r) {
          return n = e.user_properties, n && this.identityStore.editIdentity().updateUserProperties(n).commit(), [2, e];
        });
      });
    }, t.prototype.setup = function(e) {
      return _(this, void 0, void 0, function() {
        return C(this, function(n) {
          return e.instanceName && (this.identityStore = me(e.instanceName).identityStore), [
            2
            /*return*/
          ];
        });
      });
    }, t;
  })()
), Z = function() {
  var t = "ampIntegrationContext";
  if (typeof globalThis < "u" && typeof globalThis[t] < "u")
    return globalThis[t];
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
  if (typeof global < "u")
    return global;
}, bn = function(t, e) {
  e === void 0 && (e = Date.now());
  var n = Date.now(), r = n - e;
  return r > t;
}, In = function(t, e, n) {
  return e === void 0 && (e = ""), n === void 0 && (n = 10), [He, e, t.substring(0, n)].filter(Boolean).join("_");
}, Xr = function(t) {
  return "".concat(He.toLowerCase(), "_").concat(t.substring(0, 6));
}, Zr = function() {
  var t, e, n, r;
  if (typeof navigator > "u")
    return "";
  var i = navigator.userLanguage;
  return (r = (n = (e = (t = navigator.languages) === null || t === void 0 ? void 0 : t[0]) !== null && e !== void 0 ? e : navigator.language) !== null && n !== void 0 ? n : i) !== null && r !== void 0 ? r : "";
}, Ue = function() {
  var t, e = Z();
  if (!(!((t = e?.location) === null || t === void 0) && t.search))
    return {};
  var n = e.location.search.substring(1).split("&").filter(Boolean), r = n.reduce(function(i, s) {
    var o = s.split("=", 2), u = Et(o[0]), c = Et(o[1]);
    return c && (i[u] = c), i;
  }, {});
  return r;
}, Et = function(t) {
  t === void 0 && (t = "");
  try {
    return decodeURIComponent(t);
  } catch {
    return "";
  }
}, ei = function(t) {
  var e = new Error().stack || "";
  return e.split(`
`).slice(2 + t).map(function(n) {
    return n.trim();
  });
}, F = function(t) {
  return function() {
    var e = S({}, t.config), n = e.loggerProvider, r = e.logLevel;
    return {
      logger: n,
      logLevel: r
    };
  };
}, ti = function(t, e) {
  var n, r;
  e = e.replace(/\[(\w+)\]/g, ".$1"), e = e.replace(/^\./, "");
  try {
    for (var i = B(e.split(".")), s = i.next(); !s.done; s = i.next()) {
      var o = s.value;
      if (o in t)
        t = t[o];
      else
        return;
    }
  } catch (u) {
    n = { error: u };
  } finally {
    try {
      s && !s.done && (r = i.return) && r.call(i);
    } finally {
      if (n) throw n.error;
    }
  }
  return t;
}, D = function(t, e) {
  return function() {
    var n, r, i = {};
    try {
      for (var s = B(e), o = s.next(); !o.done; o = s.next()) {
        var u = o.value;
        i[u] = ti(t, u);
      }
    } catch (c) {
      n = { error: c };
    } finally {
      try {
        o && !o.done && (r = s.return) && r.call(s);
      } finally {
        if (n) throw n.error;
      }
    }
    return i;
  };
}, M = function(t, e, n, r, i) {
  return i === void 0 && (i = null), function() {
    for (var s = [], o = 0; o < arguments.length; o++)
      s[o] = arguments[o];
    var u = n(), c = u.logger, a = u.logLevel;
    if (a && a < q.Debug || !a || !c)
      return t.apply(i, s);
    var l = {
      type: "invoke public method",
      name: e,
      args: s,
      stacktrace: ei(1),
      time: {
        start: (/* @__PURE__ */ new Date()).toISOString()
      },
      states: {}
    };
    r && l.states && (l.states.before = r());
    var p = t.apply(i, s);
    return p && p.promise ? p.promise.then(function() {
      r && l.states && (l.states.after = r()), l.time && (l.time.end = (/* @__PURE__ */ new Date()).toISOString()), c.debug(JSON.stringify(l, null, 2));
    }) : (r && l.states && (l.states.after = r()), l.time && (l.time.end = (/* @__PURE__ */ new Date()).toISOString()), c.debug(JSON.stringify(l, null, 2))), p;
  };
}, yt = (
  /** @class */
  (function() {
    function t() {
      this.memoryStorage = /* @__PURE__ */ new Map();
    }
    return t.prototype.isEnabled = function() {
      return _(this, void 0, void 0, function() {
        return C(this, function(e) {
          return [2, !0];
        });
      });
    }, t.prototype.get = function(e) {
      return _(this, void 0, void 0, function() {
        return C(this, function(n) {
          return [2, this.memoryStorage.get(e)];
        });
      });
    }, t.prototype.getRaw = function(e) {
      return _(this, void 0, void 0, function() {
        var n;
        return C(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.get(e)];
            case 1:
              return n = r.sent(), [2, n ? JSON.stringify(n) : void 0];
          }
        });
      });
    }, t.prototype.set = function(e, n) {
      return _(this, void 0, void 0, function() {
        return C(this, function(r) {
          return this.memoryStorage.set(e, n), [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.remove = function(e) {
      return _(this, void 0, void 0, function() {
        return C(this, function(n) {
          return this.memoryStorage.delete(e), [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.reset = function() {
      return _(this, void 0, void 0, function() {
        return C(this, function(e) {
          return this.memoryStorage.clear(), [
            2
            /*return*/
          ];
        });
      });
    }, t;
  })()
), vt = (
  /** @class */
  (function() {
    function t(e) {
      this.options = S({}, e);
    }
    return t.prototype.isEnabled = function() {
      return _(this, void 0, void 0, function() {
        var e, n, r;
        return C(this, function(i) {
          switch (i.label) {
            case 0:
              if (!Z())
                return [2, !1];
              t.testValue = String(Date.now()), e = new t(this.options), n = "AMP_TEST", i.label = 1;
            case 1:
              return i.trys.push([1, 4, 5, 7]), [4, e.set(n, t.testValue)];
            case 2:
              return i.sent(), [4, e.get(n)];
            case 3:
              return r = i.sent(), [2, r === t.testValue];
            case 4:
              return i.sent(), [2, !1];
            case 5:
              return [4, e.remove(n)];
            case 6:
              return i.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.get = function(e) {
      var n;
      return _(this, void 0, void 0, function() {
        var r, i;
        return C(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, this.getRaw(e)];
            case 1:
              if (r = s.sent(), !r)
                return [2, void 0];
              try {
                return i = (n = ni(r)) !== null && n !== void 0 ? n : ri(r), i === void 0 ? (console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(e, ", value: ").concat(r)), [2, void 0]) : [2, JSON.parse(i)];
              } catch {
                return console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(e, ", value: ").concat(r)), [2, void 0];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getRaw = function(e) {
      var n, r;
      return _(this, void 0, void 0, function() {
        var i, s, o;
        return C(this, function(u) {
          return i = Z(), s = (r = (n = i?.document) === null || n === void 0 ? void 0 : n.cookie.split("; ")) !== null && r !== void 0 ? r : [], o = s.find(function(c) {
            return c.indexOf(e + "=") === 0;
          }), o ? [2, o.substring(e.length + 1)] : [2, void 0];
        });
      });
    }, t.prototype.set = function(e, n) {
      var r;
      return _(this, void 0, void 0, function() {
        var i, s, o, u, c, a, l;
        return C(this, function(p) {
          try {
            i = (r = this.options.expirationDays) !== null && r !== void 0 ? r : 0, s = n !== null ? i : -1, o = void 0, s && (u = /* @__PURE__ */ new Date(), u.setTime(u.getTime() + s * 24 * 60 * 60 * 1e3), o = u), c = "".concat(e, "=").concat(btoa(encodeURIComponent(JSON.stringify(n)))), o && (c += "; expires=".concat(o.toUTCString())), c += "; path=/", this.options.domain && (c += "; domain=".concat(this.options.domain)), this.options.secure && (c += "; Secure"), this.options.sameSite && (c += "; SameSite=".concat(this.options.sameSite)), a = Z(), a && (a.document.cookie = c);
          } catch (d) {
            l = d instanceof Error ? d.message : String(d), console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(e, ". Error: ").concat(l));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.remove = function(e) {
      return _(this, void 0, void 0, function() {
        return C(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.set(e, null)];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.reset = function() {
      return _(this, void 0, void 0, function() {
        return C(this, function(e) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, t;
  })()
), ni = function(t) {
  try {
    return decodeURIComponent(atob(t));
  } catch {
    return;
  }
}, ri = function(t) {
  try {
    return decodeURIComponent(atob(decodeURIComponent(t)));
  } catch {
    return;
  }
}, ii = function(t, e, n) {
  return n === void 0 && (n = 10), [He, e, t.substring(0, n)].filter(Boolean).join("_");
}, xe = (
  /** @class */
  (function() {
    function t() {
    }
    return t.prototype.send = function(e, n) {
      return Promise.resolve(null);
    }, t.prototype.buildResponse = function(e) {
      var n, r, i, s, o, u, c, a, l, p, d, f, y, m, w, v, h, g, k, b, I, T;
      if (typeof e != "object")
        return null;
      var E = e.code || 0, P = this.buildStatus(E);
      switch (P) {
        case U.Success:
          return {
            status: P,
            statusCode: E,
            body: {
              eventsIngested: (n = e.events_ingested) !== null && n !== void 0 ? n : 0,
              payloadSizeBytes: (r = e.payload_size_bytes) !== null && r !== void 0 ? r : 0,
              serverUploadTime: (i = e.server_upload_time) !== null && i !== void 0 ? i : 0
            }
          };
        case U.Invalid:
          return {
            status: P,
            statusCode: E,
            body: {
              error: (s = e.error) !== null && s !== void 0 ? s : "",
              missingField: (o = e.missing_field) !== null && o !== void 0 ? o : "",
              eventsWithInvalidFields: (u = e.events_with_invalid_fields) !== null && u !== void 0 ? u : {},
              eventsWithMissingFields: (c = e.events_with_missing_fields) !== null && c !== void 0 ? c : {},
              eventsWithInvalidIdLengths: (a = e.events_with_invalid_id_lengths) !== null && a !== void 0 ? a : {},
              epsThreshold: (l = e.eps_threshold) !== null && l !== void 0 ? l : 0,
              exceededDailyQuotaDevices: (p = e.exceeded_daily_quota_devices) !== null && p !== void 0 ? p : {},
              silencedDevices: (d = e.silenced_devices) !== null && d !== void 0 ? d : [],
              silencedEvents: (f = e.silenced_events) !== null && f !== void 0 ? f : [],
              throttledDevices: (y = e.throttled_devices) !== null && y !== void 0 ? y : {},
              throttledEvents: (m = e.throttled_events) !== null && m !== void 0 ? m : []
            }
          };
        case U.PayloadTooLarge:
          return {
            status: P,
            statusCode: E,
            body: {
              error: (w = e.error) !== null && w !== void 0 ? w : ""
            }
          };
        case U.RateLimit:
          return {
            status: P,
            statusCode: E,
            body: {
              error: (v = e.error) !== null && v !== void 0 ? v : "",
              epsThreshold: (h = e.eps_threshold) !== null && h !== void 0 ? h : 0,
              throttledDevices: (g = e.throttled_devices) !== null && g !== void 0 ? g : {},
              throttledUsers: (k = e.throttled_users) !== null && k !== void 0 ? k : {},
              exceededDailyQuotaDevices: (b = e.exceeded_daily_quota_devices) !== null && b !== void 0 ? b : {},
              exceededDailyQuotaUsers: (I = e.exceeded_daily_quota_users) !== null && I !== void 0 ? I : {},
              throttledEvents: (T = e.throttled_events) !== null && T !== void 0 ? T : []
            }
          };
        case U.Timeout:
        default:
          return {
            status: P,
            statusCode: E
          };
      }
    }, t.prototype.buildStatus = function(e) {
      return e >= 200 && e < 300 ? U.Success : e === 429 ? U.RateLimit : e === 413 ? U.PayloadTooLarge : e === 408 ? U.Timeout : e >= 400 && e < 500 ? U.Invalid : e >= 500 ? U.Failed : U.Unknown;
    }, t;
  })()
), si = (
  /** @class */
  (function(t) {
    Q(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.send = function(n, r) {
      return _(this, void 0, void 0, function() {
        var i, s, o;
        return C(this, function(u) {
          switch (u.label) {
            case 0:
              if (typeof fetch > "u")
                throw new Error("FetchTransport is not supported");
              return i = {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "*/*"
                },
                body: JSON.stringify(r),
                method: "POST"
              }, [4, fetch(n, i)];
            case 1:
              return s = u.sent(), [4, s.text()];
            case 2:
              o = u.sent();
              try {
                return [2, this.buildResponse(JSON.parse(o))];
              } catch {
                return [2, this.buildResponse({ code: s.status })];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  })(xe)
), An = null, Tn = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "label",
  "video",
  "audio",
  '[contenteditable="true" i]',
  "[data-amp-default-track]",
  ".amp-default-track"
], En = "data-amp-track-", Pn = ["div", "span", "h1", "h2", "h3", "h4", "h5", "h6"], Se = function(t, e) {
  return typeof t == "boolean" ? t : t?.[e] !== !1;
}, On = function(t) {
  return Se(t, "attribution");
}, oi = function(t) {
  return Se(t, "fileDownloads");
}, ai = function(t) {
  return Se(t, "formInteractions");
}, Rn = function(t) {
  return Se(t, "pageViews");
}, Pt = function(t) {
  return Se(t, "sessions");
}, Fn = function(t) {
  return typeof t == "boolean" ? t : typeof t == "object" && (t.elementInteractions === !0 || typeof t.elementInteractions == "object");
}, ci = function(t) {
  if (Fn(t.autocapture) && typeof t.autocapture == "object" && typeof t.autocapture.elementInteractions == "object")
    return t.autocapture.elementInteractions;
}, ui = function(t) {
  var e = function() {
    return !1;
  }, n = void 0, r, i = t.pageCounter, s = Rn(t.defaultTracking);
  return s && (e = void 0, r = void 0, t.defaultTracking && typeof t.defaultTracking == "object" && t.defaultTracking.pageViews && typeof t.defaultTracking.pageViews == "object" && ("trackOn" in t.defaultTracking.pageViews && (e = t.defaultTracking.pageViews.trackOn), "trackHistoryChanges" in t.defaultTracking.pageViews && (n = t.defaultTracking.pageViews.trackHistoryChanges), "eventType" in t.defaultTracking.pageViews && t.defaultTracking.pageViews.eventType && (r = t.defaultTracking.pageViews.eventType))), {
    trackOn: e,
    trackHistoryChanges: n,
    eventType: r,
    pageCounter: i
  };
}, li = function(t) {
  return On(t.defaultTracking) && t.defaultTracking && typeof t.defaultTracking == "object" && t.defaultTracking.attribution && typeof t.defaultTracking.attribution == "object" ? S({}, t.defaultTracking.attribution) : {};
}, et = function(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n], i = r.name, s = r.args, o = r.resolve, u = t && t[i];
    if (typeof u == "function") {
      var c = u.apply(t, s);
      typeof o == "function" && o(c?.promise);
    }
  }
  return t;
}, tt = function(t) {
  var e = t;
  return e && e._q !== void 0;
}, Dn = "2.12.2", di = "amplitude-ts", pi = "Web", vi = "$remote", hi = (
  /** @class */
  (function() {
    function t() {
      this.name = "@amplitude/plugin-context-browser", this.type = "before", this.library = "".concat(di, "/").concat(Dn), typeof navigator < "u" && (this.userAgent = navigator.userAgent);
    }
    return t.prototype.setup = function(e) {
      return this.config = e, Promise.resolve(void 0);
    }, t.prototype.execute = function(e) {
      var n, r;
      return _(this, void 0, void 0, function() {
        var i, s, o, u;
        return C(this, function(c) {
          return i = (/* @__PURE__ */ new Date()).getTime(), s = (n = this.config.lastEventId) !== null && n !== void 0 ? n : -1, o = (r = e.event_id) !== null && r !== void 0 ? r : s + 1, this.config.lastEventId = o, e.time || (this.config.lastEventTime = i), u = S(S(S(S(S(S(S(S({ user_id: this.config.userId, device_id: this.config.deviceId, session_id: this.config.sessionId, time: i }, this.config.appVersion && { app_version: this.config.appVersion }), this.config.trackingOptions.platform && { platform: pi }), this.config.trackingOptions.language && { language: Zr() }), this.config.trackingOptions.ipAddress && { ip: vi }), { insert_id: ge(), partner_id: this.config.partnerId, plan: this.config.plan }), this.config.ingestionMetadata && {
            ingestion_metadata: {
              source_name: this.config.ingestionMetadata.sourceName,
              source_version: this.config.ingestionMetadata.sourceVersion
            }
          }), e), { event_id: o, library: this.library, user_agent: this.userAgent }), [2, u];
        });
      });
    }, t;
  })()
), Mn = (
  /** @class */
  (function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.isEnabled = function() {
      return _(this, void 0, void 0, function() {
        var e, n, r, i;
        return C(this, function(s) {
          switch (s.label) {
            case 0:
              if (!this.storage)
                return [2, !1];
              e = String(Date.now()), n = new t(this.storage), r = "AMP_TEST", s.label = 1;
            case 1:
              return s.trys.push([1, 4, 5, 7]), [4, n.set(r, e)];
            case 2:
              return s.sent(), [4, n.get(r)];
            case 3:
              return i = s.sent(), [2, i === e];
            case 4:
              return s.sent(), [2, !1];
            case 5:
              return [4, n.remove(r)];
            case 6:
              return s.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.get = function(e) {
      return _(this, void 0, void 0, function() {
        var n;
        return C(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, , 3]), [4, this.getRaw(e)];
            case 1:
              return n = r.sent(), n ? [2, JSON.parse(n)] : [2, void 0];
            case 2:
              return r.sent(), console.error("[Amplitude] Error: Could not get value from storage"), [2, void 0];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getRaw = function(e) {
      var n;
      return _(this, void 0, void 0, function() {
        return C(this, function(r) {
          return [2, ((n = this.storage) === null || n === void 0 ? void 0 : n.getItem(e)) || void 0];
        });
      });
    }, t.prototype.set = function(e, n) {
      var r;
      return _(this, void 0, void 0, function() {
        return C(this, function(i) {
          try {
            (r = this.storage) === null || r === void 0 || r.setItem(e, JSON.stringify(n));
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.remove = function(e) {
      var n;
      return _(this, void 0, void 0, function() {
        return C(this, function(r) {
          try {
            (n = this.storage) === null || n === void 0 || n.removeItem(e);
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.reset = function() {
      var e;
      return _(this, void 0, void 0, function() {
        return C(this, function(n) {
          try {
            (e = this.storage) === null || e === void 0 || e.clear();
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t;
  })()
), Te = 1e3, Un = (
  /** @class */
  (function(t) {
    Q(e, t);
    function e(n) {
      var r = this, i;
      return r = t.call(this, (i = Z()) === null || i === void 0 ? void 0 : i.localStorage) || this, r.loggerProvider = n?.loggerProvider, r;
    }
    return e.prototype.set = function(n, r) {
      var i;
      return _(this, void 0, void 0, function() {
        var s;
        return C(this, function(o) {
          switch (o.label) {
            case 0:
              return Array.isArray(r) && r.length > Te ? (s = r.length - Te, [4, t.prototype.set.call(this, n, r.slice(0, Te))]) : [3, 2];
            case 1:
              return o.sent(), (i = this.loggerProvider) === null || i === void 0 || i.error("Failed to save ".concat(s, " events because the queue length exceeded ").concat(Te, ".")), [3, 4];
            case 2:
              return [4, t.prototype.set.call(this, n, r)];
            case 3:
              o.sent(), o.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  })(Mn)
), gi = (
  /** @class */
  (function(t) {
    Q(e, t);
    function e() {
      var n;
      return t.call(this, (n = Z()) === null || n === void 0 ? void 0 : n.sessionStorage) || this;
    }
    return e;
  })(Mn)
), fi = (
  /** @class */
  (function(t) {
    Q(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.state = {
        done: 4
      }, n;
    }
    return e.prototype.send = function(n, r) {
      return _(this, void 0, void 0, function() {
        var i = this;
        return C(this, function(s) {
          return [2, new Promise(function(o, u) {
            typeof XMLHttpRequest > "u" && u(new Error("XHRTransport is not supported."));
            var c = new XMLHttpRequest();
            c.open("POST", n, !0), c.onreadystatechange = function() {
              if (c.readyState === i.state.done) {
                var a = c.responseText;
                try {
                  o(i.buildResponse(JSON.parse(a)));
                } catch {
                  o(i.buildResponse({ code: c.status }));
                }
              }
            }, c.setRequestHeader("Content-Type", "application/json"), c.setRequestHeader("Accept", "*/*"), c.send(JSON.stringify(r));
          })];
        });
      });
    }, e;
  })(xe)
), yi = (
  /** @class */
  (function(t) {
    Q(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.send = function(n, r) {
      return _(this, void 0, void 0, function() {
        var i = this;
        return C(this, function(s) {
          return [2, new Promise(function(o, u) {
            var c = Z();
            if (!c?.navigator.sendBeacon)
              throw new Error("SendBeaconTransport is not supported");
            try {
              var a = JSON.stringify(r), l = c.navigator.sendBeacon(n, JSON.stringify(r));
              return o(l ? i.buildResponse({
                code: 200,
                events_ingested: r.events.length,
                payload_size_bytes: a.length,
                server_upload_time: Date.now()
              }) : i.buildResponse({ code: 500 }));
            } catch (p) {
              u(p);
            }
          })];
        });
      });
    }, e;
  })(xe)
), Ci = function(t, e, n) {
  return n === void 0 && (n = !0), _(void 0, void 0, void 0, function() {
    var r, i, s, o, u, c, a, l, p;
    return C(this, function(d) {
      switch (d.label) {
        case 0:
          return r = Xr(t), [4, e.getRaw(r)];
        case 1:
          return i = d.sent(), i ? n ? [4, e.remove(r)] : [3, 3] : [2, {
            optOut: !1
          }];
        case 2:
          d.sent(), d.label = 3;
        case 3:
          return s = O(i.split("."), 6), o = s[0], u = s[1], c = s[2], a = s[3], l = s[4], p = s[5], [2, {
            deviceId: o,
            userId: _i(u),
            sessionId: nt(a),
            lastEventId: nt(p),
            lastEventTime: nt(l),
            optOut: !!c
          }];
      }
    });
  });
}, nt = function(t) {
  var e = parseInt(t, 32);
  if (!isNaN(e))
    return e;
}, _i = function(t) {
  if (!(!atob || !escape || !t))
    try {
      return decodeURIComponent(escape(atob(t)));
    } catch {
      return;
    }
}, Y = "[Amplitude]", Ot = "".concat(Y, " Form Started"), ki = "".concat(Y, " Form Submitted"), mi = "".concat(Y, " File Downloaded"), Rt = "session_start", Ft = "session_end", wi = "".concat(Y, " File Extension"), Si = "".concat(Y, " File Name"), bi = "".concat(Y, " Link ID"), Ii = "".concat(Y, " Link Text"), Ai = "".concat(Y, " Link URL"), rt = "".concat(Y, " Form ID"), it = "".concat(Y, " Form Name"), st = "".concat(Y, " Form Destination"), Le = "cookie", Ti = "US", Ei = (
  /** @class */
  (function(t) {
    Q(e, t);
    function e(n, r, i, s, o, u, c, a, l, p, d, f, y, m, w, v, h, g, k, b, I, T, E, P, W, N, K, ee, te, se, oe, fe, ye, ue) {
      i === void 0 && (i = new yt()), s === void 0 && (s = {
        domain: "",
        expiration: 365,
        sameSite: "Lax",
        secure: !1,
        upgrade: !0
      }), a === void 0 && (a = 1e3), l === void 0 && (l = 5), p === void 0 && (p = 30), d === void 0 && (d = Le), v === void 0 && (v = new mn()), h === void 0 && (h = q.Warn), k === void 0 && (k = !1), b === void 0 && (b = !1), E === void 0 && (E = ""), P === void 0 && (P = Ti), N === void 0 && (N = 1800 * 1e3), K === void 0 && (K = new Un({ loggerProvider: v })), ee === void 0 && (ee = {
        ipAddress: !0,
        language: !0,
        platform: !0
      }), te === void 0 && (te = "fetch"), se === void 0 && (se = !1), oe === void 0 && (oe = !1);
      var A = t.call(this, { apiKey: n, storageProvider: K, transportProvider: Ln(te) }) || this;
      return A.apiKey = n, A.appVersion = r, A.cookieOptions = s, A.defaultTracking = o, A.autocapture = u, A.flushIntervalMillis = a, A.flushMaxRetries = l, A.flushQueueSize = p, A.identityStorage = d, A.ingestionMetadata = f, A.instanceName = y, A.loggerProvider = v, A.logLevel = h, A.minIdLength = g, A.offline = k, A.partnerId = I, A.plan = T, A.serverUrl = E, A.serverZone = P, A.sessionTimeout = N, A.storageProvider = K, A.trackingOptions = ee, A.transport = te, A.useBatch = se, A.fetchRemoteConfig = oe, A.version = Dn, A._optOut = !1, A._cookieStorage = i, A.deviceId = c, A.lastEventId = m, A.lastEventTime = w, A.optOut = b, A.sessionId = W, A.pageCounter = ye, A.userId = fe, A.debugLogsEnabled = ue, A.loggerProvider.enable(ue ? q.Debug : A.logLevel), A;
    }
    return Object.defineProperty(e.prototype, "cookieStorage", {
      get: function() {
        return this._cookieStorage;
      },
      set: function(n) {
        this._cookieStorage !== n && (this._cookieStorage = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "deviceId", {
      get: function() {
        return this._deviceId;
      },
      set: function(n) {
        this._deviceId !== n && (this._deviceId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "userId", {
      get: function() {
        return this._userId;
      },
      set: function(n) {
        this._userId !== n && (this._userId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "sessionId", {
      get: function() {
        return this._sessionId;
      },
      set: function(n) {
        this._sessionId !== n && (this._sessionId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(n) {
        this._optOut !== n && (this._optOut = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastEventTime", {
      get: function() {
        return this._lastEventTime;
      },
      set: function(n) {
        this._lastEventTime !== n && (this._lastEventTime = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastEventId", {
      get: function() {
        return this._lastEventId;
      },
      set: function(n) {
        this._lastEventId !== n && (this._lastEventId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "pageCounter", {
      get: function() {
        return this._pageCounter;
      },
      set: function(n) {
        this._pageCounter !== n && (this._pageCounter = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "debugLogsEnabled", {
      set: function(n) {
        this._debugLogsEnabled !== n && (this._debugLogsEnabled = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateStorage = function() {
      var n = {
        deviceId: this._deviceId,
        userId: this._userId,
        sessionId: this._sessionId,
        optOut: this._optOut,
        lastEventTime: this._lastEventTime,
        lastEventId: this._lastEventId,
        pageCounter: this._pageCounter,
        debugLogsEnabled: this._debugLogsEnabled
      };
      this.cookieStorage.set(In(this.apiKey), n);
    }, e;
  })(Nr)
), Pi = function(t, e, n) {
  return e === void 0 && (e = {}), _(void 0, void 0, void 0, function() {
    var r, i, s, o, u, c, a, l, p, d, f, y, m, w, v, h, g, k, b, I, T, E, P, W, N, K, ee, te, se, oe, fe, ye, ue, A, Ge, qe, ze, $e, je, Je, Ye, Xe, Ze;
    return C(this, function(ae) {
      switch (ae.label) {
        case 0:
          return r = e.identityStorage || Le, b = {}, r === Le ? [3, 1] : (s = "", [3, 5]);
        case 1:
          return (T = (I = e.cookieOptions) === null || I === void 0 ? void 0 : I.domain) !== null && T !== void 0 ? (o = T, [3, 4]) : [3, 2];
        case 2:
          return [4, Ri()];
        case 3:
          o = ae.sent(), ae.label = 4;
        case 4:
          s = o, ae.label = 5;
        case 5:
          return i = S.apply(void 0, [(b.domain = s, b.expiration = 365, b.sameSite = "Lax", b.secure = !1, b.upgrade = !0, b), e.cookieOptions]), u = Oi(e.identityStorage, i), [4, Ci(t, u, (P = (E = e.cookieOptions) === null || E === void 0 ? void 0 : E.upgrade) !== null && P !== void 0 ? P : !0)];
        case 6:
          return c = ae.sent(), [4, u.get(In(t))];
        case 7:
          return a = ae.sent(), l = Ue(), p = (te = (ee = (K = (N = (W = e.deviceId) !== null && W !== void 0 ? W : l.ampDeviceId) !== null && N !== void 0 ? N : l.deviceId) !== null && K !== void 0 ? K : a?.deviceId) !== null && ee !== void 0 ? ee : c.deviceId) !== null && te !== void 0 ? te : ge(), d = (se = a?.lastEventId) !== null && se !== void 0 ? se : c.lastEventId, f = (oe = a?.lastEventTime) !== null && oe !== void 0 ? oe : c.lastEventTime, y = (ye = (fe = e.optOut) !== null && fe !== void 0 ? fe : a?.optOut) !== null && ye !== void 0 ? ye : c.optOut, m = (ue = a?.sessionId) !== null && ue !== void 0 ? ue : c.sessionId, w = (Ge = (A = e.userId) !== null && A !== void 0 ? A : a?.userId) !== null && Ge !== void 0 ? Ge : c.userId, n.previousSessionDeviceId = (qe = a?.deviceId) !== null && qe !== void 0 ? qe : c.deviceId, n.previousSessionUserId = (ze = a?.userId) !== null && ze !== void 0 ? ze : c.userId, v = {
            ipAddress: (je = ($e = e.trackingOptions) === null || $e === void 0 ? void 0 : $e.ipAddress) !== null && je !== void 0 ? je : !0,
            language: (Ye = (Je = e.trackingOptions) === null || Je === void 0 ? void 0 : Je.language) !== null && Ye !== void 0 ? Ye : !0,
            platform: (Ze = (Xe = e.trackingOptions) === null || Xe === void 0 ? void 0 : Xe.platform) !== null && Ze !== void 0 ? Ze : !0
          }, h = a?.pageCounter, g = a?.debugLogsEnabled, e.autocapture !== void 0 && (e.defaultTracking = e.autocapture), k = new Ei(t, e.appVersion, u, i, e.defaultTracking, e.autocapture, p, e.flushIntervalMillis, e.flushMaxRetries, e.flushQueueSize, r, e.ingestionMetadata, e.instanceName, d, f, e.loggerProvider, e.logLevel, e.minIdLength, e.offline, y, e.partnerId, e.plan, e.serverUrl, e.serverZone, m, e.sessionTimeout, e.storageProvider, v, e.transport, e.useBatch, e.fetchRemoteConfig, w, h, g), [4, k.storageProvider.isEnabled()];
        case 8:
          return ae.sent() || (k.loggerProvider.warn("Storage provider ".concat(k.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage.")), k.storageProvider = new yt()), [2, k];
      }
    });
  });
}, Oi = function(t, e) {
  switch (t === void 0 && (t = Le), e === void 0 && (e = {}), t) {
    case "localStorage":
      return new Un();
    case "sessionStorage":
      return new gi();
    case "none":
      return new yt();
    default:
      return new vt(S(S({}, e), { expirationDays: e.expiration }));
  }
}, Ln = function(t) {
  return t === "xhr" ? new fi() : t === "beacon" ? new yi() : new si();
}, Ri = function(t) {
  return _(void 0, void 0, void 0, function() {
    var e, n, r, i, s, s, o, u, c, a;
    return C(this, function(l) {
      switch (l.label) {
        case 0:
          return [4, new vt().isEnabled()];
        case 1:
          if (!l.sent() || typeof location > "u" || !location.hostname)
            return [2, ""];
          for (e = location.hostname, n = e.split("."), r = [], i = "AMP_TLDTEST", s = n.length - 2; s >= 0; --s)
            r.push(n.slice(s).join("."));
          s = 0, l.label = 2;
        case 2:
          return s < r.length ? (o = r[s], u = { domain: "." + o }, c = new vt(u), [4, c.set(i, 1)]) : [3, 7];
        case 3:
          return l.sent(), [4, c.get(i)];
        case 4:
          return a = l.sent(), a ? [4, c.remove(i)] : [3, 6];
        case 5:
          return l.sent(), [2, "." + o];
        case 6:
          return s++, [3, 2];
        case 7:
          return [2, ""];
      }
    });
  });
}, Nn = function() {
  var t = "ampIntegrationContext";
  if (typeof globalThis < "u" && typeof globalThis[t] < "u")
    return globalThis[t];
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
  if (typeof global < "u")
    return global;
}, Dt = function() {
  var t, e = Nn();
  if (!(!((t = e?.location) === null || t === void 0) && t.search))
    return {};
  var n = e.location.search.substring(1).split("&").filter(Boolean), r = n.reduce(function(i, s) {
    var o = s.split("=", 2), u = Mt(o[0]), c = Mt(o[1]);
    return c && (i[u] = c), i;
  }, {});
  return r;
}, Mt = function(t) {
  t === void 0 && (t = "");
  try {
    return decodeURIComponent(t);
  } catch {
    return "";
  }
}, Fi = "utm_campaign", Di = "utm_content", Mi = "utm_id", Ui = "utm_medium", Li = "utm_source", Ni = "utm_term", Ut = "dclid", Lt = "fbclid", Nt = "gbraid", Vt = "gclid", Bt = "ko_click_id", Wt = "li_fat_id", Ht = "msclkid", xt = "rtd_cid", Qt = "ttclid", Kt = "twclid", Gt = "wbraid", Vn = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  referrer: void 0,
  referring_domain: void 0,
  dclid: void 0,
  gbraid: void 0,
  gclid: void 0,
  fbclid: void 0,
  ko_click_id: void 0,
  li_fat_id: void 0,
  msclkid: void 0,
  rtd_cid: void 0,
  ttclid: void 0,
  twclid: void 0,
  wbraid: void 0
}, Vi = (
  /** @class */
  (function() {
    function t() {
    }
    return t.prototype.parse = function() {
      return _(this, void 0, void 0, function() {
        return C(this, function(e) {
          return [2, S(S(S(S({}, Vn), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    }, t.prototype.getUtmParam = function() {
      var e = Dt(), n = e[Fi], r = e[Di], i = e[Mi], s = e[Ui], o = e[Li], u = e[Ni];
      return {
        utm_campaign: n,
        utm_content: r,
        utm_id: i,
        utm_medium: s,
        utm_source: o,
        utm_term: u
      };
    }, t.prototype.getReferrer = function() {
      var e, n, r = {
        referrer: void 0,
        referring_domain: void 0
      };
      try {
        r.referrer = document.referrer || void 0, r.referring_domain = (n = (e = r.referrer) === null || e === void 0 ? void 0 : e.split("/")[2]) !== null && n !== void 0 ? n : void 0;
      } catch {
      }
      return r;
    }, t.prototype.getClickIds = function() {
      var e, n = Dt();
      return e = {}, e[Ut] = n[Ut], e[Lt] = n[Lt], e[Nt] = n[Nt], e[Vt] = n[Vt], e[Bt] = n[Bt], e[Wt] = n[Wt], e[Ht] = n[Ht], e[xt] = n[xt], e[Qt] = n[Qt], e[Kt] = n[Kt], e[Gt] = n[Gt], e;
    }, t;
  })()
), Ne;
(function(t) {
  t.SET = "$set", t.SET_ONCE = "$setOnce", t.ADD = "$add", t.APPEND = "$append", t.PREPEND = "$prepend", t.REMOVE = "$remove", t.PREINSERT = "$preInsert", t.POSTINSERT = "$postInsert", t.UNSET = "$unset", t.CLEAR_ALL = "$clearAll";
})(Ne || (Ne = {}));
var qt;
(function(t) {
  t.REVENUE_PRODUCT_ID = "$productId", t.REVENUE_QUANTITY = "$quantity", t.REVENUE_PRICE = "$price", t.REVENUE_TYPE = "$revenueType", t.REVENUE_CURRENCY = "$currency", t.REVENUE = "$revenue";
})(qt || (qt = {}));
var zt;
(function(t) {
  t.IDENTIFY = "$identify", t.GROUP_IDENTIFY = "$groupidentify", t.REVENUE = "revenue_amount";
})(zt || (zt = {}));
var Ve;
(function(t) {
  t.US = "US", t.EU = "EU";
})(Ve || (Ve = {}));
var Be;
(function(t) {
  t.Unknown = "unknown", t.Skipped = "skipped", t.Success = "success", t.RateLimit = "rate_limit", t.PayloadTooLarge = "payload_too_large", t.Invalid = "invalid", t.Failed = "failed", t.Timeout = "Timeout", t.SystemError = "SystemError";
})(Be || (Be = {}));
var Bi = function(t) {
  var e = {};
  for (var n in t) {
    var r = t[n];
    r && (e[n] = r);
  }
  return e;
}, Wi = "[Amplitude] Page Viewed", Hi = function(t) {
  t === void 0 && (t = {});
  var e, n = Nn(), r = void 0, i, s, o = t.trackOn, u = t.trackHistoryChanges, c = t.eventType, a = c === void 0 ? Wi : c, l = function(v) {
    var h = v;
    try {
      h = decodeURI(v);
    } catch (g) {
      r?.error("Malformed URI sequence: ", g);
    }
    return h;
  }, p = function() {
    return _(void 0, void 0, void 0, function() {
      var v, h, g;
      return C(this, function(k) {
        switch (k.label) {
          case 0:
            return v = l(typeof location < "u" && location.href || ""), g = {
              event_type: a
            }, h = [{}], [4, xi()];
          case 1:
            return [2, (g.event_properties = S.apply(void 0, [S.apply(void 0, h.concat([k.sent()])), { "[Amplitude] Page Domain": (
              /* istanbul ignore next */
              typeof location < "u" && location.hostname || ""
            ), "[Amplitude] Page Location": v, "[Amplitude] Page Path": (
              /* istanbul ignore next */
              typeof location < "u" && l(location.pathname) || ""
            ), "[Amplitude] Page Title": (
              /* istanbul ignore next */
              typeof document < "u" && document.title || ""
            ), "[Amplitude] Page URL": v.split("?")[0] }]), g)];
        }
      });
    });
  }, d = function() {
    return typeof o > "u" || typeof o == "function" && o();
  }, f = typeof location < "u" ? location.href : null, y = function() {
    return _(void 0, void 0, void 0, function() {
      var v, h, g, k;
      return C(this, function(b) {
        switch (b.label) {
          case 0:
            return v = location.href, h = Ki(u, v, f || "") && d(), f = v, h ? (r?.log("Tracking page view event"), e != null ? [3, 1] : [3, 3]) : [3, 4];
          case 1:
            return k = (g = e).track, [4, p()];
          case 2:
            k.apply(g, [b.sent()]), b.label = 3;
          case 3:
            b.label = 4;
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, m = function() {
    y();
  }, w = {
    name: "@amplitude/plugin-page-view-tracking-browser",
    type: "enrichment",
    setup: function(v, h) {
      return _(void 0, void 0, void 0, function() {
        var g, k;
        return C(this, function(b) {
          switch (b.label) {
            case 0:
              return e = h, s = v, r = v.loggerProvider, r.log("Installing @amplitude/plugin-page-view-tracking-browser"), n && (n.addEventListener("popstate", m), i = n.history.pushState, n.history.pushState = new Proxy(n.history.pushState, {
                apply: function(I, T, E) {
                  var P = O(E, 3), W = P[0], N = P[1], K = P[2];
                  I.apply(T, [W, N, K]), y();
                }
              })), d() ? (r.log("Tracking page view event"), k = (g = e).track, [4, p()]) : [3, 2];
            case 1:
              k.apply(g, [b.sent()]), b.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    },
    execute: function(v) {
      return _(void 0, void 0, void 0, function() {
        var h;
        return C(this, function(g) {
          switch (g.label) {
            case 0:
              return o === "attribution" && Qi(v) ? (r?.log("Enriching campaign event to page view event with campaign parameters"), [4, p()]) : [3, 2];
            case 1:
              h = g.sent(), v.event_type = h.event_type, v.event_properties = S(S({}, v.event_properties), h.event_properties), g.label = 2;
            case 2:
              return s && v.event_type === a && (s.pageCounter = s.pageCounter ? s.pageCounter + 1 : 1, v.event_properties = S(S({}, v.event_properties), { "[Amplitude] Page Counter": s.pageCounter })), [2, v];
          }
        });
      });
    },
    teardown: function() {
      return _(void 0, void 0, void 0, function() {
        return C(this, function(v) {
          return n && (n.removeEventListener("popstate", m), i && (n.history.pushState = i)), [
            2
            /*return*/
          ];
        });
      });
    }
  };
  return w;
}, xi = function() {
  return _(void 0, void 0, void 0, function() {
    var t;
    return C(this, function(e) {
      switch (e.label) {
        case 0:
          return t = Bi, [4, new Vi().parse()];
        case 1:
          return [2, t.apply(void 0, [e.sent()])];
      }
    });
  });
}, Qi = function(t) {
  if (t.event_type === "$identify" && t.user_properties) {
    var e = t.user_properties, n = e[Ne.SET] || {}, r = e[Ne.UNSET] || {}, i = H(H([], O(Object.keys(n)), !1), O(Object.keys(r)), !1);
    return Object.keys(Vn).every(function(s) {
      return i.includes(s);
    });
  }
  return !1;
}, Ki = function(t, e, n) {
  switch (t) {
    case "pathOnly": {
      if (n == "")
        return !0;
      var r = new URL(e), i = new URL(n), s = r.origin + r.pathname, o = i.origin + i.pathname;
      return s !== o;
    }
    default:
      return e !== n;
  }
}, Gi = function() {
  var t, e = [], n = function(a, l, p) {
    a.addEventListener(l, p), e.push({
      element: a,
      type: l,
      handler: p
    });
  }, r = function() {
    e.forEach(function(a) {
      var l = a.element, p = a.type, d = a.handler;
      l?.removeEventListener(p, d);
    }), e = [];
  }, i = "@amplitude/plugin-form-interaction-tracking-browser", s = "enrichment", o = function(a, l) {
    return _(void 0, void 0, void 0, function() {
      var p, d;
      return C(this, function(f) {
        return p = function() {
          if (!l) {
            a.loggerProvider.warn("Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.");
            return;
          }
          if (!(typeof document > "u")) {
            var y = function(w) {
              var v = !1;
              n(w, "change", function() {
                var h, g = $t(w);
                v || l.track(Ot, (h = {}, h[rt] = le(w.id), h[it] = le(w.name), h[st] = g, h)), v = !0;
              }), n(w, "submit", function() {
                var h, g, k = $t(w);
                v || l.track(Ot, (h = {}, h[rt] = le(w.id), h[it] = le(w.name), h[st] = k, h)), l.track(ki, (g = {}, g[rt] = le(w.id), g[it] = le(w.name), g[st] = k, g)), v = !1;
              });
            }, m = Array.from(document.getElementsByTagName("form"));
            m.forEach(y), typeof MutationObserver < "u" && (t = new MutationObserver(function(w) {
              w.forEach(function(v) {
                v.addedNodes.forEach(function(h) {
                  h.nodeName === "FORM" && y(h), "querySelectorAll" in h && typeof h.querySelectorAll == "function" && Array.from(h.querySelectorAll("form")).map(y);
                });
              });
            }), t.observe(document.body, {
              subtree: !0,
              childList: !0
            }));
          }
        }, document.readyState === "complete" ? p() : (d = Z(), d ? d.addEventListener("load", p) : a.loggerProvider.debug("Form interaction tracking is not installed because global is undefined.")), [
          2
          /*return*/
        ];
      });
    });
  }, u = function(a) {
    return _(void 0, void 0, void 0, function() {
      return C(this, function(l) {
        return [2, a];
      });
    });
  }, c = function() {
    return _(void 0, void 0, void 0, function() {
      return C(this, function(a) {
        return t?.disconnect(), r(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: i,
    type: s,
    setup: o,
    execute: u,
    teardown: c
  };
}, le = function(t) {
  if (typeof t == "string")
    return t;
}, $t = function(t) {
  var e = t.getAttribute("action");
  try {
    e = new URL(encodeURI(e ?? ""), window.location.href).href;
  } catch {
  }
  return e;
}, qi = function() {
  var t, e = [], n = function(a, l, p) {
    a.addEventListener(l, p), e.push({
      element: a,
      type: l,
      handler: p
    });
  }, r = function() {
    e.forEach(function(a) {
      var l = a.element, p = a.type, d = a.handler;
      l?.removeEventListener(p, d);
    }), e = [];
  }, i = "@amplitude/plugin-file-download-tracking-browser", s = "enrichment", o = function(a, l) {
    return _(void 0, void 0, void 0, function() {
      var p, d;
      return C(this, function(f) {
        return p = function() {
          if (!l) {
            a.loggerProvider.warn("File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.");
            return;
          }
          if (!(typeof document > "u")) {
            var y = function(v) {
              var h;
              try {
                h = new URL(v.href, window.location.href);
              } catch {
                return;
              }
              var g = m.exec(h.href), k = g?.[1];
              k && n(v, "click", function() {
                var b;
                k && l.track(mi, (b = {}, b[wi] = k, b[Si] = h.pathname, b[bi] = v.id, b[Ii] = v.text, b[Ai] = v.href, b));
              });
            }, m = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)(\?.+)?$/, w = Array.from(document.getElementsByTagName("a"));
            w.forEach(y), typeof MutationObserver < "u" && (t = new MutationObserver(function(v) {
              v.forEach(function(h) {
                h.addedNodes.forEach(function(g) {
                  g.nodeName === "A" && y(g), "querySelectorAll" in g && typeof g.querySelectorAll == "function" && Array.from(g.querySelectorAll("a")).map(y);
                });
              });
            }), t.observe(document.body, {
              subtree: !0,
              childList: !0
            }));
          }
        }, document.readyState === "complete" ? p() : (d = Z(), d ? d.addEventListener("load", p) : a.loggerProvider.debug("File download tracking is not installed because global is undefined.")), [
          2
          /*return*/
        ];
      });
    });
  }, u = function(a) {
    return _(void 0, void 0, void 0, function() {
      return C(this, function(l) {
        return [2, a];
      });
    });
  }, c = function() {
    return _(void 0, void 0, void 0, function() {
      return C(this, function(a) {
        return t?.disconnect(), r(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: i,
    type: s,
    setup: o,
    execute: u,
    teardown: c
  };
}, jt = !1, zi = function(t) {
  if (!(jt || t.defaultTracking !== void 0)) {
    var e = `\`options.defaultTracking\` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to \`options.defaultTracking\`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:

amplitude.init(<YOUR_API_KEY>, {
  defaultTracking: true,
});

Visit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.`;
    t.loggerProvider.warn(e), jt = !0;
  }
}, $i = function() {
  var t = "@amplitude/plugin-network-checker-browser", e = "before", n = Z(), r = [], i = function(c, a) {
    n && (n.addEventListener(c, a), r.push({
      type: c,
      handler: a
    }));
  }, s = function() {
    r.forEach(function(c) {
      var a = c.type, l = c.handler;
      n && n.removeEventListener(a, l);
    }), r = [];
  }, o = function(c, a) {
    return _(void 0, void 0, void 0, function() {
      return C(this, function(l) {
        return typeof navigator > "u" ? (c.loggerProvider.debug("Network connectivity checker plugin is disabled because navigator is not available."), c.offline = !1, [
          2
          /*return*/
        ]) : (c.offline = !navigator.onLine, i("online", function() {
          c.loggerProvider.debug("Network connectivity changed to online."), c.offline = !1, setTimeout(function() {
            a.flush();
          }, c.flushIntervalMillis);
        }), i("offline", function() {
          c.loggerProvider.debug("Network connectivity changed to offline."), c.offline = !0;
        }), [
          2
          /*return*/
        ]);
      });
    });
  }, u = function() {
    return _(void 0, void 0, void 0, function() {
      return C(this, function(c) {
        return s(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: t,
    type: e,
    setup: o,
    teardown: u
  };
}, ji = "Network error occurred, remote config fetch failed", Ji = "Remote config successfully fetched", Yi = "Remote config fetch rejected due to exceeded retry count", Jt = "Remote config fetch rejected due to timeout after 5 seconds", Yt = "Unexpected error occurred", Xi = "https://sr-client-cfg.amplitude.com/config", Zi = "https://sr-client-cfg.stag2.amplitude.com/config", es = "https://sr-client-cfg.eu.amplitude.com/config", ts = (
  /** @class */
  (function() {
    function t(e) {
      var n = e.localConfig, r = e.configKeys, i = this;
      this.retryTimeout = 1e3, this.attempts = 0, this.sessionTargetingMatch = !1, this.metrics = {}, this.getRemoteConfig = function(s, o, u) {
        return _(i, void 0, void 0, function() {
          var c, a, l;
          return C(this, function(p) {
            switch (p.label) {
              case 0:
                return c = Date.now(), [4, this.fetchWithTimeout(u)];
              case 1:
                return a = p.sent(), a && (l = a.configs && a.configs[s], l) ? (this.metrics.fetchTimeAPISuccess = Date.now() - c, [2, l[o]]) : (this.metrics.fetchTimeAPIFail = Date.now() - c, [2, void 0]);
            }
          });
        });
      }, this.fetchWithTimeout = function(s) {
        return _(i, void 0, void 0, function() {
          var o, u, c;
          return C(this, function(a) {
            switch (a.label) {
              case 0:
                return o = new AbortController(), u = setTimeout(function() {
                  return o.abort();
                }, 5e3), [4, this.fetchRemoteConfig(o.signal, s)];
              case 1:
                return c = a.sent(), clearTimeout(u), [2, c];
            }
          });
        });
      }, this.fetchRemoteConfig = function(s, o) {
        return _(i, void 0, void 0, function() {
          var u, c, a, l, p, d, f, y, m, w, v, h, g;
          return C(this, function(k) {
            switch (k.label) {
              case 0:
                if (o === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries)
                  return [2, this.completeRequest({ err: Yi })];
                if (s.aborted)
                  return [2, this.completeRequest({ err: Jt })];
                o !== this.lastFetchedSessionId && (this.lastFetchedSessionId = o, this.attempts = 0), k.label = 1;
              case 1:
                k.trys.push([1, 3, , 4]), u = new URLSearchParams({
                  api_key: this.localConfig.apiKey
                });
                try {
                  for (c = B(this.configKeys), a = c.next(); !a.done; a = c.next())
                    l = a.value, u.append("config_keys", l);
                } catch (b) {
                  v = { error: b };
                } finally {
                  try {
                    a && !a.done && (h = c.return) && h.call(c);
                  } finally {
                    if (v) throw v.error;
                  }
                }
                return o && u.set("session_id", String(o)), p = {
                  headers: {
                    Accept: "*/*"
                  },
                  method: "GET"
                }, d = "".concat(this.getServerUrl(), "?").concat(u.toString()), this.attempts += 1, [4, fetch(d, S(S({}, p), { signal: s }))];
              case 2:
                if (f = k.sent(), f === null)
                  return [2, this.completeRequest({ err: Yt })];
                switch (y = new xe().buildStatus(f.status), y) {
                  case Be.Success:
                    return this.attempts = 0, [2, this.parseAndStoreConfig(f)];
                  case Be.Failed:
                    return [2, this.retryFetch(s, o)];
                  default:
                    return [2, this.completeRequest({ err: ji })];
                }
              case 3:
                return m = k.sent(), w = m, s.aborted ? [2, this.completeRequest({ err: Jt })] : [2, this.completeRequest({ err: (g = w.message) !== null && g !== void 0 ? g : Yt })];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, this.retryFetch = function(s, o) {
        return _(i, void 0, void 0, function() {
          var u = this;
          return C(this, function(c) {
            switch (c.label) {
              case 0:
                return [4, new Promise(function(a) {
                  return setTimeout(a, u.attempts * u.retryTimeout);
                })];
              case 1:
                return c.sent(), [2, this.fetchRemoteConfig(s, o)];
            }
          });
        });
      }, this.parseAndStoreConfig = function(s) {
        return _(i, void 0, void 0, function() {
          var o;
          return C(this, function(u) {
            switch (u.label) {
              case 0:
                return [4, s.json()];
              case 1:
                return o = u.sent(), this.completeRequest({ success: Ji }), [2, o];
            }
          });
        });
      }, this.localConfig = n, this.configKeys = r;
    }
    return t.prototype.getServerUrl = function() {
      return this.localConfig.serverZone === Ve.STAGING ? Zi : this.localConfig.serverZone === Ve.EU ? es : Xi;
    }, t.prototype.completeRequest = function(e) {
      var n = e.err, r = e.success;
      if (n)
        throw new Error(n);
      r && this.localConfig.loggerProvider.log(r);
    }, t;
  })()
), ns = function(t) {
  var e = t.localConfig, n = t.configKeys;
  return _(void 0, void 0, void 0, function() {
    return C(this, function(r) {
      return [2, new ts({ localConfig: e, configKeys: n })];
    });
  });
}, rs = ns, is = (
  /** @class */
  (function() {
    function t(e) {
      this.config = e, this.config.loggerProvider.debug("Local configuration before merging with remote config", JSON.stringify(this.config, null, 2));
    }
    return t.prototype.initialize = function() {
      return _(this, void 0, void 0, function() {
        var e;
        return C(this, function(n) {
          switch (n.label) {
            case 0:
              return e = this, [4, rs({
                localConfig: this.config,
                configKeys: ["analyticsSDK"]
              })];
            case 1:
              return e.remoteConfigFetch = n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.generateJoinedConfig = function() {
      var e, n, r, i;
      return _(this, void 0, void 0, function() {
        var s, o, u;
        return C(this, function(c) {
          switch (c.label) {
            case 0:
              return c.trys.push([0, 3, , 4]), o = this.remoteConfigFetch, o ? [4, this.remoteConfigFetch.getRemoteConfig("analyticsSDK", "browserSDK", this.config.sessionId)] : [3, 2];
            case 1:
              o = c.sent(), c.label = 2;
            case 2:
              return s = o, this.config.loggerProvider.debug("Remote configuration:", JSON.stringify(s, null, 2)), s && "autocapture" in s && (typeof s.autocapture == "boolean" && (this.config.autocapture = s.autocapture), typeof s.autocapture == "object" && (this.config.autocapture === void 0 && (this.config.autocapture = s.autocapture), typeof this.config.autocapture == "boolean" && (this.config.autocapture = S({ attribution: this.config.autocapture, fileDownloads: this.config.autocapture, formInteractions: this.config.autocapture, pageViews: this.config.autocapture, sessions: this.config.autocapture, elementInteractions: this.config.autocapture }, s.autocapture)), typeof this.config.autocapture == "object" && (this.config.autocapture = S(S({}, this.config.autocapture), s.autocapture))), this.config.defaultTracking = this.config.autocapture), this.config.loggerProvider.debug("Joined configuration: ", JSON.stringify(this.config, null, 2)), (e = (i = this.config).requestMetadata) !== null && e !== void 0 || (i.requestMetadata = new Sn()), !((n = this.remoteConfigFetch) === null || n === void 0) && n.metrics.fetchTimeAPISuccess && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_success", this.remoteConfigFetch.metrics.fetchTimeAPISuccess), !((r = this.remoteConfigFetch) === null || r === void 0) && r.metrics.fetchTimeAPIFail && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_fail", this.remoteConfigFetch.metrics.fetchTimeAPIFail), [3, 4];
            case 3:
              return u = c.sent(), this.config.loggerProvider.error("Failed to fetch remote configuration because of error: ", u), [3, 4];
            case 4:
              return [2, this.config];
          }
        });
      });
    }, t;
  })()
), ss = function(t) {
  return _(void 0, void 0, void 0, function() {
    var e;
    return C(this, function(n) {
      switch (n.label) {
        case 0:
          return e = new is(t), [4, e.initialize()];
        case 1:
          return n.sent(), [2, e];
      }
    });
  });
}, os = "@amplitude/plugin-autocapture-browser", ht = "[Amplitude] Element Clicked", as = "[Amplitude] Element Changed", cs = "[Amplitude] Element ID", us = "[Amplitude] Element Class", Bn = "[Amplitude] Element Tag", Wn = "[Amplitude] Element Text", ls = "[Amplitude] Element Hierarchy", ds = "[Amplitude] Element Href", ps = "[Amplitude] Element Position Left", vs = "[Amplitude] Element Position Top", hs = "[Amplitude] Element Aria Label", gs = "[Amplitude] Element Attributes", fs = "[Amplitude] Element Parent Label", Hn = "[Amplitude] Page URL", ys = "[Amplitude] Page Title", Cs = "[Amplitude] Viewport Height", _s = "[Amplitude] Viewport Width", Fe = "https://app.amplitude.com", ks = "https://app.eu.amplitude.com", ms = "https://apps.stag2.amplitude.com", ws = {
  US: Fe,
  EU: ks,
  STAGING: ms
}, Ss = "https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz", bs = "amp-visual-tagging-selector-highlight";
function R(t) {
  return typeof t == "function";
}
function Ct(t) {
  var e = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = t(e);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var ot = Ct(function(t) {
  return function(n) {
    t(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, i) {
      return i + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function We(t, e) {
  if (t) {
    var n = t.indexOf(e);
    0 <= n && t.splice(n, 1);
  }
}
var be = (function() {
  function t(e) {
    this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return t.prototype.unsubscribe = function() {
    var e, n, r, i, s;
    if (!this.closed) {
      this.closed = !0;
      var o = this._parentage;
      if (o)
        if (this._parentage = null, Array.isArray(o))
          try {
            for (var u = B(o), c = u.next(); !c.done; c = u.next()) {
              var a = c.value;
              a.remove(this);
            }
          } catch (m) {
            e = { error: m };
          } finally {
            try {
              c && !c.done && (n = u.return) && n.call(u);
            } finally {
              if (e) throw e.error;
            }
          }
        else
          o.remove(this);
      var l = this.initialTeardown;
      if (R(l))
        try {
          l();
        } catch (m) {
          s = m instanceof ot ? m.errors : [m];
        }
      var p = this._finalizers;
      if (p) {
        this._finalizers = null;
        try {
          for (var d = B(p), f = d.next(); !f.done; f = d.next()) {
            var y = f.value;
            try {
              Xt(y);
            } catch (m) {
              s = s ?? [], m instanceof ot ? s = H(H([], O(s)), O(m.errors)) : s.push(m);
            }
          }
        } catch (m) {
          r = { error: m };
        } finally {
          try {
            f && !f.done && (i = d.return) && i.call(d);
          } finally {
            if (r) throw r.error;
          }
        }
      }
      if (s)
        throw new ot(s);
    }
  }, t.prototype.add = function(e) {
    var n;
    if (e && e !== this)
      if (this.closed)
        Xt(e);
      else {
        if (e instanceof t) {
          if (e.closed || e._hasParent(this))
            return;
          e._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(e);
      }
  }, t.prototype._hasParent = function(e) {
    var n = this._parentage;
    return n === e || Array.isArray(n) && n.includes(e);
  }, t.prototype._addParent = function(e) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(e), n) : n ? [n, e] : e;
  }, t.prototype._removeParent = function(e) {
    var n = this._parentage;
    n === e ? this._parentage = null : Array.isArray(n) && We(n, e);
  }, t.prototype.remove = function(e) {
    var n = this._finalizers;
    n && We(n, e), e instanceof t && e._removeParent(this);
  }, t.EMPTY = (function() {
    var e = new t();
    return e.closed = !0, e;
  })(), t;
})(), xn = be.EMPTY;
function Qn(t) {
  return t instanceof be || t && "closed" in t && R(t.remove) && R(t.add) && R(t.unsubscribe);
}
function Xt(t) {
  R(t) ? t() : t.unsubscribe();
}
var Is = {
  Promise: void 0
}, As = {
  setTimeout: function(t, e) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setTimeout.apply(void 0, H([t, e], O(n)));
  },
  clearTimeout: function(t) {
    return clearTimeout(t);
  },
  delegate: void 0
};
function Kn(t) {
  As.setTimeout(function() {
    throw t;
  });
}
function gt() {
}
function De(t) {
  t();
}
var _t = (function(t) {
  Q(e, t);
  function e(n) {
    var r = t.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, Qn(n) && n.add(r)) : r.destination = Ps, r;
  }
  return e.create = function(n, r, i) {
    return new we(n, r, i);
  }, e.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, e.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this), this.destination = null);
  }, e.prototype._next = function(n) {
    this.destination.next(n);
  }, e.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, e.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, e;
})(be), Ts = (function() {
  function t(e) {
    this.partialObserver = e;
  }
  return t.prototype.next = function(e) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(e);
      } catch (r) {
        Ee(r);
      }
  }, t.prototype.error = function(e) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(e);
      } catch (r) {
        Ee(r);
      }
    else
      Ee(e);
  }, t.prototype.complete = function() {
    var e = this.partialObserver;
    if (e.complete)
      try {
        e.complete();
      } catch (n) {
        Ee(n);
      }
  }, t;
})(), we = (function(t) {
  Q(e, t);
  function e(n, r, i) {
    var s = t.call(this) || this, o;
    return R(n) || !n ? o = {
      next: n ?? void 0,
      error: r ?? void 0,
      complete: i ?? void 0
    } : o = n, s.destination = new Ts(o), s;
  }
  return e;
})(_t);
function Ee(t) {
  Kn(t);
}
function Es(t) {
  throw t;
}
var Ps = {
  closed: !0,
  next: gt,
  error: Es,
  complete: gt
}, kt = (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})();
function Gn(t) {
  return t;
}
function Os(t) {
  return t.length === 0 ? Gn : t.length === 1 ? t[0] : function(n) {
    return t.reduce(function(r, i) {
      return i(r);
    }, n);
  };
}
var x = (function() {
  function t(e) {
    e && (this._subscribe = e);
  }
  return t.prototype.lift = function(e) {
    var n = new t();
    return n.source = this, n.operator = e, n;
  }, t.prototype.subscribe = function(e, n, r) {
    var i = this, s = Fs(e) ? e : new we(e, n, r);
    return De(function() {
      var o = i, u = o.operator, c = o.source;
      s.add(u ? u.call(s, c) : c ? i._subscribe(s) : i._trySubscribe(s));
    }), s;
  }, t.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (n) {
      e.error(n);
    }
  }, t.prototype.forEach = function(e, n) {
    var r = this;
    return n = Zt(n), new n(function(i, s) {
      var o = new we({
        next: function(u) {
          try {
            e(u);
          } catch (c) {
            s(c), o.unsubscribe();
          }
        },
        error: s,
        complete: i
      });
      r.subscribe(o);
    });
  }, t.prototype._subscribe = function(e) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e);
  }, t.prototype[kt] = function() {
    return this;
  }, t.prototype.pipe = function() {
    for (var e = [], n = 0; n < arguments.length; n++)
      e[n] = arguments[n];
    return Os(e)(this);
  }, t.prototype.toPromise = function(e) {
    var n = this;
    return e = Zt(e), new e(function(r, i) {
      var s;
      n.subscribe(function(o) {
        return s = o;
      }, function(o) {
        return i(o);
      }, function() {
        return r(s);
      });
    });
  }, t.create = function(e) {
    return new t(e);
  }, t;
})();
function Zt(t) {
  var e;
  return (e = t ?? Is.Promise) !== null && e !== void 0 ? e : Promise;
}
function Rs(t) {
  return t && R(t.next) && R(t.error) && R(t.complete);
}
function Fs(t) {
  return t && t instanceof _t || Rs(t) && Qn(t);
}
function Ds(t) {
  return R(t?.lift);
}
function j(t) {
  return function(e) {
    if (Ds(e))
      return e.lift(function(n) {
        try {
          return t(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function z(t, e, n, r, i) {
  return new Ms(t, e, n, r, i);
}
var Ms = (function(t) {
  Q(e, t);
  function e(n, r, i, s, o, u) {
    var c = t.call(this, n) || this;
    return c.onFinalize = o, c.shouldUnsubscribe = u, c._next = r ? function(a) {
      try {
        r(a);
      } catch (l) {
        n.error(l);
      }
    } : t.prototype._next, c._error = s ? function(a) {
      try {
        s(a);
      } catch (l) {
        n.error(l);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._error, c._complete = i ? function() {
      try {
        i();
      } catch (a) {
        n.error(a);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._complete, c;
  }
  return e.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      t.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, e;
})(_t), Us = Ct(function(t) {
  return function() {
    t(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), qn = (function(t) {
  Q(e, t);
  function e() {
    var n = t.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return e.prototype.lift = function(n) {
    var r = new en(this, this);
    return r.operator = n, r;
  }, e.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new Us();
  }, e.prototype.next = function(n) {
    var r = this;
    De(function() {
      var i, s;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var o = B(r.currentObservers), u = o.next(); !u.done; u = o.next()) {
            var c = u.value;
            c.next(n);
          }
        } catch (a) {
          i = { error: a };
        } finally {
          try {
            u && !u.done && (s = o.return) && s.call(o);
          } finally {
            if (i) throw i.error;
          }
        }
      }
    });
  }, e.prototype.error = function(n) {
    var r = this;
    De(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = n;
        for (var i = r.observers; i.length; )
          i.shift().error(n);
      }
    });
  }, e.prototype.complete = function() {
    var n = this;
    De(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var r = n.observers; r.length; )
          r.shift().complete();
      }
    });
  }, e.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(e.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), t.prototype._trySubscribe.call(this, n);
  }, e.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, e.prototype._innerSubscribe = function(n) {
    var r = this, i = this, s = i.hasError, o = i.isStopped, u = i.observers;
    return s || o ? xn : (this.currentObservers = null, u.push(n), new be(function() {
      r.currentObservers = null, We(u, n);
    }));
  }, e.prototype._checkFinalizedStatuses = function(n) {
    var r = this, i = r.hasError, s = r.thrownError, o = r.isStopped;
    i ? n.error(s) : o && n.complete();
  }, e.prototype.asObservable = function() {
    var n = new x();
    return n.source = this, n;
  }, e.create = function(n, r) {
    return new en(n, r);
  }, e;
})(x), en = (function(t) {
  Q(e, t);
  function e(n, r) {
    var i = t.call(this) || this;
    return i.destination = n, i.source = r, i;
  }
  return e.prototype.next = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || i === void 0 || i.call(r, n);
  }, e.prototype.error = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || i === void 0 || i.call(r, n);
  }, e.prototype.complete = function() {
    var n, r;
    (r = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || r === void 0 || r.call(n);
  }, e.prototype._subscribe = function(n) {
    var r, i;
    return (i = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(n)) !== null && i !== void 0 ? i : xn;
  }, e;
})(qn), Ls = {
  now: function() {
    return Date.now();
  }
}, Ns = (function(t) {
  Q(e, t);
  function e(n, r) {
    return t.call(this) || this;
  }
  return e.prototype.schedule = function(n, r) {
    return this;
  }, e;
})(be), tn = {
  setInterval: function(t, e) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setInterval.apply(void 0, H([t, e], O(n)));
  },
  clearInterval: function(t) {
    return clearInterval(t);
  },
  delegate: void 0
}, Vs = (function(t) {
  Q(e, t);
  function e(n, r) {
    var i = t.call(this, n, r) || this;
    return i.scheduler = n, i.work = r, i.pending = !1, i;
  }
  return e.prototype.schedule = function(n, r) {
    var i;
    if (r === void 0 && (r = 0), this.closed)
      return this;
    this.state = n;
    var s = this.id, o = this.scheduler;
    return s != null && (this.id = this.recycleAsyncId(o, s, r)), this.pending = !0, this.delay = r, this.id = (i = this.id) !== null && i !== void 0 ? i : this.requestAsyncId(o, this.id, r), this;
  }, e.prototype.requestAsyncId = function(n, r, i) {
    return i === void 0 && (i = 0), tn.setInterval(n.flush.bind(n, this), i);
  }, e.prototype.recycleAsyncId = function(n, r, i) {
    if (i === void 0 && (i = 0), i != null && this.delay === i && this.pending === !1)
      return r;
    r != null && tn.clearInterval(r);
  }, e.prototype.execute = function(n, r) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var i = this._execute(n, r);
    if (i)
      return i;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, e.prototype._execute = function(n, r) {
    var i = !1, s;
    try {
      this.work(n);
    } catch (o) {
      i = !0, s = o || new Error("Scheduled action threw falsy error");
    }
    if (i)
      return this.unsubscribe(), s;
  }, e.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, r = n.id, i = n.scheduler, s = i.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, We(s, this), r != null && (this.id = this.recycleAsyncId(i, r, null)), this.delay = null, t.prototype.unsubscribe.call(this);
    }
  }, e;
})(Ns), nn = (function() {
  function t(e, n) {
    n === void 0 && (n = t.now), this.schedulerActionCtor = e, this.now = n;
  }
  return t.prototype.schedule = function(e, n, r) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, e).schedule(r, n);
  }, t.now = Ls.now, t;
})(), Bs = (function(t) {
  Q(e, t);
  function e(n, r) {
    r === void 0 && (r = nn.now);
    var i = t.call(this, n, r) || this;
    return i.actions = [], i._active = !1, i;
  }
  return e.prototype.flush = function(n) {
    var r = this.actions;
    if (this._active) {
      r.push(n);
      return;
    }
    var i;
    this._active = !0;
    do
      if (i = n.execute(n.state, n.delay))
        break;
    while (n = r.shift());
    if (this._active = !1, i) {
      for (; n = r.shift(); )
        n.unsubscribe();
      throw i;
    }
  }, e;
})(nn), Qe = new Bs(Vs), Ws = Qe, mt = new x(function(t) {
  return t.complete();
});
function zn(t) {
  return t && R(t.schedule);
}
function $n(t) {
  return t[t.length - 1];
}
function Hs(t) {
  return zn($n(t)) ? t.pop() : void 0;
}
function xs(t, e) {
  return typeof $n(t) == "number" ? t.pop() : e;
}
var wt = (function(t) {
  return t && typeof t.length == "number" && typeof t != "function";
});
function jn(t) {
  return R(t?.then);
}
function Jn(t) {
  return R(t[kt]);
}
function Yn(t) {
  return Symbol.asyncIterator && R(t?.[Symbol.asyncIterator]);
}
function Xn(t) {
  return new TypeError("You provided " + (t !== null && typeof t == "object" ? "an invalid object" : "'" + t + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function Qs() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var Zn = Qs();
function er(t) {
  return R(t?.[Zn]);
}
function tr(t) {
  return gr(this, arguments, function() {
    var n, r, i, s;
    return C(this, function(o) {
      switch (o.label) {
        case 0:
          n = t.getReader(), o.label = 1;
        case 1:
          o.trys.push([1, , 9, 10]), o.label = 2;
        case 2:
          return [4, pe(n.read())];
        case 3:
          return r = o.sent(), i = r.value, s = r.done, s ? [4, pe(void 0)] : [3, 5];
        case 4:
          return [2, o.sent()];
        case 5:
          return [4, pe(i)];
        case 6:
          return [4, o.sent()];
        case 7:
          return o.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function nr(t) {
  return R(t?.getReader);
}
function $(t) {
  if (t instanceof x)
    return t;
  if (t != null) {
    if (Jn(t))
      return Ks(t);
    if (wt(t))
      return Gs(t);
    if (jn(t))
      return qs(t);
    if (Yn(t))
      return rr(t);
    if (er(t))
      return zs(t);
    if (nr(t))
      return $s(t);
  }
  throw Xn(t);
}
function Ks(t) {
  return new x(function(e) {
    var n = t[kt]();
    if (R(n.subscribe))
      return n.subscribe(e);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function Gs(t) {
  return new x(function(e) {
    for (var n = 0; n < t.length && !e.closed; n++)
      e.next(t[n]);
    e.complete();
  });
}
function qs(t) {
  return new x(function(e) {
    t.then(function(n) {
      e.closed || (e.next(n), e.complete());
    }, function(n) {
      return e.error(n);
    }).then(null, Kn);
  });
}
function zs(t) {
  return new x(function(e) {
    var n, r;
    try {
      for (var i = B(t), s = i.next(); !s.done; s = i.next()) {
        var o = s.value;
        if (e.next(o), e.closed)
          return;
      }
    } catch (u) {
      n = { error: u };
    } finally {
      try {
        s && !s.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
    e.complete();
  });
}
function rr(t) {
  return new x(function(e) {
    js(t, e).catch(function(n) {
      return e.error(n);
    });
  });
}
function $s(t) {
  return rr(tr(t));
}
function js(t, e) {
  var n, r, i, s;
  return _(this, void 0, void 0, function() {
    var o, u;
    return C(this, function(c) {
      switch (c.label) {
        case 0:
          c.trys.push([0, 5, 6, 11]), n = fr(t), c.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = c.sent(), !!r.done) return [3, 4];
          if (o = r.value, e.next(o), e.closed)
            return [2];
          c.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return u = c.sent(), i = { error: u }, [3, 11];
        case 6:
          return c.trys.push([6, , 9, 10]), r && !r.done && (s = n.return) ? [4, s.call(n)] : [3, 8];
        case 7:
          c.sent(), c.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i) throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return e.complete(), [2];
      }
    });
  });
}
function re(t, e, n, r, i) {
  r === void 0 && (r = 0), i === void 0 && (i = !1);
  var s = e.schedule(function() {
    n(), i ? t.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (t.add(s), !i)
    return s;
}
function ir(t, e) {
  return e === void 0 && (e = 0), j(function(n, r) {
    n.subscribe(z(r, function(i) {
      return re(r, t, function() {
        return r.next(i);
      }, e);
    }, function() {
      return re(r, t, function() {
        return r.complete();
      }, e);
    }, function(i) {
      return re(r, t, function() {
        return r.error(i);
      }, e);
    }));
  });
}
function sr(t, e) {
  return e === void 0 && (e = 0), j(function(n, r) {
    r.add(t.schedule(function() {
      return n.subscribe(r);
    }, e));
  });
}
function Js(t, e) {
  return $(t).pipe(sr(e), ir(e));
}
function Ys(t, e) {
  return $(t).pipe(sr(e), ir(e));
}
function Xs(t, e) {
  return new x(function(n) {
    var r = 0;
    return e.schedule(function() {
      r === t.length ? n.complete() : (n.next(t[r++]), n.closed || this.schedule());
    });
  });
}
function Zs(t, e) {
  return new x(function(n) {
    var r;
    return re(n, e, function() {
      r = t[Zn](), re(n, e, function() {
        var i, s, o;
        try {
          i = r.next(), s = i.value, o = i.done;
        } catch (u) {
          n.error(u);
          return;
        }
        o ? n.complete() : n.next(s);
      }, 0, !0);
    }), function() {
      return R(r?.return) && r.return();
    };
  });
}
function or(t, e) {
  if (!t)
    throw new Error("Iterable cannot be null");
  return new x(function(n) {
    re(n, e, function() {
      var r = t[Symbol.asyncIterator]();
      re(n, e, function() {
        r.next().then(function(i) {
          i.done ? n.complete() : n.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function eo(t, e) {
  return or(tr(t), e);
}
function to(t, e) {
  if (t != null) {
    if (Jn(t))
      return Js(t, e);
    if (wt(t))
      return Xs(t, e);
    if (jn(t))
      return Ys(t, e);
    if (Yn(t))
      return or(t, e);
    if (er(t))
      return Zs(t, e);
    if (nr(t))
      return eo(t, e);
  }
  throw Xn(t);
}
function no(t, e) {
  return e ? to(t, e) : $(t);
}
function ar(t) {
  return t instanceof Date && !isNaN(t);
}
var ro = Ct(function(t) {
  return function(n) {
    n === void 0 && (n = null), t(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = n;
  };
});
function io(t, e) {
  var n = ar(t) ? { first: t } : typeof t == "number" ? { each: t } : t, r = n.first, i = n.each, s = n.with, o = s === void 0 ? so : s, u = n.scheduler, c = u === void 0 ? Qe : u, a = n.meta, l = a === void 0 ? null : a;
  if (r == null && i == null)
    throw new TypeError("No timeout provided.");
  return j(function(p, d) {
    var f, y, m = null, w = 0, v = function(h) {
      y = re(d, c, function() {
        try {
          f.unsubscribe(), $(o({
            meta: l,
            lastValue: m,
            seen: w
          })).subscribe(d);
        } catch (g) {
          d.error(g);
        }
      }, h);
    };
    f = p.subscribe(z(d, function(h) {
      y?.unsubscribe(), w++, d.next(m = h), i > 0 && v(i);
    }, void 0, void 0, function() {
      y?.closed || y?.unsubscribe(), m = null;
    })), !w && v(r != null ? typeof r == "number" ? r : +r - c.now() : i);
  });
}
function so(t) {
  throw new ro(t);
}
function X(t, e) {
  return j(function(n, r) {
    var i = 0;
    n.subscribe(z(r, function(s) {
      r.next(t.call(e, s, i++));
    }));
  });
}
var oo = Array.isArray;
function ao(t, e) {
  return oo(e) ? t.apply(void 0, H([], O(e))) : t(e);
}
function co(t) {
  return X(function(e) {
    return ao(t, e);
  });
}
function uo(t, e, n, r, i, s, o, u) {
  var c = [], a = 0, l = 0, p = !1, d = function() {
    p && !c.length && !a && e.complete();
  }, f = function(m) {
    return a < r ? y(m) : c.push(m);
  }, y = function(m) {
    a++;
    var w = !1;
    $(n(m, l++)).subscribe(z(e, function(v) {
      e.next(v);
    }, function() {
      w = !0;
    }, void 0, function() {
      if (w)
        try {
          a--;
          for (var v = function() {
            var h = c.shift();
            o || y(h);
          }; c.length && a < r; )
            v();
          d();
        } catch (h) {
          e.error(h);
        }
    }));
  };
  return t.subscribe(z(e, f, function() {
    p = !0, d();
  })), function() {
  };
}
function Ke(t, e, n) {
  return n === void 0 && (n = 1 / 0), R(e) ? Ke(function(r, i) {
    return X(function(s, o) {
      return e(r, s, i, o);
    })($(t(r, i)));
  }, n) : (typeof e == "number" && (n = e), j(function(r, i) {
    return uo(r, i, t, n);
  }));
}
function lo(t) {
  return t === void 0 && (t = 1 / 0), Ke(Gn, t);
}
var po = ["addListener", "removeListener"], vo = ["addEventListener", "removeEventListener"], ho = ["on", "off"];
function ke(t, e, n, r) {
  if (R(n) && (r = n, n = void 0), r)
    return ke(t, e, n).pipe(co(r));
  var i = O(yo(t) ? vo.map(function(u) {
    return function(c) {
      return t[u](e, c, n);
    };
  }) : go(t) ? po.map(rn(t, e)) : fo(t) ? ho.map(rn(t, e)) : [], 2), s = i[0], o = i[1];
  if (!s && wt(t))
    return Ke(function(u) {
      return ke(u, e, n);
    })($(t));
  if (!s)
    throw new TypeError("Invalid event target");
  return new x(function(u) {
    var c = function() {
      for (var a = [], l = 0; l < arguments.length; l++)
        a[l] = arguments[l];
      return u.next(1 < a.length ? a : a[0]);
    };
    return s(c), function() {
      return o(c);
    };
  });
}
function rn(t, e) {
  return function(n) {
    return function(r) {
      return t[n](e, r);
    };
  };
}
function go(t) {
  return R(t.addListener) && R(t.removeListener);
}
function fo(t) {
  return R(t.on) && R(t.off);
}
function yo(t) {
  return R(t.addEventListener) && R(t.removeEventListener);
}
function Co(t, e, n) {
  n === void 0 && (n = Ws);
  var r = -1;
  return e != null && (zn(e) ? n = e : r = e), new x(function(i) {
    var s = ar(t) ? +t - n.now() : t;
    s < 0 && (s = 0);
    var o = 0;
    return n.schedule(function() {
      i.closed || (i.next(o++), 0 <= r ? this.schedule(void 0, r) : i.complete());
    }, s);
  });
}
function cr() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = Hs(t), r = xs(t, 1 / 0), i = t;
  return i.length ? i.length === 1 ? $(i[0]) : lo(r)(no(i, n)) : mt;
}
function ie(t, e) {
  return j(function(n, r) {
    var i = 0;
    n.subscribe(z(r, function(s) {
      return t.call(e, s, i++) && r.next(s);
    }));
  });
}
function _o(t) {
  return j(function(e, n) {
    var r = [];
    return e.subscribe(z(n, function(i) {
      return r.push(i);
    }, function() {
      n.next(r), n.complete();
    })), $(t).subscribe(z(n, function() {
      var i = r;
      r = [], n.next(i);
    }, gt)), function() {
      r = null;
    };
  });
}
function ko(t, e) {
  return e === void 0 && (e = Qe), j(function(n, r) {
    var i = null, s = null, o = null, u = function() {
      if (i) {
        i.unsubscribe(), i = null;
        var a = s;
        s = null, r.next(a);
      }
    };
    function c() {
      var a = o + t, l = e.now();
      if (l < a) {
        i = this.schedule(void 0, a - l), r.add(i);
        return;
      }
      u();
    }
    n.subscribe(z(r, function(a) {
      s = a, o = e.now(), i || (i = e.schedule(c, t), r.add(i));
    }, function() {
      u(), r.complete();
    }, void 0, function() {
      s = i = null;
    }));
  });
}
function ur(t) {
  return t <= 0 ? function() {
    return mt;
  } : j(function(e, n) {
    var r = 0;
    e.subscribe(z(n, function(i) {
      ++r <= t && (n.next(i), t <= r && n.complete());
    }));
  });
}
function mo(t) {
  return X(function() {
    return t;
  });
}
function wo(t, e) {
  return Ke(function(n, r) {
    return $(t(n, r)).pipe(ur(1), mo(n));
  });
}
function So(t, e) {
  e === void 0 && (e = Qe);
  var n = Co(t, e);
  return wo(function() {
    return n;
  });
}
function bo() {
  return j(function(t, e) {
    var n, r = !1;
    t.subscribe(z(e, function(i) {
      var s = n;
      n = i, r && e.next([s, i]), r = !0;
    }));
  });
}
function Pe(t) {
  t === void 0 && (t = {});
  var e = t.connector, n = e === void 0 ? function() {
    return new qn();
  } : e, r = t.resetOnError, i = r === void 0 ? !0 : r, s = t.resetOnComplete, o = s === void 0 ? !0 : s, u = t.resetOnRefCountZero, c = u === void 0 ? !0 : u;
  return function(a) {
    var l, p, d, f = 0, y = !1, m = !1, w = function() {
      p?.unsubscribe(), p = void 0;
    }, v = function() {
      w(), l = d = void 0, y = m = !1;
    }, h = function() {
      var g = l;
      v(), g?.unsubscribe();
    };
    return j(function(g, k) {
      f++, !m && !y && w();
      var b = d = d ?? n();
      k.add(function() {
        f--, f === 0 && !m && !y && (p = at(h, c));
      }), b.subscribe(k), !l && f > 0 && (l = new we({
        next: function(I) {
          return b.next(I);
        },
        error: function(I) {
          m = !0, w(), p = at(v, i, I), b.error(I);
        },
        complete: function() {
          y = !0, w(), p = at(v, o), b.complete();
        }
      }), $(g).subscribe(l));
    })(a);
  };
}
function at(t, e) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  if (e === !0) {
    t();
    return;
  }
  if (e !== !1) {
    var i = new we({
      next: function() {
        i.unsubscribe(), t();
      }
    });
    return $(e.apply(void 0, H([], O(n)))).subscribe(i);
  }
}
function Io(t, e) {
  return j(function(n, r) {
    var i = null, s = 0, o = !1, u = function() {
      return o && !i && r.complete();
    };
    n.subscribe(z(r, function(c) {
      i?.unsubscribe();
      var a = 0, l = s++;
      $(t(c, l)).subscribe(i = z(r, function(p) {
        return r.next(e ? e(c, p, l, a++) : p);
      }, function() {
        i = null, u();
      }));
    }, function() {
      o = !0, u();
    }));
  });
}
var Ao = ["input", "select", "textarea"], ct = function(t, e) {
  return function(n, r) {
    var i, s, o, u = t.pageUrlAllowlist, c = t.shouldTrackEventResolver, a = (s = (i = r?.tagName) === null || i === void 0 ? void 0 : i.toLowerCase) === null || s === void 0 ? void 0 : s.call(i);
    if (!a)
      return !1;
    if (c)
      return c(n, r);
    if (!Eo(window.location.href, u))
      return !1;
    var l = String(r?.getAttribute("type")) || "";
    if (typeof l == "string")
      switch (l.toLowerCase()) {
        case "hidden":
          return !1;
        case "password":
          return !1;
      }
    if (e) {
      var p = e.some(function(f) {
        var y;
        return !!(!((y = r?.matches) === null || y === void 0) && y.call(r, f));
      });
      if (!p)
        return !1;
    }
    switch (a) {
      case "input":
      case "select":
      case "textarea":
        return n === "change" || n === "click";
      default: {
        var d = (o = window?.getComputedStyle) === null || o === void 0 ? void 0 : o.call(window, r);
        return d && d.getPropertyValue("cursor") === "pointer" && n === "click" ? !0 : n === "click";
      }
    }
  };
}, lr = function(t) {
  if (t == null)
    return !1;
  if (typeof t == "string") {
    var e = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
    if (e.test((t || "").replace(/[- ]/g, "")))
      return !1;
    var n = /(^\d{3}-?\d{2}-?\d{4}$)/;
    if (n.test(t))
      return !1;
  }
  return !0;
}, To = function(t) {
  return !!t && t.nodeType === 3;
}, dr = function(t) {
  var e, n, r, i = (n = (e = t?.tagName) === null || e === void 0 ? void 0 : e.toLowerCase) === null || n === void 0 ? void 0 : n.call(e), s = t instanceof HTMLElement ? ((r = t.getAttribute("contenteditable")) === null || r === void 0 ? void 0 : r.toLowerCase()) === "true" : !1;
  return !Ao.includes(i) && !s;
}, St = function(t) {
  var e = "";
  return dr(t) && t.childNodes && t.childNodes.length && t.childNodes.forEach(function(n) {
    var r = "";
    To(n) ? n.textContent && (r = n.textContent) : r = St(n), e += r.split(/(\s+)/).filter(lr).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
  }), e;
}, Eo = function(t, e) {
  return !e || !e.length ? !0 : e.some(function(n) {
    return typeof n == "string" ? t === n : t.match(n);
  });
}, Po = function(t, e) {
  return t.getAttributeNames().reduce(function(n, r) {
    if (r.startsWith(e)) {
      var i = r.replace(e, ""), s = t.getAttribute(r);
      i && (n[i] = s || "");
    }
    return n;
  }, {});
}, Oo = function(t) {
  return t == null || typeof t == "object" && Object.keys(t).length === 0 || typeof t == "string" && t.trim().length === 0;
}, pr = function(t) {
  return Object.keys(t).reduce(function(e, n) {
    var r = t[n];
    return Oo(r) || (e[n] = r), e;
  }, {});
}, vr = function(t) {
  var e = t.parentElement;
  if (!e)
    return "";
  var n;
  try {
    n = e.querySelector(":scope>span,h1,h2,h3,h4,h5,h6");
  } catch {
    n = null;
  }
  if (n) {
    var r = n.textContent || "";
    return lr(r) ? r : "";
  }
  return vr(e);
}, bt = function(t, e) {
  return t ? e.some(function(n) {
    var r;
    return (r = t?.matches) === null || r === void 0 ? void 0 : r.call(t, n);
  }) ? t : bt(t?.parentElement, e) : null;
}, Ro = function(t) {
  var e, n, r;
  if (!t)
    return {};
  var i = (r = (n = t?.tagName) === null || n === void 0 ? void 0 : n.toLowerCase) === null || r === void 0 ? void 0 : r.call(n), s = (e = {}, e[Bn] = i, e[Wn] = St(t), e[Hn] = window.location.href.split("?")[0], e);
  return pr(s);
}, Fo = function(t) {
  return new Promise(function(e, n) {
    var r;
    try {
      var i = document.createElement("script");
      i.type = "text/javascript", i.async = !0, i.src = t, i.addEventListener("load", function() {
        e({ status: !0 });
      }, { once: !0 }), i.addEventListener("error", function() {
        n({
          status: !1,
          message: "Failed to load the script ".concat(t)
        });
      }), (r = document.head) === null || r === void 0 || r.appendChild(i);
    } catch (s) {
      n(s);
    }
  });
};
function Do() {
  return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var It = function(t) {
  return !(t.event.target === null || !t.closestTrackedAncestor);
}, Mo = (
  /** @class */
  (function() {
    function t(e) {
      var n = e === void 0 ? {} : e, r = n.origin, i = r === void 0 ? Fe : r, s = this;
      this.endpoint = Fe, this.requestCallbacks = {}, this.onSelect = function(o) {
        s.notify({ action: "element-selected", data: o });
      }, this.onTrack = function(o, u) {
        o === "selector-mode-changed" ? s.notify({ action: "track-selector-mode-changed", data: u }) : o === "selector-moved" && s.notify({ action: "track-selector-moved", data: u });
      }, this.endpoint = i;
    }
    return t.prototype.notify = function(e) {
      var n, r, i, s;
      (r = (n = this.logger) === null || n === void 0 ? void 0 : n.debug) === null || r === void 0 || r.call(n, "Message sent: ", JSON.stringify(e)), (s = (i = window.opener) === null || i === void 0 ? void 0 : i.postMessage) === null || s === void 0 || s.call(i, e, this.endpoint);
    }, t.prototype.sendRequest = function(e, n, r) {
      var i = this;
      r === void 0 && (r = { timeout: 15e3 });
      var s = Do(), o = {
        id: s,
        action: e,
        args: n
      }, u = new Promise(function(c, a) {
        i.requestCallbacks[s] = { resolve: c, reject: a }, i.notify(o), r?.timeout > 0 && setTimeout(function() {
          a(new Error("".concat(e, " timed out (id: ").concat(s, ")"))), delete i.requestCallbacks[s];
        }, r.timeout);
      });
      return u;
    }, t.prototype.handleResponse = function(e) {
      var n;
      if (!this.requestCallbacks[e.id]) {
        (n = this.logger) === null || n === void 0 || n.warn("No callback found for request id: ".concat(e.id));
        return;
      }
      this.requestCallbacks[e.id].resolve(e.responseData), delete this.requestCallbacks[e.id];
    }, t.prototype.setup = function(e) {
      var n = this, r = e === void 0 ? {} : e, i = r.logger, s = r.endpoint, o = r.isElementSelectable, u = r.cssSelectorAllowlist, c = r.actionClickAllowlist;
      this.logger = i, s && this.endpoint === Fe && (this.endpoint = s);
      var a = null;
      window.addEventListener("message", function(l) {
        var p, d, f, y, m;
        if ((d = (p = n.logger) === null || p === void 0 ? void 0 : p.debug) === null || d === void 0 || d.call(p, "Message received: ", JSON.stringify(l)), n.endpoint === l.origin) {
          var w = l?.data, v = w?.action;
          if (v)
            if ("id" in w)
              (y = (f = n.logger) === null || f === void 0 ? void 0 : f.debug) === null || y === void 0 || y.call(f, "Received Response to previous request: ", JSON.stringify(l)), n.handleResponse(w);
            else if (v === "ping")
              n.notify({ action: "pong" });
            else if (v === "initialize-visual-tagging-selector") {
              var h = w?.data;
              Fo(Ss).then(function() {
                var g;
                a = (g = window?.amplitudeVisualTaggingSelector) === null || g === void 0 ? void 0 : g.call(window, {
                  getEventTagProps: Ro,
                  isElementSelectable: function(k) {
                    return o ? o(h?.actionType || "click", k) : !0;
                  },
                  onTrack: n.onTrack,
                  onSelect: n.onSelect,
                  visualHighlightClass: bs,
                  messenger: n,
                  cssSelectorAllowlist: u,
                  actionClickAllowlist: c
                }), n.notify({ action: "selector-loaded" });
              }).catch(function() {
                var g;
                (g = n.logger) === null || g === void 0 || g.warn("Failed to initialize visual tagging selector");
              });
            } else v === "close-visual-tagging-selector" && ((m = a?.close) === null || m === void 0 || m.call(a));
        }
      }), this.notify({ action: "page-loaded" });
    }, t;
  })()
), Uo = [
  // Already captured elsewhere in the hierarchy object
  "id",
  "class",
  // non-useful and potentially large attribute
  "style",
  // sensitive as prefilled form data may populate this attribute
  "value",
  // DOM events
  "onclick",
  "onchange",
  "oninput",
  "onblur",
  "onsubmit",
  "onfocus",
  "onkeydown",
  "onkeyup",
  "onkeypress",
  // React specific
  "data-reactid",
  "data-react-checksum",
  "data-reactroot"
], Lo = ["type"], No = ["svg", "path", "g"], Vo = ["password", "hidden"], Bo = 128, Wo = 1024;
function Ho(t) {
  var e, n, r, i, s, o;
  if (t === null)
    return null;
  var u = String(t.tagName).toLowerCase(), c = {
    tag: u
  }, a = Array.from((i = (r = t.parentElement) === null || r === void 0 ? void 0 : r.children) !== null && i !== void 0 ? i : []);
  a.length && (c.index = a.indexOf(t), c.indexOfType = a.filter(function(k) {
    return k.tagName === t.tagName;
  }).indexOf(t));
  var l = (o = (s = t.previousElementSibling) === null || s === void 0 ? void 0 : s.tagName) === null || o === void 0 ? void 0 : o.toLowerCase();
  l && (c.prevSib = String(l));
  var p = t.getAttribute("id");
  p && (c.id = String(p));
  var d = Array.from(t.classList);
  d.length && (c.classes = d);
  var f = {}, y = Array.from(t.attributes), m = y.filter(function(k) {
    return !Uo.includes(k.name);
  }), w = !dr(t);
  if (!Vo.includes(String(t.getAttribute("type"))) && !No.includes(u))
    try {
      for (var v = B(m), h = v.next(); !h.done; h = v.next()) {
        var g = h.value;
        w && !Lo.includes(g.name) || (f[g.name] = String(g.value).substring(0, Bo));
      }
    } catch (k) {
      e = { error: k };
    } finally {
      try {
        h && !h.done && (n = v.return) && n.call(v);
      } finally {
        if (e) throw e.error;
      }
    }
  return Object.keys(f).length && (c.attrs = f), c;
}
function xo(t) {
  var e = [];
  if (!t)
    return e;
  e.push(t);
  for (var n = t.parentElement; n && n.tagName !== "HTML"; )
    e.push(n), n = n.parentElement;
  return e;
}
var Qo = function(t) {
  var e = [];
  if (!t)
    return [];
  var n = xo(t);
  return e = Ko(n.map(function(r) {
    return Ho(r);
  }), Wo), e;
};
function Ko(t, e) {
  for (var n = 0, r = 0; r < t.length; r++) {
    var i = t[r];
    if (i === null)
      n += 4;
    else {
      var s = Me(i);
      n += s ? Array.from(s).length : 4;
    }
    if (n > e)
      return t.slice(0, r);
  }
  return t;
}
function Me(t, e) {
  e === void 0 && (e = !1);
  try {
    if (t == null)
      return e ? "None" : null;
    if (typeof t == "string")
      return e ? (t = t.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r"), t.includes('"') ? "'".concat(t, "'") : t.includes("'") ? '"'.concat(t.replace(/'/g, "\\'"), '"') : "'".concat(t, "'")) : t;
    if (typeof t == "boolean")
      return t ? "True" : "False";
    if (Array.isArray(t)) {
      var n = t.map(function(s) {
        return Me(s, !0);
      });
      return "[".concat(n.join(", "), "]");
    } else if (typeof t == "object") {
      var r = Object.entries(t).filter(function(s) {
        var o = O(s, 1), u = o[0];
        return u != null;
      }).map(function(s) {
        var o = O(s, 2), u = o[0], c = o[1];
        return "".concat(String(Me(u, !0)), ": ").concat(String(Me(c, !0)));
      }), i = "{".concat(r.join(", "), "}");
      return i.includes("\\'") && (i = i.replace(/'/g, "'").replace(/'/g, "\\'")), i;
    }
    return t.toString();
  } catch {
    return null;
  }
}
var Go = 5;
function qo(t) {
  var e = t.amplitude, n = t.allObservables, r = t.options, i = t.shouldTrackEvent, s = n.clickObservable, o = s.pipe(bo(), ie(function(l) {
    var p = O(l, 2), d = p[0], f = p[1], y = d.event.target !== f.event.target, m = Math.abs(f.event.screenX - d.event.screenX) <= 20 && Math.abs(f.event.screenY - d.event.screenY) <= 20;
    return y && !m;
  })), u = s.pipe(ko(r.debounceTime), X(function() {
    return "timeout";
  })), c = cr(o, u), a = s.pipe(So(0), ie(It), ie(function(l) {
    return i("click", l.closestTrackedAncestor);
  }), _o(c));
  return a.subscribe(function(l) {
    var p, d, f = (l.length >= Go, ht);
    try {
      for (var y = B(l), m = y.next(); !m.done; m = y.next()) {
        var w = m.value;
        e?.track(f, w.targetElementProperties);
      }
    } catch (v) {
      p = { error: v };
    } finally {
      try {
        m && !m.done && (d = y.return) && d.call(y);
      } finally {
        if (p) throw p.error;
      }
    }
  });
}
function zo(t) {
  var e = t.amplitude, n = t.allObservables, r = t.getEventProperties, i = t.shouldTrackEvent, s = n.changeObservable, o = s.pipe(ie(It), ie(function(u) {
    return i("change", u.closestTrackedAncestor);
  }));
  return o.subscribe(function(u) {
    e?.track(as, r("change", u.closestTrackedAncestor));
  });
}
function $o(t) {
  var e = t.amplitude, n = t.allObservables, r = t.options, i = t.getEventProperties, s = t.shouldTrackEvent, o = t.shouldTrackActionClick, u = n.clickObservable, c = n.mutationObservable, a = n.navigateObservable, l = u.pipe(ie(function(y) {
    return !s("click", y.closestTrackedAncestor);
  }), X(function(y) {
    var m = bt(y.event.target, r.actionClickAllowlist);
    return y.closestTrackedAncestor = m, y.closestTrackedAncestor !== null && (y.targetElementProperties = i(y.type, y.closestTrackedAncestor)), y;
  }), ie(It), ie(function(y) {
    return o("click", y.closestTrackedAncestor);
  })), p = [c];
  a && p.push(a);
  var d = cr.apply(void 0, H([], O(p), !1)), f = l.pipe(
    // If a mutation occurs within 0.5 seconds of a click event (timeout({ first: 500 })), it emits the original first click event.
    // take 1 to only limit the action events in case there are multiple
    Io(function(y) {
      return d.pipe(
        ur(1),
        io({ first: 500, with: function() {
          return mt;
        } }),
        // in case of timeout, map to empty to prevent any click from being emitted
        X(function() {
          return y;
        })
      );
    })
  );
  return f.subscribe(function(y) {
    e?.track(ht, i("click", y.closestTrackedAncestor));
  });
}
var de;
(function(t) {
  t.ClickObservable = "clickObservable", t.ChangeObservable = "changeObservable", t.NavigateObservable = "navigateObservable", t.MutationObservable = "mutationObservable";
})(de || (de = {}));
function jo(t) {
  return t.type === "click" || t.type === "change";
}
var Jo = function(t) {
  var e, n, r;
  t === void 0 && (t = {});
  var i = t.dataAttributePrefix, s = i === void 0 ? En : i, o = t.visualTaggingOptions, u = o === void 0 ? {
    enabled: !0,
    messenger: new Mo()
  } : o;
  t.cssSelectorAllowlist = (e = t.cssSelectorAllowlist) !== null && e !== void 0 ? e : Tn, t.actionClickAllowlist = (n = t.actionClickAllowlist) !== null && n !== void 0 ? n : Pn, t.debounceTime = (r = t.debounceTime) !== null && r !== void 0 ? r : 0;
  var c = os, a = "enrichment", l = [], p = function() {
    var v, h = ke(document, "click", { capture: !0 }).pipe(X(function(I) {
      return f(I, "click");
    }), Pe()), g = ke(document, "change", { capture: !0 }).pipe(X(function(I) {
      return f(I, "change");
    }), Pe()), k;
    window.navigation && (k = ke(window.navigation, "navigate").pipe(X(function(I) {
      return f(I, "navigate");
    }), Pe()));
    var b = new x(function(I) {
      var T = new MutationObserver(function(E) {
        I.next(E);
      });
      return T.observe(document.body, {
        childList: !0,
        attributes: !0,
        characterData: !0,
        subtree: !0
      }), function() {
        return T.disconnect();
      };
    }).pipe(X(function(I) {
      return f(I, "mutation");
    }), Pe());
    return v = {}, v[de.ClickObservable] = h, v[de.ChangeObservable] = g, // [ObservablesEnum.ErrorObservable]: errorObservable,
    v[de.NavigateObservable] = k, v[de.MutationObservable] = b, v;
  }, d = function(v, h) {
    var g, k, b, I = (b = (k = h?.tagName) === null || k === void 0 ? void 0 : k.toLowerCase) === null || b === void 0 ? void 0 : b.call(k), T = typeof h.getBoundingClientRect == "function" ? h.getBoundingClientRect() : { left: null, top: null }, E = h.getAttribute("aria-label"), P = Po(h, s), W = vr(h), N = (g = {}, g[cs] = h.getAttribute("id") || "", g[us] = h.getAttribute("class"), g[ls] = Qo(h), g[Bn] = I, g[Wn] = St(h), g[ps] = T.left == null ? null : Math.round(T.left), g[vs] = T.top == null ? null : Math.round(T.top), g[hs] = E, g[gs] = P, g[fs] = W, g[Hn] = window.location.href.split("?")[0], g[ys] = typeof document < "u" && document.title || "", g[Cs] = window.innerHeight, g[_s] = window.innerWidth, g);
    return I === "a" && v === "click" && h instanceof HTMLAnchorElement && (N[ds] = h.href), pr(N);
  }, f = function(v, h) {
    var g = {
      event: v,
      timestamp: Date.now(),
      type: h
    };
    if (jo(g) && g.event.target !== null) {
      var k = bt(g.event.target, t.cssSelectorAllowlist);
      return k && (g.closestTrackedAncestor = k, g.targetElementProperties = d(g.type, k)), g;
    }
    return g;
  }, y = function(v, h) {
    return _(void 0, void 0, void 0, function() {
      var g, k, b, I, T, E, P, W, N, K;
      return C(this, function(ee) {
        return typeof document > "u" ? [
          2
          /*return*/
        ] : (g = ct(t, t.cssSelectorAllowlist), k = ct(t, t.actionClickAllowlist), b = p(), I = qo({
          allObservables: b,
          options: t,
          amplitude: h,
          shouldTrackEvent: g
        }), l.push(I), T = zo({
          allObservables: b,
          getEventProperties: d,
          amplitude: h,
          shouldTrackEvent: g
        }), l.push(T), E = $o({
          allObservables: b,
          options: t,
          getEventProperties: d,
          amplitude: h,
          shouldTrackEvent: g,
          shouldTrackActionClick: k
        }), l.push(E), (N = v?.loggerProvider) === null || N === void 0 || N.log("".concat(c, " has been successfully added.")), window.opener && u.enabled && (P = t.cssSelectorAllowlist, W = t.actionClickAllowlist, (K = u.messenger) === null || K === void 0 || K.setup(S(S({ logger: v?.loggerProvider }, v?.serverZone && { endpoint: ws[v.serverZone] }), { isElementSelectable: ct(t, H(H([], O(P), !1), O(W), !1)), cssSelectorAllowlist: P, actionClickAllowlist: W }))), [
          2
          /*return*/
        ]);
      });
    });
  }, m = function(v) {
    return _(void 0, void 0, void 0, function() {
      return C(this, function(h) {
        return [2, v];
      });
    });
  }, w = function() {
    return _(void 0, void 0, void 0, function() {
      var v, h, g, k, b;
      return C(this, function(I) {
        try {
          for (v = B(l), h = v.next(); !h.done; h = v.next())
            g = h.value, g.unsubscribe();
        } catch (T) {
          k = { error: T };
        } finally {
          try {
            h && !h.done && (b = v.return) && b.call(v);
          } finally {
            if (k) throw k.error;
          }
        }
        return [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: c,
    type: a,
    setup: y,
    execute: m,
    teardown: w
  };
}, Yo = "utm_campaign", Xo = "utm_content", Zo = "utm_id", ea = "utm_medium", ta = "utm_source", na = "utm_term", sn = "dclid", on = "fbclid", an = "gbraid", cn = "gclid", un = "ko_click_id", ln = "li_fat_id", dn = "msclkid", pn = "rtd_cid", vn = "ttclid", hn = "twclid", gn = "wbraid", At = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  referrer: void 0,
  referring_domain: void 0,
  dclid: void 0,
  gbraid: void 0,
  gclid: void 0,
  fbclid: void 0,
  ko_click_id: void 0,
  li_fat_id: void 0,
  msclkid: void 0,
  rtd_cid: void 0,
  ttclid: void 0,
  twclid: void 0,
  wbraid: void 0
}, fn = function(t) {
  var e = t.split(".");
  return e.length <= 2 ? t : e.slice(e.length - 2, e.length).join(".");
}, ra = function(t) {
  return Object.values(t).every(function(e) {
    return !e;
  });
}, ia = function(t, e, n, r, i) {
  i === void 0 && (i = !0), t.referrer;
  var s = t.referring_domain, o = lt(t, ["referrer", "referring_domain"]), u = e || {};
  u.referrer;
  var c = u.referring_domain, a = lt(u, ["referrer", "referring_domain"]);
  if (sa(n.excludeReferrers, t.referring_domain))
    return r.debug("This is not a new campaign because ".concat(t.referring_domain, " is in the exclude referrer list.")), !1;
  if (!i && ra(t) && e)
    return r.debug("This is not a new campaign because this is a direct traffic in the same session."), !1;
  var l = JSON.stringify(o) !== JSON.stringify(a), p = fn(s || "") !== fn(c || ""), d = !e || l || p;
  return d ? r.debug("This is a new campaign. An $identify event will be sent.") : r.debug("This is not a new campaign because it's the same as the previous one."), d;
}, sa = function(t, e) {
  return t === void 0 && (t = []), e === void 0 && (e = ""), t.some(function(n) {
    return n instanceof RegExp ? n.test(e) : n === e;
  });
}, oa = function(t, e) {
  var n = S(S({}, At), t), r = Object.entries(n).reduce(function(i, s) {
    var o, u = O(s, 2), c = u[0], a = u[1];
    return i.setOnce("initial_".concat(c), (o = a ?? e.initialEmptyValue) !== null && o !== void 0 ? o : "EMPTY"), a ? i.set(c, a) : i.unset(c);
  }, new he());
  return kn(r);
}, aa = function(t) {
  var e = t;
  return e ? (e.startsWith(".") && (e = e.substring(1)), [new RegExp("".concat(e.replace(".", "\\."), "$"))]) : [];
}, ca = (
  /** @class */
  (function() {
    function t() {
    }
    return t.prototype.parse = function() {
      return _(this, void 0, void 0, function() {
        return C(this, function(e) {
          return [2, S(S(S(S({}, At), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    }, t.prototype.getUtmParam = function() {
      var e = Ue(), n = e[Yo], r = e[Xo], i = e[Zo], s = e[ea], o = e[ta], u = e[na];
      return {
        utm_campaign: n,
        utm_content: r,
        utm_id: i,
        utm_medium: s,
        utm_source: o,
        utm_term: u
      };
    }, t.prototype.getReferrer = function() {
      var e, n, r = {
        referrer: void 0,
        referring_domain: void 0
      };
      try {
        r.referrer = document.referrer || void 0, r.referring_domain = (n = (e = r.referrer) === null || e === void 0 ? void 0 : e.split("/")[2]) !== null && n !== void 0 ? n : void 0;
      } catch {
      }
      return r;
    }, t.prototype.getClickIds = function() {
      var e, n = Ue();
      return e = {}, e[sn] = n[sn], e[on] = n[on], e[an] = n[an], e[cn] = n[cn], e[un] = n[un], e[ln] = n[ln], e[dn] = n[dn], e[pn] = n[pn], e[vn] = n[vn], e[hn] = n[hn], e[gn] = n[gn], e;
    }, t;
  })()
), ua = (
  /** @class */
  (function() {
    function t(e, n) {
      var r;
      this.shouldTrackNewCampaign = !1, this.options = S({ initialEmptyValue: "EMPTY", resetSessionOnNewCampaign: !1, excludeReferrers: aa((r = n.cookieOptions) === null || r === void 0 ? void 0 : r.domain) }, e), this.storage = n.cookieStorage, this.storageKey = ii(n.apiKey, "MKTG"), this.currentCampaign = At, this.sessionTimeout = n.sessionTimeout, this.lastEventTime = n.lastEventTime, this.logger = n.loggerProvider, n.loggerProvider.log("Installing web attribution tracking.");
    }
    return t.prototype.init = function() {
      return _(this, void 0, void 0, function() {
        var e, n;
        return C(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.fetchCampaign()];
            case 1:
              return n = O.apply(void 0, [r.sent(), 2]), this.currentCampaign = n[0], this.previousCampaign = n[1], e = this.lastEventTime ? bn(this.sessionTimeout, this.lastEventTime) : !0, ia(this.currentCampaign, this.previousCampaign, this.options, this.logger, e) ? (this.shouldTrackNewCampaign = !0, [4, this.storage.set(this.storageKey, this.currentCampaign)]) : [3, 3];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.fetchCampaign = function() {
      return _(this, void 0, void 0, function() {
        return C(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, Promise.all([new ca().parse(), this.storage.get(this.storageKey)])];
            case 1:
              return [2, e.sent()];
          }
        });
      });
    }, t.prototype.generateCampaignEvent = function(e) {
      this.shouldTrackNewCampaign = !1;
      var n = oa(this.currentCampaign, this.options);
      return e && (n.event_id = e), n;
    }, t.prototype.shouldSetSessionIdOnNewCampaign = function() {
      return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
    }, t;
  })()
), la = (
  /** @class */
  (function(t) {
    Q(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.init = function(n, r, i) {
      n === void 0 && (n = "");
      var s, o;
      return arguments.length > 2 ? (s = r, o = i) : typeof r == "string" ? (s = r, o = void 0) : (s = r?.userId, o = r), G(this._init(S(S({}, o), { userId: s, apiKey: n })));
    }, e.prototype._init = function(n) {
      var r, i, s;
      return _(this, void 0, void 0, function() {
        var o, u, c, a, l, p, d = this;
        return C(this, function(f) {
          switch (f.label) {
            case 0:
              return this.initializing ? [
                2
                /*return*/
              ] : (this.initializing = !0, [4, Pi(n.apiKey, n, this)]);
            case 1:
              return o = f.sent(), n.fetchRemoteConfig ? [4, ss(o)] : [3, 4];
            case 2:
              return u = f.sent(), [4, u.generateJoinedConfig()];
            case 3:
              o = f.sent(), f.label = 4;
            case 4:
              return [4, t.prototype._init.call(this, o)];
            case 5:
              return f.sent(), this.logBrowserOptions(o), On(this.config.defaultTracking) ? (c = li(this.config), this.webAttribution = new ua(c, this.config), [4, this.webAttribution.init()]) : [3, 7];
            case 6:
              f.sent(), f.label = 7;
            case 7:
              return a = Ue(), l = Number.isNaN(Number(a.ampSessionId)) ? void 0 : Number(a.ampSessionId), this.setSessionId((s = (i = (r = n.sessionId) !== null && r !== void 0 ? r : l) !== null && i !== void 0 ? i : this.config.sessionId) !== null && s !== void 0 ? s : Date.now()), p = me(n.instanceName), p.identityStore.setIdentity({
                userId: this.config.userId,
                deviceId: this.config.deviceId
              }), this.config.offline === An ? [3, 9] : [4, this.add($i()).promise];
            case 8:
              f.sent(), f.label = 9;
            case 9:
              return [4, this.add(new Wr()).promise];
            case 10:
              return f.sent(), [4, this.add(new hi()).promise];
            case 11:
              return f.sent(), [4, this.add(new Yr()).promise];
            case 12:
              return f.sent(), zi(this.config), oi(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding file download tracking plugin"), [4, this.add(qi()).promise]) : [3, 14];
            case 13:
              f.sent(), f.label = 14;
            case 14:
              return ai(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding form interaction plugin"), [4, this.add(Gi()).promise]) : [3, 16];
            case 15:
              f.sent(), f.label = 16;
            case 16:
              return Rn(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding page view tracking plugin"), [4, this.add(Hi(ui(this.config))).promise]) : [3, 18];
            case 17:
              f.sent(), f.label = 18;
            case 18:
              return Fn(this.config.autocapture) ? (this.config.loggerProvider.debug("Adding user interactions plugin (autocapture plugin)"), [4, this.add(Jo(ci(this.config))).promise]) : [3, 20];
            case 19:
              f.sent(), f.label = 20;
            case 20:
              return this.initializing = !1, [4, this.runQueuedFunctions("dispatchQ")];
            case 21:
              return f.sent(), p.eventBridge.setEventReceiver(function(y) {
                d.track(y.eventType, y.eventProperties);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getUserId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.userId;
    }, e.prototype.setUserId = function(n) {
      if (!this.config) {
        this.q.push(this.setUserId.bind(this, n));
        return;
      }
      this.config.loggerProvider.debug("function setUserId: ", n), (n !== this.config.userId || n === void 0) && (this.config.userId = n, jr(n, this.config.instanceName));
    }, e.prototype.getDeviceId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.deviceId;
    }, e.prototype.setDeviceId = function(n) {
      if (!this.config) {
        this.q.push(this.setDeviceId.bind(this, n));
        return;
      }
      this.config.loggerProvider.debug("function setDeviceId: ", n), this.config.deviceId = n, Jr(n, this.config.instanceName);
    }, e.prototype.reset = function() {
      this.setDeviceId(ge()), this.setUserId(void 0);
    }, e.prototype.getSessionId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.sessionId;
    }, e.prototype.setSessionId = function(n) {
      var r, i = [];
      if (!this.config)
        return this.q.push(this.setSessionId.bind(this, n)), G(Promise.resolve());
      if (n === this.config.sessionId)
        return G(Promise.resolve());
      this.config.loggerProvider.debug("function setSessionId: ", n);
      var s = this.getSessionId(), o = this.config.lastEventTime, u = (r = this.config.lastEventId) !== null && r !== void 0 ? r : -1;
      this.config.sessionId = n, this.config.lastEventTime = void 0, this.config.pageCounter = 0, Pt(this.config.defaultTracking) && (s && o && i.push(this.track(Ft, void 0, {
        device_id: this.previousSessionDeviceId,
        event_id: ++u,
        session_id: s,
        time: o + 1,
        user_id: this.previousSessionUserId
      }).promise), this.config.lastEventTime = this.config.sessionId);
      var c = this.trackCampaignEventIfNeeded(++u, i);
      return Pt(this.config.defaultTracking) && i.push(this.track(Rt, void 0, {
        event_id: c ? ++u : u,
        session_id: this.config.sessionId,
        time: this.config.lastEventTime
      }).promise), this.previousSessionDeviceId = this.config.deviceId, this.previousSessionUserId = this.config.userId, G(Promise.all(i));
    }, e.prototype.extendSession = function() {
      if (!this.config) {
        this.q.push(this.extendSession.bind(this));
        return;
      }
      this.config.lastEventTime = Date.now();
    }, e.prototype.setTransport = function(n) {
      if (!this.config) {
        this.q.push(this.setTransport.bind(this, n));
        return;
      }
      this.config.transportProvider = Ln(n);
    }, e.prototype.identify = function(n, r) {
      if (tt(n)) {
        var i = n._q;
        n._q = [], n = et(new he(), i);
      }
      return r?.user_id && this.setUserId(r.user_id), r?.device_id && this.setDeviceId(r.device_id), t.prototype.identify.call(this, n, r);
    }, e.prototype.groupIdentify = function(n, r, i, s) {
      if (tt(i)) {
        var o = i._q;
        i._q = [], i = et(new he(), o);
      }
      return t.prototype.groupIdentify.call(this, n, r, i, s);
    }, e.prototype.revenue = function(n, r) {
      if (tt(n)) {
        var i = n._q;
        n._q = [], n = et(new Ur(), i);
      }
      return t.prototype.revenue.call(this, n, r);
    }, e.prototype.trackCampaignEventIfNeeded = function(n, r) {
      if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign)
        return !1;
      var i = this.webAttribution.generateCampaignEvent(n);
      return r ? r.push(this.track(i).promise) : this.track(i), this.config.loggerProvider.log("Tracking attribution."), !0;
    }, e.prototype.process = function(n) {
      return _(this, void 0, void 0, function() {
        var r, i, s;
        return C(this, function(o) {
          return r = Date.now(), i = bn(this.config.sessionTimeout, this.config.lastEventTime), s = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign(), n.event_type !== Rt && n.event_type !== Ft && (!n.session_id || n.session_id === this.getSessionId()) && (i || s ? (this.setSessionId(r), s && this.config.loggerProvider.log("Created a new session for new campaign.")) : i || this.trackCampaignEventIfNeeded()), [2, t.prototype.process.call(this, n)];
        });
      });
    }, e.prototype.logBrowserOptions = function(n) {
      try {
        var r = S(S({}, n), { apiKey: n.apiKey.substring(0, 10) + "********" });
        this.config.loggerProvider.debug("Initialized Amplitude with BrowserConfig:", JSON.stringify(r));
      } catch (i) {
        this.config.loggerProvider.error("Error logging browser config", i);
      }
    }, e;
  })(Mr)
), hr = function() {
  var t = new la();
  return {
    init: M(t.init.bind(t), "init", F(t), D(t, ["config"])),
    add: M(t.add.bind(t), "add", F(t), D(t, ["config.apiKey", "timeline.plugins"])),
    remove: M(t.remove.bind(t), "remove", F(t), D(t, ["config.apiKey", "timeline.plugins"])),
    track: M(t.track.bind(t), "track", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    logEvent: M(t.logEvent.bind(t), "logEvent", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    identify: M(t.identify.bind(t), "identify", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    groupIdentify: M(t.groupIdentify.bind(t), "groupIdentify", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    setGroup: M(t.setGroup.bind(t), "setGroup", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    revenue: M(t.revenue.bind(t), "revenue", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    flush: M(t.flush.bind(t), "flush", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    getUserId: M(t.getUserId.bind(t), "getUserId", F(t), D(t, ["config", "config.userId"])),
    setUserId: M(t.setUserId.bind(t), "setUserId", F(t), D(t, ["config", "config.userId"])),
    getDeviceId: M(t.getDeviceId.bind(t), "getDeviceId", F(t), D(t, ["config", "config.deviceId"])),
    setDeviceId: M(t.setDeviceId.bind(t), "setDeviceId", F(t), D(t, ["config", "config.deviceId"])),
    reset: M(t.reset.bind(t), "reset", F(t), D(t, ["config", "config.userId", "config.deviceId"])),
    getSessionId: M(t.getSessionId.bind(t), "getSessionId", F(t), D(t, ["config"])),
    setSessionId: M(t.setSessionId.bind(t), "setSessionId", F(t), D(t, ["config"])),
    extendSession: M(t.extendSession.bind(t), "extendSession", F(t), D(t, ["config"])),
    setOptOut: M(t.setOptOut.bind(t), "setOptOut", F(t), D(t, ["config"])),
    setTransport: M(t.setTransport.bind(t), "setTransport", F(t), D(t, ["config"]))
  };
};
const L = hr();
L.add;
L.extendSession;
L.flush;
L.getDeviceId;
L.getSessionId;
L.getUserId;
L.groupIdentify;
L.identify;
L.init;
L.logEvent;
L.remove;
L.reset;
L.revenue;
L.setDeviceId;
L.setGroup;
L.setOptOut;
L.setSessionId;
L.setTransport;
L.setUserId;
L.track;
var ft;
(function(t) {
  t.IdentifyOperation = pt, t.SpecialEventType = ce, t.RevenueProperty = J, t.LogLevel = q, t.OfflineDisabled = An, t.DEFAULT_CSS_SELECTOR_ALLOWLIST = Tn, t.DEFAULT_DATA_ATTRIBUTE_PREFIX = En, t.DEFAULT_ACTION_CLICK_ALLOWLIST = Pn;
})(ft || (ft = {}));
const da = {
  prod: "9697cc8538da787c61338c2f38936f4e",
  stag: "44832403362971771e3b4df598b6c3f2"
}, pa = {
  plan: {
    version: "119",
    branch: "main",
    source: "agent-interface",
    versionId: "5023a6a7-1329-4893-a693-bfd1136d33a8"
  },
  ingestionMetadata: {
    sourceName: "browser-typescript-ampli",
    sourceVersion: "2.0.0"
  }
};
class Jw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = ft.SpecialEventType.IDENTIFY;
}
class va {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Add Agents Modal Form Submitted";
}
class ha {
  event_type = "Agent Copilot Back Button Clicked";
}
class ga {
  event_type = "Agent Copilot Conversation Custom Attribute Suggestion Accepted";
}
class fa {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Agent Copilot Conversation Tag Suggestion Accepted";
}
class ya {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Agent Copilot Dropdown Item Clicked";
}
class Ca {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Agent Copilot Improve Writing Improvement Clicked";
}
class _a {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Agent Copilot Text Insert Below Clicked";
}
class ka {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Agent Copilot Text Replace Clicked";
}
class ma {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Agent Copilot Translate Message Language Selected";
}
class wa {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Agent Copilot Trial Learn More Clicked";
}
class Sa {
  event_type = "Agent Copilot Trial Leftmenu CTA Clicked";
}
class ba {
  event_type = "Agent Copilot Trial Leftmenu CTA Dismissed";
}
class Ia {
  event_type = "Agent Copilot Trial Request Contact Clicked";
}
class Aa {
  event_type = "Agent Copilot Trial Started";
}
class Ta {
  event_type = "Agent Copilot Trial Stopped";
}
class Ea {
  event_type = "Agent Copilot Undo Clicked";
}
class Pa {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Agent Custom Away Status Updated";
}
class Oa {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Business Hours Schedule Removed";
}
class Ra {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Business Hours Schedule Updated";
}
class Fa {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Chart Format Changed";
}
class Da {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Chart Granularity Changed";
}
class Ma {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Chart Visualization Changed";
}
class Ua {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Compare Clicked";
}
class La {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Compare Context Updated";
}
class Na {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Compare Period Updated";
}
class Va {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Context Updated";
}
class Ba {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Conversation Link Clicked";
}
class Wa {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Conversation Preview Clicked";
}
class Ha {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Dashboard Viewed";
}
class xa {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Export Clicked";
}
class Qa {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Export Download Clicked";
}
class Ka {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Export My Data Button Pressed";
}
class Ga {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Filter Cleared";
}
class qa {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Filter Opened";
}
class za {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Filter Operator Updated";
}
class $a {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Filter Value Added";
}
class ja {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Filters Applied";
}
class Ja {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Filters Cleared";
}
class Ya {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Helper Clicked";
}
class Xa {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics In Depth Clicked";
}
class Za {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Insights Copy Clicked";
}
class ec {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Insights Feedback Clicked";
}
class tc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Insights Prompt Clicked";
}
class nc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Insights Regenerate Clicked";
}
class rc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Panel Controls Opened";
}
class ic {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Period Updated";
}
class sc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Pin Panel Clicked";
}
class oc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Pin Panel Quick View Created";
}
class ac {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Auto Refresh Disabled";
}
class cc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Auto Refresh Enabled";
}
class uc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Auto Refresh Triggered";
}
class lc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Created";
}
class dc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Deleted";
}
class pc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Duplicated";
}
class vc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Favorite Toggled";
}
class hc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Landing Page Set";
}
class gc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Landing Page Unset";
}
class fc {
  event_type = "Analytics Quick View Ownership Transferred";
}
class yc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Panel Controls Updated";
}
class Cc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Panel Description Updated";
}
class _c {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Panel Pinned";
}
class kc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Panel Unpinned";
}
class mc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Panels Layout Changed";
}
class wc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Panels Reset";
}
class Sc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Panels Updated";
}
class bc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Sharing Toggled";
}
class Ic {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Updated";
}
class Ac {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Quick View Viewed";
}
class Tc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Refresh Clicked";
}
class Ec {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Table Load All Clicked";
}
class Pc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Table Sort Updated";
}
class Oc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics Timezone Updated";
}
class Rc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Analytics View Conversations Clicked";
}
class Fc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Auth Failed Init";
}
class Dc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Automations Form Cancelled";
}
class Mc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Automations Form Opened";
}
class Uc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Automations Form Submitted";
}
class Lc {
  event_type = "Automations Options Menu Opened";
}
class Nc {
  event_type = "Automations Options Menu Option Delete Clicked";
}
class Vc {
  event_type = "Automations Options Menu Option Duplicate Clicked";
}
class Bc {
  event_type = "Automations Options Menu Option Flow Clicked";
}
class Wc {
  event_type = "Automations Options Menu Option Settings Clicked";
}
class Hc {
  event_type = "Automations Pagination Next Clicked";
}
class xc {
  event_type = "Automations Pagination Previous Clicked";
}
class Qc {
  event_type = "Automations Search Applied";
}
class Kc {
  event_type = "Automations Search Closed";
}
class Gc {
  event_type = "Automations Search Opened";
}
class qc {
  event_type = "Automations Toggled Off";
}
class zc {
  event_type = "Automations Toggled On";
}
class $c {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Bans Ban User Clicked";
}
class jc {
  event_type = "Bans Unban Ip Clicked";
}
class Jc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Bans Unban User Clicked";
}
class Yc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Bulk Actions Update Clicked";
}
class Xc {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Add Schedule Audio Message Added";
}
class Zc {
  event_type = "Business Hours Add Schedule Button Clicked";
}
class eu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Add Schedule Form Cancelled";
}
class tu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Add Schedule Form Submitted";
}
class nu {
  event_type = "Business Hours Conflict Notification Button Clicked";
}
class ru {
  event_type = "Business Hours Conflict Notification Closed";
}
class iu {
  event_type = "Business Hours Delete Schedule Form Cancelled";
}
class su {
  event_type = "Business Hours Delete Schedule Form Submitted";
}
class ou {
  event_type = "Business Hours Duplicate Schedule Form Cancelled";
}
class au {
  event_type = "Business Hours Duplicate Schedule Form Submitted";
}
class cu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours First Schedule Modal Question Clicked";
}
class uu {
  event_type = "Business Hours First Schedule Support Article Clicked";
}
class lu {
  event_type = "Business Hours Go To Flow Clicked";
}
class du {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Migration Wizard Audio Message Added";
}
class pu {
  event_type = "Business Hours Migration Wizard Create New Schedule Button Clicked";
}
class vu {
  event_type = "Business Hours Migration Wizard Edit Hours Button Clicked";
}
class hu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Migration Wizard Form Cancelled";
}
class gu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Migration Wizard Form Submitted";
}
class fu {
  event_type = "Business Hours Migration Wizard Opening Hours Form Cancelled";
}
class yu {
  event_type = "Business Hours Migration Wizard Opening Hours Form Submitted";
}
class Cu {
  event_type = "Business Hours Migration Wizard Start Update Button Clicked";
}
class _u {
  event_type = "Business Hours Options Menu Opened";
}
class ku {
  event_type = "Business Hours Options Menu Option Delete Clicked";
}
class mu {
  event_type = "Business Hours Options Menu Option Duplicate Clicked";
}
class wu {
  event_type = "Business Hours Options Menu Option Edit Clicked";
}
class Su {
  event_type = "Business Hours Options Menu Option Rename Clicked";
}
class bu {
  event_type = "Business Hours Rename Schedule Form Cancelled";
}
class Iu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Rename Schedule Form Submitted";
}
class Au {
  event_type = "Business Hours Schedule Add Exception Button Clicked";
}
class Tu {
  event_type = "Business Hours Schedule Add Exception Form Cancelled";
}
class Eu {
  event_type = "Business Hours Schedule Add Exception Form Submitted";
}
class Pu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Audio Message Form Cancelled";
}
class Ou {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Audio Message Form Submitted";
}
class Ru {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Audio Message Options Menu Opened";
}
class Fu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Audio Message Options Menu Option Clear Clicked";
}
class Du {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Audio Message Options Menu Option Record Clicked";
}
class Mu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Audio Message Options Menu Option Upload Clicked";
}
class Uu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Auto Reply Options Menu Option Clear Clicked";
}
class Lu {
  event_type = "Business Hours Schedule Conflict Change Button Clicked";
}
class Nu {
  event_type = "Business Hours Schedule Conflict Review Button Clicked";
}
class Vu {
  event_type = "Business Hours Schedule Delete Exception Form Cancelled";
}
class Bu {
  event_type = "Business Hours Schedule Delete Exception Form Submitted";
}
class Wu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Exception Options Menu Option Delete Clicked";
}
class Hu {
  event_type = "Business Hours Schedule Import Holiday Form Cancelled";
}
class xu {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Import Holiday Form Submitted";
}
class Qu {
  event_type = "Business Hours Schedule Options Menu Import Holidays Clicked";
}
class Ku {
  event_type = "Business Hours Schedule Options Menu Opened";
}
class Gu {
  event_type = "Business Hours Schedule Options Menu Recover Holidays Clicked";
}
class qu {
  event_type = "Business Hours Schedule Options Menu Rename Clicked";
}
class zu {
  event_type = "Business Hours Schedule Options Menu Timezone Clicked";
}
class $u {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Preview Button Clicked";
}
class ju {
  event_type = "Business Hours Schedule Recover Holidays Form Cancelled";
}
class Ju {
  event_type = "Business Hours Schedule Recover Holidays Form Submitted";
}
class Yu {
  event_type = "Business Hours Schedule Review Form Cancelled";
}
class Xu {
  event_type = "Business Hours Schedule Review Form Submitted";
}
class Zu {
  event_type = "Business Hours Schedule Save Schedule Button Clicked";
}
class el {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule Tab Clicked";
}
class tl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Business Hours Schedule View Clicked";
}
class nl {
  event_type = "Chat Flow Options Menu Option Audit Log Clicked";
}
class rl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Chat Form Canceled";
}
class il {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Chat Form Opened";
}
class sl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Chat Form Submitted";
}
class ol {
  event_type = "Chat Options Menu Opened";
}
class al {
  event_type = "Chat Options Menu Option Delete Clicked";
}
class cl {
  event_type = "Chat Options Menu Option Duplicate Clicked";
}
class ul {
  event_type = "Chat Options Menu Option Flow Clicked";
}
class ll {
  event_type = "Chat Options Menu Option Rename Clicked";
}
class dl {
  event_type = "Chat Options Menu Option Setup Clicked";
}
class pl {
  event_type = "Chat Pagination Next Clicked";
}
class vl {
  event_type = "Chat Pagination Previous Clicked";
}
class hl {
  event_type = "Chat Search Applied";
}
class gl {
  event_type = "Chat Search Closed";
}
class fl {
  event_type = "Chat Search Opened";
}
class yl {
  event_type = "Chatbot Create Modal Opened";
}
class Cl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Chatbot Created";
}
class _l {
  event_type = "Chatbot Delete Modal Opened";
}
class kl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Chatbot Deleted";
}
class ml {
  event_type = "Chatbot Edit Identity Modal Opened";
}
class wl {
  event_type = "Chatbot Identity Edited";
}
class Sl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Color Mode Updated";
}
class bl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Command Executed";
}
class Il {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Command Palette Action Selected";
}
class Al {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Command Palette Closed";
}
class Tl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Command Palette Opened";
}
class El {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Company Modal Form Submitted";
}
class Pl {
  event_type = "Contacts Add New Company Clicked";
}
class Ol {
  event_type = "Contacts Add New Contact Clicked";
}
class Rl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Contacts Ban User Clicked";
}
class Fl {
  event_type = "Contacts Card Actions Menu Opened";
}
class Dl {
  event_type = "Contacts Card Compose New Email Clicked";
}
class Ml {
  event_type = "Contacts Card Edit Company Clicked";
}
class Ul {
  event_type = "Contacts Card Edit Contact Clicked";
}
class Ll {
  event_type = "Contacts Card Make Call Clicked";
}
class Nl {
  event_type = "Contacts Card See All Assigned Conversations Clicked";
}
class Vl {
  event_type = "Contacts Card See All Conversations Clicked";
}
class Bl {
  event_type = "Contacts Card View Company Clicked";
}
class Wl {
  event_type = "Contacts Card View User Clicked";
}
class Hl {
  event_type = "Contacts Search Blurred";
}
class xl {
  event_type = "Contacts Search Focused";
}
class Ql {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Contacts Unban User Clicked";
}
class Kl {
  event_type = "Contacts View Companies";
}
class Gl {
  event_type = "Contacts View End Users";
}
class ql {
  event_type = "Conversation Actions Menu Opened";
}
class zl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Actions Menu Option Clicked";
}
class $l {
  event_type = "Conversation Activity Log Closed";
}
class jl {
  event_type = "Conversation Activity Log Flooter Expanded";
}
class Jl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Activity Log Opened";
}
class Yl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Article Draft Improvement Requested";
}
class Xl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Article Draft Improvement Response Received";
}
class Zl {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Article Draft Preview Requested";
}
class ed {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Article Draft Preview Response Received";
}
class td {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Article Draft Save Requested";
}
class nd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Article Draft Save Response Received";
}
class rd {
  event_type = "Conversation Attached Image Is Downloaded";
}
class id {
  event_type = "Conversation Attached Image Is Viewed";
}
class sd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Claimed";
}
class od {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Closed";
}
class ad {
  event_type = "Conversation Csat Cancelled";
}
class cd {
  event_type = "Conversation Csat Menu Cancel Option Clicked";
}
class ud {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Csat Menu Language Selected";
}
class ld {
  event_type = "Conversation Csat Menu Opened";
}
class dd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Focus Mode Toggled";
}
class pd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Follow Up";
}
class vd {
  event_type = "Conversation Follow Up Menu Opened";
}
class hd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Follow Up Menu Option Clicked";
}
class gd {
  event_type = "Conversation Header Conversation Details Menu Opened";
}
class fd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Header Tag Added";
}
class yd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Header Tag Include Deactivated Toggled";
}
class Cd {
  event_type = "Conversation Header Tag Menu Opened";
}
class _d {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Header Tag Removed";
}
class kd {
  event_type = "Conversation Header Transfer To Agent Item Selected";
}
class md {
  event_type = "Conversation Header Transfer To Agent Menu Opened";
}
class wd {
  event_type = "Conversation Header Transfer To Number Button Clicked";
}
class Sd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Header Transfer To Queue Item Selected";
}
class bd {
  event_type = "Conversation Header Transfer To Queue Menu Opened";
}
class Id {
  event_type = "Conversation Internal Note Editor Opened";
}
class Ad {
  event_type = "Conversation Message Redaction Modal Opened";
}
class Td {
  event_type = "Conversation Message Redaction Modal Submitted";
}
class Ed {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Offered";
}
class Pd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Replied";
}
class Od {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Reply Window Toggled";
}
class Rd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Resolved As A Knowledge Article Draft";
}
class Fd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Resolved As A Knowledge Gap";
}
class Dd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Resolved By Knowledge";
}
class Md {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Resolved With No Knowledge Article";
}
class Ud {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Right Sidebar Item Reordered";
}
class Ld {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Right Sidebar Item Visibility Toggled";
}
class Nd {
  event_type = "Conversation Sidebar Closed";
}
class Vd {
  event_type = "Conversation Sidebar Conversation History Closed";
}
class Bd {
  event_type = "Conversation Sidebar Conversation History Navigated To Conversation";
}
class Wd {
  event_type = "Conversation Sidebar Conversation History Opened";
}
class Hd {
  event_type = "Conversation Sidebar Customer Info Email Clicked";
}
class xd {
  event_type = "Conversation Sidebar Customer Info Phone Number Clicked";
}
class Qd {
  event_type = "Conversation Sidebar Opened";
}
class Kd {
  event_type = "Conversation Timeline Item Opened";
}
class Gd {
  event_type = "Conversation Timeline Navigated To Conversation";
}
class qd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversation Transferred";
}
class zd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversations Bulk Actions Clicked";
}
class $d {
  event_type = "Conversations Clear All Clicked";
}
class jd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversations Filter Agent Clicked";
}
class Jd {
  event_type = "Conversations Filter Clear All Clicked";
}
class Yd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversations Filter Cleared";
}
class Xd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversations Filter Contact Clicked";
}
class Zd {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversations Filter Toggled";
}
class ep {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversations Go To Conversation Clicked";
}
class tp {
  event_type = "Conversations Item Preview Clicked";
}
class np {
  event_type = "Conversations Next Page Clicked";
}
class rp {
  event_type = "Conversations Previous Page Clicked";
}
class ip {
  event_type = "Conversations Select All Clicked";
}
class sp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversations Select Clicked";
}
class op {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Conversations Timestamp Clicked";
}
class ap {
  event_type = "Conversations Transfer To Queue Clicked";
}
class cp {
  event_type = "Conversations View Agent Clicked";
}
class up {
  event_type = "Conversations View Contact Clicked";
}
class lp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "ConversationSummaryFeedbackNotUseful";
}
class dp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "ConversationSummaryFeedbackUseful";
}
class pp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "ConversationSummaryRegenerateSummary";
}
class vp {
  event_type = "Copy Script";
}
class hp {
  event_type = "Country Code Selected";
}
class gp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Custom Attribute Value Updated";
}
class fp {
  event_type = "Dashboard Channel All Conversations Clicked";
}
class yp {
  event_type = "Dashboard Channel Go To Analytics Clicked";
}
class Cp {
  event_type = "Dashboard Channel Longest Queued Time Metric Clicked";
}
class _p {
  event_type = "Dashboard Channel Name Clicked";
}
class kp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Channel Pending Conversations Metric Clicked";
}
class mp {
  event_type = "Dashboard Channel Tv Dashboard Clicked";
}
class wp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Favorite Created";
}
class Sp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Favorite Deleted";
}
class bp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Favorite Landing Page Set";
}
class Ip {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Favorite Landing Page Unset";
}
class Ap {
  event_type = "Dashboard Favorite Ownership Transferred";
}
class Tp {
  event_type = "Dashboard Favorite Queues Reordered";
}
class Ep {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Favorite Sharing Toggled";
}
class Pp {
  event_type = "Dashboard Favorite Tv Dashboard Clicked";
}
class Op {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Favorite Updated";
}
class Rp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Favorite Viewed";
}
class Fp {
  event_type = "Dashboard Global Tv Dashboard Clicked";
}
class Dp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Layout Changed";
}
class Mp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Longest Queued Time Metric Clicked";
}
class Up {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Metric Helper Clicked";
}
class Lp {
  event_type = "Dashboard Next Page Clicked";
}
class Np {
  event_type = "Dashboard Organization Timezone Settings Clicked";
}
class Vp {
  event_type = "Dashboard Previous Page Clicked";
}
class Bp {
  event_type = "Dashboard Queue All Conversations Clicked";
}
class Wp {
  event_type = "Dashboard Queue Go To Analytics Clicked";
}
class Hp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Queue Item Favorite Toggled";
}
class xp {
  event_type = "Dashboard Queue Name Clicked";
}
class Qp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Queue Pending Conversations Metric Clicked";
}
class Kp {
  event_type = "Dashboard Queue Settings Clicked";
}
class Gp {
  event_type = "Dashboard Queue Tv Dashboard Clicked";
}
class qp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Queues Manually Selected";
}
class zp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Queues Search Field Cleared";
}
class $p {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Queues Search Field Submitted";
}
class jp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Queues Sorting Updated";
}
class Jp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Queues Type Changed";
}
class Yp {
  event_type = "Dashboard Refresh Data Clicked";
}
class Xp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Tv Reloaded";
}
class Zp {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Dashboard Viewed";
}
class ev {
  event_type = "Email Flow Options Menu Option Audit Log Clicked";
}
class tv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Email Form Submitted";
}
class nv {
  event_type = "Email Options Menu Opened";
}
class rv {
  event_type = "Email Options Menu Option Delete Clicked";
}
class iv {
  event_type = "Email Options Menu Option Duplicate Clicked";
}
class sv {
  event_type = "Email Options Menu Option Email Clicked";
}
class ov {
  event_type = "Email Options Menu Option Flow Clicked";
}
class av {
  event_type = "Email Options Menu Option Rename Clicked";
}
class cv {
  event_type = "Email Search Applied";
}
class uv {
  event_type = "Email Search Closed";
}
class lv {
  event_type = "Email Search Opened";
}
class dv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Action Add Saved";
}
class pv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Action Condition Added";
}
class vv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Action Condition Removed";
}
class hv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Action Deleted";
}
class gv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Action Edit Clicked";
}
class fv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Action Edit Saved";
}
class yv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Activate Clicked";
}
class Cv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Add Action Action Selected";
}
class _v {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Add Action Cancelled";
}
class kv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Add Action Opened";
}
class mv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Back To Settings Clicked";
}
class wv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Context Align Clicked";
}
class Sv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Context Delete Cancel Clicked";
}
class bv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Context Delete Clicked";
}
class Iv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Context Delete Confirm Clicked";
}
class Av {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Context Node Arrange Clicked";
}
class Tv {
  event_type = "Flow Phone Number Changed";
}
class Ev {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Save Clicked";
}
class Pv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Title Edit Clicked";
}
class Ov {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Zoom In Clicked";
}
class Rv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Zoom Out Clicked";
}
class Fv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Flow Zoom Reset Clicked";
}
class Dv {
  event_type = "Follow Up Conversation Modal Internal Note Added";
}
class Mv {
  event_type = "Follow Up Conversation Modal Offer In Queue Added";
}
class Uv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Intelligence Dashboard Viewed";
}
class Lv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Intelligence Distribution Chart Opened";
}
class Nv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Intelligence Evolution Chart Opened";
}
class Vv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Intelligence Filter Changed";
}
class Bv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Intelligence Filter Period Changed";
}
class Wv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Intelligence Group By Changed";
}
class Hv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Intelligence Preset Comparison Started";
}
class xv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Intelligence Table Customized";
}
class Qv {
  event_type = "Intent Detection Created";
}
class Kv {
  event_type = "Intent Detection Deleted";
}
class Gv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Intent Detection Flow Node Saved";
}
class qv {
  event_type = "Intent Detection Updated";
}
class zv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Archived";
}
class $v {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Changes Discarded";
}
class jv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Created";
}
class Jv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Destroyed";
}
class Yv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Feedback Submitted";
}
class Xv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Marked As Helpful";
}
class Zv {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Moved";
}
class eh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Published";
}
class th {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Reordered";
}
class nh {
  event_type = "Knowledge Article Restored";
}
class rh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Tag Added";
}
class ih {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Tag Removed";
}
class sh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Unpublished";
}
class oh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Updated";
}
class ah {
  event_type = "Knowledge Article Version History Clicked";
}
class ch {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Article Viewed";
}
class uh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Articles Search By Term Submitted";
}
class lh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Category Created";
}
class dh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Category Destroyed";
}
class ph {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Category Reordered";
}
class vh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Category Updated";
}
class hh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Collection Created";
}
class gh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Collection Destroyed";
}
class fh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Collection Updated";
}
class yh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Collection Viewed";
}
class Ch {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Help Center Created";
}
class _h {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Help Center Deleted";
}
class kh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Help Center Updated";
}
class mh {
  event_type = "Knowledge Internal Kb Dashboard Viewed";
}
class wh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Internal Kb Search Result Clicked";
}
class Sh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Resolution Cancelled";
}
class bh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Resolution Initialised";
}
class Ih {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Retranslate Article Block Clicked";
}
class Ah {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Retranslate Article Title Clicked";
}
class Th {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Knowledge Translate Article Clicked";
}
class Eh {
  event_type = "Link Conversations Modal Opened";
}
class Ph {
  event_type = "Link Conversations Submitted";
}
class Oh {
  event_type = "Mention User Notification Clicked";
}
class Rh {
  event_type = "Mention User Selected";
}
class Fh {
  event_type = "Merge Contacts Merge Cancelled";
}
class Dh {
  event_type = "Merge Contacts Merge Failed";
}
class Mh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Merge Contacts Merge Succeeded";
}
class Uh {
  event_type = "Merge Contacts Modal Closed";
}
class Lh {
  event_type = "Merge Contacts Modal Opened";
}
class Nh {
  event_type = "Merge Contacts Source Contact Selected";
}
class Vh {
  event_type = "Messenger Flow Options Menu Option Audit Log Clicked";
}
class Bh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Messenger Form Cancelled";
}
class Wh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Messenger Form Opened";
}
class Hh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Messenger Form Submitted";
}
class xh {
  event_type = "Messenger Options Menu Opened";
}
class Qh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Messenger Options Menu Option Clicked";
}
class Kh {
  event_type = "Modal Conversation Close Cancel Clicked";
}
class Gh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Modal Conversation Close Confirm Clicked";
}
class qh {
  event_type = "Modal Transfer To Queue Cancel Clicked";
}
class zh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Modal Transfer To Queue Confirm Clicked";
}
class $h {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Network Connection Status Changed";
}
class jh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Notification Offer Accepted";
}
class Jh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Notification Offer Closed";
}
class Yh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Notification Offer Rejected";
}
class Xh {
  event_type = "Notification Offer Timeout";
}
class Zh {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Notification Transfer Offer Accepted";
}
class eg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Notification Transfer Offer Closed";
}
class tg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Notification Transfer Offer Rejected";
}
class ng {
  event_type = "Notification Transfer Offer Timeout";
}
class rg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Organizations Navigation Organization Clicked";
}
class ig {
  event_type = "Partner Integrations Braze Profile Received";
}
class sg {
  event_type = "Partner Integrations Braze Subscription Email Opt in Succeeded";
}
class og {
  event_type = "Partner Integrations Braze Subscription Email Unsubscribed Succeeded";
}
class ag {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Condition Created";
}
class cg {
  event_type = "Partner Integrations Condition Deleted";
}
class ug {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Condition Updated";
}
class lg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github Create New Issue Canceled";
}
class dg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github Create New Issue Clicked";
}
class pg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github Create New Issue Confirmed";
}
class vg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github Link Issue Clicked";
}
class hg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github Unlink All Issues Canceled";
}
class gg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github Unlink All Issues Clicked";
}
class fg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github Unlink All Issues Confirmed";
}
class yg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github Unlink Issue Canceled";
}
class Cg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github Unlink Issue Clicked";
}
class _g {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github Unlink Issue Confirmed";
}
class kg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Github View Link Clicked";
}
class mg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Comments Collapsed";
}
class wg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Comments Expanded";
}
class Sg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Create Issue Failed";
}
class bg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Create Issue Succeeded";
}
class Ig {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Link Issue Clicked";
}
class Ag {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Open Issue Clicked";
}
class Tg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Open Jira Clicked";
}
class Eg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Remove All Dangling Clicked";
}
class Pg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Remove Dangling Issue Clicked";
}
class Og {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Unlink All Issues Cancelled";
}
class Rg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Unlink All Issues Clicked";
}
class Fg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Unlink All Issues Confirmed";
}
class Dg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Unlink Issue Cancelled";
}
class Mg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Unlink Issue Clicked";
}
class Ug {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Jira Unlink Issue Confirmed";
}
class Lg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Klaviyo Messages Received";
}
class Ng {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Klaviyo Profile Failed";
}
class Vg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Klaviyo Profile Received";
}
class Bg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Klaviyo Profile Subscription To Channel Clicked";
}
class Wg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Klaviyo Profile Subscription To Channel Failed";
}
class Hg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Klaviyo Profile Subscription To Channel Succeeded";
}
class xg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Klaviyo Profile Unsubscribe Clicked";
}
class Qg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Klaviyo Profile Unsubscribe Failed";
}
class Kg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Klaviyo Profile Unsubscribe Succeeded";
}
class Gg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Linear Create New Issue Cancelled";
}
class qg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Linear Create New Issue Clicked";
}
class zg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Linear Create New Issue Confirmed";
}
class $g {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Linear Link Issue Clicked";
}
class jg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Linear Open Issue Clicked";
}
class Jg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Linear Open Linear Clicked";
}
class Yg {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Linear Unlink Issue Clicked";
}
class Xg {
  event_type = "Partner Integrations Recharge Widget Customer Overview Opened";
}
class Zg {
  event_type = "Partner Integrations Recharge Widget Order Opened";
}
class ef {
  event_type = "Partner Integrations Recharge Widget Orders List Opened";
}
class tf {
  event_type = "Partner Integrations Recharge Widget Profile Received";
}
class nf {
  event_type = "Partner Integrations Recharge Widget Subscription Cancelled";
}
class rf {
  event_type = "Partner Integrations Recharge Widget Subscription Opened";
}
class sf {
  event_type = "Partner Integrations Recharge Widget Subscription Reactivated";
}
class of {
  event_type = "Partner Integrations Recharge Widget Subscriptions List Opened";
}
class af {
  event_type = "Partner Integrations RivoLoyalty Widget Customer Clicked";
}
class cf {
  event_type = "Partner Integrations RivoLoyalty Widget Customer Received";
}
class uf {
  event_type = "Partner Integrations RivoLoyalty Widget Points Add Failed";
}
class lf {
  event_type = "Partner Integrations RivoLoyalty Widget Points Add Succeeded";
}
class df {
  event_type = "Partner Integrations RivoLoyalty Widget Points Remove Failed";
}
class pf {
  event_type = "Partner Integrations RivoLoyalty Widget Points Remove Succeeded";
}
class vf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Settings Create Submitted";
}
class hf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Settings Overview Created";
}
class gf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Settings Overview Viewed";
}
class ff {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Settings View Delete Canceled";
}
class yf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Settings View Delete Confirmed";
}
class Cf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Settings View Delete Requested";
}
class _f {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Settings View OAuth Started";
}
class kf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Settings View OAuth Succeeded";
}
class mf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Settings View Submitted";
}
class wf {
  event_type = "Partner Integrations Shopify Widget Create Draft Order Failed";
}
class Sf {
  event_type = "Partner Integrations Shopify Widget Create Draft Order Succeeded";
}
class bf {
  event_type = "Partner Integrations Shopify Widget Create Order Failed";
}
class If {
  event_type = "Partner Integrations Shopify Widget Create Order Succeeded";
}
class Af {
  event_type = "Partner Integrations Shopify Widget Discount Code Created";
}
class Tf {
  event_type = "Partner Integrations Shopify Widget Duplicate Order Failed";
}
class Ef {
  event_type = "Partner Integrations Shopify Widget Duplicate Order Succeeded";
}
class Pf {
  event_type = "Partner Integrations Shopify Widget Order Cancelled";
}
class Of {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Order Collapse Closed";
}
class Rf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Order Collapse Opened";
}
class Ff {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Order Edit Shipping Address Modal Canceled";
}
class Df {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Order Edit Shipping Address Modal Opened";
}
class Mf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Order Edit Shipping Address Submitted";
}
class Uf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Order Refund Canceled";
}
class Lf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Order Refund Confirmed";
}
class Nf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Order Refund Requested";
}
class Vf {
  event_type = "Partner Integrations Shopify Widget Order Tags Updated";
}
class Bf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Order View All Orders In Shopify Clicked";
}
class Wf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Order View Order In Shopify Clicked";
}
class Hf {
  event_type = "Partner Integrations Shopify Widget Profile Created";
}
class xf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget Refreshed";
}
class Qf {
  event_type = "Partner Integrations Shopify Widget Refund Partial Order Failed";
}
class Kf {
  event_type = "Partner Integrations Shopify Widget Refund Partial Order Succeeded";
}
class Gf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Shopify Widget View Customer In Shopify Clicked";
}
class qf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Channel Subscription Clicked";
}
class zf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Channel Subscription Failed";
}
class $f {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Channel Subscription Succeeded";
}
class jf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Channel Unsubscription Clicked";
}
class Jf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Channel Unsubscription Failed";
}
class Yf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Channel Unsubscription Succeeded";
}
class Xf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Message External Link Opened";
}
class Zf {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Messages Received";
}
class ey {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Orders Received";
}
class ty {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Profile Received";
}
class ny {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Voyado Widget Transactions Received";
}
class ry {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Widget Collapse Closed";
}
class iy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Partner Integrations Widget Collapse Opened";
}
class sy {
  event_type = "Partner Integrations Widget LoyaltyLion Add Points Failed";
}
class oy {
  event_type = "Partner Integrations Widget LoyaltyLion Add Points Succeeded";
}
class ay {
  event_type = "Partner Integrations Widget LoyaltyLion Customer Received";
}
class cy {
  event_type = "Partner Integrations Widget LoyaltyLion Remove Points Failed";
}
class uy {
  event_type = "Partner Integrations Widget LoyaltyLion Remove Points Succeeded";
}
class ly {
  event_type = "Partner Integrations Widget Voyado Update Points Failed";
}
class dy {
  event_type = "Partner Integrations Widget Voyado Update Points Succeeded";
}
class py {
  event_type = "Phone Actions Menu Action Add Outbound Caller ID Clicked";
}
class vy {
  event_type = "Phone Actions Menu Action Change Hold Music Clicked";
}
class hy {
  event_type = "Phone Actions Menu Opened";
}
class gy {
  event_type = "Phone Add Outbound Caller ID Form Cancelled";
}
class fy {
  event_type = "Phone Add Outbound Caller ID Form Submitted";
}
class yy {
  event_type = "Phone Change Hold Music Form Cancelled";
}
class Cy {
  event_type = "Phone Change Hold Music Form Submitted";
}
class _y {
  event_type = "Phone Create Flow Form Cancelled";
}
class ky {
  event_type = "Phone Create Flow Form Submitted";
}
class my {
  event_type = "Phone Flow Options Menu Option Audit Log Clicked";
}
class wy {
  event_type = "Phone Flow Options Menu Option Delete Clicked";
}
class Sy {
  event_type = "Phone Flow Options Menu Option Duplicate Clicked";
}
class by {
  event_type = "Phone Flow Options Menu Option Edit Clicked";
}
class Iy {
  event_type = "Phone Flow Options Menu Option Move To Another Number Clicked";
}
class Ay {
  event_type = "Phone Flow Options Menu Option Opened";
}
class Ty {
  event_type = "Phone Flow Options Menu Option Rename Clicked";
}
class Ey {
  event_type = "Phone Form Cancelled";
}
class Py {
  event_type = "Phone Form Opened";
}
class Oy {
  event_type = "Phone Form Submitted";
}
class Ry {
  event_type = "Phone Options Menu Opened";
}
class Fy {
  event_type = "Phone Options Menu Option Create Flow Clicked";
}
class Dy {
  event_type = "Phone Options Menu Option Edit Clicked";
}
class My {
  event_type = "Phone Options Menu Option Remove Number Clicked";
}
class Uy {
  event_type = "Phone Options Menu Option Set Default Caller ID Clicked";
}
class Ly {
  event_type = "Phone Options Menu Option Setup Clicked";
}
class Ny {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Phone Recording Downloaded";
}
class Vy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Phone Recording Pause Clicked";
}
class By {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Phone Recording Play Clicked";
}
class Wy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Phone Recording Playback Abandoned";
}
class Hy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Phone Recording Playback Ended";
}
class xy {
  event_type = "Phone Search Applied";
}
class Qy {
  event_type = "Presence List Item Clicked";
}
class Ky {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Presence Media Other Agent Updated";
}
class Gy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Presence Media Updated";
}
class qy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Presence Other Agent Updated";
}
class zy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Presence Updated";
}
class $y {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Push Notification Platform Form Cancelled";
}
class jy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Push Notification Platform Form Opened";
}
class Jy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Push Notification Platform Form Submitted";
}
class Yy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Quick Replies Opened";
}
class Xy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Quick Reply Chosen";
}
class Zy {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Quick Reply Feedback for Recommended Replies Clicked";
}
class eC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Quick Reply Filter Chosen";
}
class tC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Quick Reply Language Selected";
}
class nC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Quick Reply Template Favorite Toggled";
}
class rC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Rewind Dismissed";
}
class iC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Rewind Feedback Clicked";
}
class sC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Rewind Opened";
}
class oC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Rewind Share To LinkedIn Clicked";
}
class aC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Rewind Slide Image Copied";
}
class cC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Rewind Slide Image Saved";
}
class uC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Rewind Slide Text Copied";
}
class lC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Rewind Slide Viewed";
}
class dC {
  event_type = "Saved Search Applied";
}
class pC {
  event_type = "Saved Search Closed";
}
class vC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Saved Search Created";
}
class hC {
  event_type = "Saved Search Deleted";
}
class gC {
  event_type = "Saved Search Updated";
}
class fC {
  event_type = "Scheduled Conversations Csv Import Clicked";
}
class yC {
  event_type = "Scheduled Conversations Csv Imported";
}
class CC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Contact Preview Closed";
}
class _C {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Contact Preview Go To Clicked";
}
class kC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Contact Preview Opened";
}
class mC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Contact Type Changed";
}
class wC {
  event_type = "Search Conversation Preview Closed";
}
class SC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Conversation Preview Go To Clicked";
}
class bC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Conversation Preview Opened";
}
class IC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Field Blurred";
}
class AC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Field Cleared";
}
class TC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Field Focused";
}
class EC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Field Submitted";
}
class PC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filter Condition Added";
}
class OC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filter Condition Removed";
}
class RC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filter Operator Updated";
}
class FC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filter Strategy Updated";
}
class DC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filter Value Added";
}
class MC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filter Value Cleared";
}
class UC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filters Applied";
}
class LC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filters Cleared";
}
class NC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filters Closed";
}
class VC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filters Opened";
}
class BC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Filters Validation Failed";
}
class WC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Sorting Updated";
}
class HC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Strict Toggled";
}
class xC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Search Tab Opened";
}
class QC {
  event_type = "Settings Agents Add Agent Button Clicked";
}
class KC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Agents Custom Workload Assigned";
}
class GC {
  event_type = "Settings Agents Custom Workload Created";
}
class qC {
  event_type = "Settings Agents Custom Workload Deleted";
}
class zC {
  event_type = "Settings Agents Edit Button Clicked";
}
class $C {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Agents Tab Clicked";
}
class jC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Audio Delete Cancel Clicked";
}
class JC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Audio Delete Clicked";
}
class YC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Audio Delete Confirm Clicked";
}
class XC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Audio Usage Flow Clicked";
}
class ZC {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Audio Usage Link Clicked";
}
class e_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Commands Assign Keybindings";
}
class t_ {
  event_type = "Settings Commands Reset All Keybindings";
}
class n_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Commands Reset Keybindings";
}
class r_ {
  event_type = "Settings Commands Unassign All Keybindings";
}
class i_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Commands Unassign Keybindings";
}
class s_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Custom Attribute Activated";
}
class o_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Custom Attribute Add New Attribute Clicked";
}
class a_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Custom Attribute Archived";
}
class c_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Custom Attribute Created";
}
class u_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Custom Attribute Deactivated";
}
class l_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Custom Attribute Reordered";
}
class d_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Custom Attribute Unarchived";
}
class p_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Custom Attribute Updated";
}
class v_ {
  event_type = "Settings Custom Away Status Add New Clicked";
}
class h_ {
  event_type = "Settings Custom Away Status Archived";
}
class g_ {
  event_type = "Settings Custom Away Status Created";
}
class f_ {
  event_type = "Settings Custom Away Status Unarchived";
}
class y_ {
  event_type = "Settings Custom Away Status Updated";
}
class C_ {
  event_type = "Settings Forms Embed Url Copied";
}
class __ {
  event_type = "Settings Forms Styling Added";
}
class k_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Api Tokens Add Confirm";
}
class m_ {
  event_type = "Settings Integrations Api Tokens Copy";
}
class w_ {
  event_type = "Settings Integrations Api Tokens Documentation Link Integrations Api";
}
class S_ {
  event_type = "Settings Integrations Api Tokens Remove";
}
class b_ {
  event_type = "Settings Integrations Api Tokens Remove Cancel";
}
class I_ {
  event_type = "Settings Integrations Api Tokens Remove Confirm";
}
class A_ {
  event_type = "Settings Integrations Api Tokens View";
}
class T_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Card Edit Save";
}
class E_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Card Edit Test";
}
class P_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Card Listing Add Card";
}
class O_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Card Read Documentation";
}
class R_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Card Test";
}
class F_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Card Test Add Parameter";
}
class D_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Card Test Remove Parameter";
}
class M_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Custom Card Created";
}
class U_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Custom Card Edited";
}
class L_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Custom Card Oauth Provider Authentication Failed";
}
class N_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Custom Card Oauth Provider Authentication Succeeded";
}
class V_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Custom Card Oauth Provider Authentication Timed Out";
}
class B_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Custom Card Oauth Provider Created";
}
class W_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Custom Card Oauth Provider Updated";
}
class H_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Backfill Started Failed";
}
class x_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Backfill Started Succeeded";
}
class Q_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Configuration Enabled Failed";
}
class K_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Configuration Enabled Succeeded";
}
class G_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Create Configuration Failed";
}
class q_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Create Configuration Succeeded";
}
class z_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Delete Configuration Failed";
}
class $_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Delete Configuration Succeeded";
}
class j_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Retry Backfilling Failed";
}
class J_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Retry Backfilling Succeeded";
}
class Y_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Start Syncing Events Succeeded";
}
class X_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Type Clicked";
}
class Z_ {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Update Configuration Failed";
}
class ek {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Data Sync Update Configuration Succeeded";
}
class tk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Item Clicked";
}
class nk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Webform Endpoints Add Save";
}
class rk {
  event_type = "Settings Integrations Webform Endpoints Copy";
}
class ik {
  event_type = "Settings Integrations Webform Endpoints Read Documentation Link";
}
class sk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Webform Endpoints Remove";
}
class ok {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Webform Endpoints Remove Cancel";
}
class ak {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Integrations Webform Endpoints Remove Confirm";
}
class ck {
  event_type = "Settings Integrations Webhooks Add";
}
class uk {
  event_type = "Settings Integrations Webhooks Add Confirm";
}
class lk {
  event_type = "Settings Integrations Webhooks Documentation Link Clicked";
}
class dk {
  event_type = "Settings Integrations Webhooks Edit";
}
class pk {
  event_type = "Settings Integrations Webhooks Edit Save";
}
class vk {
  event_type = "Settings Integrations Webhooks Enabled Off";
}
class hk {
  event_type = "Settings Integrations Webhooks Enabled On";
}
class gk {
  event_type = "Settings Integrations Webhooks Remove";
}
class fk {
  event_type = "Settings Integrations Webhooks Remove Cancel";
}
class yk {
  event_type = "Settings Integrations Webhooks Remove Confirm";
}
class Ck {
  event_type = "Settings Integrations Webhooks View";
}
class _k {
  event_type = "Settings Integrations Webhooks View Copy Secret";
}
class kk {
  event_type = "Settings Integrations Webhooks View Copy Url";
}
class mk {
  event_type = "Settings Integrations Webhooks View Edit";
}
class wk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Menu Item Clicked";
}
class Sk {
  event_type = "Settings Organization Form Submitted";
}
class bk {
  event_type = "Settings Organization Logo Changed";
}
class Ik {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Profile Form Submitted";
}
class Ak {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Queue Added";
}
class Tk {
  event_type = "Settings Queue Agent Deleted";
}
class Ek {
  event_type = "Settings Queue Agent Search Submitted";
}
class Pk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Queue Agent Sorted";
}
class Ok {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Queue Alerts Saved";
}
class Rk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Queue Saved";
}
class Fk {
  event_type = "Settings Queue Teams Add Team Button Clicked";
}
class Dk {
  event_type = "Settings Queue Teams Add Team Form Submitted";
}
class Mk {
  event_type = "Settings Queue Teams Delete Team Button Clicked";
}
class Uk {
  event_type = "Settings Queues Add Queue Clicked";
}
class Lk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Queues Archive Queue Clicked";
}
class Nk {
  event_type = "Settings Queues Edit Queue Clicked";
}
class Vk {
  event_type = "Settings Queues Unarchive Queue Clicked";
}
class Bk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Roles Custom Role Created";
}
class Wk {
  event_type = "Settings Roles Custom Role Deleted";
}
class Hk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Roles Custom Role Edited";
}
class xk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Satisfaction Filters Channel Added";
}
class Qk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Satisfaction Filters Channel Removed";
}
class Kk {
  event_type = "Settings Satisfaction Filters Create Viewed";
}
class Gk {
  event_type = "Settings Satisfaction Filters Created";
}
class qk {
  event_type = "Settings Satisfaction Filters Edited";
}
class zk {
  event_type = "Settings Summarization Save Changes Clicked";
}
class $k {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Summarization Show Automatically Clicked";
}
class jk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Summarization Show On Demand Clicked";
}
class Jk {
  event_type = "Settings Survey Accent Color Changed";
}
class Yk {
  event_type = "Settings Survey Back To List Clicked";
}
class Xk {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Back To Survey Clicked";
}
class Zk {
  event_type = "Settings Survey Create Failed";
}
class em {
  event_type = "Settings Survey Create Modal Opened";
}
class tm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Created";
}
class nm {
  event_type = "Settings Survey Delete Cancelled";
}
class rm {
  event_type = "Settings Survey Delete Confirmed";
}
class im {
  event_type = "Settings Survey Delete Failed";
}
class sm {
  event_type = "Settings Survey Deleted";
}
class om {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Edit Button Clicked";
}
class am {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Edit Viewed";
}
class cm {
  event_type = "Settings Survey Email Preview Area Clicked";
}
class um {
  event_type = "Settings Survey Font Color Changed";
}
class lm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Header Image Type Changed";
}
class dm {
  event_type = "Settings Survey Ivr Details Save Failed";
}
class pm {
  event_type = "Settings Survey Ivr Details Saved";
}
class vm {
  event_type = "Settings Survey Ivr Details Viewed";
}
class hm {
  event_type = "Settings Survey Language Added";
}
class gm {
  event_type = "Settings Survey Language Delete Cancelled";
}
class fm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Language Delete Confirmed";
}
class ym {
  event_type = "Settings Survey Language Delete Failed";
}
class Cm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Language Deleted";
}
class _m {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Language Disabled";
}
class km {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Language Edit Clicked";
}
class mm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Language Enabled";
}
class wm {
  event_type = "Settings Survey List Viewed";
}
class Sm {
  event_type = "Settings Survey Multi Question Details Save Failed";
}
class bm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Multi Question Details Saved";
}
class Im {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Multi Question Details Viewed";
}
class Am {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Multi Question Tab Changed";
}
class Tm {
  event_type = "Settings Survey Name Save Failed";
}
class Em {
  event_type = "Settings Survey Name Saved";
}
class Pm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Preview Mode Changed";
}
class Om {
  event_type = "Settings Survey Question Add Clicked";
}
class Rm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Question Added";
}
class Fm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Question Deleted";
}
class Dm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Question Edit Clicked";
}
class Mm {
  event_type = "Settings Survey Question Editor Cancelled";
}
class Um {
  event_type = "Settings Survey Question Reordered";
}
class Lm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Question Updated";
}
class Nm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Unsaved Changes Dialog Shown";
}
class Vm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Unsaved Changes Discarded";
}
class Bm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Survey Unsaved Changes Kept";
}
class Wm {
  event_type = "Settings Tags Add Tag Button Clicked";
}
class Hm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Tags Tag Activated";
}
class xm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Tags Tag Deactivated";
}
class Qm {
  event_type = "Settings Team Add Team Button Clicked";
}
class Km {
  event_type = "Settings Team Details Add Agents Button Clicked";
}
class Gm {
  event_type = "Settings Team Edit Team Button Clicked";
}
class qm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Team Modal Form Submitted";
}
class zm {
  event_type = "Settings Team Remove Team Button Clicked";
}
class $m {
  event_type = "Settings Team Remove Team Confirmed";
}
class jm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Templates Add Template Button Clicked";
}
class Jm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Templates Edit Template Button Clicked";
}
class Ym {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Templates Modal Form Submitted";
}
class Xm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Templates Remove Template Button Clicked";
}
class Zm {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Templates Remove Template Confirmed";
}
class ew {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Settings Templates Tab Clicked";
}
class tw {
  event_type = "Shared Worker Tab Or Window Changed";
}
class nw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Shared Worker Tab Or Window Closed";
}
class rw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Shared Worker Tab Or Window Opened";
}
class iw {
  event_type = "Sidebar Add Agent Button Clicked";
}
class sw {
  event_type = "Sidebar Collapsed";
}
class ow {
  event_type = "Sidebar Expanded";
}
class aw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Sidebar Nav Clicked";
}
class cw {
  event_type = "Sign Out Aborted";
}
class uw {
  event_type = "Sign Out Confirmed";
}
class lw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Simultaneous Ring Updated";
}
class dw {
  event_type = "SLA Policies Reordered";
}
class pw {
  event_type = "SLA Policy Activated";
}
class vw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "SLA Policy Created";
}
class hw {
  event_type = "SLA Policy Deactivated";
}
class gw {
  event_type = "SLA Policy Deleted";
}
class fw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "SLA Policy Updated";
}
class yw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Smart Conversation Reply Button Clicked";
}
class Cw {
  event_type = "Subflow Back To Main Flow Node Reused";
}
class _w {
  event_type = "Subflow Back To Main Flow Node Used";
}
class kw {
  event_type = "Subflow Created From Highlighted Nodes";
}
class mw {
  event_type = "Subflow Created From Scratch";
}
class ww {
  event_type = "Subflow Reused";
}
class Sw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Tag Select Create New Tag Clicked";
}
class bw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Tags Create Modal Color Changed";
}
class Iw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Tags Create Modal Form Submitted";
}
class Aw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Tags Create Modal Opened";
}
class Tw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Team Agent Actions Menu Item Clicked";
}
class Ew {
  event_type = "Team Agent Actions Menu Opened";
}
class Pw {
  event_type = "Team Agent Collapsed";
}
class Ow {
  event_type = "Team Agent Expanded";
}
class Rw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Team Favorite Toggled";
}
class Fw {
  event_type = "Theme Imported";
}
class Dw {
  event_type = "Theme Shared";
}
class Mw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Theme Updated";
}
class Uw {
  event_type = "Topbar Beamer Opened";
}
class Lw {
  event_type = "Topbar Email Opened";
}
class Nw {
  event_type = "Topbar Notifications Opened";
}
class Vw {
  event_type = "Topbar Phones Opened";
}
class Bw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Topbar Search Quick Action Clicked";
}
class Ww {
  event_type = "Topbar Support Opened";
}
class Hw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "User Modal Form Submitted";
}
class xw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "User Modal Role Changed";
}
class Qw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "User Modal User Type Changed";
}
class Kw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Websocket Active Connection Changed";
}
class Gw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Websocket Close Event Received";
}
class qw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Websocket Connection Closed";
}
class zw {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Websocket Connection Created";
}
class $w {
  constructor(e) {
    this.event_properties = e, this.event_properties = e;
  }
  event_properties;
  event_type = "Websocket Reconnect Attempt Started";
}
const _e = () => ({ promise: Promise.resolve() });
class jw {
  disabled = !1;
  amplitude;
  get client() {
    return this.isInitializedAndEnabled(), this.amplitude;
  }
  get isLoaded() {
    return this.amplitude != null;
  }
  isInitializedAndEnabled() {
    return this.amplitude ? !this.disabled : (console.error("ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?"), !1);
  }
  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(e) {
    if (this.disabled = e.disabled ?? !1, this.amplitude)
      return console.warn("WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup."), _e();
    let n = null;
    if (e.client && "apiKey" in e.client ? n = e.client.apiKey : "environment" in e && (n = da[e.environment]), e.client && "instance" in e.client)
      this.amplitude = e.client.instance;
    else if (n) {
      this.amplitude = hr();
      const r = e.client && "configuration" in e.client ? e.client.configuration : {};
      return this.amplitude.init(n, void 0, { ...pa, ...r });
    } else
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    return _e();
  }
  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(e, n, r) {
    if (!this.isInitializedAndEnabled())
      return _e();
    e && (r = { ...r, user_id: e });
    const i = new he(), s = n;
    if (s != null)
      for (const [o, u] of Object.entries(s))
        i.set(o, u);
    return this.amplitude.identify(
      i,
      r
    );
  }
  /**
   * Flush the event.
   */
  flush() {
    return this.isInitializedAndEnabled() ? this.amplitude.flush() : _e();
  }
  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(e, n) {
    return this.isInitializedAndEnabled() ? this.amplitude.track(e, void 0, n) : _e();
  }
  /**
   * Add Agents Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Add%20Agents%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on Add agents modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. addTo)
   * @param options Amplitude event options.
   */
  addAgentsModalFormSubmitted(e, n) {
    return this.track(new va(e), n);
  }
  /**
   * Agent Copilot Back Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Back%20Button%20Clicked)
   *
   * When the user clicks the back button in Agent Copilot
   *
   * @param options Amplitude event options.
   */
  agentCopilotBackButtonClicked(e) {
    return this.track(new ha(), e);
  }
  /**
   * Agent Copilot Conversation Custom Attribute Suggestion Accepted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Conversation%20Custom%20Attribute%20Suggestion%20Accepted)
   *
   * This event is triggered when a custom attributes suggestion is applied
   *
   * @param options Amplitude event options.
   */
  agentCopilotConversationCustomAttributeSuggestionAccepted(e) {
    return this.track(new ga(), e);
  }
  /**
   * Agent Copilot Conversation Tag Suggestion Accepted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Conversation%20Tag%20Suggestion%20Accepted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  agentCopilotConversationTagSuggestionAccepted(e, n) {
    return this.track(new fa(e), n);
  }
  /**
   * Agent Copilot Dropdown Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Dropdown%20Item%20Clicked)
   *
   * When the user clicks an items from the Agent Copilot dropdown in the reply area.
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  agentCopilotDropdownItemClicked(e, n) {
    return this.track(new ya(e), n);
  }
  /**
   * Agent Copilot Improve Writing Improvement Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Improve%20Writing%20Improvement%20Clicked)
   *
   * When the user selects a writing improvement option
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  agentCopilotImproveWritingImprovementClicked(e, n) {
    return this.track(new Ca(e), n);
  }
  /**
   * Agent Copilot Text Insert Below Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Text%20Insert%20Below%20Clicked)
   *
   * When the user clicks the Replace Text action in a copilot action.
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  agentCopilotTextInsertBelowClicked(e, n) {
    return this.track(new _a(e), n);
  }
  /**
   * Agent Copilot Text Replace Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Text%20Replace%20Clicked)
   *
   * When the user clicks the Insert Below action in a copilot action.
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  agentCopilotTextReplaceClicked(e, n) {
    return this.track(new ka(e), n);
  }
  /**
   * Agent Copilot Translate Message Language Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Translate%20Message%20Language%20Selected)
   *
   * When the user selects a language to translate a message to.
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  agentCopilotTranslateMessageLanguageSelected(e, n) {
    return this.track(new ma(e), n);
  }
  /**
   * Agent Copilot Trial Learn More Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Learn%20More%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. url)
   * @param options Amplitude event options.
   */
  agentCopilotTrialLearnMoreClicked(e, n) {
    return this.track(new wa(e), n);
  }
  /**
   * Agent Copilot Trial Leftmenu CTA Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Leftmenu%20CTA%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  agentCopilotTrialLeftmenuCtaClicked(e) {
    return this.track(new Sa(), e);
  }
  /**
   * Agent Copilot Trial Leftmenu CTA Dismissed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Leftmenu%20CTA%20Dismissed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  agentCopilotTrialLeftmenuCtaDismissed(e) {
    return this.track(new ba(), e);
  }
  /**
   * Agent Copilot Trial Request Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Request%20Contact%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  agentCopilotTrialRequestContactClicked(e) {
    return this.track(new Ia(), e);
  }
  /**
   * Agent Copilot Trial Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Started)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  agentCopilotTrialStarted(e) {
    return this.track(new Aa(), e);
  }
  /**
   * Agent Copilot Trial Stopped
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Stopped)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  agentCopilotTrialStopped(e) {
    return this.track(new Ta(), e);
  }
  /**
   * Agent Copilot Undo Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Undo%20Clicked)
   *
   * When the user clicks the undo button in Agent Copilot
   *
   * @param options Amplitude event options.
   */
  agentCopilotUndoClicked(e) {
    return this.track(new Ea(), e);
  }
  /**
   * Agent Custom Away Status Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Custom%20Away%20Status%20Updated)
   *
   * Event to track when the custom away status of an agent is changed by an agent in the Dixa Agent-Interface
   *
   * @param properties The event's properties (e.g. statusEmoji)
   * @param options Amplitude event options.
   */
  agentCustomAwayStatusUpdated(e, n) {
    return this.track(new Pa(e), n);
  }
  /**
   * Analytics Business Hours Schedule Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Business%20Hours%20Schedule%20Removed)
   *
   * When the user remoes a global business hours schedule filter on a dashboard or contextually on a panel
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsBusinessHoursScheduleRemoved(e, n) {
    return this.track(new Oa(e), n);
  }
  /**
   * Analytics Business Hours Schedule Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Business%20Hours%20Schedule%20Updated)
   *
   * When the user selects a global business hours schedule filter on a dashboard or contextually on a panel
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsBusinessHoursScheduleUpdated(e, n) {
    return this.track(new Ra(e), n);
  }
  /**
   * Analytics Chart Format Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Chart%20Format%20Changed)
   *
   * When the user changes the format of a chart
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsChartFormatChanged(e, n) {
    return this.track(new Fa(e), n);
  }
  /**
   * Analytics Chart Granularity Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Chart%20Granularity%20Changed)
   *
   * When the user changes the granularity of a chart
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsChartGranularityChanged(e, n) {
    return this.track(new Da(e), n);
  }
  /**
   * Analytics Chart Visualization Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Chart%20Visualization%20Changed)
   *
   * When the user changes the visualization of a chart
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsChartVisualizationChanged(e, n) {
    return this.track(new Ma(e), n);
  }
  /**
   * Analytics Compare Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Compare%20Clicked)
   *
   * When the user clicks the compare button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsCompareClicked(e, n) {
    return this.track(new Ua(e), n);
  }
  /**
   * Analytics Compare Context Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Compare%20Context%20Updated)
   *
   * When the user updates the context in a comparison
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsCompareContextUpdated(e, n) {
    return this.track(new La(e), n);
  }
  /**
   * Analytics Compare Period Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Compare%20Period%20Updated)
   *
   * When the user updates the context in a comparison
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsComparePeriodUpdated(e, n) {
    return this.track(new Na(e), n);
  }
  /**
   * Analytics Context Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Context%20Updated)
   *
   * When the user updates the global context on a dashboard or contextually on a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsContextUpdated(e, n) {
    return this.track(new Va(e), n);
  }
  /**
   * Analytics Conversation Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Conversation%20Link%20Clicked)
   *
   * When the user clicks on a conversation link in supported instruments
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  analyticsConversationLinkClicked(e, n) {
    return this.track(new Ba(e), n);
  }
  /**
   * Analytics Conversation Preview Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Conversation%20Preview%20Clicked)
   *
   * When the user clicks on the button to preview a conversation in supported instruments
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  analyticsConversationPreviewClicked(e, n) {
    return this.track(new Wa(e), n);
  }
  /**
   * Analytics Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Dashboard%20Viewed)
   *
   * When the user views a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  analyticsDashboardViewed(e, n) {
    return this.track(new Ha(e), n);
  }
  /**
   * Analytics Export Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Export%20Clicked)
   *
   * When the user clicks the export button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsExportClicked(e, n) {
    return this.track(new xa(e), n);
  }
  /**
   * Analytics Export Download Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Export%20Download%20Clicked)
   *
   * When the user clicks the export download button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsExportDownloadClicked(e, n) {
    return this.track(new Qa(e), n);
  }
  /**
   * Analytics Export My Data Button Pressed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Export%20My%20Data%20Button%20Pressed)
   *
   * When the user clicks Export my data button on Analytics Export Dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. numberOfDays)
   * @param options Amplitude event options.
   */
  analyticsExportMyDataButtonPressed(e, n) {
    return this.track(new Ka(e), n);
  }
  /**
   * Analytics Filter Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Cleared)
   *
   * When the user clears a filter in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFilterCleared(e, n) {
    return this.track(new Ga(e), n);
  }
  /**
   * Analytics Filter Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Opened)
   *
   * When the user opens a filter in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFilterOpened(e, n) {
    return this.track(new qa(e), n);
  }
  /**
   * Analytics Filter Operator Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Operator%20Updated)
   *
   * When the updates the operator of filter in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFilterOperatorUpdated(e, n) {
    return this.track(new za(e), n);
  }
  /**
   * Analytics Filter Value Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Value%20Added)
   *
   * When the user adds a filter value in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. all)
   * @param options Amplitude event options.
   */
  analyticsFilterValueAdded(e, n) {
    return this.track(new $a(e), n);
  }
  /**
   * Analytics Filters Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filters%20Applied)
   *
   * When the user applies some global filters in a dashboard or contextually on a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFiltersApplied(e, n) {
    return this.track(new ja(e), n);
  }
  /**
   * Analytics Filters Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filters%20Cleared)
   *
   * When the user clears all global filters in a dashboard or contextually in a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFiltersCleared(e, n) {
    return this.track(new Ja(e), n);
  }
  /**
   * Analytics Helper Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Helper%20Clicked)
   *
   * When the user clicks a helper in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsHelperClicked(e, n) {
    return this.track(new Ya(e), n);
  }
  /**
   * Analytics In Depth Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20In%20Depth%20Clicked)
   *
   * When the user clicks an in-depth button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInDepthClicked(e, n) {
    return this.track(new Xa(e), n);
  }
  /**
   * Analytics Insights Copy Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Copy%20Clicked)
   *
   * When the user clicks copy to clipboard on an AI insight in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsCopyClicked(e, n) {
    return this.track(new Za(e), n);
  }
  /**
   * Analytics Insights Feedback Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Feedback%20Clicked)
   *
   * When the user clicks a feedback button on an AI insight in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsFeedbackClicked(e, n) {
    return this.track(new ec(e), n);
  }
  /**
   * Analytics Insights Prompt Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Prompt%20Clicked)
   *
   * When the user clicks on an AI insight prompt in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsPromptClicked(e, n) {
    return this.track(new tc(e), n);
  }
  /**
   * Analytics Insights Regenerate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Regenerate%20Clicked)
   *
   * When the user clicks regenerate on an AI insight prompt in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsRegenerateClicked(e, n) {
    return this.track(new nc(e), n);
  }
  /**
   * Analytics Panel Controls Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Panel%20Controls%20Opened)
   *
   * When the user opens the panel controls modal
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsPanelControlsOpened(e, n) {
    return this.track(new rc(e), n);
  }
  /**
   * Analytics Period Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Period%20Updated)
   *
   * When the user updates the global period on a dashboard or contextually in a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsPeriodUpdated(e, n) {
    return this.track(new ic(e), n);
  }
  /**
   * Analytics Pin Panel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Pin%20Panel%20Clicked)
   *
   * When the user clicks the pin panel button in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsPinPanelClicked(e, n) {
    return this.track(new sc(e), n);
  }
  /**
   * Analytics Pin Panel Quick View Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Pin%20Panel%20Quick%20View%20Created)
   *
   * When the user creates a quick view from the pin panel modal
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsPinPanelQuickViewCreated(e, n) {
    return this.track(new oc(e), n);
  }
  /**
   * Analytics Quick View Auto Refresh Disabled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Auto%20Refresh%20Disabled)
   *
   * When the user disables auto-refresh on a quick view
   *
   * @param properties The event's properties (e.g. interval)
   * @param options Amplitude event options.
   */
  analyticsQuickViewAutoRefreshDisabled(e, n) {
    return this.track(new ac(e), n);
  }
  /**
   * Analytics Quick View Auto Refresh Enabled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Auto%20Refresh%20Enabled)
   *
   * When the user enables auto-refresh on a quick view
   *
   * @param properties The event's properties (e.g. interval)
   * @param options Amplitude event options.
   */
  analyticsQuickViewAutoRefreshEnabled(e, n) {
    return this.track(new cc(e), n);
  }
  /**
   * Analytics Quick View Auto Refresh Triggered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Auto%20Refresh%20Triggered)
   *
   * When the quick view auto-refresh is triggered
   *
   * @param properties The event's properties (e.g. interval)
   * @param options Amplitude event options.
   */
  analyticsQuickViewAutoRefreshTriggered(e, n) {
    return this.track(new uc(e), n);
  }
  /**
   * Analytics Quick View Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Created)
   *
   * When the user creates a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewCreated(e, n) {
    return this.track(new lc(e), n);
  }
  /**
   * Analytics Quick View Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Deleted)
   *
   * When the user deletes a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  analyticsQuickViewDeleted(e, n) {
    return this.track(new dc(e), n);
  }
  /**
   * Analytics Quick View Duplicated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Duplicated)
   *
   * When the user duplicates a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewDuplicated(e, n) {
    return this.track(new pc(e), n);
  }
  /**
   * Analytics Quick View Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Favorite%20Toggled)
   *
   * When the user favorites or unfavorites a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. favorited)
   * @param options Amplitude event options.
   */
  analyticsQuickViewFavoriteToggled(e, n) {
    return this.track(new vc(e), n);
  }
  /**
   * Analytics Quick View Landing Page Set
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Landing%20Page%20Set)
   *
   * When the user sets a quick view as the Analytics landing page
   *
   * @param properties The event's properties (e.g. isOwner)
   * @param options Amplitude event options.
   */
  analyticsQuickViewLandingPageSet(e, n) {
    return this.track(new hc(e), n);
  }
  /**
   * Analytics Quick View Landing Page Unset
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Landing%20Page%20Unset)
   *
   * When the user sets a quick view as the Analytics landing page
   *
   * @param properties The event's properties (e.g. isOwner)
   * @param options Amplitude event options.
   */
  analyticsQuickViewLandingPageUnset(e, n) {
    return this.track(new gc(e), n);
  }
  /**
   * Analytics Quick View Ownership Transferred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Ownership%20Transferred)
   *
   * When the user transfers ownership of a quick view
   *
   * @param options Amplitude event options.
   */
  analyticsQuickViewOwnershipTransferred(e) {
    return this.track(new fc(), e);
  }
  /**
   * Analytics Quick View Panel Controls Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panel%20Controls%20Updated)
   *
   * When the user updates the controls of a panel in a quick view
   *
   * @param properties The event's properties (e.g. applyToAll)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelControlsUpdated(e, n) {
    return this.track(new yc(e), n);
  }
  /**
   * Analytics Quick View Panel Description Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panel%20Description%20Updated)
   *
   * When the user updates the description of a panel in a quick view
   *
   * @param properties The event's properties (e.g. panel)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelDescriptionUpdated(e, n) {
    return this.track(new Cc(e), n);
  }
  /**
   * Analytics Quick View Panel Pinned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panel%20Pinned)
   *
   * When the user pins a panel to a quick view
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelPinned(e, n) {
    return this.track(new _c(e), n);
  }
  /**
   * Analytics Quick View Panel Unpinned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panel%20Unpinned)
   *
   * When the user unpins a panel from a quick view
   *
   * @param properties The event's properties (e.g. panel)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelUnpinned(e, n) {
    return this.track(new kc(e), n);
  }
  /**
   * Analytics Quick View Panels Layout Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panels%20Layout%20Changed)
   *
   * When the user changes the layout of panels in a quick view by dragging or resizing
   *
   * @param properties The event's properties (e.g. event)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelsLayoutChanged(e, n) {
    return this.track(new mc(e), n);
  }
  /**
   * Analytics Quick View Panels Reset
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panels%20Reset)
   *
   * When the user resets the panels in a quick view
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelsReset(e, n) {
    return this.track(new wc(e), n);
  }
  /**
   * Analytics Quick View Panels Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panels%20Updated)
   *
   * When the user updates the panels in a quick view
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelsUpdated(e, n) {
    return this.track(new Sc(e), n);
  }
  /**
   * Analytics Quick View Sharing Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Sharing%20Toggled)
   *
   * When the user shares or unshares a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewSharingToggled(e, n) {
    return this.track(new bc(e), n);
  }
  /**
   * Analytics Quick View Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Updated)
   *
   * When the user updates a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewUpdated(e, n) {
    return this.track(new Ic(e), n);
  }
  /**
   * Analytics Quick View Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Viewed)
   *
   * When the user views a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewViewed(e, n) {
    return this.track(new Ac(e), n);
  }
  /**
   * Analytics Refresh Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Refresh%20Clicked)
   *
   * When the user clicks a refresh button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsRefreshClicked(e, n) {
    return this.track(new Tc(e), n);
  }
  /**
   * Analytics Table Load All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Table%20Load%20All%20Clicked)
   *
   * When the user clicks the load all results button on a table
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsTableLoadAllClicked(e, n) {
    return this.track(new Ec(e), n);
  }
  /**
   * Analytics Table Sort Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Table%20Sort%20Updated)
   *
   * When the user updates the sorting on a table
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. column)
   * @param options Amplitude event options.
   */
  analyticsTableSortUpdated(e, n) {
    return this.track(new Pc(e), n);
  }
  /**
   * Analytics Timezone Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Timezone%20Updated)
   *
   * When the user updates the global timezone on a dashboard or contextually on a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsTimezoneUpdated(e, n) {
    return this.track(new Oc(e), n);
  }
  /**
   * Analytics View Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20View%20Conversations%20Clicked)
   *
   * When the user clicks the view conversations button in a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsViewConversationsClicked(e, n) {
    return this.track(new Rc(e), n);
  }
  /**
   * Auth Failed Init
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Auth%20Failed%20Init)
   *
   * When the application fails to initialize authentication
   *
   * @param properties The event's properties (e.g. failureReason)
   * @param options Amplitude event options.
   */
  authFailedInit(e, n) {
    return this.track(new Fc(e), n);
  }
  /**
   * Automations Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Form%20Cancelled)
   *
   * When the user cancels the Automation form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  automationsFormCancelled(e, n) {
    return this.track(new Dc(e), n);
  }
  /**
   * Automations Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Form%20Opened)
   *
   * When the user opens the create/update Automation form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  automationsFormOpened(e, n) {
    return this.track(new Mc(e), n);
  }
  /**
   * Automations Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Form%20Submitted)
   *
   * When the user proceeds on the Automation form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  automationsFormSubmitted(e, n) {
    return this.track(new Uc(e), n);
  }
  /**
   * Automations Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Opened)
   *
   * When the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOpened(e) {
    return this.track(new Lc(), e);
  }
  /**
   * Automations Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionDeleteClicked(e) {
    return this.track(new Nc(), e);
  }
  /**
   * Automations Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new Vc(), e);
  }
  /**
   * Automations Options Menu Option Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Flow%20Clicked)
   *
   * When the user selects Edit Flow in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionFlowClicked(e) {
    return this.track(new Bc(), e);
  }
  /**
   * Automations Options Menu Option Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Settings%20Clicked)
   *
   * When the user selects Settings in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionSettingsClicked(e) {
    return this.track(new Wc(), e);
  }
  /**
   * Automations Pagination Next Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Pagination%20Next%20Clicked)
   *
   * When the user clicks the next page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsPaginationNextClicked(e) {
    return this.track(new Hc(), e);
  }
  /**
   * Automations Pagination Previous Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Pagination%20Previous%20Clicked)
   *
   * When the user clicks the previous page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsPaginationPreviousClicked(e) {
    return this.track(new xc(), e);
  }
  /**
   * Automations Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Search%20Applied)
   *
   * When the user performs a search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsSearchApplied(e) {
    return this.track(new Qc(), e);
  }
  /**
   * Automations Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Search%20Closed)
   *
   * When the user closes the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsSearchClosed(e) {
    return this.track(new Kc(), e);
  }
  /**
   * Automations Search Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Search%20Opened)
   *
   * When the user opens the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsSearchOpened(e) {
    return this.track(new Gc(), e);
  }
  /**
   * Automations Toggled Off
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Toggled%20Off)
   *
   * When the user toggles an automation off
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsToggledOff(e) {
    return this.track(new qc(), e);
  }
  /**
   * Automations Toggled On
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Toggled%20On)
   *
   * When the user toggles an automation on
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsToggledOn(e) {
    return this.track(new zc(), e);
  }
  /**
   * Bans Ban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bans%20Ban%20User%20Clicked)
   *
   * When the user clicks the Ban User button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  bansBanUserClicked(e, n) {
    return this.track(new $c(e), n);
  }
  /**
   * Bans Unban Ip Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bans%20Unban%20Ip%20Clicked)
   *
   * When the user clicks the Unban IP button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  bansUnbanIpClicked(e) {
    return this.track(new jc(), e);
  }
  /**
   * Bans Unban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bans%20Unban%20User%20Clicked)
   *
   * When the user clicks the Unban User button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  bansUnbanUserClicked(e, n) {
    return this.track(new Jc(e), n);
  }
  /**
   * Bulk Actions Update Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bulk%20Actions%20Update%20Clicked)
   *
   * When the user clicks the Update button in the Bulk Actions
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. conversationsCount)
   * @param options Amplitude event options.
   */
  bulkActionsUpdateClicked(e, n) {
    return this.track(new Yc(e), n);
  }
  /**
   * Business Hours Add Schedule Audio Message Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Audio%20Message%20Added)
   *
   * When the user added an Audio message.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleAudioMessageAdded(e, n) {
    return this.track(new Xc(e), n);
  }
  /**
   * Business Hours Add Schedule Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Button%20Clicked)
   *
   * When the user clicked the Add new schedule button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleButtonClicked(e) {
    return this.track(new Zc(), e);
  }
  /**
   * Business Hours Add Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Add new schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleFormCancelled(e, n) {
    return this.track(new eu(e), n);
  }
  /**
   * Business Hours Add Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Add new schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. countryCode)
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleFormSubmitted(e, n) {
    return this.track(new tu(e), n);
  }
  /**
   * Business Hours Conflict Notification Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Conflict%20Notification%20Button%20Clicked)
   *
   * When the user clicked the Go to Business Hours button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursConflictNotificationButtonClicked(e) {
    return this.track(new nu(), e);
  }
  /**
   * Business Hours Conflict Notification Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Conflict%20Notification%20Closed)
   *
   * When the user clicked the close button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursConflictNotificationClosed(e) {
    return this.track(new ru(), e);
  }
  /**
   * Business Hours Delete Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Delete%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Delete schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDeleteScheduleFormCancelled(e) {
    return this.track(new iu(), e);
  }
  /**
   * Business Hours Delete Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Delete%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Delete schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDeleteScheduleFormSubmitted(e) {
    return this.track(new su(), e);
  }
  /**
   * Business Hours Duplicate Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Duplicate%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Duplicate schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDuplicateScheduleFormCancelled(e) {
    return this.track(new ou(), e);
  }
  /**
   * Business Hours Duplicate Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Duplicate%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Duplicate schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDuplicateScheduleFormSubmitted(e) {
    return this.track(new au(), e);
  }
  /**
   * Business Hours First Schedule Modal Question Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20First%20Schedule%20Modal%20Question%20Clicked)
   *
   * When the user clicked the one of the question toggle.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. question)
   * @param options Amplitude event options.
   */
  businessHoursFirstScheduleModalQuestionClicked(e, n) {
    return this.track(new cu(e), n);
  }
  /**
   * Business Hours First Schedule Support Article Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20First%20Schedule%20Support%20Article%20Clicked)
   *
   * When the user clicked the Support article link.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursFirstScheduleSupportArticleClicked(e) {
    return this.track(new uu(), e);
  }
  /**
   * Business Hours Go To Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Go%20To%20Flow%20Clicked)
   *
   * When the user clicked the Go to flow on the Schedules listing page.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursGoToFlowClicked(e) {
    return this.track(new lu(), e);
  }
  /**
   * Business Hours Migration Wizard Audio Message Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Audio%20Message%20Added)
   *
   * When the user added an Audio message.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardAudioMessageAdded(e, n) {
    return this.track(new du(e), n);
  }
  /**
   * Business Hours Migration Wizard Create New Schedule Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Create%20New%20Schedule%20Button%20Clicked)
   *
   * When the clicked the Create new schedule button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardCreateNewScheduleButtonClicked(e) {
    return this.track(new pu(), e);
  }
  /**
   * Business Hours Migration Wizard Edit Hours Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Edit%20Hours%20Button%20Clicked)
   *
   * When the user clicked the Edit hours button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardEditHoursButtonClicked(e) {
    return this.track(new vu(), e);
  }
  /**
   * Business Hours Migration Wizard Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Form%20Cancelled)
   *
   * When the user cancelled the Migration wizard modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. step)
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardFormCancelled(e, n) {
    return this.track(new hu(e), n);
  }
  /**
   * Business Hours Migration Wizard Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Form%20Submitted)
   *
   * When the user submitted the Migration wizard modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. countryCode)
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardFormSubmitted(e, n) {
    return this.track(new gu(e), n);
  }
  /**
   * Business Hours Migration Wizard Opening Hours Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Opening%20Hours%20Form%20Cancelled)
   *
   * When the user cancelled the Migration wizard Opening hours form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardOpeningHoursFormCancelled(e) {
    return this.track(new fu(), e);
  }
  /**
   * Business Hours Migration Wizard Opening Hours Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Opening%20Hours%20Form%20Submitted)
   *
   * When the user submitted the Migration wizard Opening hours form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardOpeningHoursFormSubmitted(e) {
    return this.track(new yu(), e);
  }
  /**
   * Business Hours Migration Wizard Start Update Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Start%20Update%20Button%20Clicked)
   *
   * When the user clicked the Start update button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardStartUpdateButtonClicked(e) {
    return this.track(new Cu(), e);
  }
  /**
   * Business Hours Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Opened)
   *
   * When the user opened the Options Menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOpened(e) {
    return this.track(new _u(), e);
  }
  /**
   * Business Hours Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selected Delete in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionDeleteClicked(e) {
    return this.track(new ku(), e);
  }
  /**
   * Business Hours Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selected Duplicate in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new mu(), e);
  }
  /**
   * Business Hours Options Menu Option Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Edit%20Clicked)
   *
   * When the user selected Edit schedule in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionEditClicked(e) {
    return this.track(new wu(), e);
  }
  /**
   * Business Hours Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selected Rename in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionRenameClicked(e) {
    return this.track(new Su(), e);
  }
  /**
   * Business Hours Rename Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Rename%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Rename schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursRenameScheduleFormCancelled(e) {
    return this.track(new bu(), e);
  }
  /**
   * Business Hours Rename Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Rename%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Rename schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. view)
   * @param options Amplitude event options.
   */
  businessHoursRenameScheduleFormSubmitted(e, n) {
    return this.track(new Iu(e), n);
  }
  /**
   * Business Hours Schedule Add Exception Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Add%20Exception%20Button%20Clicked)
   *
   * When user clicked on the Add exception button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleAddExceptionButtonClicked(e) {
    return this.track(new Au(), e);
  }
  /**
   * Business Hours Schedule Add Exception Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Add%20Exception%20Form%20Cancelled)
   *
   * When the user cancelled the Add exception form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleAddExceptionFormCancelled(e) {
    return this.track(new Tu(), e);
  }
  /**
   * Business Hours Schedule Add Exception Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Add%20Exception%20Form%20Submitted)
   *
   * When the user submitted Add exception form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleAddExceptionFormSubmitted(e) {
    return this.track(new Eu(), e);
  }
  /**
   * Business Hours Schedule Audio Message Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Form%20Cancelled)
   *
   * When the user cancelled the Audio message modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageFormCancelled(e, n) {
    return this.track(new Pu(e), n);
  }
  /**
   * Business Hours Schedule Audio Message Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Form%20Submitted)
   *
   * When the user submitted the Audio message modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageFormSubmitted(e, n) {
    return this.track(new Ou(e), n);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Opened)
   *
   * When the user opened the Audio message options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOpened(e, n) {
    return this.track(new Ru(e), n);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Option Clear Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Option%20Clear%20Clicked)
   *
   * When the user selected Clear from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOptionClearClicked(e, n) {
    return this.track(new Fu(e), n);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Option Record Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Option%20Record%20Clicked)
   *
   * When the user selected Record audio message from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked(e, n) {
    return this.track(new Du(e), n);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Option Upload Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Option%20Upload%20Clicked)
   *
   * When the user selected Upload audio message from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked(e, n) {
    return this.track(new Mu(e), n);
  }
  /**
   * Business Hours Schedule Auto Reply Options Menu Option Clear Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Auto%20Reply%20Options%20Menu%20Option%20Clear%20Clicked)
   *
   * When the user selected Clear from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAutoReplyOptionsMenuOptionClearClicked(e, n) {
    return this.track(new Uu(e), n);
  }
  /**
   * Business Hours Schedule Conflict Change Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Conflict%20Change%20Button%20Clicked)
   *
   * When the user clicked the Change button on the overridden item.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleConflictChangeButtonClicked(e) {
    return this.track(new Lu(), e);
  }
  /**
   * Business Hours Schedule Conflict Review Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Conflict%20Review%20Button%20Clicked)
   *
   * When the user clicked the Review conflicts button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleConflictReviewButtonClicked(e) {
    return this.track(new Nu(), e);
  }
  /**
   * Business Hours Schedule Delete Exception Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Delete%20Exception%20Form%20Cancelled)
   *
   * When the user cancelled the Delete exception modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleDeleteExceptionFormCancelled(e) {
    return this.track(new Vu(), e);
  }
  /**
   * Business Hours Schedule Delete Exception Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Delete%20Exception%20Form%20Submitted)
   *
   * When the user submitted the Delete exception modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleDeleteExceptionFormSubmitted(e) {
    return this.track(new Bu(), e);
  }
  /**
   * Business Hours Schedule Exception Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Exception%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selected Delete in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleExceptionOptionsMenuOptionDeleteClicked(e, n) {
    return this.track(new Wu(e), n);
  }
  /**
   * Business Hours Schedule Import Holiday Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Import%20Holiday%20Form%20Cancelled)
   *
   * When the user cancelled the Import holiday form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleImportHolidayFormCancelled(e) {
    return this.track(new Hu(), e);
  }
  /**
   * Business Hours Schedule Import Holiday Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Import%20Holiday%20Form%20Submitted)
   *
   * When the user submitted the Import holiday form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. countryCode)
   * @param options Amplitude event options.
   */
  businessHoursScheduleImportHolidayFormSubmitted(e, n) {
    return this.track(new xu(e), n);
  }
  /**
   * Business Hours Schedule Options Menu Import Holidays Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Import%20Holidays%20Clicked)
   *
   * When the user selected Import holidays in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuImportHolidaysClicked(e) {
    return this.track(new Qu(), e);
  }
  /**
   * Business Hours Schedule Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Opened)
   *
   * When the user opened the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuOpened(e) {
    return this.track(new Ku(), e);
  }
  /**
   * Business Hours Schedule Options Menu Recover Holidays Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Recover%20Holidays%20Clicked)
   *
   * When the user selected Recover deleted holidays in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuRecoverHolidaysClicked(e) {
    return this.track(new Gu(), e);
  }
  /**
   * Business Hours Schedule Options Menu Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Rename%20Clicked)
   *
   * When the user selected Rename in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuRenameClicked(e) {
    return this.track(new qu(), e);
  }
  /**
   * Business Hours Schedule Options Menu Timezone Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Timezone%20Clicked)
   *
   * When the user selected Edit timezone in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuTimezoneClicked(e) {
    return this.track(new zu(), e);
  }
  /**
   * Business Hours Schedule Preview Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Preview%20Button%20Clicked)
   *
   * When the user clicked the Preview button.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. view)
   * @param options Amplitude event options.
   */
  businessHoursSchedulePreviewButtonClicked(e, n) {
    return this.track(new $u(e), n);
  }
  /**
   * Business Hours Schedule Recover Holidays Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Recover%20Holidays%20Form%20Cancelled)
   *
   * When the user cancelled the Recover holidays modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleRecoverHolidaysFormCancelled(e) {
    return this.track(new ju(), e);
  }
  /**
   * Business Hours Schedule Recover Holidays Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Recover%20Holidays%20Form%20Submitted)
   *
   * When the user submitted the Recover holidays modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleRecoverHolidaysFormSubmitted(e) {
    return this.track(new Ju(), e);
  }
  /**
   * Business Hours Schedule Review Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Review%20Form%20Cancelled)
   *
   * When the user cancelled the Review conflicts form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleReviewFormCancelled(e) {
    return this.track(new Yu(), e);
  }
  /**
   * Business Hours Schedule Review Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Review%20Form%20Submitted)
   *
   * When the user submitted the Review conflicts form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleReviewFormSubmitted(e) {
    return this.track(new Xu(), e);
  }
  /**
   * Business Hours Schedule Save Schedule Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Save%20Schedule%20Button%20Clicked)
   *
   * When the user clicked the Save schedule button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleSaveScheduleButtonClicked(e) {
    return this.track(new Zu(), e);
  }
  /**
   * Business Hours Schedule Tab Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Tab%20Clicked)
   *
   * When user clicked one of the view tabs.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. view)
   * @param options Amplitude event options.
   */
  businessHoursScheduleTabClicked(e, n) {
    return this.track(new el(e), n);
  }
  /**
   * Business Hours Schedule View Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20View%20Clicked)
   *
   * When the user clicked one of the view buttons.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  businessHoursScheduleViewClicked(e, n) {
    return this.track(new tl(e), n);
  }
  /**
   * Chat Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in chat settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new nl(), e);
  }
  /**
   * Chat Form Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Form%20Canceled)
   *
   * When the user cancels the Widget form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  chatFormCanceled(e, n) {
    return this.track(new rl(e), n);
  }
  /**
   * Chat Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Form%20Opened)
   *
   * When the user opens the create/rename Widget form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  chatFormOpened(e, n) {
    return this.track(new il(e), n);
  }
  /**
   * Chat Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Form%20Submitted)
   *
   * When the user proceed on the Widget form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  chatFormSubmitted(e, n) {
    return this.track(new sl(e), n);
  }
  /**
   * Chat Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Opened)
   *
   * Whether the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOpened(e) {
    return this.track(new ol(), e);
  }
  /**
   * Chat Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionDeleteClicked(e) {
    return this.track(new al(), e);
  }
  /**
   * Chat Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new cl(), e);
  }
  /**
   * Chat Options Menu Option Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Flow%20Clicked)
   *
   * When the user selects Edit flow in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionFlowClicked(e) {
    return this.track(new ul(), e);
  }
  /**
   * Chat Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selects Rename in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionRenameClicked(e) {
    return this.track(new ll(), e);
  }
  /**
   * Chat Options Menu Option Setup Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Setup%20Clicked)
   *
   * When the user selects Setup in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionSetupClicked(e) {
    return this.track(new dl(), e);
  }
  /**
   * Chat Pagination Next Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Pagination%20Next%20Clicked)
   *
   * When the user clicks the next page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatPaginationNextClicked(e) {
    return this.track(new pl(), e);
  }
  /**
   * Chat Pagination Previous Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Pagination%20Previous%20Clicked)
   *
   * When the user clicks the previous page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatPaginationPreviousClicked(e) {
    return this.track(new vl(), e);
  }
  /**
   * Chat Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Search%20Applied)
   *
   * When the user performs a search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatSearchApplied(e) {
    return this.track(new hl(), e);
  }
  /**
   * Chat Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Search%20Closed)
   *
   * When the user closes the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatSearchClosed(e) {
    return this.track(new gl(), e);
  }
  /**
   * Chat Search Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Search%20Opened)
   *
   * When the user opens the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatSearchOpened(e) {
    return this.track(new fl(), e);
  }
  /**
   * Chatbot Create Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Create%20Modal%20Opened)
   *
   * When the user opens the Create new chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotCreateModalOpened(e) {
    return this.track(new yl(), e);
  }
  /**
   * Chatbot Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Created)
   *
   * When the user creates a new chatbot
   *
   * @param properties The event's properties (e.g. chatbotType)
   * @param options Amplitude event options.
   */
  chatbotCreated(e, n) {
    return this.track(new Cl(e), n);
  }
  /**
   * Chatbot Delete Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Delete%20Modal%20Opened)
   *
   * When the user opens the Delete chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotDeleteModalOpened(e) {
    return this.track(new _l(), e);
  }
  /**
   * Chatbot Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Deleted)
   *
   * When the user deletes a chatbot
   *
   * @param properties The event's properties (e.g. chatbotType)
   * @param options Amplitude event options.
   */
  chatbotDeleted(e, n) {
    return this.track(new kl(e), n);
  }
  /**
   * Chatbot Edit Identity Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Edit%20Identity%20Modal%20Opened)
   *
   * When the user opens the Identity chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotEditIdentityModalOpened(e) {
    return this.track(new ml(), e);
  }
  /**
   * Chatbot Identity Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Identity%20Edited)
   *
   * When the user edits the Identity chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotIdentityEdited(e) {
    return this.track(new wl(), e);
  }
  /**
   * Color Mode Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Color%20Mode%20Updated)
   *
   * When the user updates their preferred color mode.
   *
   * @param properties The event's properties (e.g. colorMode)
   * @param options Amplitude event options.
   */
  colorModeUpdated(e, n) {
    return this.track(new Sl(e), n);
  }
  /**
   * Command Executed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Command%20Executed)
   *
   * When the user executes a command.
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  commandExecuted(e, n) {
    return this.track(new bl(e), n);
  }
  /**
   * Command Palette Action Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Command%20Palette%20Action%20Selected)
   *
   * When the user selects an action from the command palette
   *
   * @param properties The event's properties (e.g. actionLabel)
   * @param options Amplitude event options.
   */
  commandPaletteActionSelected(e, n) {
    return this.track(new Il(e), n);
  }
  /**
   * Command Palette Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Command%20Palette%20Closed)
   *
   * When the user closes the command palette without selecting
   *
   * @param properties The event's properties (e.g. closedBy)
   * @param options Amplitude event options.
   */
  commandPaletteClosed(e, n) {
    return this.track(new Al(e), n);
  }
  /**
   * Command Palette Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Command%20Palette%20Opened)
   *
   * How the palette was opened: keyboard, button
   *
   * Owner: Jakob Nielsen
   *
   * @param properties The event's properties (e.g. openedBy)
   * @param options Amplitude event options.
   */
  commandPaletteOpened(e, n) {
    return this.track(new Tl(e), n);
  }
  /**
   * Company Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Company%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on company modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  companyModalFormSubmitted(e, n) {
    return this.track(new El(e), n);
  }
  /**
   * Contacts Add New Company Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Add%20New%20Company%20Clicked)
   *
   * When the user clicks the Add New Company button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsAddNewCompanyClicked(e) {
    return this.track(new Pl(), e);
  }
  /**
   * Contacts Add New Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Add%20New%20Contact%20Clicked)
   *
   * When the user clicks the Add New Contact button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsAddNewContactClicked(e) {
    return this.track(new Ol(), e);
  }
  /**
   * Contacts Ban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Ban%20User%20Clicked)
   *
   * When the user clicks the Ban User button on the Contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  contactsBanUserClicked(e, n) {
    return this.track(new Rl(e), n);
  }
  /**
   * Contacts Card Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Actions%20Menu%20Opened)
   *
   * When the user opens the Actions Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardActionsMenuOpened(e) {
    return this.track(new Fl(), e);
  }
  /**
   * Contacts Card Compose New Email Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Compose%20New%20Email%20Clicked)
   *
   * When the user clicks the Compose New Email button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardComposeNewEmailClicked(e) {
    return this.track(new Dl(), e);
  }
  /**
   * Contacts Card Edit Company Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Edit%20Company%20Clicked)
   *
   * When the user clicks the to edit a company
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardEditCompanyClicked(e) {
    return this.track(new Ml(), e);
  }
  /**
   * Contacts Card Edit Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Edit%20Contact%20Clicked)
   *
   * When the user clicks the to edit a contact
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardEditContactClicked(e) {
    return this.track(new Ul(), e);
  }
  /**
   * Contacts Card Make Call Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Make%20Call%20Clicked)
   *
   * When the user clicks to make a call in the contact card
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardMakeCallClicked(e) {
    return this.track(new Ll(), e);
  }
  /**
   * Contacts Card See All Assigned Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20See%20All%20Assigned%20Conversations%20Clicked)
   *
   * When the user clicks the button to see all assigned conversations
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardSeeAllAssignedConversationsClicked(e) {
    return this.track(new Nl(), e);
  }
  /**
   * Contacts Card See All Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20See%20All%20Conversations%20Clicked)
   *
   * When the user clicks the button to see all conversations
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardSeeAllConversationsClicked(e) {
    return this.track(new Vl(), e);
  }
  /**
   * Contacts Card View Company Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20View%20Company%20Clicked)
   *
   * When the user clicks to view the company in the contacts card
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardViewCompanyClicked(e) {
    return this.track(new Bl(), e);
  }
  /**
   * Contacts Card View User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20View%20User%20Clicked)
   *
   * When the user clicks to view the user in the contacts card
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardViewUserClicked(e) {
    return this.track(new Wl(), e);
  }
  /**
   * Contacts Search Blurred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Search%20Blurred)
   *
   * When the search input is blurred
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsSearchBlurred(e) {
    return this.track(new Hl(), e);
  }
  /**
   * Contacts Search Focused
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Search%20Focused)
   *
   * When the search input is focused
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsSearchFocused(e) {
    return this.track(new xl(), e);
  }
  /**
   * Contacts Unban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Unban%20User%20Clicked)
   *
   * When the user clicks the Unban User button on the Contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  contactsUnbanUserClicked(e, n) {
    return this.track(new Ql(e), n);
  }
  /**
   * Contacts View Companies
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20View%20Companies)
   *
   * When the user selects Companies in the dropdown in the contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsViewCompanies(e) {
    return this.track(new Kl(), e);
  }
  /**
   * Contacts View End Users
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20View%20End%20Users)
   *
   * When the user selects Contacts from the dropdown in the contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsViewEndUsers(e) {
    return this.track(new Gl(), e);
  }
  /**
   * Conversation Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Actions%20Menu%20Opened)
   *
   * When the user opens the Actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationActionsMenuOpened(e) {
    return this.track(new ql(), e);
  }
  /**
   * Conversation Actions Menu Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Actions%20Menu%20Option%20Clicked)
   *
   * When the user selects an option from the Actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. option)
   * @param options Amplitude event options.
   */
  conversationActionsMenuOptionClicked(e, n) {
    return this.track(new zl(e), n);
  }
  /**
   * Conversation Activity Log Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Activity%20Log%20Closed)
   *
   * When the user closed the Activity Log
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationActivityLogClosed(e) {
    return this.track(new $l(), e);
  }
  /**
   * Conversation Activity Log Flooter Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Activity%20Log%20Flooter%20Expanded)
   *
   * When the agent has expanded the Flooter.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationActivityLogFlooterExpanded(e) {
    return this.track(new jl(), e);
  }
  /**
   * Conversation Activity Log Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Activity%20Log%20Opened)
   *
   * When the user opens the Activity Log
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  conversationActivityLogOpened(e, n) {
    return this.track(new Jl(e), n);
  }
  /**
   * Conversation Article Draft Improvement Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Improvement%20Requested)
   *
   * Event triggered when an agent requests improvements to a drafted article for a conversation.
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftImprovementRequested(e, n) {
    return this.track(new Yl(e), n);
  }
  /**
   * Conversation Article Draft Improvement Response Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Improvement%20Response%20Received)
   *
   * Event indicating that a response has been received for improving a draft article within a conversation.
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftImprovementResponseReceived(e, n) {
    return this.track(new Xl(e), n);
  }
  /**
   * Conversation Article Draft Preview Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Preview%20Requested)
   *
   * Event indicating that a user has requested a preview of a draft article within a conversation.
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftPreviewRequested(e, n) {
    return this.track(new Zl(e), n);
  }
  /**
   * Conversation Article Draft Preview Response Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Preview%20Response%20Received)
   *
   * Event indicating that a draft article preview was received for a conversation.
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftPreviewResponseReceived(e, n) {
    return this.track(new ed(e), n);
  }
  /**
   * Conversation Article Draft Save Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Save%20Requested)
   *
   * Event indicating that a user has requested to save a draft of an article within a conversation.
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftSaveRequested(e, n) {
    return this.track(new td(e), n);
  }
  /**
   * Conversation Article Draft Save Response Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Save%20Response%20Received)
   *
   * Event indicating that saving a draft of an article in a conversation has succeeded.
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftSaveResponseReceived(e, n) {
    return this.track(new nd(e), n);
  }
  /**
   * Conversation Attached Image Is Downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Attached%20Image%20Is%20Downloaded)
   *
   * When the user downloads an image attachment from the preview modal
   *
   * @param options Amplitude event options.
   */
  conversationAttachedImageIsDownloaded(e) {
    return this.track(new rd(), e);
  }
  /**
   * Conversation Attached Image Is Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Attached%20Image%20Is%20Viewed)
   *
   * When the user clicks on an image attachment that opens the preview
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationAttachedImageIsViewed(e) {
    return this.track(new id(), e);
  }
  /**
   * Conversation Claimed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Claimed)
   *
   * When the user claims the conversation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationClaimed(e, n) {
    return this.track(new sd(e), n);
  }
  /**
   * Conversation Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Closed)
   *
   * When the user closes the conversatio
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationClosed(e, n) {
    return this.track(new od(e), n);
  }
  /**
   * Conversation Csat Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Cancelled)
   *
   * When the user cancels the CSAT
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationCsatCancelled(e) {
    return this.track(new ad(), e);
  }
  /**
   * Conversation Csat Menu Cancel Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Menu%20Cancel%20Option%20Clicked)
   *
   * When the user clicks the Cancel CSAT menu option
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationCsatMenuCancelOptionClicked(e) {
    return this.track(new cd(), e);
  }
  /**
   * Conversation Csat Menu Language Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Menu%20Language%20Selected)
   *
   * When the user changes the language from the CSAT menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. languageCode)
   * @param options Amplitude event options.
   */
  conversationCsatMenuLanguageSelected(e, n) {
    return this.track(new ud(e), n);
  }
  /**
   * Conversation Csat Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Menu%20Opened)
   *
   * When the user opens the CSAT menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationCsatMenuOpened(e) {
    return this.track(new ld(), e);
  }
  /**
   * Conversation Focus Mode Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Focus%20Mode%20Toggled)
   *
   * When user decides to turn on or off Focus mode (which makes the area for writing messages bigger)
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationFocusModeToggled(e, n) {
    return this.track(new dd(e), n);
  }
  /**
   * Conversation Follow Up
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Follow%20Up)
   *
   * When a conversation was followed up.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationFollowUp(e, n) {
    return this.track(new pd(e), n);
  }
  /**
   * Conversation Follow Up Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Follow%20Up%20Menu%20Opened)
   *
   * When the user opens the Follow Up menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationFollowUpMenuOpened(e) {
    return this.track(new vd(), e);
  }
  /**
   * Conversation Follow Up Menu Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Follow%20Up%20Menu%20Option%20Clicked)
   *
   * When the user selects an option from the Follow Up menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. option)
   * @param options Amplitude event options.
   */
  conversationFollowUpMenuOptionClicked(e, n) {
    return this.track(new hd(e), n);
  }
  /**
   * Conversation Header Conversation Details Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Conversation%20Details%20Menu%20Opened)
   *
   * When the user opens conversation details dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderConversationDetailsMenuOpened(e) {
    return this.track(new gd(), e);
  }
  /**
   * Conversation Header Tag Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Added)
   *
   * When the user adds a tag from tag dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  conversationHeaderTagAdded(e, n) {
    return this.track(new fd(e), n);
  }
  /**
   * Conversation Header Tag Include Deactivated Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Include%20Deactivated%20Toggled)
   *
   * When the user toggles Include deactivated tags in tag select dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. include)
   * @param options Amplitude event options.
   */
  conversationHeaderTagIncludeDeactivatedToggled(e, n) {
    return this.track(new yd(e), n);
  }
  /**
   * Conversation Header Tag Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Menu%20Opened)
   *
   * When the user opens tags select dropdown from conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTagMenuOpened(e) {
    return this.track(new Cd(), e);
  }
  /**
   * Conversation Header Tag Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Removed)
   *
   * When the user removes a tag from conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  conversationHeaderTagRemoved(e, n) {
    return this.track(new _d(e), n);
  }
  /**
   * Conversation Header Transfer To Agent Item Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Agent%20Item%20Selected)
   *
   * When the user selects an agent from transfer to agent dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToAgentItemSelected(e) {
    return this.track(new kd(), e);
  }
  /**
   * Conversation Header Transfer To Agent Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Agent%20Menu%20Opened)
   *
   * When the user opens the transfer to agent dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToAgentMenuOpened(e) {
    return this.track(new md(), e);
  }
  /**
   * Conversation Header Transfer To Number Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Number%20Button%20Clicked)
   *
   * When the user clicks on transfer to number button in the conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToNumberButtonClicked(e) {
    return this.track(new wd(), e);
  }
  /**
   * Conversation Header Transfer To Queue Item Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Queue%20Item%20Selected)
   *
   * When the user selects a queue from transfer to queue dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. queue)
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToQueueItemSelected(e, n) {
    return this.track(new Sd(e), n);
  }
  /**
   * Conversation Header Transfer To Queue Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Queue%20Menu%20Opened)
   *
   * When the user opens the transfer to queue dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToQueueMenuOpened(e) {
    return this.track(new bd(), e);
  }
  /**
   * Conversation Internal Note Editor Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Internal%20Note%20Editor%20Opened)
   *
   * When the user opens the internal note tab
   *
   * @param options Amplitude event options.
   */
  conversationInternalNoteEditorOpened(e) {
    return this.track(new Id(), e);
  }
  /**
   * Conversation Message Redaction Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Message%20Redaction%20Modal%20Opened)
   *
   * When a redact message modal is opened
   *
   * @param options Amplitude event options.
   */
  conversationMessageRedactionModalOpened(e) {
    return this.track(new Ad(), e);
  }
  /**
   * Conversation Message Redaction Modal Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Message%20Redaction%20Modal%20Submitted)
   *
   * When a message redaction modal is submitted
   *
   * @param options Amplitude event options.
   */
  conversationMessageRedactionModalSubmitted(e) {
    return this.track(new Td(), e);
  }
  /**
   * Conversation Offered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Offered)
   *
   * When a conversation was offered to an agent
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationOffered(e, n) {
    return this.track(new Ed(e), n);
  }
  /**
   * Conversation Replied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Replied)
   *
   * When the user replies a conversation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationReplied(e, n) {
    return this.track(new Pd(e), n);
  }
  /**
   * Conversation Reply Window Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Reply%20Window%20Toggled)
   *
   * User toggled conversation reply window configuration
   *
   * @param properties The event's properties (e.g. isEnabled)
   * @param options Amplitude event options.
   */
  conversationReplyWindowToggled(e, n) {
    return this.track(new Od(e), n);
  }
  /**
   * Conversation Resolved As A Knowledge Article Draft
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20As%20A%20Knowledge%20Article%20Draft)
   *
   * When a user chooses to create a draft when they resolve a conversation
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedAsAKnowledgeArticleDraft(e, n) {
    return this.track(new Rd(e), n);
  }
  /**
   * Conversation Resolved As A Knowledge Gap
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20As%20A%20Knowledge%20Gap)
   *
   * When a user chooses to register a knowledge gap when they resolve a conversation
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedAsAKnowledgeGap(e, n) {
    return this.track(new Fd(e), n);
  }
  /**
   * Conversation Resolved By Knowledge
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20By%20Knowledge)
   *
   * When a user resolves a conversation using the knowledge flow
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedByKnowledge(e, n) {
    return this.track(new Dd(e), n);
  }
  /**
   * Conversation Resolved With No Knowledge Article
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20With%20No%20Knowledge%20Article)
   *
   * When a user chooses to resolve a conversation without marking any knowledge article as having helped
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedWithNoKnowledgeArticle(e, n) {
    return this.track(new Md(e), n);
  }
  /**
   * Conversation Right Sidebar Item Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Right%20Sidebar%20Item%20Reordered)
   *
   * When the user reorders a card or section in a conversation right sidebar
   *
   * @param properties The event's properties (e.g. sidebarItemType)
   * @param options Amplitude event options.
   */
  conversationRightSidebarItemReordered(e, n) {
    return this.track(new Ud(e), n);
  }
  /**
   * Conversation Right Sidebar Item Visibility Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Right%20Sidebar%20Item%20Visibility%20Toggled)
   *
   * When the user toggles visibility of a card/section
   *
   * @param properties The event's properties (e.g. isVisible)
   * @param options Amplitude event options.
   */
  conversationRightSidebarItemVisibilityToggled(e, n) {
    return this.track(new Ld(e), n);
  }
  /**
   * Conversation Sidebar Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Closed)
   *
   * When the user closes the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarClosed(e) {
    return this.track(new Nd(), e);
  }
  /**
   * Conversation Sidebar Conversation History Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Conversation%20History%20Closed)
   *
   * When the user closes the accordion item conversation history
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarConversationHistoryClosed(e) {
    return this.track(new Vd(), e);
  }
  /**
   * Conversation Sidebar Conversation History Navigated To Conversation
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Conversation%20History%20Navigated%20To%20Conversation)
   *
   * When the user navigates to a conversation listed in the conversation history accordion item in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarConversationHistoryNavigatedToConversation(e) {
    return this.track(new Bd(), e);
  }
  /**
   * Conversation Sidebar Conversation History Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Conversation%20History%20Opened)
   *
   * When the user opens the accordion item conversation history
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarConversationHistoryOpened(e) {
    return this.track(new Wd(), e);
  }
  /**
   * Conversation Sidebar Customer Info Email Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Customer%20Info%20Email%20Clicked)
   *
   * When the user opens compose email from clicking the customers email in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarCustomerInfoEmailClicked(e) {
    return this.track(new Hd(), e);
  }
  /**
   * Conversation Sidebar Customer Info Phone Number Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Customer%20Info%20Phone%20Number%20Clicked)
   *
   * When the user starts phone call from clicking the customers phone number in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarCustomerInfoPhoneNumberClicked(e) {
    return this.track(new xd(), e);
  }
  /**
   * Conversation Sidebar Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Opened)
   *
   * When the user opens the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarOpened(e) {
    return this.track(new Qd(), e);
  }
  /**
   * Conversation Timeline Item Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Timeline%20Item%20Opened)
   *
   * When the user clicks an item in the conversation timeline
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationTimelineItemOpened(e) {
    return this.track(new Kd(), e);
  }
  /**
   * Conversation Timeline Navigated To Conversation
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Timeline%20Navigated%20To%20Conversation)
   *
   * When the user clicks a conversation listed in a timeline item
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationTimelineNavigatedToConversation(e) {
    return this.track(new Gd(), e);
  }
  /**
   * Conversation Transferred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Transferred)
   *
   * When a conversation was transferred.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationTransferred(e, n) {
    return this.track(new qd(e), n);
  }
  /**
   * Conversations Bulk Actions Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Bulk%20Actions%20Clicked)
   *
   * When the user clicks the Bulk Actions button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  conversationsBulkActionsClicked(e, n) {
    return this.track(new zd(e), n);
  }
  /**
   * Conversations Clear All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Clear%20All%20Clicked)
   *
   * When the user clicks the clear all checkbox
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsClearAllClicked(e) {
    return this.track(new $d(), e);
  }
  /**
   * Conversations Filter Agent Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Agent%20Clicked)
   *
   * When the user clicks the Filter Conversations" button for the agent"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  conversationsFilterAgentClicked(e, n) {
    return this.track(new jd(e), n);
  }
  /**
   * Conversations Filter Clear All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Clear%20All%20Clicked)
   *
   * When the user clicks the Clear all button in the Conversations filters
   *
   * @param options Amplitude event options.
   */
  conversationsFilterClearAllClicked(e) {
    return this.track(new Jd(), e);
  }
  /**
   * Conversations Filter Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Cleared)
   *
   * When the user clears a conversations filter
   *
   * @param properties The event's properties (e.g. filter)
   * @param options Amplitude event options.
   */
  conversationsFilterCleared(e, n) {
    return this.track(new Yd(e), n);
  }
  /**
   * Conversations Filter Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Contact%20Clicked)
   *
   * When the user clicks the Filter Conversations" button for the contact"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  conversationsFilterContactClicked(e, n) {
    return this.track(new Xd(e), n);
  }
  /**
   * Conversations Filter Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Toggled)
   *
   * When the user toggles a conversations filter
   *
   * @param properties The event's properties (e.g. checked)
   * @param options Amplitude event options.
   */
  conversationsFilterToggled(e, n) {
    return this.track(new Zd(e), n);
  }
  /**
   * Conversations Go To Conversation Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Go%20To%20Conversation%20Clicked)
   *
   * When the user clicks the Go To Conversations button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  conversationsGoToConversationClicked(e, n) {
    return this.track(new ep(e), n);
  }
  /**
   * Conversations Item Preview Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Item%20Preview%20Clicked)
   *
   * When the user clicks the preview conversation button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsItemPreviewClicked(e) {
    return this.track(new tp(), e);
  }
  /**
   * Conversations Next Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Next%20Page%20Clicked)
   *
   * When the user clicks the Next Page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsNextPageClicked(e) {
    return this.track(new np(), e);
  }
  /**
   * Conversations Previous Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Previous%20Page%20Clicked)
   *
   * When the user clicks the Previous Page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsPreviousPageClicked(e) {
    return this.track(new rp(), e);
  }
  /**
   * Conversations Select All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Select%20All%20Clicked)
   *
   * When the user clicks the select all checkbox
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsSelectAllClicked(e) {
    return this.track(new ip(), e);
  }
  /**
   * Conversations Select Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Select%20Clicked)
   *
   * When the user clicks the select checkbox for a single conversation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  conversationsSelectClicked(e, n) {
    return this.track(new sp(e), n);
  }
  /**
   * Conversations Timestamp Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Timestamp%20Clicked)
   *
   * When the user clicks a timestamp
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  conversationsTimestampClicked(e, n) {
    return this.track(new op(e), n);
  }
  /**
   * Conversations Transfer To Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Transfer%20To%20Queue%20Clicked)
   *
   * When the user clicks the Transfer To Queue button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsTransferToQueueClicked(e) {
    return this.track(new ap(), e);
  }
  /**
   * Conversations View Agent Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20View%20Agent%20Clicked)
   *
   * When the user clicks the View Agent button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsViewAgentClicked(e) {
    return this.track(new cp(), e);
  }
  /**
   * Conversations View Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20View%20Contact%20Clicked)
   *
   * When the user clicks the View Contact button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsViewContactClicked(e) {
    return this.track(new up(), e);
  }
  /**
   * ConversationSummaryFeedbackNotUseful
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/ConversationSummaryFeedbackNotUseful)
   *
   * When an agent doesn't find the summary of conversation useful and clicks on thumbs down button.
   *
   * @param properties The event's properties (e.g. summaryId)
   * @param options Amplitude event options.
   */
  conversationSummaryFeedbackNotUseful(e, n) {
    return this.track(new lp(e), n);
  }
  /**
   * ConversationSummaryFeedbackUseful
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/ConversationSummaryFeedbackUseful)
   *
   * When an agent finds the summary of conversation useful and clicks on thumbs up button.
   *
   * @param properties The event's properties (e.g. summaryId)
   * @param options Amplitude event options.
   */
  conversationSummaryFeedbackUseful(e, n) {
    return this.track(new dp(e), n);
  }
  /**
   * ConversationSummaryRegenerateSummary
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/ConversationSummaryRegenerateSummary)
   *
   * When an agent requests for a new conversation summary
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  conversationSummaryRegenerateSummary(e, n) {
    return this.track(new pp(e), n);
  }
  /**
   * Copy Script
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Copy%20Script)
   *
   * When the user copy the Dixa Widget script
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  copyScript(e) {
    return this.track(new vp(), e);
  }
  /**
   * Country Code Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Country%20Code%20Selected)
   *
   * When the user selects a country from the Country Code Dropdown in Telephony Search User field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  countryCodeSelected(e) {
    return this.track(new hp(), e);
  }
  /**
   * Custom Attribute Value Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Custom%20Attribute%20Value%20Updated)
   *
   * Whenever the user updates value of a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  customAttributeValueUpdated(e, n) {
    return this.track(new gp(e), n);
  }
  /**
   * Dashboard Channel All Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20All%20Conversations%20Clicked)
   *
   * When the user clicks the link to see all the channel conversations in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardChannelAllConversationsClicked(e) {
    return this.track(new fp(), e);
  }
  /**
   * Dashboard Channel Go To Analytics Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20Go%20To%20Analytics%20Clicked)
   *
   * When the user clicks the link to go to the channel Analytics
   *
   * @param options Amplitude event options.
   */
  dashboardChannelGoToAnalyticsClicked(e) {
    return this.track(new yp(), e);
  }
  /**
   * Dashboard Channel Longest Queued Time Metric Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20Longest%20Queued%20Time%20Metric%20Clicked)
   *
   * When the user clicks the longest queued time metric in the channel dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardChannelLongestQueuedTimeMetricClicked(e) {
    return this.track(new Cp(), e);
  }
  /**
   * Dashboard Channel Name Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20Name%20Clicked)
   *
   * When the user clicks the channel name link in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardChannelNameClicked(e) {
    return this.track(new _p(), e);
  }
  /**
   * Dashboard Channel Pending Conversations Metric Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20Pending%20Conversations%20Metric%20Clicked)
   *
   * When the user clicks the pending conversations metric in the channel dashboard
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  dashboardChannelPendingConversationsMetricClicked(e, n) {
    return this.track(new kp(e), n);
  }
  /**
   * Dashboard Channel Tv Dashboard Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20Tv%20Dashboard%20Clicked)
   *
   * When the user clicks the link to see the channel tv dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardChannelTvDashboardClicked(e) {
    return this.track(new mp(), e);
  }
  /**
   * Dashboard Favorite Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Favorite%20Created)
   *
   * When the user creates a new dashboard favorite
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  dashboardFavoriteCreated(e, n) {
    return this.track(new wp(e), n);
  }
  /**
   * Dashboard Favorite Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Favorite%20Deleted)
   *
   * When the user deletes a dashboard favorite
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  dashboardFavoriteDeleted(e, n) {
    return this.track(new Sp(e), n);
  }
  /**
   * Dashboard Favorite Landing Page Set
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Favorite%20Landing%20Page%20Set)
   *
   * When the user sets a dashboard favorite as their landing page
   *
   * @param properties The event's properties (e.g. isOwner)
   * @param options Amplitude event options.
   */
  dashboardFavoriteLandingPageSet(e, n) {
    return this.track(new bp(e), n);
  }
  /**
   * Dashboard Favorite Landing Page Unset
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Favorite%20Landing%20Page%20Unset)
   *
   * When the user removes a dashboard favorite as their landing page
   *
   * @param properties The event's properties (e.g. isOwner)
   * @param options Amplitude event options.
   */
  dashboardFavoriteLandingPageUnset(e, n) {
    return this.track(new Ip(e), n);
  }
  /**
   * Dashboard Favorite Ownership Transferred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Favorite%20Ownership%20Transferred)
   *
   * When the user transfers ownership a dashboard favorite
   *
   * @param options Amplitude event options.
   */
  dashboardFavoriteOwnershipTransferred(e) {
    return this.track(new Ap(), e);
  }
  /**
   * Dashboard Favorite Queues Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Favorite%20Queues%20Reordered)
   *
   * When the user reorders the queues in a dashboard favorite
   *
   * @param options Amplitude event options.
   */
  dashboardFavoriteQueuesReordered(e) {
    return this.track(new Tp(), e);
  }
  /**
   * Dashboard Favorite Sharing Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Favorite%20Sharing%20Toggled)
   *
   * When the user shares or unshares a dashboard favorite
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  dashboardFavoriteSharingToggled(e, n) {
    return this.track(new Ep(e), n);
  }
  /**
   * Dashboard Favorite Tv Dashboard Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Favorite%20Tv%20Dashboard%20Clicked)
   *
   * When the user clicks the link to see the favorite tv dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardFavoriteTvDashboardClicked(e) {
    return this.track(new Pp(), e);
  }
  /**
   * Dashboard Favorite Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Favorite%20Updated)
   *
   * When the user updates a dashboard favorite
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  dashboardFavoriteUpdated(e, n) {
    return this.track(new Op(e), n);
  }
  /**
   * Dashboard Favorite Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Favorite%20Viewed)
   *
   * When the user views a dashboard favorite list
   *
   * @param properties The event's properties (e.g. isOwner)
   * @param options Amplitude event options.
   */
  dashboardFavoriteViewed(e, n) {
    return this.track(new Rp(e), n);
  }
  /**
   * Dashboard Global Tv Dashboard Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Global%20Tv%20Dashboard%20Clicked)
   *
   * When the user clicks the global tv dashboard button
   *
   * @param options Amplitude event options.
   */
  dashboardGlobalTvDashboardClicked(e) {
    return this.track(new Fp(), e);
  }
  /**
   * Dashboard Layout Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Layout%20Changed)
   *
   * When the user changes the dashboard layout
   *
   * @param properties The event's properties (e.g. layout)
   * @param options Amplitude event options.
   */
  dashboardLayoutChanged(e, n) {
    return this.track(new Dp(e), n);
  }
  /**
   * Dashboard Longest Queued Time Metric Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Longest%20Queued%20Time%20Metric%20Clicked)
   *
   * When the user clicks the longest queued time metric in the queue dashboard
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  dashboardLongestQueuedTimeMetricClicked(e, n) {
    return this.track(new Mp(e), n);
  }
  /**
   * Dashboard Metric Helper Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Metric%20Helper%20Clicked)
   *
   * When the user clicks on the helper button on a metric
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  dashboardMetricHelperClicked(e, n) {
    return this.track(new Up(e), n);
  }
  /**
   * Dashboard Next Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Next%20Page%20Clicked)
   *
   * When the user clicks the next page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  dashboardNextPageClicked(e) {
    return this.track(new Lp(), e);
  }
  /**
   * Dashboard Organization Timezone Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Organization%20Timezone%20Settings%20Clicked)
   *
   * When the user clicks on the link to go to organization settings from the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardOrganizationTimezoneSettingsClicked(e) {
    return this.track(new Np(), e);
  }
  /**
   * Dashboard Previous Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Previous%20Page%20Clicked)
   *
   * When the user clicks the previous page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  dashboardPreviousPageClicked(e) {
    return this.track(new Vp(), e);
  }
  /**
   * Dashboard Queue All Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20All%20Conversations%20Clicked)
   *
   * When the user clicks the link to see all the queue conversations in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardQueueAllConversationsClicked(e) {
    return this.track(new Bp(), e);
  }
  /**
   * Dashboard Queue Go To Analytics Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Go%20To%20Analytics%20Clicked)
   *
   * When the user clicks the link to go to the queue Analytics
   *
   * @param options Amplitude event options.
   */
  dashboardQueueGoToAnalyticsClicked(e) {
    return this.track(new Wp(), e);
  }
  /**
   * Dashboard Queue Item Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Item%20Favorite%20Toggled)
   *
   * When the user adds or removes a queue from favorites
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  dashboardQueueItemFavoriteToggled(e, n) {
    return this.track(new Hp(e), n);
  }
  /**
   * Dashboard Queue Name Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Name%20Clicked)
   *
   * When the user clicks the queue name link in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardQueueNameClicked(e) {
    return this.track(new xp(), e);
  }
  /**
   * Dashboard Queue Pending Conversations Metric Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Pending%20Conversations%20Metric%20Clicked)
   *
   * When the user clicks the pending conversations metric in the queue dashboard
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  dashboardQueuePendingConversationsMetricClicked(e, n) {
    return this.track(new Qp(e), n);
  }
  /**
   * Dashboard Queue Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Settings%20Clicked)
   *
   * When the user clicks the link to go to the queue settings
   *
   * @param options Amplitude event options.
   */
  dashboardQueueSettingsClicked(e) {
    return this.track(new Kp(), e);
  }
  /**
   * Dashboard Queue Tv Dashboard Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Tv%20Dashboard%20Clicked)
   *
   * When the user clicks the link to see the queue tv dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardQueueTvDashboardClicked(e) {
    return this.track(new Gp(), e);
  }
  /**
   * Dashboard Queues Manually Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Manually%20Selected)
   *
   * When the user manually selects which queues to show in the dashboard
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  dashboardQueuesManuallySelected(e, n) {
    return this.track(new qp(e), n);
  }
  /**
   * Dashboard Queues Search Field Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Search%20Field%20Cleared)
   *
   * When the user clears the query in the queues search field
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  dashboardQueuesSearchFieldCleared(e, n) {
    return this.track(new zp(e), n);
  }
  /**
   * Dashboard Queues Search Field Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Search%20Field%20Submitted)
   *
   * When the user submits the query in the queues search field
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  dashboardQueuesSearchFieldSubmitted(e, n) {
    return this.track(new $p(e), n);
  }
  /**
   * Dashboard Queues Sorting Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Sorting%20Updated)
   *
   * When the user updates the queues sorting on the dashboard
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  dashboardQueuesSortingUpdated(e, n) {
    return this.track(new jp(e), n);
  }
  /**
   * Dashboard Queues Type Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Type%20Changed)
   *
   * When the user changes the queues type
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  dashboardQueuesTypeChanged(e, n) {
    return this.track(new Jp(e), n);
  }
  /**
   * Dashboard Refresh Data Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Refresh%20Data%20Clicked)
   *
   * When the user clicks the refresh data button in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardRefreshDataClicked(e) {
    return this.track(new Yp(), e);
  }
  /**
   * Dashboard Tv Reloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Tv%20Reloaded)
   *
   * When the TV dashboard is automatically reloaded
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  dashboardTvReloaded(e, n) {
    return this.track(new Xp(e), n);
  }
  /**
   * Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Viewed)
   *
   * When the user views the dashboard
   *
   * @param properties The event's properties (e.g. layout)
   * @param options Amplitude event options.
   */
  dashboardViewed(e, n) {
    return this.track(new Zp(e), n);
  }
  /**
   * Email Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in email settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new ev(), e);
  }
  /**
   * Email Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Form%20Submitted)
   *
   * When the user proceeds on the Email form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  emailFormSubmitted(e, n) {
    return this.track(new tv(e), n);
  }
  /**
   * Email Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Opened)
   *
   * When the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOpened(e) {
    return this.track(new nv(), e);
  }
  /**
   * Email Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionDeleteClicked(e) {
    return this.track(new rv(), e);
  }
  /**
   * Email Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new iv(), e);
  }
  /**
   * Email Options Menu Option Email Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Email%20Clicked)
   *
   * When the user selects Edit Email in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionEmailClicked(e) {
    return this.track(new sv(), e);
  }
  /**
   * Email Options Menu Option Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Flow%20Clicked)
   *
   * When the user selects Edit Flow in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionFlowClicked(e) {
    return this.track(new ov(), e);
  }
  /**
   * Email Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selects Rename in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionRenameClicked(e) {
    return this.track(new av(), e);
  }
  /**
   * Email Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Search%20Applied)
   *
   * When the user performs a search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailSearchApplied(e) {
    return this.track(new cv(), e);
  }
  /**
   * Email Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Search%20Closed)
   *
   * When the user closes the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailSearchClosed(e) {
    return this.track(new uv(), e);
  }
  /**
   * Email Search Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Search%20Opened)
   *
   * When the user opens the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailSearchOpened(e) {
    return this.track(new lv(), e);
  }
  /**
   * Flow Action Add Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Add%20Saved)
   *
   * When the user added an action and saved it.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionAddSaved(e, n) {
    return this.track(new dv(e), n);
  }
  /**
   * Flow Action Condition Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Condition%20Added)
   *
   * When the user adds a condition to a branch/condition-action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionConditionAdded(e, n) {
    return this.track(new pv(e), n);
  }
  /**
   * Flow Action Condition Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Condition%20Removed)
   *
   * When the user adds a condition to a branch/condition-action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionConditionRemoved(e, n) {
    return this.track(new vv(e), n);
  }
  /**
   * Flow Action Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Deleted)
   *
   * When the user deletes a node in a flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionDeleted(e, n) {
    return this.track(new hv(e), n);
  }
  /**
   * Flow Action Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Edit%20Clicked)
   *
   * When the user clicks the edit button on an action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionEditClicked(e, n) {
    return this.track(new gv(e), n);
  }
  /**
   * Flow Action Edit Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Edit%20Saved)
   *
   * When the user saves an action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionEditSaved(e, n) {
    return this.track(new fv(e), n);
  }
  /**
   * Flow Activate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Activate%20Clicked)
   *
   * When the user saves a flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActivateClicked(e, n) {
    return this.track(new yv(e), n);
  }
  /**
   * Flow Add Action Action Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Add%20Action%20Action%20Selected)
   *
   * When the user selects a specific action to add
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowAddActionActionSelected(e, n) {
    return this.track(new Cv(e), n);
  }
  /**
   * Flow Add Action Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Add%20Action%20Cancelled)
   *
   * When the user closes the add action modal without making a selection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowAddActionCancelled(e, n) {
    return this.track(new _v(e), n);
  }
  /**
   * Flow Add Action Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Add%20Action%20Opened)
   *
   * When the user opens the add action modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowAddActionOpened(e, n) {
    return this.track(new kv(e), n);
  }
  /**
   * Flow Back To Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Back%20To%20Settings%20Clicked)
   *
   * When the user clicks the go back to settings button in a Flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowBackToSettingsClicked(e, n) {
    return this.track(new mv(e), n);
  }
  /**
   * Flow Context Align Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Align%20Clicked)
   *
   * When the user clicks Align" in the context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextAlignClicked(e, n) {
    return this.track(new wv(e), n);
  }
  /**
   * Flow Context Delete Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Delete%20Cancel%20Clicked)
   *
   * When the user clicks Cancel" in the confirm modal after clicking the "Delete" option in context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextDeleteCancelClicked(e, n) {
    return this.track(new Sv(e), n);
  }
  /**
   * Flow Context Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Delete%20Clicked)
   *
   * When the user clicks Delete" in the context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextDeleteClicked(e, n) {
    return this.track(new bv(e), n);
  }
  /**
   * Flow Context Delete Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Delete%20Confirm%20Clicked)
   *
   * When the user clicks Confirm" in the confirm modal after clicking the "Delete" option in context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextDeleteConfirmClicked(e, n) {
    return this.track(new Iv(e), n);
  }
  /**
   * Flow Context Node Arrange Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Node%20Arrange%20Clicked)
   *
   * When the user clicks Arrange nodes" in the context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextNodeArrangeClicked(e, n) {
    return this.track(new Av(e), n);
  }
  /**
   * Flow Phone Number Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Phone%20Number%20Changed)
   *
   * When the user changed the phone number in the phone flow.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  flowPhoneNumberChanged(e) {
    return this.track(new Tv(), e);
  }
  /**
   * Flow Save Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Save%20Clicked)
   *
   * When the user saves a flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowSaveClicked(e, n) {
    return this.track(new Ev(e), n);
  }
  /**
   * Flow Title Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Title%20Edit%20Clicked)
   *
   * When the user clicks the Flow Title to Edit
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowTitleEditClicked(e, n) {
    return this.track(new Pv(e), n);
  }
  /**
   * Flow Zoom In Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Zoom%20In%20Clicked)
   *
   * When the user uses zooms in using the zoom control
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowZoomInClicked(e, n) {
    return this.track(new Ov(e), n);
  }
  /**
   * Flow Zoom Out Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Zoom%20Out%20Clicked)
   *
   * When the user uses zooms out using the zoom control
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowZoomOutClicked(e, n) {
    return this.track(new Rv(e), n);
  }
  /**
   * Flow Zoom Reset Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Zoom%20Reset%20Clicked)
   *
   * When the user reset the zoom level using the zoom control
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowZoomResetClicked(e, n) {
    return this.track(new Fv(e), n);
  }
  /**
   * Follow Up Conversation Modal Internal Note Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Follow%20Up%20Conversation%20Modal%20Internal%20Note%20Added)
   *
   * When the user selects the option to include an internal note
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  followUpConversationModalInternalNoteAdded(e) {
    return this.track(new Dv(), e);
  }
  /**
   * Follow Up Conversation Modal Offer In Queue Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Follow%20Up%20Conversation%20Modal%20Offer%20In%20Queue%20Added)
   *
   * When the user selects the option to offer the conversation in the queue
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  followUpConversationModalOfferInQueueAdded(e) {
    return this.track(new Mv(), e);
  }
  /**
   * Intelligence Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Dashboard%20Viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  intelligenceDashboardViewed(e, n) {
    return this.track(new Uv(e), n);
  }
  /**
   * Intelligence Distribution Chart Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Distribution%20Chart%20Opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  intelligenceDistributionChartOpened(e, n) {
    return this.track(new Lv(e), n);
  }
  /**
   * Intelligence Evolution Chart Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Evolution%20Chart%20Opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  intelligenceEvolutionChartOpened(e, n) {
    return this.track(new Nv(e), n);
  }
  /**
   * Intelligence Filter Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Filter%20Changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. changeType)
   * @param options Amplitude event options.
   */
  intelligenceFilterChanged(e, n) {
    return this.track(new Vv(e), n);
  }
  /**
   * Intelligence Filter Period Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Filter%20Period%20Changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. dayCount)
   * @param options Amplitude event options.
   */
  intelligenceFilterPeriodChanged(e, n) {
    return this.track(new Bv(e), n);
  }
  /**
   * Intelligence Group By Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Group%20By%20Changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. changeType)
   * @param options Amplitude event options.
   */
  intelligenceGroupByChanged(e, n) {
    return this.track(new Wv(e), n);
  }
  /**
   * Intelligence Preset Comparison Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Preset%20Comparison%20Started)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. presetCount)
   * @param options Amplitude event options.
   */
  intelligencePresetComparisonStarted(e, n) {
    return this.track(new Hv(e), n);
  }
  /**
   * Intelligence Table Customized
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Table%20Customized)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. tableName)
   * @param options Amplitude event options.
   */
  intelligenceTableCustomized(e, n) {
    return this.track(new xv(e), n);
  }
  /**
   * Intent Detection Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intent%20Detection%20Created)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  intentDetectionCreated(e) {
    return this.track(new Qv(), e);
  }
  /**
   * Intent Detection Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intent%20Detection%20Deleted)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  intentDetectionDeleted(e) {
    return this.track(new Kv(), e);
  }
  /**
   * Intent Detection Flow Node Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intent%20Detection%20Flow%20Node%20Saved)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  intentDetectionFlowNodeSaved(e, n) {
    return this.track(new Gv(e), n);
  }
  /**
   * Intent Detection Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intent%20Detection%20Updated)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  intentDetectionUpdated(e) {
    return this.track(new qv(), e);
  }
  /**
   * Knowledge Article Archived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Archived)
   *
   * When a user archives an article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleArchived(e, n) {
    return this.track(new zv(e), n);
  }
  /**
   * Knowledge Article Changes Discarded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Changes%20Discarded)
   *
   * When a user discards changes made to a work in progress article
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleChangesDiscarded(e, n) {
    return this.track(new $v(e), n);
  }
  /**
   * Knowledge Article Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Created)
   *
   * When an article is created in knowledge, either from content management or other sources (like conversation sidebar)
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleCreated(e, n) {
    return this.track(new jv(e), n);
  }
  /**
   * Knowledge Article Destroyed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Destroyed)
   *
   * When the user deletes an article
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleDestroyed(e, n) {
    return this.track(new Jv(e), n);
  }
  /**
   * Knowledge Article Feedback Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Feedback%20Submitted)
   *
   * When a user submits feedback on an article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleFeedbackSubmitted(e, n) {
    return this.track(new Yv(e), n);
  }
  /**
   * Knowledge Article Marked As Helpful
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Marked%20As%20Helpful)
   *
   * When a user indicates that an article was helpful
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. assistType)
   * @param options Amplitude event options.
   */
  knowledgeArticleMarkedAsHelpful(e, n) {
    return this.track(new Xv(e), n);
  }
  /**
   * Knowledge Article Moved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Moved)
   *
   * When the user moves an article to a new collection
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleMoved(e, n) {
    return this.track(new Zv(e), n);
  }
  /**
   * Knowledge Article Published
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Published)
   *
   * When a user publishes an article
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticlePublished(e, n) {
    return this.track(new eh(e), n);
  }
  /**
   * Knowledge Article Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Reordered)
   *
   * When an article is re-ordered in the knowledge management screen
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleReordered(e, n) {
    return this.track(new th(e), n);
  }
  /**
   * Knowledge Article Restored
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Restored)
   *
   * When a user clicks on restore this version in the knowledge article version history view
   *
   * @param options Amplitude event options.
   */
  knowledgeArticleRestored(e) {
    return this.track(new nh(), e);
  }
  /**
   * Knowledge Article Tag Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Tag%20Added)
   *
   * When a user adds a tag to a knowledge article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleTagAdded(e, n) {
    return this.track(new rh(e), n);
  }
  /**
   * Knowledge Article Tag Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Tag%20Removed)
   *
   * When a user removes a tag from a knowledge article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleTagRemoved(e, n) {
    return this.track(new ih(e), n);
  }
  /**
   * Knowledge Article Unpublished
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Unpublished)
   *
   * When a user unpublishes a knowledge article
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleUnpublished(e, n) {
    return this.track(new sh(e), n);
  }
  /**
   * Knowledge Article Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Updated)
   *
   * When the user updates an article, either the content or meta
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleUpdated(e, n) {
    return this.track(new oh(e), n);
  }
  /**
   * Knowledge Article Version History Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Version%20History%20Clicked)
   *
   * When a user clicks on the version history in a knowledge article
   *
   * @param options Amplitude event options.
   */
  knowledgeArticleVersionHistoryClicked(e) {
    return this.track(new ah(), e);
  }
  /**
   * Knowledge Article Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Viewed)
   *
   * When a user views a knowledge article
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleViewed(e, n) {
    return this.track(new ch(e), n);
  }
  /**
   * Knowledge Articles Search By Term Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Articles%20Search%20By%20Term%20Submitted)
   *
   * When a user searches for knowledge articles
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeArticlesSearchByTermSubmitted(e, n) {
    return this.track(new uh(e), n);
  }
  /**
   * Knowledge Category Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Created)
   *
   * When a user creates a knowledge category
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryCreated(e, n) {
    return this.track(new lh(e), n);
  }
  /**
   * Knowledge Category Destroyed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Destroyed)
   *
   * When a user deletes a knowledge category
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryDestroyed(e, n) {
    return this.track(new dh(e), n);
  }
  /**
   * Knowledge Category Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Reordered)
   *
   * When a category is re-ordered in the knowledge management screen
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryReordered(e, n) {
    return this.track(new ph(e), n);
  }
  /**
   * Knowledge Category Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Updated)
   *
   * When a user makes a change to a knowledge category
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryUpdated(e, n) {
    return this.track(new vh(e), n);
  }
  /**
   * Knowledge Collection Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Created)
   *
   * When a user creates a knowledge collection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeCollectionCreated(e, n) {
    return this.track(new hh(e), n);
  }
  /**
   * Knowledge Collection Destroyed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Destroyed)
   *
   * When a user deletes a knowledge collection
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeCollectionDestroyed(e, n) {
    return this.track(new gh(e), n);
  }
  /**
   * Knowledge Collection Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Updated)
   *
   * When a user makes a change to a collection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  knowledgeCollectionUpdated(e, n) {
    return this.track(new fh(e), n);
  }
  /**
   * Knowledge Collection Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Viewed)
   *
   * When a user views the knowledge collection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeCollectionViewed(e, n) {
    return this.track(new yh(e), n);
  }
  /**
   * Knowledge Help Center Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Help%20Center%20Created)
   *
   * When the user creates a Knowledge Help Center
   *
   * @param properties The event's properties (e.g. helpCenterId)
   * @param options Amplitude event options.
   */
  knowledgeHelpCenterCreated(e, n) {
    return this.track(new Ch(e), n);
  }
  /**
   * Knowledge Help Center Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Help%20Center%20Deleted)
   *
   * When the user updates a Knowledge Help Center
   *
   * @param properties The event's properties (e.g. helpCenterId)
   * @param options Amplitude event options.
   */
  knowledgeHelpCenterDeleted(e, n) {
    return this.track(new _h(e), n);
  }
  /**
   * Knowledge Help Center Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Help%20Center%20Updated)
   *
   * When the user deletes a Knowledge Help Center
   *
   * @param properties The event's properties (e.g. helpCenterId)
   * @param options Amplitude event options.
   */
  knowledgeHelpCenterUpdated(e, n) {
    return this.track(new kh(e), n);
  }
  /**
   * Knowledge Internal Kb Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Internal%20Kb%20Dashboard%20Viewed)
   *
   * When a knowledge user views the dashboard in an Internal KB
   *
   * @param options Amplitude event options.
   */
  knowledgeInternalKbDashboardViewed(e) {
    return this.track(new mh(), e);
  }
  /**
   * Knowledge Internal Kb Search Result Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Internal%20Kb%20Search%20Result%20Clicked)
   *
   * Knowledge Internal Kb Search Result Clicked
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeInternalKbSearchResultClicked(e, n) {
    return this.track(new wh(e), n);
  }
  /**
   * Knowledge Resolution Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Resolution%20Cancelled)
   *
   * When a knowledge resolution is cancelled
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  knowledgeResolutionCancelled(e, n) {
    return this.track(new Sh(e), n);
  }
  /**
   * Knowledge Resolution Initialised
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Resolution%20Initialised)
   *
   * When a initialises a knowledge conversation resolution flow
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  knowledgeResolutionInitialised(e, n) {
    return this.track(new bh(e), n);
  }
  /**
   * Knowledge Retranslate Article Block Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Retranslate%20Article%20Block%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. languageId)
   * @param options Amplitude event options.
   */
  knowledgeRetranslateArticleBlockClicked(e, n) {
    return this.track(new Ih(e), n);
  }
  /**
   * Knowledge Retranslate Article Title Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Retranslate%20Article%20Title%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. languageId)
   * @param options Amplitude event options.
   */
  knowledgeRetranslateArticleTitleClicked(e, n) {
    return this.track(new Ah(e), n);
  }
  /**
   * Knowledge Translate Article Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Translate%20Article%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. languageId)
   * @param options Amplitude event options.
   */
  knowledgeTranslateArticleClicked(e, n) {
    return this.track(new Th(e), n);
  }
  /**
   * Link Conversations Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Link%20Conversations%20Modal%20Opened)
   *
   * When the user opens the modal to link selected conversations
   *
   * @param options Amplitude event options.
   */
  linkConversationsModalOpened(e) {
    return this.track(new Eh(), e);
  }
  /**
   * Link Conversations Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Link%20Conversations%20Submitted)
   *
   * When user submits the conversations link
   *
   * @param options Amplitude event options.
   */
  linkConversationsSubmitted(e) {
    return this.track(new Ph(), e);
  }
  /**
   * Mention User Notification Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Mention%20User%20Notification%20Clicked)
   *
   * When the user follows the received mention notification.
   *
   * @param options Amplitude event options.
   */
  mentionUserNotificationClicked(e) {
    return this.track(new Oh(), e);
  }
  /**
   * Mention User Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Mention%20User%20Selected)
   *
   * When the user selects an agent to mention.
   *
   * @param options Amplitude event options.
   */
  mentionUserSelected(e) {
    return this.track(new Rh(), e);
  }
  /**
   * Merge Contacts Merge Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Merge%20Cancelled)
   *
   * When a user has been selected and the modal is closed afterwards
   *
   * @param options Amplitude event options.
   */
  mergeContactsMergeCancelled(e) {
    return this.track(new Fh(), e);
  }
  /**
   * Merge Contacts Merge Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Merge%20Failed)
   *
   * When a merge is failing for some reason
   *
   * @param options Amplitude event options.
   */
  mergeContactsMergeFailed(e) {
    return this.track(new Dh(), e);
  }
  /**
   * Merge Contacts Merge Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Merge%20Succeeded)
   *
   * When a contact has successfully been merged
   *
   * @param properties The event's properties (e.g. numberOfEmails)
   * @param options Amplitude event options.
   */
  mergeContactsMergeSucceeded(e, n) {
    return this.track(new Mh(e), n);
  }
  /**
   * Merge Contacts Modal Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Modal%20Closed)
   *
   * When the merge contacts modal is closed
   *
   * @param options Amplitude event options.
   */
  mergeContactsModalClosed(e) {
    return this.track(new Uh(), e);
  }
  /**
   * Merge Contacts Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Modal%20Opened)
   *
   * When the merge contacts modal is opened
   *
   * @param options Amplitude event options.
   */
  mergeContactsModalOpened(e) {
    return this.track(new Lh(), e);
  }
  /**
   * Merge Contacts Source Contact Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Source%20Contact%20Selected)
   *
   * When a contact is selected in the merge contacts modal
   *
   * @param options Amplitude event options.
   */
  mergeContactsSourceContactSelected(e) {
    return this.track(new Nh(), e);
  }
  /**
   * Messenger Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in messenger settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  messengerFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new Vh(), e);
  }
  /**
   * Messenger Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Form%20Cancelled)
   *
   * When the user cancels the Messenger modal/form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  messengerFormCancelled(e, n) {
    return this.track(new Bh(e), n);
  }
  /**
   * Messenger Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Form%20Opened)
   *
   * When the user opens one of the Messenger listing modals/forms
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  messengerFormOpened(e, n) {
    return this.track(new Wh(e), n);
  }
  /**
   * Messenger Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Form%20Submitted)
   *
   * When the user proceeds on a messenger form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  messengerFormSubmitted(e, n) {
    return this.track(new Hh(e), n);
  }
  /**
   * Messenger Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Options%20Menu%20Opened)
   *
   * When the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  messengerOptionsMenuOpened(e) {
    return this.track(new xh(), e);
  }
  /**
   * Messenger Options Menu Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Options%20Menu%20Option%20Clicked)
   *
   * When the user selects an option in the Messenger options menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. option)
   * @param options Amplitude event options.
   */
  messengerOptionsMenuOptionClicked(e, n) {
    return this.track(new Qh(e), n);
  }
  /**
   * Modal Conversation Close Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Conversation%20Close%20Cancel%20Clicked)
   *
   * When the user clicks cancel in the confirm close conversation modal
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  modalConversationCloseCancelClicked(e) {
    return this.track(new Kh(), e);
  }
  /**
   * Modal Conversation Close Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Conversation%20Close%20Confirm%20Clicked)
   *
   * When the user clicks confirm in the confirm close conversation modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  modalConversationCloseConfirmClicked(e, n) {
    return this.track(new Gh(e), n);
  }
  /**
   * Modal Transfer To Queue Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Transfer%20To%20Queue%20Cancel%20Clicked)
   *
   * When the user clicks cancel in the transfer to queue modal
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  modalTransferToQueueCancelClicked(e) {
    return this.track(new qh(), e);
  }
  /**
   * Modal Transfer To Queue Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Transfer%20To%20Queue%20Confirm%20Clicked)
   *
   * When the user clicks confirm in the transfer to queue modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  modalTransferToQueueConfirmClicked(e, n) {
    return this.track(new zh(e), n);
  }
  /**
   * Network Connection Status Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Network%20Connection%20Status%20Changed)
   *
   * When the user network connection changes
   *
   * @param properties The event's properties (e.g. status)
   * @param options Amplitude event options.
   */
  networkConnectionStatusChanged(e, n) {
    return this.track(new $h(e), n);
  }
  /**
   * Notification Offer Accepted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Accepted)
   *
   * When the user accepts an offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationOfferAccepted(e, n) {
    return this.track(new jh(e), n);
  }
  /**
   * Notification Offer Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Closed)
   *
   * When the user closes an offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationOfferClosed(e, n) {
    return this.track(new Jh(e), n);
  }
  /**
   * Notification Offer Rejected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Rejected)
   *
   * When the user rejects an offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationOfferRejected(e, n) {
    return this.track(new Yh(e), n);
  }
  /**
   * Notification Offer Timeout
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Timeout)
   *
   * When the offer notification times out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  notificationOfferTimeout(e) {
    return this.track(new Xh(), e);
  }
  /**
   * Notification Transfer Offer Accepted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Accepted)
   *
   * When the user accepts a transfer offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationTransferOfferAccepted(e, n) {
    return this.track(new Zh(e), n);
  }
  /**
   * Notification Transfer Offer Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Closed)
   *
   * When the user closes a transfer offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationTransferOfferClosed(e, n) {
    return this.track(new eg(e), n);
  }
  /**
   * Notification Transfer Offer Rejected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Rejected)
   *
   * When the user rejects a transfer offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationTransferOfferRejected(e, n) {
    return this.track(new tg(e), n);
  }
  /**
   * Notification Transfer Offer Timeout
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Timeout)
   *
   * When the transfer offer notification times out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  notificationTransferOfferTimeout(e) {
    return this.track(new ng(), e);
  }
  /**
   * Organizations Navigation Organization Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Organizations%20Navigation%20Organization%20Clicked)
   *
   * When the user clicks an organization in the organizations navigation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  organizationsNavigationOrganizationClicked(e, n) {
    return this.track(new rg(e), n);
  }
  /**
   * Partner Integrations Braze Profile Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Braze%20Profile%20Received)
   *
   * When the integration received data to be displayed in the conversation sidebar.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsBrazeProfileReceived(e) {
    return this.track(new ig(), e);
  }
  /**
   * Partner Integrations Braze Subscription Email Opt in Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Braze%20Subscription%20Email%20Opt%20in%20Succeeded)
   *
   * When the email subscription status got updated to opt-in.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsBrazeSubscriptionEmailOptInSucceeded(e) {
    return this.track(new sg(), e);
  }
  /**
   * Partner Integrations Braze Subscription Email Unsubscribed Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Braze%20Subscription%20Email%20Unsubscribed%20Succeeded)
   *
   * When the email subscription status got updated to unsubscribed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsBrazeSubscriptionEmailUnsubscribedSucceeded(e) {
    return this.track(new og(), e);
  }
  /**
   * Partner Integrations Condition Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Condition%20Created)
   *
   * Created a condition to show/hide a native integration in the conversation sidebar based on conversation context.
   *
   * @param properties The event's properties (e.g. conditionType)
   * @param options Amplitude event options.
   */
  partnerIntegrationsConditionCreated(e, n) {
    return this.track(new ag(e), n);
  }
  /**
   * Partner Integrations Condition Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Condition%20Deleted)
   *
   * Deleted a condition to show/hide a native integration in the conversation sidebar based on conversation context.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsConditionDeleted(e) {
    return this.track(new cg(), e);
  }
  /**
   * Partner Integrations Condition Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Condition%20Updated)
   *
   * Updating a condition to show/hide a native integration in the conversation sidebar based on conversation context.
   *
   * @param properties The event's properties (e.g. conditionType)
   * @param options Amplitude event options.
   */
  partnerIntegrationsConditionUpdated(e, n) {
    return this.track(new ug(e), n);
  }
  /**
   * Partner Integrations Github Create New Issue Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Create%20New%20Issue%20Canceled)
   *
   * When the user closes the create new modal without confirming/saving.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubCreateNewIssueCanceled(e, n) {
    return this.track(new lg(e), n);
  }
  /**
   * Partner Integrations Github Create New Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Create%20New%20Issue%20Clicked)
   *
   * When the user clicked on the create new button.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubCreateNewIssueClicked(e, n) {
    return this.track(new dg(e), n);
  }
  /**
   * Partner Integrations Github Create New Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Create%20New%20Issue%20Confirmed)
   *
   * When the user confirmed to create a new issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubCreateNewIssueConfirmed(e, n) {
    return this.track(new pg(e), n);
  }
  /**
   * Partner Integrations Github Link Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Link%20Issue%20Clicked)
   *
   * When the user clicked on an issue in the search results to link it to the conversation.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubLinkIssueClicked(e, n) {
    return this.track(new vg(e), n);
  }
  /**
   * Partner Integrations Github Unlink All Issues Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20All%20Issues%20Canceled)
   *
   * when the user canceled to unlink all issues.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkAllIssuesCanceled(e, n) {
    return this.track(new hg(e), n);
  }
  /**
   * Partner Integrations Github Unlink All Issues Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20All%20Issues%20Clicked)
   *
   * When the user clicked on the unlink all button.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkAllIssuesClicked(e, n) {
    return this.track(new gg(e), n);
  }
  /**
   * Partner Integrations Github Unlink All Issues Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20All%20Issues%20Confirmed)
   *
   * When the user confirmed to unlink all issues.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkAllIssuesConfirmed(e, n) {
    return this.track(new fg(e), n);
  }
  /**
   * Partner Integrations Github Unlink Issue Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20Issue%20Canceled)
   *
   * When the user canceled to unlink an issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkIssueCanceled(e, n) {
    return this.track(new yg(e), n);
  }
  /**
   * Partner Integrations Github Unlink Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20Issue%20Clicked)
   *
   * When the user clicked on the button to unlink an issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkIssueClicked(e, n) {
    return this.track(new Cg(e), n);
  }
  /**
   * Partner Integrations Github Unlink Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20Issue%20Confirmed)
   *
   * When the user confirmed to unlink an issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkIssueConfirmed(e, n) {
    return this.track(new _g(e), n);
  }
  /**
   * Partner Integrations Github View Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20View%20Link%20Clicked)
   *
   * When the user clicked on a linked issue to open it in Github.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubViewLinkClicked(e, n) {
    return this.track(new kg(e), n);
  }
  /**
   * Partner Integrations Jira Comments Collapsed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Comments%20Collapsed)
   *
   * When the user collapses an issue's comments
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraCommentsCollapsed(e, n) {
    return this.track(new mg(e), n);
  }
  /**
   * Partner Integrations Jira Comments Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Comments%20Expanded)
   *
   * When the user expands an issue's comments
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraCommentsExpanded(e, n) {
    return this.track(new wg(e), n);
  }
  /**
   * Partner Integrations Jira Create Issue Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Create%20Issue%20Failed)
   *
   * When the user failed to create a Jira issue from the Jira integration.
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraCreateIssueFailed(e, n) {
    return this.track(new Sg(e), n);
  }
  /**
   * Partner Integrations Jira Create Issue Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Create%20Issue%20Succeeded)
   *
   * When the user successfully create a Jira issue from the Jira integration.
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraCreateIssueSucceeded(e, n) {
    return this.track(new bg(e), n);
  }
  /**
   * Partner Integrations Jira Link Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Link%20Issue%20Clicked)
   *
   * When the user creates a link to a Jira issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraLinkIssueClicked(e, n) {
    return this.track(new Ig(e), n);
  }
  /**
   * Partner Integrations Jira Open Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Open%20Issue%20Clicked)
   *
   * When the user opens a Jira issue's details
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraOpenIssueClicked(e, n) {
    return this.track(new Ag(e), n);
  }
  /**
   * Partner Integrations Jira Open Jira Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Open%20Jira%20Clicked)
   *
   * When the user opens Jira from the widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraOpenJiraClicked(e, n) {
    return this.track(new Tg(e), n);
  }
  /**
   * Partner Integrations Jira Remove All Dangling Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Remove%20All%20Dangling%20Clicked)
   *
   * When the user clicks remove all dangling links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraRemoveAllDanglingClicked(e, n) {
    return this.track(new Eg(e), n);
  }
  /**
   * Partner Integrations Jira Remove Dangling Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Remove%20Dangling%20Issue%20Clicked)
   *
   * When the user clicks remove on a dangling link
   *
   * @param properties The event's properties (e.g. jiraDanglingIssueKey)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraRemoveDanglingIssueClicked(e, n) {
    return this.track(new Pg(e), n);
  }
  /**
   * Partner Integrations Jira Unlink All Issues Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20All%20Issues%20Cancelled)
   *
   * When the user cancels removing all dangling links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkAllIssuesCancelled(e, n) {
    return this.track(new Og(e), n);
  }
  /**
   * Partner Integrations Jira Unlink All Issues Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20All%20Issues%20Clicked)
   *
   * When the user clicks unlink all links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkAllIssuesClicked(e, n) {
    return this.track(new Rg(e), n);
  }
  /**
   * Partner Integrations Jira Unlink All Issues Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20All%20Issues%20Confirmed)
   *
   * When the user confirms removing all dangling links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkAllIssuesConfirmed(e, n) {
    return this.track(new Fg(e), n);
  }
  /**
   * Partner Integrations Jira Unlink Issue Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20Issue%20Cancelled)
   *
   * When the user cancels unlinking an issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkIssueCancelled(e, n) {
    return this.track(new Dg(e), n);
  }
  /**
   * Partner Integrations Jira Unlink Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20Issue%20Clicked)
   *
   * When the user clicks unlink issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkIssueClicked(e, n) {
    return this.track(new Mg(e), n);
  }
  /**
   * Partner Integrations Jira Unlink Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20Issue%20Confirmed)
   *
   * When the user confirms unlinking an issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkIssueConfirmed(e, n) {
    return this.track(new Ug(e), n);
  }
  /**
   * Partner Integrations Klaviyo Messages Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Messages%20Received)
   *
   * When the widget received messages
   *
   * @param properties The event's properties (e.g. emailsBounced)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoMessagesReceived(e, n) {
    return this.track(new Lg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Failed)
   *
   * When the widget failed to receive profile information
   *
   * @param properties The event's properties (e.g. reason)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileFailed(e, n) {
    return this.track(new Ng(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Received)
   *
   * When the widget received profile information
   *
   * @param properties The event's properties (e.g. hasProfile)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileReceived(e, n) {
    return this.track(new Vg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Subscription To Channel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Subscription%20To%20Channel%20Clicked)
   *
   * When the user clicked to subscribe to a channel.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileSubscriptionToChannelClicked(e, n) {
    return this.track(new Bg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Subscription To Channel Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Subscription%20To%20Channel%20Failed)
   *
   * When the subscription to a channel failed.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileSubscriptionToChannelFailed(e, n) {
    return this.track(new Wg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Subscription To Channel Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Subscription%20To%20Channel%20Succeeded)
   *
   * When the user successfully subscribed to a channel.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileSubscriptionToChannelSucceeded(e, n) {
    return this.track(new Hg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Unsubscribe Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Unsubscribe%20Clicked)
   *
   * When the user unsubscribed a given channel
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileUnsubscribeClicked(e, n) {
    return this.track(new xg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Unsubscribe Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Unsubscribe%20Failed)
   *
   * When the user unsubscription attempt failed
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileUnsubscribeFailed(e, n) {
    return this.track(new Qg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Unsubscribe Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Unsubscribe%20Succeeded)
   *
   * When the user successfully unsubscribed from a channel.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileUnsubscribeSucceeded(e, n) {
    return this.track(new Kg(e), n);
  }
  /**
   * Partner Integrations Linear Create New Issue Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Create%20New%20Issue%20Cancelled)
   *
   * When the user cancels to create a new Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearCreateNewIssueCancelled(e, n) {
    return this.track(new Gg(e), n);
  }
  /**
   * Partner Integrations Linear Create New Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Create%20New%20Issue%20Clicked)
   *
   * When the user clicks to open a new Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearCreateNewIssueClicked(e, n) {
    return this.track(new qg(e), n);
  }
  /**
   * Partner Integrations Linear Create New Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Create%20New%20Issue%20Confirmed)
   *
   * When the user confirms to create a new Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearCreateNewIssueConfirmed(e, n) {
    return this.track(new zg(e), n);
  }
  /**
   * Partner Integrations Linear Link Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Link%20Issue%20Clicked)
   *
   * When the user creates a link to a Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearLinkIssueClicked(e, n) {
    return this.track(new $g(e), n);
  }
  /**
   * Partner Integrations Linear Open Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Open%20Issue%20Clicked)
   *
   * When the user opens the details of a Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearOpenIssueClicked(e, n) {
    return this.track(new jg(e), n);
  }
  /**
   * Partner Integrations Linear Open Linear Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Open%20Linear%20Clicked)
   *
   * When the user opens Linear from the widget
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearOpenLinearClicked(e, n) {
    return this.track(new Jg(e), n);
  }
  /**
   * Partner Integrations Linear Unlink Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Unlink%20Issue%20Clicked)
   *
   * When the user clicks unlink issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearUnlinkIssueClicked(e, n) {
    return this.track(new Yg(e), n);
  }
  /**
   * Partner Integrations Recharge Widget Customer Overview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Customer%20Overview%20Opened)
   *
   * When the agent opens the link to see the customers overview in Recharge.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetCustomerOverviewOpened(e) {
    return this.track(new Xg(), e);
  }
  /**
   * Partner Integrations Recharge Widget Order Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Order%20Opened)
   *
   * When the agent opens the link to see the order in Recharge.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetOrderOpened(e) {
    return this.track(new Zg(), e);
  }
  /**
   * Partner Integrations Recharge Widget Orders List Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Orders%20List%20Opened)
   *
   * When the agent opens the link to see a list of orders in Recharge.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetOrdersListOpened(e) {
    return this.track(new ef(), e);
  }
  /**
   * Partner Integrations Recharge Widget Profile Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Profile%20Received)
   *
   * When the integration received a customer profile from Recharge.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetProfileReceived(e) {
    return this.track(new tf(), e);
  }
  /**
   * Partner Integrations Recharge Widget Subscription Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Subscription%20Cancelled)
   *
   * When the agent cancels a subscription.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetSubscriptionCancelled(e) {
    return this.track(new nf(), e);
  }
  /**
   * Partner Integrations Recharge Widget Subscription Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Subscription%20Opened)
   *
   * When the agent opens the link to see a subscription in Recharge.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetSubscriptionOpened(e) {
    return this.track(new rf(), e);
  }
  /**
   * Partner Integrations Recharge Widget Subscription Reactivated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Subscription%20Reactivated)
   *
   * When the agent reactivated a subscription.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetSubscriptionReactivated(e) {
    return this.track(new sf(), e);
  }
  /**
   * Partner Integrations Recharge Widget Subscriptions List Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Subscriptions%20List%20Opened)
   *
   * When the agent opens the link to see all subscriptions in Recharge.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetSubscriptionsListOpened(e) {
    return this.track(new of(), e);
  }
  /**
   * Partner Integrations RivoLoyalty Widget Customer Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20RivoLoyalty%20Widget%20Customer%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRivoLoyaltyWidgetCustomerClicked(e) {
    return this.track(new af(), e);
  }
  /**
   * Partner Integrations RivoLoyalty Widget Customer Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20RivoLoyalty%20Widget%20Customer%20Received)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRivoLoyaltyWidgetCustomerReceived(e) {
    return this.track(new cf(), e);
  }
  /**
   * Partner Integrations RivoLoyalty Widget Points Add Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20RivoLoyalty%20Widget%20Points%20Add%20Failed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRivoLoyaltyWidgetPointsAddFailed(e) {
    return this.track(new uf(), e);
  }
  /**
   * Partner Integrations RivoLoyalty Widget Points Add Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20RivoLoyalty%20Widget%20Points%20Add%20Succeeded)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRivoLoyaltyWidgetPointsAddSucceeded(e) {
    return this.track(new lf(), e);
  }
  /**
   * Partner Integrations RivoLoyalty Widget Points Remove Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20RivoLoyalty%20Widget%20Points%20Remove%20Failed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRivoLoyaltyWidgetPointsRemoveFailed(e) {
    return this.track(new df(), e);
  }
  /**
   * Partner Integrations RivoLoyalty Widget Points Remove Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20RivoLoyalty%20Widget%20Points%20Remove%20Succeeded)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRivoLoyaltyWidgetPointsRemoveSucceeded(e) {
    return this.track(new pf(), e);
  }
  /**
   * Partner Integrations Settings Create Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20Create%20Submitted)
   *
   * When the user submitted the creation of a partner integration configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetType)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsCreateSubmitted(e, n) {
    return this.track(new vf(e), n);
  }
  /**
   * Partner Integrations Settings Overview Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20Overview%20Created)
   *
   * When the user created a partner integration settings page from the integration settings overview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetType)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsOverviewCreated(e, n) {
    return this.track(new hf(e), n);
  }
  /**
   * Partner Integrations Settings Overview Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20Overview%20Viewed)
   *
   * When the user viewed a partner integration settings page from the integration settings overview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsOverviewViewed(e, n) {
    return this.track(new gf(e), n);
  }
  /**
   * Partner Integrations Settings View Delete Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Delete%20Canceled)
   *
   * When the user canceled the deletion request
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewDeleteCanceled(e, n) {
    return this.track(new ff(e), n);
  }
  /**
   * Partner Integrations Settings View Delete Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Delete%20Confirmed)
   *
   * When the user confirmed the deletion of a partner integrations configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewDeleteConfirmed(e, n) {
    return this.track(new yf(e), n);
  }
  /**
   * Partner Integrations Settings View Delete Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Delete%20Requested)
   *
   * Then the user requested the deletion of a partner integrations configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewDeleteRequested(e, n) {
    return this.track(new Cf(e), n);
  }
  /**
   * Partner Integrations Settings View OAuth Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20OAuth%20Started)
   *
   * When the user clicked the OAuth button in the widget settings view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewOAuthStarted(e, n) {
    return this.track(new _f(e), n);
  }
  /**
   * Partner Integrations Settings View OAuth Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20OAuth%20Succeeded)
   *
   * When the user clicked the OAuth button in the widget settings view and the connection was successful
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewOAuthSucceeded(e, n) {
    return this.track(new kf(e), n);
  }
  /**
   * Partner Integrations Settings View Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Submitted)
   *
   * When the user submitted changes to a partner integration configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewSubmitted(e, n) {
    return this.track(new mf(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Create Draft Order Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Create%20Draft%20Order%20Failed)
   *
   * When the creation of a Shopify draft order failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetCreateDraftOrderFailed(e) {
    return this.track(new wf(), e);
  }
  /**
   * Partner Integrations Shopify Widget Create Draft Order Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Create%20Draft%20Order%20Succeeded)
   *
   * When the creation of a Shopify draft order was successful.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetCreateDraftOrderSucceeded(e) {
    return this.track(new Sf(), e);
  }
  /**
   * Partner Integrations Shopify Widget Create Order Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Create%20Order%20Failed)
   *
   * When the creation of a Shopify order failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetCreateOrderFailed(e) {
    return this.track(new bf(), e);
  }
  /**
   * Partner Integrations Shopify Widget Create Order Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Create%20Order%20Succeeded)
   *
   * When the creation of a Shopify order was successful.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetCreateOrderSucceeded(e) {
    return this.track(new If(), e);
  }
  /**
   * Partner Integrations Shopify Widget Discount Code Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Discount%20Code%20Created)
   *
   * When the user created a new discount code from the Shopify integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetDiscountCodeCreated(e) {
    return this.track(new Af(), e);
  }
  /**
   * Partner Integrations Shopify Widget Duplicate Order Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Duplicate%20Order%20Failed)
   *
   * When the duplication of a Shopify order failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetDuplicateOrderFailed(e) {
    return this.track(new Tf(), e);
  }
  /**
   * Partner Integrations Shopify Widget Duplicate Order Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Duplicate%20Order%20Succeeded)
   *
   * When the duplication of a Shopify order was successful.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetDuplicateOrderSucceeded(e) {
    return this.track(new Ef(), e);
  }
  /**
   * Partner Integrations Shopify Widget Order Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Cancelled)
   *
   * When the user cancels an order from the Shopify integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderCancelled(e) {
    return this.track(new Pf(), e);
  }
  /**
   * Partner Integrations Shopify Widget Order Collapse Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Collapse%20Closed)
   *
   * When the user closed an order collapse inside the partner integration widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderCollapseClosed(e, n) {
    return this.track(new Of(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Collapse Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Collapse%20Opened)
   *
   * When the user opened an order collapse inside the partner integration widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderCollapseOpened(e, n) {
    return this.track(new Rf(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Edit Shipping Address Modal Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Edit%20Shipping%20Address%20Modal%20Canceled)
   *
   * When the user canceled the change of the shipping address of an order
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled(e, n) {
    return this.track(new Ff(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Edit Shipping Address Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Edit%20Shipping%20Address%20Modal%20Opened)
   *
   * When the user opened the change shipping address modal for an order
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened(e, n) {
    return this.track(new Df(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Edit Shipping Address Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Edit%20Shipping%20Address%20Submitted)
   *
   * When the user submitted a change of the shipping address for an order
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted(e, n) {
    return this.track(new Mf(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Refund Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Refund%20Canceled)
   *
   * When the user canceled the refund order option request
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderRefundCanceled(e, n) {
    return this.track(new Uf(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Refund Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Refund%20Confirmed)
   *
   * When the user confirmed the refund order option
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderRefundConfirmed(e, n) {
    return this.track(new Lf(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Refund Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Refund%20Requested)
   *
   * When the user requested the refund order option
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderRefundRequested(e, n) {
    return this.track(new Nf(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Tags Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Tags%20Updated)
   *
   * When the user updated the tags on an order from the Shopify integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderTagsUpdated(e) {
    return this.track(new Vf(), e);
  }
  /**
   * Partner Integrations Shopify Widget Order View All Orders In Shopify Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20View%20All%20Orders%20In%20Shopify%20Clicked)
   *
   * When the user clicked on the view all orders in Shopify" deeplink"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shopifyId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked(e, n) {
    return this.track(new Bf(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order View Order In Shopify Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20View%20Order%20In%20Shopify%20Clicked)
   *
   * When the user clicked on the view order in Shopify" deeplink"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked(e, n) {
    return this.track(new Wf(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Profile Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Profile%20Created)
   *
   * When the user created a new shopify profile for the customer from the Shopfiy integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetProfileCreated(e) {
    return this.track(new Hf(), e);
  }
  /**
   * Partner Integrations Shopify Widget Refreshed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Refreshed)
   *
   * When the user refreshed the partner integration widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shopifyId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetRefreshed(e, n) {
    return this.track(new xf(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Refund Partial Order Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Refund%20Partial%20Order%20Failed)
   *
   * When the refund of a partial Shopify order failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetRefundPartialOrderFailed(e) {
    return this.track(new Qf(), e);
  }
  /**
   * Partner Integrations Shopify Widget Refund Partial Order Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Refund%20Partial%20Order%20Succeeded)
   *
   * When the refund of a partial Shopify order succeeded.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetRefundPartialOrderSucceeded(e) {
    return this.track(new Kf(), e);
  }
  /**
   * Partner Integrations Shopify Widget View Customer In Shopify Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20View%20Customer%20In%20Shopify%20Clicked)
   *
   * When the user clicked on the view customer in Shopify" deeplink"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shopifyId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked(e, n) {
    return this.track(new Gf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Subscription Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Subscription%20Clicked)
   *
   * If the icon to subscribe to a channel got clicked.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelSubscriptionClicked(e, n) {
    return this.track(new qf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Subscription Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Subscription%20Failed)
   *
   * If a channel subscription failed.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelSubscriptionFailed(e, n) {
    return this.track(new zf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Subscription Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Subscription%20Succeeded)
   *
   * If a channel subscription succeeded.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelSubscriptionSucceeded(e, n) {
    return this.track(new $f(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Unsubscription Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Unsubscription%20Clicked)
   *
   * If the icon to unsubscribe to a channel got clicked.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelUnsubscriptionClicked(e, n) {
    return this.track(new jf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Unsubscription Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Unsubscription%20Failed)
   *
   * If a channel unsubscription failed.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelUnsubscriptionFailed(e, n) {
    return this.track(new Jf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Unsubscription Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Unsubscription%20Succeeded)
   *
   * If a channel unsubscription succeeded.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelUnsubscriptionSucceeded(e, n) {
    return this.track(new Yf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Message External Link Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Message%20External%20Link%20Opened)
   *
   * A link to an external message got opened.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetMessageExternalLinkOpened(e, n) {
    return this.track(new Xf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Messages Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Messages%20Received)
   *
   * Describes if the widget received messages.
   *
   * @param properties The event's properties (e.g. emailsReceived)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetMessagesReceived(e, n) {
    return this.track(new Zf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Orders Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Orders%20Received)
   *
   * Describes if the widget received transactions.
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetOrdersReceived(e, n) {
    return this.track(new ey(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Profile Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Profile%20Received)
   *
   * Describes if the widget received profile informations.
   *
   * @param properties The event's properties (e.g. hasProfile)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetProfileReceived(e, n) {
    return this.track(new ty(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Transactions Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Transactions%20Received)
   *
   * Describes if the widget received transactions.
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetTransactionsReceived(e, n) {
    return this.track(new ny(e), n);
  }
  /**
   * Partner Integrations Widget Collapse Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20Collapse%20Closed)
   *
   * When the user closed the partner integration widget in the conversation sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetCollapseClosed(e, n) {
    return this.track(new ry(e), n);
  }
  /**
   * Partner Integrations Widget Collapse Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20Collapse%20Opened)
   *
   * When the user opened the partner integration widget in the conversation sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetCollapseOpened(e, n) {
    return this.track(new iy(e), n);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Add Points Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Add%20Points%20Failed)
   *
   * When adding points to the customers points balance failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionAddPointsFailed(e) {
    return this.track(new sy(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Add Points Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Add%20Points%20Succeeded)
   *
   * When the agent successfuly added points to the customers point balance.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionAddPointsSucceeded(e) {
    return this.track(new oy(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Customer Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Customer%20Received)
   *
   * When the user received customer data to be displayed in the integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionCustomerReceived(e) {
    return this.track(new ay(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Remove Points Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Remove%20Points%20Failed)
   *
   * When removing points from the customers point balance failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionRemovePointsFailed(e) {
    return this.track(new cy(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Remove Points Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Remove%20Points%20Succeeded)
   *
   * When the agent successfuly removed points from the customers points balance.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionRemovePointsSucceeded(e) {
    return this.track(new uy(), e);
  }
  /**
   * Partner Integrations Widget Voyado Update Points Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20Voyado%20Update%20Points%20Failed)
   *
   * When the points balance update failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetVoyadoUpdatePointsFailed(e) {
    return this.track(new ly(), e);
  }
  /**
   * Partner Integrations Widget Voyado Update Points Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20Voyado%20Update%20Points%20Succeeded)
   *
   * When the agent successfuly updated the points balance.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetVoyadoUpdatePointsSucceeded(e) {
    return this.track(new dy(), e);
  }
  /**
   * Phone Actions Menu Action Add Outbound Caller ID Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Actions%20Menu%20Action%20Add%20Outbound%20Caller%20ID%20Clicked)
   *
   * When the user selects Add outbound caller ID from the Actions drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneActionsMenuActionAddOutboundCallerIdClicked(e) {
    return this.track(new py(), e);
  }
  /**
   * Phone Actions Menu Action Change Hold Music Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Actions%20Menu%20Action%20Change%20Hold%20Music%20Clicked)
   *
   * When the user selects Change hold music from the Actions drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneActionsMenuActionChangeHoldMusicClicked(e) {
    return this.track(new vy(), e);
  }
  /**
   * Phone Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Actions%20Menu%20Opened)
   *
   * When the users opens the Actions drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneActionsMenuOpened(e) {
    return this.track(new hy(), e);
  }
  /**
   * Phone Add Outbound Caller ID Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Add%20Outbound%20Caller%20ID%20Form%20Cancelled)
   *
   * When the user cancels to verify a phone number
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneAddOutboundCallerIdFormCancelled(e) {
    return this.track(new gy(), e);
  }
  /**
   * Phone Add Outbound Caller ID Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Add%20Outbound%20Caller%20ID%20Form%20Submitted)
   *
   * When the user verifies a phone number
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneAddOutboundCallerIdFormSubmitted(e) {
    return this.track(new fy(), e);
  }
  /**
   * Phone Change Hold Music Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Change%20Hold%20Music%20Form%20Cancelled)
   *
   * When the user cancels the change the hold music form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneChangeHoldMusicFormCancelled(e) {
    return this.track(new yy(), e);
  }
  /**
   * Phone Change Hold Music Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Change%20Hold%20Music%20Form%20Submitted)
   *
   * When the user changes the hold music
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneChangeHoldMusicFormSubmitted(e) {
    return this.track(new Cy(), e);
  }
  /**
   * Phone Create Flow Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Create%20Flow%20Form%20Cancelled)
   *
   * When the user cancels the Create flow form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneCreateFlowFormCancelled(e) {
    return this.track(new _y(), e);
  }
  /**
   * Phone Create Flow Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Create%20Flow%20Form%20Submitted)
   *
   * When the user submit the Create flow form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneCreateFlowFormSubmitted(e) {
    return this.track(new ky(), e);
  }
  /**
   * Phone Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in phone settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new my(), e);
  }
  /**
   * Phone Flow Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionDeleteClicked(e) {
    return this.track(new wy(), e);
  }
  /**
   * Phone Flow Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new Sy(), e);
  }
  /**
   * Phone Flow Options Menu Option Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Edit%20Clicked)
   *
   * When the user selects Edit from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionEditClicked(e) {
    return this.track(new by(), e);
  }
  /**
   * Phone Flow Options Menu Option Move To Another Number Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Move%20To%20Another%20Number%20Clicked)
   *
   * When the user selects Move to another number from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionMoveToAnotherNumberClicked(e) {
    return this.track(new Iy(), e);
  }
  /**
   * Phone Flow Options Menu Option Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Opened)
   *
   * When the user opens the flow ellipsis menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionOpened(e) {
    return this.track(new Ay(), e);
  }
  /**
   * Phone Flow Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selects Rename from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionRenameClicked(e) {
    return this.track(new Ty(), e);
  }
  /**
   * Phone Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Form%20Cancelled)
   *
   * When the user cancels the buy number form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFormCancelled(e) {
    return this.track(new Ey(), e);
  }
  /**
   * Phone Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Form%20Opened)
   *
   * When the user opens the buy number form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFormOpened(e) {
    return this.track(new Py(), e);
  }
  /**
   * Phone Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Form%20Submitted)
   *
   * When the user buys a phone number
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFormSubmitted(e) {
    return this.track(new Oy(), e);
  }
  /**
   * Phone Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Opened)
   *
   * When the user opens the ellipsis menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOpened(e) {
    return this.track(new Ry(), e);
  }
  /**
   * Phone Options Menu Option Create Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Create%20Flow%20Clicked)
   *
   * When the user selects Create flow from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionCreateFlowClicked(e) {
    return this.track(new Fy(), e);
  }
  /**
   * Phone Options Menu Option Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Edit%20Clicked)
   *
   * When the user selects Edit from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionEditClicked(e) {
    return this.track(new Dy(), e);
  }
  /**
   * Phone Options Menu Option Remove Number Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Remove%20Number%20Clicked)
   *
   * When the user selects Remove number from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionRemoveNumberClicked(e) {
    return this.track(new My(), e);
  }
  /**
   * Phone Options Menu Option Set Default Caller ID Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Set%20Default%20Caller%20ID%20Clicked)
   *
   * When the user selects Set default caller ID from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionSetDefaultCallerIdClicked(e) {
    return this.track(new Uy(), e);
  }
  /**
   * Phone Options Menu Option Setup Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Setup%20Clicked)
   *
   * When the user selects Setup from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionSetupClicked(e) {
    return this.track(new Ly(), e);
  }
  /**
   * Phone Recording Downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Downloaded)
   *
   * When a user downloads the voice conversation recording
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingDownloaded(e, n) {
    return this.track(new Ny(e), n);
  }
  /**
   * Phone Recording Pause Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Pause%20Clicked)
   *
   * When a user clicks pause" on the voice conversation recording"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPauseClicked(e, n) {
    return this.track(new Vy(e), n);
  }
  /**
   * Phone Recording Play Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Play%20Clicked)
   *
   * When a user clicks play" on the voice conversation recording"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPlayClicked(e, n) {
    return this.track(new By(e), n);
  }
  /**
   * Phone Recording Playback Abandoned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Playback%20Abandoned)
   *
   * When a user navigates away from a conversation while the voice conversation recording is playing
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPlaybackAbandoned(e, n) {
    return this.track(new Wy(e), n);
  }
  /**
   * Phone Recording Playback Ended
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Playback%20Ended)
   *
   * When the voice conversation recording plays through to the end
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPlaybackEnded(e, n) {
    return this.track(new Hy(e), n);
  }
  /**
   * Phone Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Search%20Applied)
   *
   * When the user searches for a flow
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneSearchApplied(e) {
    return this.track(new xy(), e);
  }
  /**
   * Presence List Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Presence%20List%20Item%20Clicked)
   *
   * Event to track when an agent clicks on a presence list item in the sidebar.
   *
   * @param options Amplitude event options.
   */
  presenceListItemClicked(e) {
    return this.track(new Qy(), e);
  }
  /**
   * Presence Media Other Agent Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Presence%20Media%20Other%20Agent%20Updated)
   *
   * When the user updates another agent's status to Away or Working
   *
   * @param properties The event's properties (e.g. enabled)
   * @param options Amplitude event options.
   */
  presenceMediaOtherAgentUpdated(e, n) {
    return this.track(new Ky(e), n);
  }
  /**
   * Presence Media Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Presence%20Media%20Updated)
   *
   * When the user updates their availability for a channel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. enabled)
   * @param options Amplitude event options.
   */
  presenceMediaUpdated(e, n) {
    return this.track(new Gy(e), n);
  }
  /**
   * Presence Other Agent Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Presence%20Other%20Agent%20Updated)
   *
   * When the user updates another agent's status to Away or Working
   *
   * @param properties The event's properties (e.g. status)
   * @param options Amplitude event options.
   */
  presenceOtherAgentUpdated(e, n) {
    return this.track(new qy(e), n);
  }
  /**
   * Presence Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Presence%20Updated)
   *
   * When the user updates their status to Away or Working
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  presenceUpdated(e, n) {
    return this.track(new zy(e), n);
  }
  /**
   * Push Notification Platform Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Push%20Notification%20Platform%20Form%20Cancelled)
   *
   * When the user cancels the push notification platform modal/form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  pushNotificationPlatformFormCancelled(e, n) {
    return this.track(new $y(e), n);
  }
  /**
   * Push Notification Platform Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Push%20Notification%20Platform%20Form%20Opened)
   *
   * When the user opens one of the push notification platform listing modals/forms
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  pushNotificationPlatformFormOpened(e, n) {
    return this.track(new jy(e), n);
  }
  /**
   * Push Notification Platform Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Push%20Notification%20Platform%20Form%20Submitted)
   *
   * When the user submits push notification platform form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  pushNotificationPlatformFormSubmitted(e, n) {
    return this.track(new Jy(e), n);
  }
  /**
   * Quick Replies Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Replies%20Opened)
   *
   * Event to track when user opens the Quick replies. Two ways to do it: conversation -> lightning icon/ triggering through editor with '='
   *
   * @param properties The event's properties (e.g. openedBy)
   * @param options Amplitude event options.
   */
  quickRepliesOpened(e, n) {
    return this.track(new Yy(e), n);
  }
  /**
   * Quick Reply Chosen
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Reply%20Chosen)
   *
   * Event to track some data related to chosen by user Quick Reply template
   *
   * @param properties The event's properties (e.g. macroRan)
   * @param options Amplitude event options.
   */
  quickReplyChosen(e, n) {
    return this.track(new Xy(e), n);
  }
  /**
   * Quick Reply Feedback for Recommended Replies Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Reply%20Feedback%20for%20Recommended%20Replies%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. feedback)
   * @param options Amplitude event options.
   */
  quickReplyFeedbackForRecommendedRepliesClicked(e, n) {
    return this.track(new Zy(e), n);
  }
  /**
   * Quick Reply Filter Chosen
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Reply%20Filter%20Chosen)
   *
   * Event triggered when user applies filter in the Quick Replies
   *
   * @param properties The event's properties (e.g. filterUsed)
   * @param options Amplitude event options.
   */
  quickReplyFilterChosen(e, n) {
    return this.track(new eC(e), n);
  }
  /**
   * Quick Reply Language Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Reply%20Language%20Selected)
   *
   * When the user selects a language in the quick replies dropdown
   *
   * @param properties The event's properties (e.g. language)
   * @param options Amplitude event options.
   */
  quickReplyLanguageSelected(e, n) {
    return this.track(new tC(e), n);
  }
  /**
   * Quick Reply Template Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Reply%20Template%20Favorite%20Toggled)
   *
   * Event to track when a quick reply is favorited/unfavorited by user
   *
   * @param properties The event's properties (e.g. favorited)
   * @param options Amplitude event options.
   */
  quickReplyTemplateFavoriteToggled(e, n) {
    return this.track(new nC(e), n);
  }
  /**
   * Rewind Dismissed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Rewind%20Dismissed)
   *
   * When the user dismisses the rewind button in the sidebar
   *
   * @param properties The event's properties (e.g. year)
   * @param options Amplitude event options.
   */
  rewindDismissed(e, n) {
    return this.track(new rC(e), n);
  }
  /**
   * Rewind Feedback Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Rewind%20Feedback%20Clicked)
   *
   * When the user clicks on the rewind feedback button
   *
   * @param properties The event's properties (e.g. slide)
   * @param options Amplitude event options.
   */
  rewindFeedbackClicked(e, n) {
    return this.track(new iC(e), n);
  }
  /**
   * Rewind Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Rewind%20Opened)
   *
   * When the user opens the rewind modal
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  rewindOpened(e, n) {
    return this.track(new sC(e), n);
  }
  /**
   * Rewind Share To LinkedIn Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Rewind%20Share%20To%20LinkedIn%20Clicked)
   *
   * When the user clicks on the rewind share to LinkedIn button
   *
   * @param properties The event's properties (e.g. slide)
   * @param options Amplitude event options.
   */
  rewindShareToLinkedInClicked(e, n) {
    return this.track(new oC(e), n);
  }
  /**
   * Rewind Slide Image Copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Rewind%20Slide%20Image%20Copied)
   *
   * When the user copies the image of a rewind slide
   *
   * @param properties The event's properties (e.g. slide)
   * @param options Amplitude event options.
   */
  rewindSlideImageCopied(e, n) {
    return this.track(new aC(e), n);
  }
  /**
   * Rewind Slide Image Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Rewind%20Slide%20Image%20Saved)
   *
   * When the user saves the image of a rewind slide
   *
   * @param properties The event's properties (e.g. slide)
   * @param options Amplitude event options.
   */
  rewindSlideImageSaved(e, n) {
    return this.track(new cC(e), n);
  }
  /**
   * Rewind Slide Text Copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Rewind%20Slide%20Text%20Copied)
   *
   * When the user copies the text of a rewind slide
   *
   * @param properties The event's properties (e.g. slide)
   * @param options Amplitude event options.
   */
  rewindSlideTextCopied(e, n) {
    return this.track(new uC(e), n);
  }
  /**
   * Rewind Slide Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Rewind%20Slide%20Viewed)
   *
   * When the user views a rewind slide
   *
   * @param properties The event's properties (e.g. slide)
   * @param options Amplitude event options.
   */
  rewindSlideViewed(e, n) {
    return this.track(new lC(e), n);
  }
  /**
   * Saved Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Applied)
   *
   * When the user applies a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchApplied(e) {
    return this.track(new dC(), e);
  }
  /**
   * Saved Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Closed)
   *
   * When the user closes a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchClosed(e) {
    return this.track(new pC(), e);
  }
  /**
   * Saved Search Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Created)
   *
   * When the user creates a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. saveAsNew)
   * @param options Amplitude event options.
   */
  savedSearchCreated(e, n) {
    return this.track(new vC(e), n);
  }
  /**
   * Saved Search Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Deleted)
   *
   * When the user deletes a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchDeleted(e) {
    return this.track(new hC(), e);
  }
  /**
   * Saved Search Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Updated)
   *
   * When the user updates a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchUpdated(e) {
    return this.track(new gC(), e);
  }
  /**
   * Scheduled Conversations Csv Import Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Scheduled%20Conversations%20Csv%20Import%20Clicked)
   *
   * When the user clicks the import csv button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  scheduledConversationsCsvImportClicked(e) {
    return this.track(new fC(), e);
  }
  /**
   * Scheduled Conversations Csv Imported
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Scheduled%20Conversations%20Csv%20Imported)
   *
   * When the user submits a csv file
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  scheduledConversationsCsvImported(e) {
    return this.track(new yC(), e);
  }
  /**
   * Search Contact Preview Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Preview%20Closed)
   *
   * When the users closes the contact preview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactPreviewClosed(e, n) {
    return this.track(new CC(e), n);
  }
  /**
   * Search Contact Preview Go To Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Preview%20Go%20To%20Clicked)
   *
   * When the user navigates to the full contact view from the search preview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactPreviewGoToClicked(e, n) {
    return this.track(new _C(e), n);
  }
  /**
   * Search Contact Preview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Preview%20Opened)
   *
   * When the users clicks on a contact in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactPreviewOpened(e, n) {
    return this.track(new kC(e), n);
  }
  /**
   * Search Contact Type Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Type%20Changed)
   *
   * When the users changes the contact type in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactTypeChanged(e, n) {
    return this.track(new mC(e), n);
  }
  /**
   * Search Conversation Preview Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Conversation%20Preview%20Closed)
   *
   * When the user closes the conversation preview
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  searchConversationPreviewClosed(e) {
    return this.track(new wC(), e);
  }
  /**
   * Search Conversation Preview Go To Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Conversation%20Preview%20Go%20To%20Clicked)
   *
   * When the user navigates to the full conversation view from the search preview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  searchConversationPreviewGoToClicked(e, n) {
    return this.track(new SC(e), n);
  }
  /**
   * Search Conversation Preview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Conversation%20Preview%20Opened)
   *
   * When the user clicks on a conversation in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  searchConversationPreviewOpened(e, n) {
    return this.track(new bC(e), n);
  }
  /**
   * Search Field Blurred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Blurred)
   *
   * When the user clicks outside of the search field and it loses focus
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFieldBlurred(e, n) {
    return this.track(new IC(e), n);
  }
  /**
   * Search Field Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Cleared)
   *
   * When the user clicks the button to clear the search field
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFieldCleared(e, n) {
    return this.track(new AC(e), n);
  }
  /**
   * Search Field Focused
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Focused)
   *
   * When the user clicks on the search field and it becomes focused
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFieldFocused(e, n) {
    return this.track(new TC(e), n);
  }
  /**
   * Search Field Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Submitted)
   *
   * When the user submits the value in the search field
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. isEmpty)
   * @param options Amplitude event options.
   */
  searchFieldSubmitted(e, n) {
    return this.track(new EC(e), n);
  }
  /**
   * Search Filter Condition Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Condition%20Added)
   *
   * When the user adds a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFilterConditionAdded(e, n) {
    return this.track(new PC(e), n);
  }
  /**
   * Search Filter Condition Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Condition%20Removed)
   *
   * When the user removes a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchFilterConditionRemoved(e, n) {
    return this.track(new OC(e), n);
  }
  /**
   * Search Filter Operator Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Operator%20Updated)
   *
   * When the user updates the operator of a search filter
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. operator)
   * @param options Amplitude event options.
   */
  searchFilterOperatorUpdated(e, n) {
    return this.track(new RC(e), n);
  }
  /**
   * Search Filter Strategy Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Strategy%20Updated)
   *
   * When the user updates the search filtering strategy
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. strategy)
   * @param options Amplitude event options.
   */
  searchFilterStrategyUpdated(e, n) {
    return this.track(new FC(e), n);
  }
  /**
   * Search Filter Value Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Value%20Added)
   *
   * When the user adds a value to a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. operator)
   * @param options Amplitude event options.
   */
  searchFilterValueAdded(e, n) {
    return this.track(new DC(e), n);
  }
  /**
   * Search Filter Value Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Value%20Cleared)
   *
   * When the user clears the value of a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFilterValueCleared(e, n) {
    return this.track(new MC(e), n);
  }
  /**
   * Search Filters Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Applied)
   *
   * When the user applies the search filters
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersApplied(e, n) {
    return this.track(new UC(e), n);
  }
  /**
   * Search Filters Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Cleared)
   *
   * When the user clears the search filters
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersCleared(e, n) {
    return this.track(new LC(e), n);
  }
  /**
   * Search Filters Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Closed)
   *
   * When the user closes the search filters sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersClosed(e, n) {
    return this.track(new NC(e), n);
  }
  /**
   * Search Filters Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Opened)
   *
   * When the user opens the search filters sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersOpened(e, n) {
    return this.track(new VC(e), n);
  }
  /**
   * Search Filters Validation Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Validation%20Failed)
   *
   * When the validation of the search filters fails
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. errors)
   * @param options Amplitude event options.
   */
  searchFiltersValidationFailed(e, n) {
    return this.track(new BC(e), n);
  }
  /**
   * Search Sorting Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Sorting%20Updated)
   *
   * When the user changes the search results sorting
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  searchSortingUpdated(e, n) {
    return this.track(new WC(e), n);
  }
  /**
   * Search Strict Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Strict%20Toggled)
   *
   * When the user toggles strict search
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  searchStrictToggled(e, n) {
    return this.track(new HC(e), n);
  }
  /**
   * Search Tab Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Tab%20Opened)
   *
   * When the user opens a different search tab
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  searchTabOpened(e, n) {
    return this.track(new xC(e), n);
  }
  /**
   * Settings Agents Add Agent Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Add%20Agent%20Button%20Clicked)
   *
   * When the user clicks on Add agent" button on agents settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsAgentsAddAgentButtonClicked(e) {
    return this.track(new QC(), e);
  }
  /**
   * Settings Agents Custom Workload Assigned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Custom%20Workload%20Assigned)
   *
   * When the user assigns a custom workload to 1 or more agents
   *
   * @param properties The event's properties (e.g. numberOfAgents)
   * @param options Amplitude event options.
   */
  settingsAgentsCustomWorkloadAssigned(e, n) {
    return this.track(new KC(e), n);
  }
  /**
   * Settings Agents Custom Workload Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Custom%20Workload%20Created)
   *
   * When the user creates a new custom workload on agents settings page - Workloads tab
   *
   * @param options Amplitude event options.
   */
  settingsAgentsCustomWorkloadCreated(e) {
    return this.track(new GC(), e);
  }
  /**
   * Settings Agents Custom Workload Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Custom%20Workload%20Deleted)
   *
   * When the user deletes a custom workload on agents settings page - Workloads tab
   *
   * @param options Amplitude event options.
   */
  settingsAgentsCustomWorkloadDeleted(e) {
    return this.track(new qC(), e);
  }
  /**
   * Settings Agents Edit Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Edit%20Button%20Clicked)
   *
   * When the user clicks on the edit icon in the agents table on settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsAgentsEditButtonClicked(e) {
    return this.track(new zC(), e);
  }
  /**
   * Settings Agents Tab Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Tab%20Clicked)
   *
   * When the user switches between tabs on agents settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  settingsAgentsTabClicked(e, n) {
    return this.track(new $C(e), n);
  }
  /**
   * Settings Audio Delete Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Delete%20Cancel%20Clicked)
   *
   * When the user opens the confirm delete modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioDeleteCancelClicked(e, n) {
    return this.track(new jC(e), n);
  }
  /**
   * Settings Audio Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Delete%20Clicked)
   *
   * When the user opens the confirm delete modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioDeleteClicked(e, n) {
    return this.track(new JC(e), n);
  }
  /**
   * Settings Audio Delete Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Delete%20Confirm%20Clicked)
   *
   * When the user opens the confirm delete modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioDeleteConfirmClicked(e, n) {
    return this.track(new YC(e), n);
  }
  /**
   * Settings Audio Usage Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Usage%20Flow%20Clicked)
   *
   * When the user interacts with audio usage
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioUsageFlowClicked(e, n) {
    return this.track(new XC(e), n);
  }
  /**
   * Settings Audio Usage Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Usage%20Link%20Clicked)
   *
   * When the user interacts with audio usage
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioUsageLinkClicked(e, n) {
    return this.track(new ZC(e), n);
  }
  /**
   * Settings Commands Assign Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Assign%20Keybindings)
   *
   * When the user assigns keybindings to a command
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  settingsCommandsAssignKeybindings(e, n) {
    return this.track(new e_(e), n);
  }
  /**
   * Settings Commands Reset All Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Reset%20All%20Keybindings)
   *
   * When the user resets all commands to their default keybindings
   *
   * @param options Amplitude event options.
   */
  settingsCommandsResetAllKeybindings(e) {
    return this.track(new t_(), e);
  }
  /**
   * Settings Commands Reset Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Reset%20Keybindings)
   *
   * When the user resets a command's keybindings
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  settingsCommandsResetKeybindings(e, n) {
    return this.track(new n_(e), n);
  }
  /**
   * Settings Commands Unassign All Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Unassign%20All%20Keybindings)
   *
   * When the user unassigns all commands' keybindings
   *
   * @param options Amplitude event options.
   */
  settingsCommandsUnassignAllKeybindings(e) {
    return this.track(new r_(), e);
  }
  /**
   * Settings Commands Unassign Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Unassign%20Keybindings)
   *
   * When the user unassigns a command's keybindings
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  settingsCommandsUnassignKeybindings(e, n) {
    return this.track(new i_(e), n);
  }
  /**
   * Settings Custom Attribute Activated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Activated)
   *
   * When the user activated a custom attribute
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeActivated(e, n) {
    return this.track(new s_(e), n);
  }
  /**
   * Settings Custom Attribute Add New Attribute Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Add%20New%20Attribute%20Clicked)
   *
   * When the user clicks the Add new attribute button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. entityId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeAddNewAttributeClicked(e, n) {
    return this.track(new o_(e), n);
  }
  /**
   * Settings Custom Attribute Archived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Archived)
   *
   * When the user archives a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeArchived(e, n) {
    return this.track(new a_(e), n);
  }
  /**
   * Settings Custom Attribute Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Created)
   *
   * When the user create a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. entityId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeCreated(e, n) {
    return this.track(new c_(e), n);
  }
  /**
   * Settings Custom Attribute Deactivated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Deactivated)
   *
   * When the user deactivates a custom attribute
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeDeactivated(e, n) {
    return this.track(new u_(e), n);
  }
  /**
   * Settings Custom Attribute Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Reordered)
   *
   * When the user reorders a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeReordered(e, n) {
    return this.track(new l_(e), n);
  }
  /**
   * Settings Custom Attribute Unarchived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Unarchived)
   *
   * When the user unarchives a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeUnarchived(e, n) {
    return this.track(new d_(e), n);
  }
  /**
   * Settings Custom Attribute Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Updated)
   *
   * When the user updates a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeUpdated(e, n) {
    return this.track(new p_(e), n);
  }
  /**
   * Settings Custom Away Status Add New Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Away%20Status%20Add%20New%20Clicked)
   *
   * When the user clicks Create new status button
   *
   * @param options Amplitude event options.
   */
  settingsCustomAwayStatusAddNewClicked(e) {
    return this.track(new v_(), e);
  }
  /**
   * Settings Custom Away Status Archived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Away%20Status%20Archived)
   *
   * When the user archives a custom away status
   *
   * @param options Amplitude event options.
   */
  settingsCustomAwayStatusArchived(e) {
    return this.track(new h_(), e);
  }
  /**
   * Settings Custom Away Status Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Away%20Status%20Created)
   *
   * When the user creates a custom away status
   *
   * @param options Amplitude event options.
   */
  settingsCustomAwayStatusCreated(e) {
    return this.track(new g_(), e);
  }
  /**
   * Settings Custom Away Status Unarchived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Away%20Status%20Unarchived)
   *
   * When the user unarchives a custom away status
   *
   * @param options Amplitude event options.
   */
  settingsCustomAwayStatusUnarchived(e) {
    return this.track(new f_(), e);
  }
  /**
   * Settings Custom Away Status Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Away%20Status%20Updated)
   *
   * When the user updates a custom away status
   *
   * @param options Amplitude event options.
   */
  settingsCustomAwayStatusUpdated(e) {
    return this.track(new y_(), e);
  }
  /**
   * Settings Forms Embed Url Copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Forms%20Embed%20Url%20Copied)
   *
   * When the user copies form embed url.
   *
   * @param options Amplitude event options.
   */
  settingsFormsEmbedUrlCopied(e) {
    return this.track(new C_(), e);
  }
  /**
   * Settings Forms Styling Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Forms%20Styling%20Added)
   *
   * When user adds styling to a form that didn't have any styling in the previous version.
   *
   * @param options Amplitude event options.
   */
  settingsFormsStylingAdded(e) {
    return this.track(new __(), e);
  }
  /**
   * Settings Integrations Api Tokens Add Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Add%20Confirm)
   *
   * When the user creates a new API token
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. apiTokenVersion)
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensAddConfirm(e, n) {
    return this.track(new k_(e), n);
  }
  /**
   * Settings Integrations Api Tokens Copy
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Copy)
   *
   * When the user clicks on the button to copy an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensCopy(e) {
    return this.track(new m_(), e);
  }
  /**
   * Settings Integrations Api Tokens Documentation Link Integrations Api
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Documentation%20Link%20Integrations%20Api)
   *
   * When the user clicks on the link to open the documentation for the Integrations API
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensDocumentationLinkIntegrationsApi(e) {
    return this.track(new w_(), e);
  }
  /**
   * Settings Integrations Api Tokens Remove
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Remove)
   *
   * When the user clicks on the button to remove an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensRemove(e) {
    return this.track(new S_(), e);
  }
  /**
   * Settings Integrations Api Tokens Remove Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Remove%20Cancel)
   *
   * When the user cancels removing an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensRemoveCancel(e) {
    return this.track(new b_(), e);
  }
  /**
   * Settings Integrations Api Tokens Remove Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Remove%20Confirm)
   *
   * When the user confirms removing an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensRemoveConfirm(e) {
    return this.track(new I_(), e);
  }
  /**
   * Settings Integrations Api Tokens View
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20View)
   *
   * When the user clicks on the button to view an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensView(e) {
    return this.track(new A_(), e);
  }
  /**
   * Settings Integrations Card Edit Save
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Edit%20Save)
   *
   * When the user is on the card edit page and saves changes to an existing card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardEditSave(e, n) {
    return this.track(new T_(e), n);
  }
  /**
   * Settings Integrations Card Edit Test
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Edit%20Test)
   *
   * When the user is on the card edit page and clicks on Test
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardEditTest(e, n) {
    return this.track(new E_(e), n);
  }
  /**
   * Settings Integrations Card Listing Add Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Add%20Card)
   *
   * When the user clicks on Add card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingAddCard(e, n) {
    return this.track(new P_(e), n);
  }
  /**
   * Settings Integrations Card Read Documentation
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Read%20Documentation)
   *
   * When the user clicks on the documentation link in the header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardRoute)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardReadDocumentation(e, n) {
    return this.track(new O_(e), n);
  }
  /**
   * Settings Integrations Card Test
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Test)
   *
   * When the user is on the test card page and clicks on Test
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardTest(e, n) {
    return this.track(new R_(e), n);
  }
  /**
   * Settings Integrations Card Test Add Parameter
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Test%20Add%20Parameter)
   *
   * When the user is on the test card page and adds a parameter
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardTestAddParameter(e, n) {
    return this.track(new F_(e), n);
  }
  /**
   * Settings Integrations Card Test Remove Parameter
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Test%20Remove%20Parameter)
   *
   * When the user is on the test card page and removes a parameter
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardTestRemoveParameter(e, n) {
    return this.track(new D_(e), n);
  }
  /**
   * Settings Integrations Custom Card Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Created)
   *
   * When the user created a custom card.
   *
   * @param properties The event's properties (e.g. authorizationHeader)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardCreated(e, n) {
    return this.track(new M_(e), n);
  }
  /**
   * Settings Integrations Custom Card Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Edited)
   *
   * When the user edited a custom card.
   *
   * @param properties The event's properties (e.g. authorizationHeader)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardEdited(e, n) {
    return this.track(new U_(e), n);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Authentication Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Authentication%20Failed)
   *
   * When the authentication of the OAuth provider failed.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderAuthenticationFailed(e, n) {
    return this.track(new L_(e), n);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Authentication Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Authentication%20Succeeded)
   *
   * When the authentication of the OAuth provider succeeded.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded(e, n) {
    return this.track(new N_(e), n);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Authentication Timed Out
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Authentication%20Timed%20Out)
   *
   * When the authentication of the OAuth provider timed out.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut(e, n) {
    return this.track(new V_(e), n);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Created)
   *
   * When the user created a new OAuth provider.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderCreated(e, n) {
    return this.track(new B_(e), n);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Updated)
   *
   * When the user updated an existing OAuth provider.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderUpdated(e, n) {
    return this.track(new W_(e), n);
  }
  /**
   * Settings Integrations Data Sync Backfill Started Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Backfill%20Started%20Failed)
   *
   * When the backfilling started failed.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncBackfillStartedFailed(e, n) {
    return this.track(new H_(e), n);
  }
  /**
   * Settings Integrations Data Sync Backfill Started Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Backfill%20Started%20Succeeded)
   *
   * When the backfilling started successfully.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncBackfillStartedSucceeded(e, n) {
    return this.track(new x_(e), n);
  }
  /**
   * Settings Integrations Data Sync Configuration Enabled Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Configuration%20Enabled%20Failed)
   *
   * When enabling a configuration failed.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncConfigurationEnabledFailed(e, n) {
    return this.track(new Q_(e), n);
  }
  /**
   * Settings Integrations Data Sync Configuration Enabled Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Configuration%20Enabled%20Succeeded)
   *
   * When a configuration got enabled successfully.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncConfigurationEnabledSucceeded(e, n) {
    return this.track(new K_(e), n);
  }
  /**
   * Settings Integrations Data Sync Create Configuration Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Create%20Configuration%20Failed)
   *
   * When the creation of a data sync failed.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncCreateConfigurationFailed(e, n) {
    return this.track(new G_(e), n);
  }
  /**
   * Settings Integrations Data Sync Create Configuration Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Create%20Configuration%20Succeeded)
   *
   * When the user successfully create a data sync configuraiton.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncCreateConfigurationSucceeded(e, n) {
    return this.track(new q_(e), n);
  }
  /**
   * Settings Integrations Data Sync Delete Configuration Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Delete%20Configuration%20Failed)
   *
   * When the deletion of a data sync failed.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncDeleteConfigurationFailed(e, n) {
    return this.track(new z_(e), n);
  }
  /**
   * Settings Integrations Data Sync Delete Configuration Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Delete%20Configuration%20Succeeded)
   *
   * When the user successfully deleted a data sync configuration.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncDeleteConfigurationSucceeded(e, n) {
    return this.track(new $_(e), n);
  }
  /**
   * Settings Integrations Data Sync Retry Backfilling Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Retry%20Backfilling%20Failed)
   *
   * When the retrying the backfill process failed.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncRetryBackfillingFailed(e, n) {
    return this.track(new j_(e), n);
  }
  /**
   * Settings Integrations Data Sync Retry Backfilling Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Retry%20Backfilling%20Succeeded)
   *
   * When the retrying the backfill process succeeded.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncRetryBackfillingSucceeded(e, n) {
    return this.track(new J_(e), n);
  }
  /**
   * Settings Integrations Data Sync Start Syncing Events Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Start%20Syncing%20Events%20Succeeded)
   *
   * When starting to sync events succeeded.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncStartSyncingEventsSucceeded(e, n) {
    return this.track(new Y_(e), n);
  }
  /**
   * Settings Integrations Data Sync Type Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Type%20Clicked)
   *
   * When the customer clicked on a data sync type.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncTypeClicked(e, n) {
    return this.track(new X_(e), n);
  }
  /**
   * Settings Integrations Data Sync Update Configuration Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Update%20Configuration%20Failed)
   *
   * When updating of a data sync failed.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncUpdateConfigurationFailed(e, n) {
    return this.track(new Z_(e), n);
  }
  /**
   * Settings Integrations Data Sync Update Configuration Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Data%20Sync%20Update%20Configuration%20Succeeded)
   *
   * When updating of a data sync succeeded.
   *
   * @param properties The event's properties (e.g. dataSyncType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsDataSyncUpdateConfigurationSucceeded(e, n) {
    return this.track(new ek(e), n);
  }
  /**
   * Settings Integrations Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Item%20Clicked)
   *
   * When the user clicks on one of the integrations
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. integrationsId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsItemClicked(e, n) {
    return this.track(new tk(e), n);
  }
  /**
   * Settings Integrations Webform Endpoints Add Save
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Add%20Save)
   *
   * When the user adds a new webform endpoint
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. hasRedirectUrl)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsAddSave(e, n) {
    return this.track(new nk(e), n);
  }
  /**
   * Settings Integrations Webform Endpoints Copy
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Copy)
   *
   * When the user copies a webform endpoint
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsCopy(e) {
    return this.track(new rk(), e);
  }
  /**
   * Settings Integrations Webform Endpoints Read Documentation Link
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Read%20Documentation%20Link)
   *
   * When the user clicks on the documentation link in the header of the webforms endpoint page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsReadDocumentationLink(e) {
    return this.track(new ik(), e);
  }
  /**
   * Settings Integrations Webform Endpoints Remove
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Remove)
   *
   * When the user clicks the delete button on a webform endpoint
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. webformId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsRemove(e, n) {
    return this.track(new sk(e), n);
  }
  /**
   * Settings Integrations Webform Endpoints Remove Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Remove%20Cancel)
   *
   * When the user cancels deleting a webform endpoint
   *
   * @param properties The event's properties (e.g. webformId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsRemoveCancel(e, n) {
    return this.track(new ok(e), n);
  }
  /**
   * Settings Integrations Webform Endpoints Remove Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Remove%20Confirm)
   *
   * When the user confirms deleting a webform endpoint
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. webformId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsRemoveConfirm(e, n) {
    return this.track(new ak(e), n);
  }
  /**
   * Settings Integrations Webhooks Add
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Add)
   *
   * When the user confirms adding a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksAdd(e) {
    return this.track(new ck(), e);
  }
  /**
   * Settings Integrations Webhooks Add Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Add%20Confirm)
   *
   * When the user adds a new webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksAddConfirm(e) {
    return this.track(new uk(), e);
  }
  /**
   * Settings Integrations Webhooks Documentation Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Documentation%20Link%20Clicked)
   *
   * When the user clicks on the webhooks documentation link
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksDocumentationLinkClicked(e) {
    return this.track(new lk(), e);
  }
  /**
   * Settings Integrations Webhooks Edit
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Edit)
   *
   * When the user clicks on the button to edit a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEdit(e) {
    return this.track(new dk(), e);
  }
  /**
   * Settings Integrations Webhooks Edit Save
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Edit%20Save)
   *
   * When the user clicks on the button to save changes to a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEditSave(e) {
    return this.track(new pk(), e);
  }
  /**
   * Settings Integrations Webhooks Enabled Off
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Enabled%20Off)
   *
   * When the user disables a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEnabledOff(e) {
    return this.track(new vk(), e);
  }
  /**
   * Settings Integrations Webhooks Enabled On
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Enabled%20On)
   *
   * When the user enables a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEnabledOn(e) {
    return this.track(new hk(), e);
  }
  /**
   * Settings Integrations Webhooks Remove
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Remove)
   *
   * When the user clicks on the button to remove a webhook
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksRemove(e) {
    return this.track(new gk(), e);
  }
  /**
   * Settings Integrations Webhooks Remove Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Remove%20Cancel)
   *
   * When the user cancels removing a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksRemoveCancel(e) {
    return this.track(new fk(), e);
  }
  /**
   * Settings Integrations Webhooks Remove Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Remove%20Confirm)
   *
   * When the user confirms removing a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksRemoveConfirm(e) {
    return this.track(new yk(), e);
  }
  /**
   * Settings Integrations Webhooks View
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View)
   *
   * When the user clicks on the button to view a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksView(e) {
    return this.track(new Ck(), e);
  }
  /**
   * Settings Integrations Webhooks View Copy Secret
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View%20Copy%20Secret)
   *
   * When the user clicks on the copy webhook URL button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksViewCopySecret(e) {
    return this.track(new _k(), e);
  }
  /**
   * Settings Integrations Webhooks View Copy Url
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View%20Copy%20Url)
   *
   * When the user is on the Settings/Webhooks page and views a webhook and clicks on the copy URL button
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksViewCopyUrl(e) {
    return this.track(new kk(), e);
  }
  /**
   * Settings Integrations Webhooks View Edit
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View%20Edit)
   *
   * When the user clicks on the button to edit a webhook from the webhook view
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksViewEdit(e) {
    return this.track(new mk(), e);
  }
  /**
   * Settings Menu Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Menu%20Item%20Clicked)
   *
   * When the user clicks the settings menu item
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  settingsMenuItemClicked(e, n) {
    return this.track(new wk(e), n);
  }
  /**
   * Settings Organization Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Organization%20Form%20Submitted)
   *
   * When the user submits the form on organization settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsOrganizationFormSubmitted(e) {
    return this.track(new Sk(), e);
  }
  /**
   * Settings Organization Logo Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Organization%20Logo%20Changed)
   *
   * When the user changes organization logo
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsOrganizationLogoChanged(e) {
    return this.track(new bk(), e);
  }
  /**
   * Settings Profile Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Profile%20Form%20Submitted)
   *
   * When the user submits the form on profile settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. payload)
   * @param options Amplitude event options.
   */
  settingsProfileFormSubmitted(e, n) {
    return this.track(new Ik(e), n);
  }
  /**
   * Settings Queue Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Added)
   *
   * When the user added a queue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. isDefault)
   * @param options Amplitude event options.
   */
  settingsQueueAdded(e, n) {
    return this.track(new Ak(e), n);
  }
  /**
   * Settings Queue Agent Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Agent%20Deleted)
   *
   * When the user performed a search.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueAgentDeleted(e) {
    return this.track(new Tk(), e);
  }
  /**
   * Settings Queue Agent Search Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Agent%20Search%20Submitted)
   *
   * When an agent was deleted.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueAgentSearchSubmitted(e) {
    return this.track(new Ek(), e);
  }
  /**
   * Settings Queue Agent Sorted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Agent%20Sorted)
   *
   * When sorting was applied.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  settingsQueueAgentSorted(e, n) {
    return this.track(new Pk(e), n);
  }
  /**
   * Settings Queue Alerts Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Alerts%20Saved)
   *
   * When the queue settings alerts form was saved.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. availableAgentsEnabled)
   * @param options Amplitude event options.
   */
  settingsQueueAlertsSaved(e, n) {
    return this.track(new Ok(e), n);
  }
  /**
   * Settings Queue Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Saved)
   *
   * When the user saved a queue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. isDefault)
   * @param options Amplitude event options.
   */
  settingsQueueSaved(e, n) {
    return this.track(new Rk(e), n);
  }
  /**
   * Settings Queue Teams Add Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Teams%20Add%20Team%20Button%20Clicked)
   *
   * When the Add team button was clicked.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueTeamsAddTeamButtonClicked(e) {
    return this.track(new Fk(), e);
  }
  /**
   * Settings Queue Teams Add Team Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Teams%20Add%20Team%20Form%20Submitted)
   *
   * When the Add team form was submitted.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueTeamsAddTeamFormSubmitted(e) {
    return this.track(new Dk(), e);
  }
  /**
   * Settings Queue Teams Delete Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Teams%20Delete%20Team%20Button%20Clicked)
   *
   * When the Delete team button was clicked.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueTeamsDeleteTeamButtonClicked(e) {
    return this.track(new Mk(), e);
  }
  /**
   * Settings Queues Add Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Add%20Queue%20Clicked)
   *
   * When the user clicks the Add Queue button in the queue settings
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueuesAddQueueClicked(e) {
    return this.track(new Uk(), e);
  }
  /**
   * Settings Queues Archive Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Archive%20Queue%20Clicked)
   *
   * When the users clicks the archive queue button in the queue settings
   *
   * @param properties The event's properties (e.g. openConversationsCount)
   * @param options Amplitude event options.
   */
  settingsQueuesArchiveQueueClicked(e, n) {
    return this.track(new Lk(e), n);
  }
  /**
   * Settings Queues Edit Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Edit%20Queue%20Clicked)
   *
   * When the user clicks the edit button in the queue settings
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueuesEditQueueClicked(e) {
    return this.track(new Nk(), e);
  }
  /**
   * Settings Queues Unarchive Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Unarchive%20Queue%20Clicked)
   *
   * When the users clicks the unarchive queue button in the queue settings
   *
   * @param options Amplitude event options.
   */
  settingsQueuesUnarchiveQueueClicked(e) {
    return this.track(new Vk(), e);
  }
  /**
   * Settings Roles Custom Role Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20Custom%20Role%20Created)
   *
   * When a user creates a custom role
   *
   * @param properties The event's properties (e.g. hasDescription)
   * @param options Amplitude event options.
   */
  settingsRolesCustomRoleCreated(e, n) {
    return this.track(new Bk(e), n);
  }
  /**
   * Settings Roles Custom Role Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20Custom%20Role%20Deleted)
   *
   * When a user deletes a custom role
   *
   * @param options Amplitude event options.
   */
  settingsRolesCustomRoleDeleted(e) {
    return this.track(new Wk(), e);
  }
  /**
   * Settings Roles Custom Role Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20Custom%20Role%20Edited)
   *
   * When a user edits a custom role
   *
   * @param properties The event's properties (e.g. hasDescription)
   * @param options Amplitude event options.
   */
  settingsRolesCustomRoleEdited(e, n) {
    return this.track(new Hk(e), n);
  }
  /**
   * Settings Satisfaction Filters Channel Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Satisfaction%20Filters%20Channel%20Added)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  settingsSatisfactionFiltersChannelAdded(e, n) {
    return this.track(new xk(e), n);
  }
  /**
   * Settings Satisfaction Filters Channel Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Satisfaction%20Filters%20Channel%20Removed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  settingsSatisfactionFiltersChannelRemoved(e, n) {
    return this.track(new Qk(e), n);
  }
  /**
   * Settings Satisfaction Filters Create Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Satisfaction%20Filters%20Create%20Viewed)
   *
   * When a new filter is created in the settings > satsifaction > filters
   *
   * @param options Amplitude event options.
   */
  settingsSatisfactionFiltersCreateViewed(e) {
    return this.track(new Kk(), e);
  }
  /**
   * Settings Satisfaction Filters Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Satisfaction%20Filters%20Created)
   *
   * When a new filter is created in the settings > satsifaction > filters
   *
   * @param options Amplitude event options.
   */
  settingsSatisfactionFiltersCreated(e) {
    return this.track(new Gk(), e);
  }
  /**
   * Settings Satisfaction Filters Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Satisfaction%20Filters%20Edited)
   *
   * When an filter in edited in settings > satisfaction > filters
   *
   * @param options Amplitude event options.
   */
  settingsSatisfactionFiltersEdited(e) {
    return this.track(new qk(), e);
  }
  /**
   * Settings Summarization Save Changes Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Summarization%20Save%20Changes%20Clicked)
   *
   * The Settings Summarization Save Changes Clicked" is triggered when user have saved changes to their summarization settings. In this instance
   *
   * @param options Amplitude event options.
   */
  settingsSummarizationSaveChangesClicked(e) {
    return this.track(new zk(), e);
  }
  /**
   * Settings Summarization Show Automatically Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Summarization%20Show%20Automatically%20Clicked)
   *
   * The Settings summarization show automatically clicked" is triggered when user chooses to show automatic summaries for said channel"
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  settingsSummarizationShowAutomaticallyClicked(e, n) {
    return this.track(new $k(e), n);
  }
  /**
   * Settings Summarization Show On Demand Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Summarization%20Show%20On%20Demand%20Clicked)
   *
   * The Settings summarization show on demand clicked" is triggered when user chooses to show summaries on demand for said channel"
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  settingsSummarizationShowOnDemandClicked(e, n) {
    return this.track(new jk(e), n);
  }
  /**
   * Settings Survey Accent Color Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Accent%20Color%20Changed)
   *
   * When the user changes the survey accent color
   *
   * @param options Amplitude event options.
   */
  settingsSurveyAccentColorChanged(e) {
    return this.track(new Jk(), e);
  }
  /**
   * Settings Survey Back To List Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Back%20To%20List%20Clicked)
   *
   * When the user clicks the Back to list button on the survey edit page
   *
   * @param options Amplitude event options.
   */
  settingsSurveyBackToListClicked(e) {
    return this.track(new Yk(), e);
  }
  /**
   * Settings Survey Back To Survey Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Back%20To%20Survey%20Clicked)
   *
   * When the user clicks the Back to survey button on a language details page
   *
   * @param properties The event's properties (e.g. surveyType)
   * @param options Amplitude event options.
   */
  settingsSurveyBackToSurveyClicked(e, n) {
    return this.track(new Xk(e), n);
  }
  /**
   * Settings Survey Create Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Create%20Failed)
   *
   * When creating a survey fails
   *
   * @param options Amplitude event options.
   */
  settingsSurveyCreateFailed(e) {
    return this.track(new Zk(), e);
  }
  /**
   * Settings Survey Create Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Create%20Modal%20Opened)
   *
   * When the user clicks the Add survey button
   *
   * @param options Amplitude event options.
   */
  settingsSurveyCreateModalOpened(e) {
    return this.track(new em(), e);
  }
  /**
   * Settings Survey Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Created)
   *
   * When a new survey is successfully created
   *
   * @param properties The event's properties (e.g. surveyType)
   * @param options Amplitude event options.
   */
  settingsSurveyCreated(e, n) {
    return this.track(new tm(e), n);
  }
  /**
   * Settings Survey Delete Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Delete%20Cancelled)
   *
   * When the user cancels the survey delete confirmation
   *
   * @param options Amplitude event options.
   */
  settingsSurveyDeleteCancelled(e) {
    return this.track(new nm(), e);
  }
  /**
   * Settings Survey Delete Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Delete%20Confirmed)
   *
   * When the user confirms deletion of a survey
   *
   * @param options Amplitude event options.
   */
  settingsSurveyDeleteConfirmed(e) {
    return this.track(new rm(), e);
  }
  /**
   * Settings Survey Delete Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Delete%20Failed)
   *
   * When deleting a survey fails
   *
   * @param options Amplitude event options.
   */
  settingsSurveyDeleteFailed(e) {
    return this.track(new im(), e);
  }
  /**
   * Settings Survey Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Deleted)
   *
   * When a survey is successfully deleted
   *
   * @param options Amplitude event options.
   */
  settingsSurveyDeleted(e) {
    return this.track(new sm(), e);
  }
  /**
   * Settings Survey Edit Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Edit%20Button%20Clicked)
   *
   * When the user clicks the edit button on a survey row
   *
   * @param properties The event's properties (e.g. surveyType)
   * @param options Amplitude event options.
   */
  settingsSurveyEditButtonClicked(e, n) {
    return this.track(new om(e), n);
  }
  /**
   * Settings Survey Edit Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Edit%20Viewed)
   *
   * When the user views the survey edit page
   *
   * @param properties The event's properties (e.g. surveyType)
   * @param options Amplitude event options.
   */
  settingsSurveyEditViewed(e, n) {
    return this.track(new am(e), n);
  }
  /**
   * Settings Survey Email Preview Area Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Email%20Preview%20Area%20Clicked)
   *
   * When the user clicks a changeable area in the email preview to navigate to the landing page tab
   *
   * @param options Amplitude event options.
   */
  settingsSurveyEmailPreviewAreaClicked(e) {
    return this.track(new cm(), e);
  }
  /**
   * Settings Survey Font Color Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Font%20Color%20Changed)
   *
   * When the user changes the survey font color
   *
   * @param options Amplitude event options.
   */
  settingsSurveyFontColorChanged(e) {
    return this.track(new um(), e);
  }
  /**
   * Settings Survey Header Image Type Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Header%20Image%20Type%20Changed)
   *
   * When the user changes the survey header image type
   *
   * @param properties The event's properties (e.g. headerImageType)
   * @param options Amplitude event options.
   */
  settingsSurveyHeaderImageTypeChanged(e, n) {
    return this.track(new lm(e), n);
  }
  /**
   * Settings Survey Ivr Details Save Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Ivr%20Details%20Save%20Failed)
   *
   * When saving the IVR survey details fails
   *
   * @param options Amplitude event options.
   */
  settingsSurveyIvrDetailsSaveFailed(e) {
    return this.track(new dm(), e);
  }
  /**
   * Settings Survey Ivr Details Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Ivr%20Details%20Saved)
   *
   * When the user saves the IVR survey details
   *
   * @param options Amplitude event options.
   */
  settingsSurveyIvrDetailsSaved(e) {
    return this.track(new pm(), e);
  }
  /**
   * Settings Survey Ivr Details Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Ivr%20Details%20Viewed)
   *
   * When the user views the IVR survey details page
   *
   * @param options Amplitude event options.
   */
  settingsSurveyIvrDetailsViewed(e) {
    return this.track(new vm(), e);
  }
  /**
   * Settings Survey Language Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Language%20Added)
   *
   * When the user adds a new language to the survey
   *
   * @param options Amplitude event options.
   */
  settingsSurveyLanguageAdded(e) {
    return this.track(new hm(), e);
  }
  /**
   * Settings Survey Language Delete Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Language%20Delete%20Cancelled)
   *
   * When the user cancels the language delete confirmation
   *
   * @param options Amplitude event options.
   */
  settingsSurveyLanguageDeleteCancelled(e) {
    return this.track(new gm(), e);
  }
  /**
   * Settings Survey Language Delete Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Language%20Delete%20Confirmed)
   *
   * When the user confirms deletion of a survey language
   *
   * @param properties The event's properties (e.g. languageCode)
   * @param options Amplitude event options.
   */
  settingsSurveyLanguageDeleteConfirmed(e, n) {
    return this.track(new fm(e), n);
  }
  /**
   * Settings Survey Language Delete Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Language%20Delete%20Failed)
   *
   * When deleting a survey language fails
   *
   * @param options Amplitude event options.
   */
  settingsSurveyLanguageDeleteFailed(e) {
    return this.track(new ym(), e);
  }
  /**
   * Settings Survey Language Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Language%20Deleted)
   *
   * When a survey language is successfully deleted
   *
   * @param properties The event's properties (e.g. languageCode)
   * @param options Amplitude event options.
   */
  settingsSurveyLanguageDeleted(e, n) {
    return this.track(new Cm(e), n);
  }
  /**
   * Settings Survey Language Disabled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Language%20Disabled)
   *
   * When the user disables a survey language
   *
   * @param properties The event's properties (e.g. languageCode)
   * @param options Amplitude event options.
   */
  settingsSurveyLanguageDisabled(e, n) {
    return this.track(new _m(e), n);
  }
  /**
   * Settings Survey Language Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Language%20Edit%20Clicked)
   *
   * When the user clicks the edit button on a survey language
   *
   * @param properties The event's properties (e.g. languageCode)
   * @param options Amplitude event options.
   */
  settingsSurveyLanguageEditClicked(e, n) {
    return this.track(new km(e), n);
  }
  /**
   * Settings Survey Language Enabled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Language%20Enabled)
   *
   * When the user enables a survey language
   *
   * @param properties The event's properties (e.g. languageCode)
   * @param options Amplitude event options.
   */
  settingsSurveyLanguageEnabled(e, n) {
    return this.track(new mm(e), n);
  }
  /**
   * Settings Survey List Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20List%20Viewed)
   *
   * When the user views the survey list page
   *
   * @param options Amplitude event options.
   */
  settingsSurveyListViewed(e) {
    return this.track(new wm(), e);
  }
  /**
   * Settings Survey Multi Question Details Save Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Multi%20Question%20Details%20Save%20Failed)
   *
   * When saving the multi-question survey details fails
   *
   * @param options Amplitude event options.
   */
  settingsSurveyMultiQuestionDetailsSaveFailed(e) {
    return this.track(new Sm(), e);
  }
  /**
   * Settings Survey Multi Question Details Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Multi%20Question%20Details%20Saved)
   *
   * When the user saves the multi-question survey details
   *
   * @param properties The event's properties (e.g. languageCode)
   * @param options Amplitude event options.
   */
  settingsSurveyMultiQuestionDetailsSaved(e, n) {
    return this.track(new bm(e), n);
  }
  /**
   * Settings Survey Multi Question Details Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Multi%20Question%20Details%20Viewed)
   *
   * When the user views the multi-question survey details page
   *
   * @param properties The event's properties (e.g. languageCode)
   * @param options Amplitude event options.
   */
  settingsSurveyMultiQuestionDetailsViewed(e, n) {
    return this.track(new Im(e), n);
  }
  /**
   * Settings Survey Multi Question Tab Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Multi%20Question%20Tab%20Changed)
   *
   * When the user switches tabs on the multi-question survey details page
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  settingsSurveyMultiQuestionTabChanged(e, n) {
    return this.track(new Am(e), n);
  }
  /**
   * Settings Survey Name Save Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Name%20Save%20Failed)
   *
   * When saving the survey name fails
   *
   * @param options Amplitude event options.
   */
  settingsSurveyNameSaveFailed(e) {
    return this.track(new Tm(), e);
  }
  /**
   * Settings Survey Name Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Name%20Saved)
   *
   * When the user saves the survey name
   *
   * @param options Amplitude event options.
   */
  settingsSurveyNameSaved(e) {
    return this.track(new Em(), e);
  }
  /**
   * Settings Survey Preview Mode Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Preview%20Mode%20Changed)
   *
   * When the user changes the satisfaction survey preview mode
   *
   * @param properties The event's properties (e.g. previewMode)
   * @param options Amplitude event options.
   */
  settingsSurveyPreviewModeChanged(e, n) {
    return this.track(new Pm(e), n);
  }
  /**
   * Settings Survey Question Add Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Question%20Add%20Clicked)
   *
   * When the user clicks the Add new field button
   *
   * @param options Amplitude event options.
   */
  settingsSurveyQuestionAddClicked(e) {
    return this.track(new Om(), e);
  }
  /**
   * Settings Survey Question Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Question%20Added)
   *
   * When a new survey question is successfully added
   *
   * @param properties The event's properties (e.g. questionType)
   * @param options Amplitude event options.
   */
  settingsSurveyQuestionAdded(e, n) {
    return this.track(new Rm(e), n);
  }
  /**
   * Settings Survey Question Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Question%20Deleted)
   *
   * When the user deletes a survey question
   *
   * @param properties The event's properties (e.g. questionType)
   * @param options Amplitude event options.
   */
  settingsSurveyQuestionDeleted(e, n) {
    return this.track(new Fm(e), n);
  }
  /**
   * Settings Survey Question Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Question%20Edit%20Clicked)
   *
   * When the user clicks the edit button on a survey question
   *
   * @param properties The event's properties (e.g. questionType)
   * @param options Amplitude event options.
   */
  settingsSurveyQuestionEditClicked(e, n) {
    return this.track(new Dm(e), n);
  }
  /**
   * Settings Survey Question Editor Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Question%20Editor%20Cancelled)
   *
   * When the user cancels the question editor modal
   *
   * @param options Amplitude event options.
   */
  settingsSurveyQuestionEditorCancelled(e) {
    return this.track(new Mm(), e);
  }
  /**
   * Settings Survey Question Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Question%20Reordered)
   *
   * When the user reorders a survey question via drag and drop
   *
   * @param options Amplitude event options.
   */
  settingsSurveyQuestionReordered(e) {
    return this.track(new Um(), e);
  }
  /**
   * Settings Survey Question Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Question%20Updated)
   *
   * When an existing survey question is updated
   *
   * @param properties The event's properties (e.g. questionType)
   * @param options Amplitude event options.
   */
  settingsSurveyQuestionUpdated(e, n) {
    return this.track(new Lm(e), n);
  }
  /**
   * Settings Survey Unsaved Changes Dialog Shown
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Unsaved%20Changes%20Dialog%20Shown)
   *
   * When the unsaved changes dialog is shown to the user upon attempting to navigate away
   *
   * @param properties The event's properties (e.g. surveyType)
   * @param options Amplitude event options.
   */
  settingsSurveyUnsavedChangesDialogShown(e, n) {
    return this.track(new Nm(e), n);
  }
  /**
   * Settings Survey Unsaved Changes Discarded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Unsaved%20Changes%20Discarded)
   *
   * When the user discards unsaved changes and leaves the page
   *
   * @param properties The event's properties (e.g. surveyType)
   * @param options Amplitude event options.
   */
  settingsSurveyUnsavedChangesDiscarded(e, n) {
    return this.track(new Vm(e), n);
  }
  /**
   * Settings Survey Unsaved Changes Kept
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Survey%20Unsaved%20Changes%20Kept)
   *
   * When the user chooses to stay on the page and keep unsaved changes
   *
   * @param properties The event's properties (e.g. surveyType)
   * @param options Amplitude event options.
   */
  settingsSurveyUnsavedChangesKept(e, n) {
    return this.track(new Bm(e), n);
  }
  /**
   * Settings Tags Add Tag Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Tags%20Add%20Tag%20Button%20Clicked)
   *
   * When the user clicks on Add Tag button on tags settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTagsAddTagButtonClicked(e) {
    return this.track(new Wm(), e);
  }
  /**
   * Settings Tags Tag Activated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Tags%20Tag%20Activated)
   *
   * When the user activates a tag on tags settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tagName)
   * @param options Amplitude event options.
   */
  settingsTagsTagActivated(e, n) {
    return this.track(new Hm(e), n);
  }
  /**
   * Settings Tags Tag Deactivated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Tags%20Tag%20Deactivated)
   *
   * When the user deactivates a tag on tags settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tagName)
   * @param options Amplitude event options.
   */
  settingsTagsTagDeactivated(e, n) {
    return this.track(new xm(e), n);
  }
  /**
   * Settings Team Add Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Add%20Team%20Button%20Clicked)
   *
   * When the user clicks on Add team" button on team settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamAddTeamButtonClicked(e) {
    return this.track(new Qm(), e);
  }
  /**
   * Settings Team Details Add Agents Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Details%20Add%20Agents%20Button%20Clicked)
   *
   * When the user clicks on Add agents" button on team details settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamDetailsAddAgentsButtonClicked(e) {
    return this.track(new Km(), e);
  }
  /**
   * Settings Team Edit Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Edit%20Team%20Button%20Clicked)
   *
   * When the user clicks on Edit" icon in the table on team settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamEditTeamButtonClicked(e) {
    return this.track(new Gm(), e);
  }
  /**
   * Settings Team Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on team modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. teamName)
   * @param options Amplitude event options.
   */
  settingsTeamModalFormSubmitted(e, n) {
    return this.track(new qm(e), n);
  }
  /**
   * Settings Team Remove Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Remove%20Team%20Button%20Clicked)
   *
   * When the user clicks on Remove" icon in the table on team settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamRemoveTeamButtonClicked(e) {
    return this.track(new zm(), e);
  }
  /**
   * Settings Team Remove Team Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Remove%20Team%20Confirmed)
   *
   * When the user presses confirm button on delete team modal
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamRemoveTeamConfirmed(e) {
    return this.track(new $m(), e);
  }
  /**
   * Settings Templates Add Template Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Add%20Template%20Button%20Clicked)
   *
   * When the user clicks on the add button in one of the tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateType)
   * @param options Amplitude event options.
   */
  settingsTemplatesAddTemplateButtonClicked(e, n) {
    return this.track(new jm(e), n);
  }
  /**
   * Settings Templates Edit Template Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Edit%20Template%20Button%20Clicked)
   *
   * When the user clicks on the edit icon in one of the tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateName)
   * @param options Amplitude event options.
   */
  settingsTemplatesEditTemplateButtonClicked(e, n) {
    return this.track(new Jm(e), n);
  }
  /**
   * Settings Templates Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on template modal on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  settingsTemplatesModalFormSubmitted(e, n) {
    return this.track(new Ym(e), n);
  }
  /**
   * Settings Templates Remove Template Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Remove%20Template%20Button%20Clicked)
   *
   * When the user clicks on the delete icon in one of the tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateName)
   * @param options Amplitude event options.
   */
  settingsTemplatesRemoveTemplateButtonClicked(e, n) {
    return this.track(new Xm(e), n);
  }
  /**
   * Settings Templates Remove Template Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Remove%20Template%20Confirmed)
   *
   * When the user clicks on confirm button on remove template confirm modal on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateName)
   * @param options Amplitude event options.
   */
  settingsTemplatesRemoveTemplateConfirmed(e, n) {
    return this.track(new Zm(e), n);
  }
  /**
   * Settings Templates Tab Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Tab%20Clicked)
   *
   * When the user switches between tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  settingsTemplatesTabClicked(e, n) {
    return this.track(new ew(e), n);
  }
  /**
   * Shared Worker Tab Or Window Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Shared%20Worker%20Tab%20Or%20Window%20Changed)
   *
   * When the user opens and closes a tab or window if there are any instances left and when the focus changes between different instances
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sharedWorkerTabOrWindowChanged(e) {
    return this.track(new tw(), e);
  }
  /**
   * Shared Worker Tab Or Window Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Shared%20Worker%20Tab%20Or%20Window%20Closed)
   *
   * When the user closes the agent interface. Including every tab and window.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. numberOfInstances)
   * @param options Amplitude event options.
   */
  sharedWorkerTabOrWindowClosed(e, n) {
    return this.track(new nw(e), n);
  }
  /**
   * Shared Worker Tab Or Window Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Shared%20Worker%20Tab%20Or%20Window%20Opened)
   *
   * When the user opens the agent interface. Including every tab and window.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. numberOfInstances)
   * @param options Amplitude event options.
   */
  sharedWorkerTabOrWindowOpened(e, n) {
    return this.track(new rw(e), n);
  }
  /**
   * Sidebar Add Agent Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Add%20Agent%20Button%20Clicked)
   *
   * When the user clicks on add agent icon on sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sidebarAddAgentButtonClicked(e) {
    return this.track(new iw(), e);
  }
  /**
   * Sidebar Collapsed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Collapsed)
   *
   * When the sidebar is collapsed
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sidebarCollapsed(e) {
    return this.track(new sw(), e);
  }
  /**
   * Sidebar Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Expanded)
   *
   * When the sidebar is expanded
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sidebarExpanded(e) {
    return this.track(new ow(), e);
  }
  /**
   * Sidebar Nav Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Nav%20Clicked)
   *
   * When the user clicks on a navigation link in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. item)
   * @param options Amplitude event options.
   */
  sidebarNavClicked(e, n) {
    return this.track(new aw(e), n);
  }
  /**
   * Sign Out Aborted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sign%20Out%20Aborted)
   *
   * When the user aborts signing out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  signOutAborted(e) {
    return this.track(new cw(), e);
  }
  /**
   * Sign Out Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sign%20Out%20Confirmed)
   *
   * When the user confirms signing out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  signOutConfirmed(e) {
    return this.track(new uw(), e);
  }
  /**
   * Simultaneous Ring Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Simultaneous%20Ring%20Updated)
   *
   * When the user updates their simultaneous ring status
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. enabled)
   * @param options Amplitude event options.
   */
  simultaneousRingUpdated(e, n) {
    return this.track(new lw(e), n);
  }
  /**
   * SLA Policies Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/SLA%20Policies%20Reordered)
   *
   * When the user reorders the list of SLA policies
   *
   * @param options Amplitude event options.
   */
  slaPoliciesReordered(e) {
    return this.track(new dw(), e);
  }
  /**
   * SLA Policy Activated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/SLA%20Policy%20Activated)
   *
   * When the user activates a SLA policy
   *
   * @param options Amplitude event options.
   */
  slaPolicyActivated(e) {
    return this.track(new pw(), e);
  }
  /**
   * SLA Policy Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/SLA%20Policy%20Created)
   *
   * When the user creates a new SLA policy
   *
   * @param properties The event's properties (e.g. conditions)
   * @param options Amplitude event options.
   */
  slaPolicyCreated(e, n) {
    return this.track(new vw(e), n);
  }
  /**
   * SLA Policy Deactivated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/SLA%20Policy%20Deactivated)
   *
   * When the user deactivates a SLA policy
   *
   * @param options Amplitude event options.
   */
  slaPolicyDeactivated(e) {
    return this.track(new hw(), e);
  }
  /**
   * SLA Policy Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/SLA%20Policy%20Deleted)
   *
   * When the user deletes a SLA policy
   *
   * @param options Amplitude event options.
   */
  slaPolicyDeleted(e) {
    return this.track(new gw(), e);
  }
  /**
   * SLA Policy Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/SLA%20Policy%20Updated)
   *
   * When the user updates an existing SLA policy
   *
   * @param properties The event's properties (e.g. conditions)
   * @param options Amplitude event options.
   */
  slaPolicyUpdated(e, n) {
    return this.track(new fw(e), n);
  }
  /**
   * Smart Conversation Reply Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Smart%20Conversation%20Reply%20Button%20Clicked)
   *
   * When the user clicks the Smart Conversation Reply" button from the Elevio or Dixa knowledge sidebar card"
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  smartConversationReplyButtonClicked(e, n) {
    return this.track(new yw(e), n);
  }
  /**
   * Subflow Back To Main Flow Node Reused
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Subflow%20Back%20To%20Main%20Flow%20Node%20Reused)
   *
   * This happens when in the subflow editor, a user decides to instead of creating a new exit path, reuse an existing one by selecting it in the "return to main flow" node modal
   *
   * @param options Amplitude event options.
   */
  subflowBackToMainFlowNodeReused(e) {
    return this.track(new Cw(), e);
  }
  /**
   * Subflow Back To Main Flow Node Used
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Subflow%20Back%20To%20Main%20Flow%20Node%20Used)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  subflowBackToMainFlowNodeUsed(e) {
    return this.track(new _w(), e);
  }
  /**
   * Subflow Created From Highlighted Nodes
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Subflow%20Created%20From%20Highlighted%20Nodes)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  subflowCreatedFromHighlightedNodes(e) {
    return this.track(new kw(), e);
  }
  /**
   * Subflow Created From Scratch
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Subflow%20Created%20From%20Scratch)
   *
   * When a subflow is created from scratch.
   *
   * @param options Amplitude event options.
   */
  subflowCreatedFromScratch(e) {
    return this.track(new mw(), e);
  }
  /**
   * Subflow Reused
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Subflow%20Reused)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  subflowReused(e) {
    return this.track(new ww(), e);
  }
  /**
   * Tag Select Create New Tag Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tag%20Select%20Create%20New%20Tag%20Clicked)
   *
   * When the user clicks on the inline tag creation item on the list to create a tag with the searched value
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. component)
   * @param options Amplitude event options.
   */
  tagSelectCreateNewTagClicked(e, n) {
    return this.track(new Sw(e), n);
  }
  /**
   * Tags Create Modal Color Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tags%20Create%20Modal%20Color%20Changed)
   *
   * When the user changes the tag color on Create new tag modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. color)
   * @param options Amplitude event options.
   */
  tagsCreateModalColorChanged(e, n) {
    return this.track(new bw(e), n);
  }
  /**
   * Tags Create Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tags%20Create%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on Create new tag modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. path)
   * @param options Amplitude event options.
   */
  tagsCreateModalFormSubmitted(e, n) {
    return this.track(new Iw(e), n);
  }
  /**
   * Tags Create Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tags%20Create%20Modal%20Opened)
   *
   * When the user opens the Create new tag modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. path)
   * @param options Amplitude event options.
   */
  tagsCreateModalOpened(e, n) {
    return this.track(new Aw(e), n);
  }
  /**
   * Team Agent Actions Menu Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Actions%20Menu%20Item%20Clicked)
   *
   * When the user clicks the agent actions menu item
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  teamAgentActionsMenuItemClicked(e, n) {
    return this.track(new Tw(e), n);
  }
  /**
   * Team Agent Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Actions%20Menu%20Opened)
   *
   * When the user opens the agent actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamAgentActionsMenuOpened(e) {
    return this.track(new Ew(), e);
  }
  /**
   * Team Agent Collapsed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Collapsed)
   *
   * When the user collapsed the agent item
   *
   * @param options Amplitude event options.
   */
  teamAgentCollapsed(e) {
    return this.track(new Pw(), e);
  }
  /**
   * Team Agent Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Expanded)
   *
   * When the user expands the agent item
   *
   * @param options Amplitude event options.
   */
  teamAgentExpanded(e) {
    return this.track(new Ow(), e);
  }
  /**
   * Team Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Favorite%20Toggled)
   *
   * When the user toggles the favorite agent
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  teamFavoriteToggled(e, n) {
    return this.track(new Rw(e), n);
  }
  /**
   * Theme Imported
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Theme%20Imported)
   *
   * When the user imports a custom theme.
   *
   * @param options Amplitude event options.
   */
  themeImported(e) {
    return this.track(new Fw(), e);
  }
  /**
   * Theme Shared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Theme%20Shared)
   *
   * When the user shares their custom theme.
   *
   * @param options Amplitude event options.
   */
  themeShared(e) {
    return this.track(new Dw(), e);
  }
  /**
   * Theme Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Theme%20Updated)
   *
   * When the user updates their preferred theme.
   *
   * @param properties The event's properties (e.g. theme)
   * @param options Amplitude event options.
   */
  themeUpdated(e, n) {
    return this.track(new Mw(e), n);
  }
  /**
   * Topbar Beamer Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Beamer%20Opened)
   *
   * When Beamer is opened from the topbar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarBeamerOpened(e) {
    return this.track(new Uw(), e);
  }
  /**
   * Topbar Email Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Email%20Opened)
   *
   * When the email dropdown in the topbar is opened
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarEmailOpened(e) {
    return this.track(new Lw(), e);
  }
  /**
   * Topbar Notifications Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Notifications%20Opened)
   *
   * When the notifications dropdown is opened from the topbar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarNotificationsOpened(e) {
    return this.track(new Nw(), e);
  }
  /**
   * Topbar Phones Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Phones%20Opened)
   *
   * When the phones dropdown in the topbar is opened
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarPhonesOpened(e) {
    return this.track(new Vw(), e);
  }
  /**
   * Topbar Search Quick Action Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Search%20Quick%20Action%20Clicked)
   *
   * When the user clicks on a quick action in the topbar search field
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  topbarSearchQuickActionClicked(e, n) {
    return this.track(new Bw(e), n);
  }
  /**
   * Topbar Support Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Support%20Opened)
   *
   * When the support menu is opened from the topbar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarSupportOpened(e) {
    return this.track(new Ww(), e);
  }
  /**
   * User Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/User%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on user modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. company)
   * @param options Amplitude event options.
   */
  userModalFormSubmitted(e, n) {
    return this.track(new Hw(e), n);
  }
  /**
   * User Modal Role Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/User%20Modal%20Role%20Changed)
   *
   * When the user changes the role of a user in the user modal
   *
   * @param properties The event's properties (e.g. after)
   * @param options Amplitude event options.
   */
  userModalRoleChanged(e, n) {
    return this.track(new xw(e), n);
  }
  /**
   * User Modal User Type Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/User%20Modal%20User%20Type%20Changed)
   *
   * When the user changes the type of a user in the user modal
   *
   * @param properties The event's properties (e.g. after)
   * @param options Amplitude event options.
   */
  userModalUserTypeChanged(e, n) {
    return this.track(new Qw(e), n);
  }
  /**
   * Websocket Active Connection Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Active%20Connection%20Changed)
   *
   * When the active websocket connection changes
   *
   * @param properties The event's properties (e.g. newConnectionId)
   * @param options Amplitude event options.
   */
  websocketActiveConnectionChanged(e, n) {
    return this.track(new Kw(e), n);
  }
  /**
   * Websocket Close Event Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Close%20Event%20Received)
   *
   * When the websocket receives a close event
   *
   * @param properties The event's properties (e.g. code)
   * @param options Amplitude event options.
   */
  websocketCloseEventReceived(e, n) {
    return this.track(new Gw(e), n);
  }
  /**
   * Websocket Connection Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Connection%20Closed)
   *
   * When the websocket connection is created
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  websocketConnectionClosed(e, n) {
    return this.track(new qw(e), n);
  }
  /**
   * Websocket Connection Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Connection%20Created)
   *
   * When the websocket connection is closed
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  websocketConnectionCreated(e, n) {
    return this.track(new zw(e), n);
  }
  /**
   * Websocket Reconnect Attempt Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Reconnect%20Attempt%20Started)
   *
   * When the websocket reconnect attempt starts
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  websocketReconnectAttemptStarted(e, n) {
    return this.track(new $w(e), n);
  }
}
const yn = new jw();
function Yw(t, e, n) {
  if (!yn.isLoaded)
    return { promise: Promise.resolve() };
  const r = new he();
  if (n)
    for (const [i, s] of Object.entries(n))
      s != null && r.set(i, s);
  return yn.client.groupIdentify(t, e, r);
}
export {
  va as AddAgentsModalFormSubmitted,
  ha as AgentCopilotBackButtonClicked,
  ga as AgentCopilotConversationCustomAttributeSuggestionAccepted,
  fa as AgentCopilotConversationTagSuggestionAccepted,
  ya as AgentCopilotDropdownItemClicked,
  Ca as AgentCopilotImproveWritingImprovementClicked,
  _a as AgentCopilotTextInsertBelowClicked,
  ka as AgentCopilotTextReplaceClicked,
  ma as AgentCopilotTranslateMessageLanguageSelected,
  wa as AgentCopilotTrialLearnMoreClicked,
  Sa as AgentCopilotTrialLeftmenuCtaClicked,
  ba as AgentCopilotTrialLeftmenuCtaDismissed,
  Ia as AgentCopilotTrialRequestContactClicked,
  Aa as AgentCopilotTrialStarted,
  Ta as AgentCopilotTrialStopped,
  Ea as AgentCopilotUndoClicked,
  Pa as AgentCustomAwayStatusUpdated,
  jw as Ampli,
  Oa as AnalyticsBusinessHoursScheduleRemoved,
  Ra as AnalyticsBusinessHoursScheduleUpdated,
  Fa as AnalyticsChartFormatChanged,
  Da as AnalyticsChartGranularityChanged,
  Ma as AnalyticsChartVisualizationChanged,
  Ua as AnalyticsCompareClicked,
  La as AnalyticsCompareContextUpdated,
  Na as AnalyticsComparePeriodUpdated,
  Va as AnalyticsContextUpdated,
  Ba as AnalyticsConversationLinkClicked,
  Wa as AnalyticsConversationPreviewClicked,
  Ha as AnalyticsDashboardViewed,
  xa as AnalyticsExportClicked,
  Qa as AnalyticsExportDownloadClicked,
  Ka as AnalyticsExportMyDataButtonPressed,
  Ga as AnalyticsFilterCleared,
  qa as AnalyticsFilterOpened,
  za as AnalyticsFilterOperatorUpdated,
  $a as AnalyticsFilterValueAdded,
  ja as AnalyticsFiltersApplied,
  Ja as AnalyticsFiltersCleared,
  Ya as AnalyticsHelperClicked,
  Xa as AnalyticsInDepthClicked,
  Za as AnalyticsInsightsCopyClicked,
  ec as AnalyticsInsightsFeedbackClicked,
  tc as AnalyticsInsightsPromptClicked,
  nc as AnalyticsInsightsRegenerateClicked,
  rc as AnalyticsPanelControlsOpened,
  ic as AnalyticsPeriodUpdated,
  sc as AnalyticsPinPanelClicked,
  oc as AnalyticsPinPanelQuickViewCreated,
  ac as AnalyticsQuickViewAutoRefreshDisabled,
  cc as AnalyticsQuickViewAutoRefreshEnabled,
  uc as AnalyticsQuickViewAutoRefreshTriggered,
  lc as AnalyticsQuickViewCreated,
  dc as AnalyticsQuickViewDeleted,
  pc as AnalyticsQuickViewDuplicated,
  vc as AnalyticsQuickViewFavoriteToggled,
  hc as AnalyticsQuickViewLandingPageSet,
  gc as AnalyticsQuickViewLandingPageUnset,
  fc as AnalyticsQuickViewOwnershipTransferred,
  yc as AnalyticsQuickViewPanelControlsUpdated,
  Cc as AnalyticsQuickViewPanelDescriptionUpdated,
  _c as AnalyticsQuickViewPanelPinned,
  kc as AnalyticsQuickViewPanelUnpinned,
  mc as AnalyticsQuickViewPanelsLayoutChanged,
  wc as AnalyticsQuickViewPanelsReset,
  Sc as AnalyticsQuickViewPanelsUpdated,
  bc as AnalyticsQuickViewSharingToggled,
  Ic as AnalyticsQuickViewUpdated,
  Ac as AnalyticsQuickViewViewed,
  Tc as AnalyticsRefreshClicked,
  Ec as AnalyticsTableLoadAllClicked,
  Pc as AnalyticsTableSortUpdated,
  Oc as AnalyticsTimezoneUpdated,
  Rc as AnalyticsViewConversationsClicked,
  da as ApiKey,
  Fc as AuthFailedInit,
  Dc as AutomationsFormCancelled,
  Mc as AutomationsFormOpened,
  Uc as AutomationsFormSubmitted,
  Lc as AutomationsOptionsMenuOpened,
  Nc as AutomationsOptionsMenuOptionDeleteClicked,
  Vc as AutomationsOptionsMenuOptionDuplicateClicked,
  Bc as AutomationsOptionsMenuOptionFlowClicked,
  Wc as AutomationsOptionsMenuOptionSettingsClicked,
  Hc as AutomationsPaginationNextClicked,
  xc as AutomationsPaginationPreviousClicked,
  Qc as AutomationsSearchApplied,
  Kc as AutomationsSearchClosed,
  Gc as AutomationsSearchOpened,
  qc as AutomationsToggledOff,
  zc as AutomationsToggledOn,
  $c as BansBanUserClicked,
  jc as BansUnbanIpClicked,
  Jc as BansUnbanUserClicked,
  Yc as BulkActionsUpdateClicked,
  Xc as BusinessHoursAddScheduleAudioMessageAdded,
  Zc as BusinessHoursAddScheduleButtonClicked,
  eu as BusinessHoursAddScheduleFormCancelled,
  tu as BusinessHoursAddScheduleFormSubmitted,
  nu as BusinessHoursConflictNotificationButtonClicked,
  ru as BusinessHoursConflictNotificationClosed,
  iu as BusinessHoursDeleteScheduleFormCancelled,
  su as BusinessHoursDeleteScheduleFormSubmitted,
  ou as BusinessHoursDuplicateScheduleFormCancelled,
  au as BusinessHoursDuplicateScheduleFormSubmitted,
  cu as BusinessHoursFirstScheduleModalQuestionClicked,
  uu as BusinessHoursFirstScheduleSupportArticleClicked,
  lu as BusinessHoursGoToFlowClicked,
  du as BusinessHoursMigrationWizardAudioMessageAdded,
  pu as BusinessHoursMigrationWizardCreateNewScheduleButtonClicked,
  vu as BusinessHoursMigrationWizardEditHoursButtonClicked,
  hu as BusinessHoursMigrationWizardFormCancelled,
  gu as BusinessHoursMigrationWizardFormSubmitted,
  fu as BusinessHoursMigrationWizardOpeningHoursFormCancelled,
  yu as BusinessHoursMigrationWizardOpeningHoursFormSubmitted,
  Cu as BusinessHoursMigrationWizardStartUpdateButtonClicked,
  _u as BusinessHoursOptionsMenuOpened,
  ku as BusinessHoursOptionsMenuOptionDeleteClicked,
  mu as BusinessHoursOptionsMenuOptionDuplicateClicked,
  wu as BusinessHoursOptionsMenuOptionEditClicked,
  Su as BusinessHoursOptionsMenuOptionRenameClicked,
  bu as BusinessHoursRenameScheduleFormCancelled,
  Iu as BusinessHoursRenameScheduleFormSubmitted,
  Au as BusinessHoursScheduleAddExceptionButtonClicked,
  Tu as BusinessHoursScheduleAddExceptionFormCancelled,
  Eu as BusinessHoursScheduleAddExceptionFormSubmitted,
  Pu as BusinessHoursScheduleAudioMessageFormCancelled,
  Ou as BusinessHoursScheduleAudioMessageFormSubmitted,
  Ru as BusinessHoursScheduleAudioMessageOptionsMenuOpened,
  Fu as BusinessHoursScheduleAudioMessageOptionsMenuOptionClearClicked,
  Du as BusinessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked,
  Mu as BusinessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked,
  Uu as BusinessHoursScheduleAutoReplyOptionsMenuOptionClearClicked,
  Lu as BusinessHoursScheduleConflictChangeButtonClicked,
  Nu as BusinessHoursScheduleConflictReviewButtonClicked,
  Vu as BusinessHoursScheduleDeleteExceptionFormCancelled,
  Bu as BusinessHoursScheduleDeleteExceptionFormSubmitted,
  Wu as BusinessHoursScheduleExceptionOptionsMenuOptionDeleteClicked,
  Hu as BusinessHoursScheduleImportHolidayFormCancelled,
  xu as BusinessHoursScheduleImportHolidayFormSubmitted,
  Qu as BusinessHoursScheduleOptionsMenuImportHolidaysClicked,
  Ku as BusinessHoursScheduleOptionsMenuOpened,
  Gu as BusinessHoursScheduleOptionsMenuRecoverHolidaysClicked,
  qu as BusinessHoursScheduleOptionsMenuRenameClicked,
  zu as BusinessHoursScheduleOptionsMenuTimezoneClicked,
  $u as BusinessHoursSchedulePreviewButtonClicked,
  ju as BusinessHoursScheduleRecoverHolidaysFormCancelled,
  Ju as BusinessHoursScheduleRecoverHolidaysFormSubmitted,
  Yu as BusinessHoursScheduleReviewFormCancelled,
  Xu as BusinessHoursScheduleReviewFormSubmitted,
  Zu as BusinessHoursScheduleSaveScheduleButtonClicked,
  el as BusinessHoursScheduleTabClicked,
  tl as BusinessHoursScheduleViewClicked,
  nl as ChatFlowOptionsMenuOptionAuditLogClicked,
  rl as ChatFormCanceled,
  il as ChatFormOpened,
  sl as ChatFormSubmitted,
  ol as ChatOptionsMenuOpened,
  al as ChatOptionsMenuOptionDeleteClicked,
  cl as ChatOptionsMenuOptionDuplicateClicked,
  ul as ChatOptionsMenuOptionFlowClicked,
  ll as ChatOptionsMenuOptionRenameClicked,
  dl as ChatOptionsMenuOptionSetupClicked,
  pl as ChatPaginationNextClicked,
  vl as ChatPaginationPreviousClicked,
  hl as ChatSearchApplied,
  gl as ChatSearchClosed,
  fl as ChatSearchOpened,
  yl as ChatbotCreateModalOpened,
  Cl as ChatbotCreated,
  _l as ChatbotDeleteModalOpened,
  kl as ChatbotDeleted,
  ml as ChatbotEditIdentityModalOpened,
  wl as ChatbotIdentityEdited,
  Sl as ColorModeUpdated,
  bl as CommandExecuted,
  Il as CommandPaletteActionSelected,
  Al as CommandPaletteClosed,
  Tl as CommandPaletteOpened,
  El as CompanyModalFormSubmitted,
  Pl as ContactsAddNewCompanyClicked,
  Ol as ContactsAddNewContactClicked,
  Rl as ContactsBanUserClicked,
  Fl as ContactsCardActionsMenuOpened,
  Dl as ContactsCardComposeNewEmailClicked,
  Ml as ContactsCardEditCompanyClicked,
  Ul as ContactsCardEditContactClicked,
  Ll as ContactsCardMakeCallClicked,
  Nl as ContactsCardSeeAllAssignedConversationsClicked,
  Vl as ContactsCardSeeAllConversationsClicked,
  Bl as ContactsCardViewCompanyClicked,
  Wl as ContactsCardViewUserClicked,
  Hl as ContactsSearchBlurred,
  xl as ContactsSearchFocused,
  Ql as ContactsUnbanUserClicked,
  Kl as ContactsViewCompanies,
  Gl as ContactsViewEndUsers,
  ql as ConversationActionsMenuOpened,
  zl as ConversationActionsMenuOptionClicked,
  $l as ConversationActivityLogClosed,
  jl as ConversationActivityLogFlooterExpanded,
  Jl as ConversationActivityLogOpened,
  Yl as ConversationArticleDraftImprovementRequested,
  Xl as ConversationArticleDraftImprovementResponseReceived,
  Zl as ConversationArticleDraftPreviewRequested,
  ed as ConversationArticleDraftPreviewResponseReceived,
  td as ConversationArticleDraftSaveRequested,
  nd as ConversationArticleDraftSaveResponseReceived,
  rd as ConversationAttachedImageIsDownloaded,
  id as ConversationAttachedImageIsViewed,
  sd as ConversationClaimed,
  od as ConversationClosed,
  ad as ConversationCsatCancelled,
  cd as ConversationCsatMenuCancelOptionClicked,
  ud as ConversationCsatMenuLanguageSelected,
  ld as ConversationCsatMenuOpened,
  dd as ConversationFocusModeToggled,
  pd as ConversationFollowUp,
  vd as ConversationFollowUpMenuOpened,
  hd as ConversationFollowUpMenuOptionClicked,
  gd as ConversationHeaderConversationDetailsMenuOpened,
  fd as ConversationHeaderTagAdded,
  yd as ConversationHeaderTagIncludeDeactivatedToggled,
  Cd as ConversationHeaderTagMenuOpened,
  _d as ConversationHeaderTagRemoved,
  kd as ConversationHeaderTransferToAgentItemSelected,
  md as ConversationHeaderTransferToAgentMenuOpened,
  wd as ConversationHeaderTransferToNumberButtonClicked,
  Sd as ConversationHeaderTransferToQueueItemSelected,
  bd as ConversationHeaderTransferToQueueMenuOpened,
  Id as ConversationInternalNoteEditorOpened,
  Ad as ConversationMessageRedactionModalOpened,
  Td as ConversationMessageRedactionModalSubmitted,
  Ed as ConversationOffered,
  Pd as ConversationReplied,
  Od as ConversationReplyWindowToggled,
  Rd as ConversationResolvedAsAKnowledgeArticleDraft,
  Fd as ConversationResolvedAsAKnowledgeGap,
  Dd as ConversationResolvedByKnowledge,
  Md as ConversationResolvedWithNoKnowledgeArticle,
  Ud as ConversationRightSidebarItemReordered,
  Ld as ConversationRightSidebarItemVisibilityToggled,
  Nd as ConversationSidebarClosed,
  Vd as ConversationSidebarConversationHistoryClosed,
  Bd as ConversationSidebarConversationHistoryNavigatedToConversation,
  Wd as ConversationSidebarConversationHistoryOpened,
  Hd as ConversationSidebarCustomerInfoEmailClicked,
  xd as ConversationSidebarCustomerInfoPhoneNumberClicked,
  Qd as ConversationSidebarOpened,
  lp as ConversationSummaryFeedbackNotUseful,
  dp as ConversationSummaryFeedbackUseful,
  pp as ConversationSummaryRegenerateSummary,
  Kd as ConversationTimelineItemOpened,
  Gd as ConversationTimelineNavigatedToConversation,
  qd as ConversationTransferred,
  zd as ConversationsBulkActionsClicked,
  $d as ConversationsClearAllClicked,
  jd as ConversationsFilterAgentClicked,
  Jd as ConversationsFilterClearAllClicked,
  Yd as ConversationsFilterCleared,
  Xd as ConversationsFilterContactClicked,
  Zd as ConversationsFilterToggled,
  ep as ConversationsGoToConversationClicked,
  tp as ConversationsItemPreviewClicked,
  np as ConversationsNextPageClicked,
  rp as ConversationsPreviousPageClicked,
  ip as ConversationsSelectAllClicked,
  sp as ConversationsSelectClicked,
  op as ConversationsTimestampClicked,
  ap as ConversationsTransferToQueueClicked,
  cp as ConversationsViewAgentClicked,
  up as ConversationsViewContactClicked,
  vp as CopyScript,
  hp as CountryCodeSelected,
  gp as CustomAttributeValueUpdated,
  fp as DashboardChannelAllConversationsClicked,
  yp as DashboardChannelGoToAnalyticsClicked,
  Cp as DashboardChannelLongestQueuedTimeMetricClicked,
  _p as DashboardChannelNameClicked,
  kp as DashboardChannelPendingConversationsMetricClicked,
  mp as DashboardChannelTvDashboardClicked,
  wp as DashboardFavoriteCreated,
  Sp as DashboardFavoriteDeleted,
  bp as DashboardFavoriteLandingPageSet,
  Ip as DashboardFavoriteLandingPageUnset,
  Ap as DashboardFavoriteOwnershipTransferred,
  Tp as DashboardFavoriteQueuesReordered,
  Ep as DashboardFavoriteSharingToggled,
  Pp as DashboardFavoriteTvDashboardClicked,
  Op as DashboardFavoriteUpdated,
  Rp as DashboardFavoriteViewed,
  Fp as DashboardGlobalTvDashboardClicked,
  Dp as DashboardLayoutChanged,
  Mp as DashboardLongestQueuedTimeMetricClicked,
  Up as DashboardMetricHelperClicked,
  Lp as DashboardNextPageClicked,
  Np as DashboardOrganizationTimezoneSettingsClicked,
  Vp as DashboardPreviousPageClicked,
  Bp as DashboardQueueAllConversationsClicked,
  Wp as DashboardQueueGoToAnalyticsClicked,
  Hp as DashboardQueueItemFavoriteToggled,
  xp as DashboardQueueNameClicked,
  Qp as DashboardQueuePendingConversationsMetricClicked,
  Kp as DashboardQueueSettingsClicked,
  Gp as DashboardQueueTvDashboardClicked,
  qp as DashboardQueuesManuallySelected,
  zp as DashboardQueuesSearchFieldCleared,
  $p as DashboardQueuesSearchFieldSubmitted,
  jp as DashboardQueuesSortingUpdated,
  Jp as DashboardQueuesTypeChanged,
  Yp as DashboardRefreshDataClicked,
  Xp as DashboardTvReloaded,
  Zp as DashboardViewed,
  pa as DefaultConfiguration,
  ev as EmailFlowOptionsMenuOptionAuditLogClicked,
  tv as EmailFormSubmitted,
  nv as EmailOptionsMenuOpened,
  rv as EmailOptionsMenuOptionDeleteClicked,
  iv as EmailOptionsMenuOptionDuplicateClicked,
  sv as EmailOptionsMenuOptionEmailClicked,
  ov as EmailOptionsMenuOptionFlowClicked,
  av as EmailOptionsMenuOptionRenameClicked,
  cv as EmailSearchApplied,
  uv as EmailSearchClosed,
  lv as EmailSearchOpened,
  dv as FlowActionAddSaved,
  pv as FlowActionConditionAdded,
  vv as FlowActionConditionRemoved,
  hv as FlowActionDeleted,
  gv as FlowActionEditClicked,
  fv as FlowActionEditSaved,
  yv as FlowActivateClicked,
  Cv as FlowAddActionActionSelected,
  _v as FlowAddActionCancelled,
  kv as FlowAddActionOpened,
  mv as FlowBackToSettingsClicked,
  wv as FlowContextAlignClicked,
  Sv as FlowContextDeleteCancelClicked,
  bv as FlowContextDeleteClicked,
  Iv as FlowContextDeleteConfirmClicked,
  Av as FlowContextNodeArrangeClicked,
  Tv as FlowPhoneNumberChanged,
  Ev as FlowSaveClicked,
  Pv as FlowTitleEditClicked,
  Ov as FlowZoomInClicked,
  Rv as FlowZoomOutClicked,
  Fv as FlowZoomResetClicked,
  Dv as FollowUpConversationModalInternalNoteAdded,
  Mv as FollowUpConversationModalOfferInQueueAdded,
  Jw as Identify,
  Uv as IntelligenceDashboardViewed,
  Lv as IntelligenceDistributionChartOpened,
  Nv as IntelligenceEvolutionChartOpened,
  Vv as IntelligenceFilterChanged,
  Bv as IntelligenceFilterPeriodChanged,
  Wv as IntelligenceGroupByChanged,
  Hv as IntelligencePresetComparisonStarted,
  xv as IntelligenceTableCustomized,
  Qv as IntentDetectionCreated,
  Kv as IntentDetectionDeleted,
  Gv as IntentDetectionFlowNodeSaved,
  qv as IntentDetectionUpdated,
  zv as KnowledgeArticleArchived,
  $v as KnowledgeArticleChangesDiscarded,
  jv as KnowledgeArticleCreated,
  Jv as KnowledgeArticleDestroyed,
  Yv as KnowledgeArticleFeedbackSubmitted,
  Xv as KnowledgeArticleMarkedAsHelpful,
  Zv as KnowledgeArticleMoved,
  eh as KnowledgeArticlePublished,
  th as KnowledgeArticleReordered,
  nh as KnowledgeArticleRestored,
  rh as KnowledgeArticleTagAdded,
  ih as KnowledgeArticleTagRemoved,
  sh as KnowledgeArticleUnpublished,
  oh as KnowledgeArticleUpdated,
  ah as KnowledgeArticleVersionHistoryClicked,
  ch as KnowledgeArticleViewed,
  uh as KnowledgeArticlesSearchByTermSubmitted,
  lh as KnowledgeCategoryCreated,
  dh as KnowledgeCategoryDestroyed,
  ph as KnowledgeCategoryReordered,
  vh as KnowledgeCategoryUpdated,
  hh as KnowledgeCollectionCreated,
  gh as KnowledgeCollectionDestroyed,
  fh as KnowledgeCollectionUpdated,
  yh as KnowledgeCollectionViewed,
  Ch as KnowledgeHelpCenterCreated,
  _h as KnowledgeHelpCenterDeleted,
  kh as KnowledgeHelpCenterUpdated,
  mh as KnowledgeInternalKbDashboardViewed,
  wh as KnowledgeInternalKbSearchResultClicked,
  Sh as KnowledgeResolutionCancelled,
  bh as KnowledgeResolutionInitialised,
  Ih as KnowledgeRetranslateArticleBlockClicked,
  Ah as KnowledgeRetranslateArticleTitleClicked,
  Th as KnowledgeTranslateArticleClicked,
  Eh as LinkConversationsModalOpened,
  Ph as LinkConversationsSubmitted,
  Oh as MentionUserNotificationClicked,
  Rh as MentionUserSelected,
  Fh as MergeContactsMergeCancelled,
  Dh as MergeContactsMergeFailed,
  Mh as MergeContactsMergeSucceeded,
  Uh as MergeContactsModalClosed,
  Lh as MergeContactsModalOpened,
  Nh as MergeContactsSourceContactSelected,
  Vh as MessengerFlowOptionsMenuOptionAuditLogClicked,
  Bh as MessengerFormCancelled,
  Wh as MessengerFormOpened,
  Hh as MessengerFormSubmitted,
  xh as MessengerOptionsMenuOpened,
  Qh as MessengerOptionsMenuOptionClicked,
  Kh as ModalConversationCloseCancelClicked,
  Gh as ModalConversationCloseConfirmClicked,
  qh as ModalTransferToQueueCancelClicked,
  zh as ModalTransferToQueueConfirmClicked,
  $h as NetworkConnectionStatusChanged,
  jh as NotificationOfferAccepted,
  Jh as NotificationOfferClosed,
  Yh as NotificationOfferRejected,
  Xh as NotificationOfferTimeout,
  Zh as NotificationTransferOfferAccepted,
  eg as NotificationTransferOfferClosed,
  tg as NotificationTransferOfferRejected,
  ng as NotificationTransferOfferTimeout,
  rg as OrganizationsNavigationOrganizationClicked,
  ig as PartnerIntegrationsBrazeProfileReceived,
  sg as PartnerIntegrationsBrazeSubscriptionEmailOptInSucceeded,
  og as PartnerIntegrationsBrazeSubscriptionEmailUnsubscribedSucceeded,
  ag as PartnerIntegrationsConditionCreated,
  cg as PartnerIntegrationsConditionDeleted,
  ug as PartnerIntegrationsConditionUpdated,
  lg as PartnerIntegrationsGithubCreateNewIssueCanceled,
  dg as PartnerIntegrationsGithubCreateNewIssueClicked,
  pg as PartnerIntegrationsGithubCreateNewIssueConfirmed,
  vg as PartnerIntegrationsGithubLinkIssueClicked,
  hg as PartnerIntegrationsGithubUnlinkAllIssuesCanceled,
  gg as PartnerIntegrationsGithubUnlinkAllIssuesClicked,
  fg as PartnerIntegrationsGithubUnlinkAllIssuesConfirmed,
  yg as PartnerIntegrationsGithubUnlinkIssueCanceled,
  Cg as PartnerIntegrationsGithubUnlinkIssueClicked,
  _g as PartnerIntegrationsGithubUnlinkIssueConfirmed,
  kg as PartnerIntegrationsGithubViewLinkClicked,
  mg as PartnerIntegrationsJiraCommentsCollapsed,
  wg as PartnerIntegrationsJiraCommentsExpanded,
  Sg as PartnerIntegrationsJiraCreateIssueFailed,
  bg as PartnerIntegrationsJiraCreateIssueSucceeded,
  Ig as PartnerIntegrationsJiraLinkIssueClicked,
  Ag as PartnerIntegrationsJiraOpenIssueClicked,
  Tg as PartnerIntegrationsJiraOpenJiraClicked,
  Eg as PartnerIntegrationsJiraRemoveAllDanglingClicked,
  Pg as PartnerIntegrationsJiraRemoveDanglingIssueClicked,
  Og as PartnerIntegrationsJiraUnlinkAllIssuesCancelled,
  Rg as PartnerIntegrationsJiraUnlinkAllIssuesClicked,
  Fg as PartnerIntegrationsJiraUnlinkAllIssuesConfirmed,
  Dg as PartnerIntegrationsJiraUnlinkIssueCancelled,
  Mg as PartnerIntegrationsJiraUnlinkIssueClicked,
  Ug as PartnerIntegrationsJiraUnlinkIssueConfirmed,
  Lg as PartnerIntegrationsKlaviyoMessagesReceived,
  Ng as PartnerIntegrationsKlaviyoProfileFailed,
  Vg as PartnerIntegrationsKlaviyoProfileReceived,
  Bg as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelClicked,
  Wg as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelFailed,
  Hg as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelSucceeded,
  xg as PartnerIntegrationsKlaviyoProfileUnsubscribeClicked,
  Qg as PartnerIntegrationsKlaviyoProfileUnsubscribeFailed,
  Kg as PartnerIntegrationsKlaviyoProfileUnsubscribeSucceeded,
  Gg as PartnerIntegrationsLinearCreateNewIssueCancelled,
  qg as PartnerIntegrationsLinearCreateNewIssueClicked,
  zg as PartnerIntegrationsLinearCreateNewIssueConfirmed,
  $g as PartnerIntegrationsLinearLinkIssueClicked,
  jg as PartnerIntegrationsLinearOpenIssueClicked,
  Jg as PartnerIntegrationsLinearOpenLinearClicked,
  Yg as PartnerIntegrationsLinearUnlinkIssueClicked,
  Xg as PartnerIntegrationsRechargeWidgetCustomerOverviewOpened,
  Zg as PartnerIntegrationsRechargeWidgetOrderOpened,
  ef as PartnerIntegrationsRechargeWidgetOrdersListOpened,
  tf as PartnerIntegrationsRechargeWidgetProfileReceived,
  nf as PartnerIntegrationsRechargeWidgetSubscriptionCancelled,
  rf as PartnerIntegrationsRechargeWidgetSubscriptionOpened,
  sf as PartnerIntegrationsRechargeWidgetSubscriptionReactivated,
  of as PartnerIntegrationsRechargeWidgetSubscriptionsListOpened,
  af as PartnerIntegrationsRivoLoyaltyWidgetCustomerClicked,
  cf as PartnerIntegrationsRivoLoyaltyWidgetCustomerReceived,
  uf as PartnerIntegrationsRivoLoyaltyWidgetPointsAddFailed,
  lf as PartnerIntegrationsRivoLoyaltyWidgetPointsAddSucceeded,
  df as PartnerIntegrationsRivoLoyaltyWidgetPointsRemoveFailed,
  pf as PartnerIntegrationsRivoLoyaltyWidgetPointsRemoveSucceeded,
  vf as PartnerIntegrationsSettingsCreateSubmitted,
  hf as PartnerIntegrationsSettingsOverviewCreated,
  gf as PartnerIntegrationsSettingsOverviewViewed,
  ff as PartnerIntegrationsSettingsViewDeleteCanceled,
  yf as PartnerIntegrationsSettingsViewDeleteConfirmed,
  Cf as PartnerIntegrationsSettingsViewDeleteRequested,
  _f as PartnerIntegrationsSettingsViewOAuthStarted,
  kf as PartnerIntegrationsSettingsViewOAuthSucceeded,
  mf as PartnerIntegrationsSettingsViewSubmitted,
  wf as PartnerIntegrationsShopifyWidgetCreateDraftOrderFailed,
  Sf as PartnerIntegrationsShopifyWidgetCreateDraftOrderSucceeded,
  bf as PartnerIntegrationsShopifyWidgetCreateOrderFailed,
  If as PartnerIntegrationsShopifyWidgetCreateOrderSucceeded,
  Af as PartnerIntegrationsShopifyWidgetDiscountCodeCreated,
  Tf as PartnerIntegrationsShopifyWidgetDuplicateOrderFailed,
  Ef as PartnerIntegrationsShopifyWidgetDuplicateOrderSucceeded,
  Pf as PartnerIntegrationsShopifyWidgetOrderCancelled,
  Of as PartnerIntegrationsShopifyWidgetOrderCollapseClosed,
  Rf as PartnerIntegrationsShopifyWidgetOrderCollapseOpened,
  Ff as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled,
  Df as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened,
  Mf as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted,
  Uf as PartnerIntegrationsShopifyWidgetOrderRefundCanceled,
  Lf as PartnerIntegrationsShopifyWidgetOrderRefundConfirmed,
  Nf as PartnerIntegrationsShopifyWidgetOrderRefundRequested,
  Vf as PartnerIntegrationsShopifyWidgetOrderTagsUpdated,
  Bf as PartnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked,
  Wf as PartnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked,
  Hf as PartnerIntegrationsShopifyWidgetProfileCreated,
  xf as PartnerIntegrationsShopifyWidgetRefreshed,
  Qf as PartnerIntegrationsShopifyWidgetRefundPartialOrderFailed,
  Kf as PartnerIntegrationsShopifyWidgetRefundPartialOrderSucceeded,
  Gf as PartnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked,
  qf as PartnerIntegrationsVoyadoWidgetChannelSubscriptionClicked,
  zf as PartnerIntegrationsVoyadoWidgetChannelSubscriptionFailed,
  $f as PartnerIntegrationsVoyadoWidgetChannelSubscriptionSucceeded,
  jf as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionClicked,
  Jf as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionFailed,
  Yf as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionSucceeded,
  Xf as PartnerIntegrationsVoyadoWidgetMessageExternalLinkOpened,
  Zf as PartnerIntegrationsVoyadoWidgetMessagesReceived,
  ey as PartnerIntegrationsVoyadoWidgetOrdersReceived,
  ty as PartnerIntegrationsVoyadoWidgetProfileReceived,
  ny as PartnerIntegrationsVoyadoWidgetTransactionsReceived,
  ry as PartnerIntegrationsWidgetCollapseClosed,
  iy as PartnerIntegrationsWidgetCollapseOpened,
  sy as PartnerIntegrationsWidgetLoyaltyLionAddPointsFailed,
  oy as PartnerIntegrationsWidgetLoyaltyLionAddPointsSucceeded,
  ay as PartnerIntegrationsWidgetLoyaltyLionCustomerReceived,
  cy as PartnerIntegrationsWidgetLoyaltyLionRemovePointsFailed,
  uy as PartnerIntegrationsWidgetLoyaltyLionRemovePointsSucceeded,
  ly as PartnerIntegrationsWidgetVoyadoUpdatePointsFailed,
  dy as PartnerIntegrationsWidgetVoyadoUpdatePointsSucceeded,
  py as PhoneActionsMenuActionAddOutboundCallerIdClicked,
  vy as PhoneActionsMenuActionChangeHoldMusicClicked,
  hy as PhoneActionsMenuOpened,
  gy as PhoneAddOutboundCallerIdFormCancelled,
  fy as PhoneAddOutboundCallerIdFormSubmitted,
  yy as PhoneChangeHoldMusicFormCancelled,
  Cy as PhoneChangeHoldMusicFormSubmitted,
  _y as PhoneCreateFlowFormCancelled,
  ky as PhoneCreateFlowFormSubmitted,
  my as PhoneFlowOptionsMenuOptionAuditLogClicked,
  wy as PhoneFlowOptionsMenuOptionDeleteClicked,
  Sy as PhoneFlowOptionsMenuOptionDuplicateClicked,
  by as PhoneFlowOptionsMenuOptionEditClicked,
  Iy as PhoneFlowOptionsMenuOptionMoveToAnotherNumberClicked,
  Ay as PhoneFlowOptionsMenuOptionOpened,
  Ty as PhoneFlowOptionsMenuOptionRenameClicked,
  Ey as PhoneFormCancelled,
  Py as PhoneFormOpened,
  Oy as PhoneFormSubmitted,
  Ry as PhoneOptionsMenuOpened,
  Fy as PhoneOptionsMenuOptionCreateFlowClicked,
  Dy as PhoneOptionsMenuOptionEditClicked,
  My as PhoneOptionsMenuOptionRemoveNumberClicked,
  Uy as PhoneOptionsMenuOptionSetDefaultCallerIdClicked,
  Ly as PhoneOptionsMenuOptionSetupClicked,
  Ny as PhoneRecordingDownloaded,
  Vy as PhoneRecordingPauseClicked,
  By as PhoneRecordingPlayClicked,
  Wy as PhoneRecordingPlaybackAbandoned,
  Hy as PhoneRecordingPlaybackEnded,
  xy as PhoneSearchApplied,
  Qy as PresenceListItemClicked,
  Ky as PresenceMediaOtherAgentUpdated,
  Gy as PresenceMediaUpdated,
  qy as PresenceOtherAgentUpdated,
  zy as PresenceUpdated,
  $y as PushNotificationPlatformFormCancelled,
  jy as PushNotificationPlatformFormOpened,
  Jy as PushNotificationPlatformFormSubmitted,
  Yy as QuickRepliesOpened,
  Xy as QuickReplyChosen,
  Zy as QuickReplyFeedbackForRecommendedRepliesClicked,
  eC as QuickReplyFilterChosen,
  tC as QuickReplyLanguageSelected,
  nC as QuickReplyTemplateFavoriteToggled,
  rC as RewindDismissed,
  iC as RewindFeedbackClicked,
  sC as RewindOpened,
  oC as RewindShareToLinkedInClicked,
  aC as RewindSlideImageCopied,
  cC as RewindSlideImageSaved,
  uC as RewindSlideTextCopied,
  lC as RewindSlideViewed,
  dC as SavedSearchApplied,
  pC as SavedSearchClosed,
  vC as SavedSearchCreated,
  hC as SavedSearchDeleted,
  gC as SavedSearchUpdated,
  fC as ScheduledConversationsCsvImportClicked,
  yC as ScheduledConversationsCsvImported,
  CC as SearchContactPreviewClosed,
  _C as SearchContactPreviewGoToClicked,
  kC as SearchContactPreviewOpened,
  mC as SearchContactTypeChanged,
  wC as SearchConversationPreviewClosed,
  SC as SearchConversationPreviewGoToClicked,
  bC as SearchConversationPreviewOpened,
  IC as SearchFieldBlurred,
  AC as SearchFieldCleared,
  TC as SearchFieldFocused,
  EC as SearchFieldSubmitted,
  PC as SearchFilterConditionAdded,
  OC as SearchFilterConditionRemoved,
  RC as SearchFilterOperatorUpdated,
  FC as SearchFilterStrategyUpdated,
  DC as SearchFilterValueAdded,
  MC as SearchFilterValueCleared,
  UC as SearchFiltersApplied,
  LC as SearchFiltersCleared,
  NC as SearchFiltersClosed,
  VC as SearchFiltersOpened,
  BC as SearchFiltersValidationFailed,
  WC as SearchSortingUpdated,
  HC as SearchStrictToggled,
  xC as SearchTabOpened,
  QC as SettingsAgentsAddAgentButtonClicked,
  KC as SettingsAgentsCustomWorkloadAssigned,
  GC as SettingsAgentsCustomWorkloadCreated,
  qC as SettingsAgentsCustomWorkloadDeleted,
  zC as SettingsAgentsEditButtonClicked,
  $C as SettingsAgentsTabClicked,
  jC as SettingsAudioDeleteCancelClicked,
  JC as SettingsAudioDeleteClicked,
  YC as SettingsAudioDeleteConfirmClicked,
  XC as SettingsAudioUsageFlowClicked,
  ZC as SettingsAudioUsageLinkClicked,
  e_ as SettingsCommandsAssignKeybindings,
  t_ as SettingsCommandsResetAllKeybindings,
  n_ as SettingsCommandsResetKeybindings,
  r_ as SettingsCommandsUnassignAllKeybindings,
  i_ as SettingsCommandsUnassignKeybindings,
  s_ as SettingsCustomAttributeActivated,
  o_ as SettingsCustomAttributeAddNewAttributeClicked,
  a_ as SettingsCustomAttributeArchived,
  c_ as SettingsCustomAttributeCreated,
  u_ as SettingsCustomAttributeDeactivated,
  l_ as SettingsCustomAttributeReordered,
  d_ as SettingsCustomAttributeUnarchived,
  p_ as SettingsCustomAttributeUpdated,
  v_ as SettingsCustomAwayStatusAddNewClicked,
  h_ as SettingsCustomAwayStatusArchived,
  g_ as SettingsCustomAwayStatusCreated,
  f_ as SettingsCustomAwayStatusUnarchived,
  y_ as SettingsCustomAwayStatusUpdated,
  C_ as SettingsFormsEmbedUrlCopied,
  __ as SettingsFormsStylingAdded,
  k_ as SettingsIntegrationsApiTokensAddConfirm,
  m_ as SettingsIntegrationsApiTokensCopy,
  w_ as SettingsIntegrationsApiTokensDocumentationLinkIntegrationsApi,
  S_ as SettingsIntegrationsApiTokensRemove,
  b_ as SettingsIntegrationsApiTokensRemoveCancel,
  I_ as SettingsIntegrationsApiTokensRemoveConfirm,
  A_ as SettingsIntegrationsApiTokensView,
  T_ as SettingsIntegrationsCardEditSave,
  E_ as SettingsIntegrationsCardEditTest,
  P_ as SettingsIntegrationsCardListingAddCard,
  O_ as SettingsIntegrationsCardReadDocumentation,
  R_ as SettingsIntegrationsCardTest,
  F_ as SettingsIntegrationsCardTestAddParameter,
  D_ as SettingsIntegrationsCardTestRemoveParameter,
  M_ as SettingsIntegrationsCustomCardCreated,
  U_ as SettingsIntegrationsCustomCardEdited,
  L_ as SettingsIntegrationsCustomCardOauthProviderAuthenticationFailed,
  N_ as SettingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded,
  V_ as SettingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut,
  B_ as SettingsIntegrationsCustomCardOauthProviderCreated,
  W_ as SettingsIntegrationsCustomCardOauthProviderUpdated,
  H_ as SettingsIntegrationsDataSyncBackfillStartedFailed,
  x_ as SettingsIntegrationsDataSyncBackfillStartedSucceeded,
  Q_ as SettingsIntegrationsDataSyncConfigurationEnabledFailed,
  K_ as SettingsIntegrationsDataSyncConfigurationEnabledSucceeded,
  G_ as SettingsIntegrationsDataSyncCreateConfigurationFailed,
  q_ as SettingsIntegrationsDataSyncCreateConfigurationSucceeded,
  z_ as SettingsIntegrationsDataSyncDeleteConfigurationFailed,
  $_ as SettingsIntegrationsDataSyncDeleteConfigurationSucceeded,
  j_ as SettingsIntegrationsDataSyncRetryBackfillingFailed,
  J_ as SettingsIntegrationsDataSyncRetryBackfillingSucceeded,
  Y_ as SettingsIntegrationsDataSyncStartSyncingEventsSucceeded,
  X_ as SettingsIntegrationsDataSyncTypeClicked,
  Z_ as SettingsIntegrationsDataSyncUpdateConfigurationFailed,
  ek as SettingsIntegrationsDataSyncUpdateConfigurationSucceeded,
  tk as SettingsIntegrationsItemClicked,
  nk as SettingsIntegrationsWebformEndpointsAddSave,
  rk as SettingsIntegrationsWebformEndpointsCopy,
  ik as SettingsIntegrationsWebformEndpointsReadDocumentationLink,
  sk as SettingsIntegrationsWebformEndpointsRemove,
  ok as SettingsIntegrationsWebformEndpointsRemoveCancel,
  ak as SettingsIntegrationsWebformEndpointsRemoveConfirm,
  ck as SettingsIntegrationsWebhooksAdd,
  uk as SettingsIntegrationsWebhooksAddConfirm,
  lk as SettingsIntegrationsWebhooksDocumentationLinkClicked,
  dk as SettingsIntegrationsWebhooksEdit,
  pk as SettingsIntegrationsWebhooksEditSave,
  vk as SettingsIntegrationsWebhooksEnabledOff,
  hk as SettingsIntegrationsWebhooksEnabledOn,
  gk as SettingsIntegrationsWebhooksRemove,
  fk as SettingsIntegrationsWebhooksRemoveCancel,
  yk as SettingsIntegrationsWebhooksRemoveConfirm,
  Ck as SettingsIntegrationsWebhooksView,
  _k as SettingsIntegrationsWebhooksViewCopySecret,
  kk as SettingsIntegrationsWebhooksViewCopyUrl,
  mk as SettingsIntegrationsWebhooksViewEdit,
  wk as SettingsMenuItemClicked,
  Sk as SettingsOrganizationFormSubmitted,
  bk as SettingsOrganizationLogoChanged,
  Ik as SettingsProfileFormSubmitted,
  Ak as SettingsQueueAdded,
  Tk as SettingsQueueAgentDeleted,
  Ek as SettingsQueueAgentSearchSubmitted,
  Pk as SettingsQueueAgentSorted,
  Ok as SettingsQueueAlertsSaved,
  Rk as SettingsQueueSaved,
  Fk as SettingsQueueTeamsAddTeamButtonClicked,
  Dk as SettingsQueueTeamsAddTeamFormSubmitted,
  Mk as SettingsQueueTeamsDeleteTeamButtonClicked,
  Uk as SettingsQueuesAddQueueClicked,
  Lk as SettingsQueuesArchiveQueueClicked,
  Nk as SettingsQueuesEditQueueClicked,
  Vk as SettingsQueuesUnarchiveQueueClicked,
  Bk as SettingsRolesCustomRoleCreated,
  Wk as SettingsRolesCustomRoleDeleted,
  Hk as SettingsRolesCustomRoleEdited,
  xk as SettingsSatisfactionFiltersChannelAdded,
  Qk as SettingsSatisfactionFiltersChannelRemoved,
  Kk as SettingsSatisfactionFiltersCreateViewed,
  Gk as SettingsSatisfactionFiltersCreated,
  qk as SettingsSatisfactionFiltersEdited,
  zk as SettingsSummarizationSaveChangesClicked,
  $k as SettingsSummarizationShowAutomaticallyClicked,
  jk as SettingsSummarizationShowOnDemandClicked,
  Jk as SettingsSurveyAccentColorChanged,
  Yk as SettingsSurveyBackToListClicked,
  Xk as SettingsSurveyBackToSurveyClicked,
  Zk as SettingsSurveyCreateFailed,
  em as SettingsSurveyCreateModalOpened,
  tm as SettingsSurveyCreated,
  nm as SettingsSurveyDeleteCancelled,
  rm as SettingsSurveyDeleteConfirmed,
  im as SettingsSurveyDeleteFailed,
  sm as SettingsSurveyDeleted,
  om as SettingsSurveyEditButtonClicked,
  am as SettingsSurveyEditViewed,
  cm as SettingsSurveyEmailPreviewAreaClicked,
  um as SettingsSurveyFontColorChanged,
  lm as SettingsSurveyHeaderImageTypeChanged,
  dm as SettingsSurveyIvrDetailsSaveFailed,
  pm as SettingsSurveyIvrDetailsSaved,
  vm as SettingsSurveyIvrDetailsViewed,
  hm as SettingsSurveyLanguageAdded,
  gm as SettingsSurveyLanguageDeleteCancelled,
  fm as SettingsSurveyLanguageDeleteConfirmed,
  ym as SettingsSurveyLanguageDeleteFailed,
  Cm as SettingsSurveyLanguageDeleted,
  _m as SettingsSurveyLanguageDisabled,
  km as SettingsSurveyLanguageEditClicked,
  mm as SettingsSurveyLanguageEnabled,
  wm as SettingsSurveyListViewed,
  Sm as SettingsSurveyMultiQuestionDetailsSaveFailed,
  bm as SettingsSurveyMultiQuestionDetailsSaved,
  Im as SettingsSurveyMultiQuestionDetailsViewed,
  Am as SettingsSurveyMultiQuestionTabChanged,
  Tm as SettingsSurveyNameSaveFailed,
  Em as SettingsSurveyNameSaved,
  Pm as SettingsSurveyPreviewModeChanged,
  Om as SettingsSurveyQuestionAddClicked,
  Rm as SettingsSurveyQuestionAdded,
  Fm as SettingsSurveyQuestionDeleted,
  Dm as SettingsSurveyQuestionEditClicked,
  Mm as SettingsSurveyQuestionEditorCancelled,
  Um as SettingsSurveyQuestionReordered,
  Lm as SettingsSurveyQuestionUpdated,
  Nm as SettingsSurveyUnsavedChangesDialogShown,
  Vm as SettingsSurveyUnsavedChangesDiscarded,
  Bm as SettingsSurveyUnsavedChangesKept,
  Wm as SettingsTagsAddTagButtonClicked,
  Hm as SettingsTagsTagActivated,
  xm as SettingsTagsTagDeactivated,
  Qm as SettingsTeamAddTeamButtonClicked,
  Km as SettingsTeamDetailsAddAgentsButtonClicked,
  Gm as SettingsTeamEditTeamButtonClicked,
  qm as SettingsTeamModalFormSubmitted,
  zm as SettingsTeamRemoveTeamButtonClicked,
  $m as SettingsTeamRemoveTeamConfirmed,
  jm as SettingsTemplatesAddTemplateButtonClicked,
  Jm as SettingsTemplatesEditTemplateButtonClicked,
  Ym as SettingsTemplatesModalFormSubmitted,
  Xm as SettingsTemplatesRemoveTemplateButtonClicked,
  Zm as SettingsTemplatesRemoveTemplateConfirmed,
  ew as SettingsTemplatesTabClicked,
  tw as SharedWorkerTabOrWindowChanged,
  nw as SharedWorkerTabOrWindowClosed,
  rw as SharedWorkerTabOrWindowOpened,
  iw as SidebarAddAgentButtonClicked,
  sw as SidebarCollapsed,
  ow as SidebarExpanded,
  aw as SidebarNavClicked,
  cw as SignOutAborted,
  uw as SignOutConfirmed,
  lw as SimultaneousRingUpdated,
  dw as SlaPoliciesReordered,
  pw as SlaPolicyActivated,
  vw as SlaPolicyCreated,
  hw as SlaPolicyDeactivated,
  gw as SlaPolicyDeleted,
  fw as SlaPolicyUpdated,
  yw as SmartConversationReplyButtonClicked,
  Cw as SubflowBackToMainFlowNodeReused,
  _w as SubflowBackToMainFlowNodeUsed,
  kw as SubflowCreatedFromHighlightedNodes,
  mw as SubflowCreatedFromScratch,
  ww as SubflowReused,
  Sw as TagSelectCreateNewTagClicked,
  bw as TagsCreateModalColorChanged,
  Iw as TagsCreateModalFormSubmitted,
  Aw as TagsCreateModalOpened,
  Tw as TeamAgentActionsMenuItemClicked,
  Ew as TeamAgentActionsMenuOpened,
  Pw as TeamAgentCollapsed,
  Ow as TeamAgentExpanded,
  Rw as TeamFavoriteToggled,
  Fw as ThemeImported,
  Dw as ThemeShared,
  Mw as ThemeUpdated,
  Uw as TopbarBeamerOpened,
  Lw as TopbarEmailOpened,
  Nw as TopbarNotificationsOpened,
  Vw as TopbarPhonesOpened,
  Bw as TopbarSearchQuickActionClicked,
  Ww as TopbarSupportOpened,
  Hw as UserModalFormSubmitted,
  xw as UserModalRoleChanged,
  Qw as UserModalUserTypeChanged,
  Kw as WebsocketActiveConnectionChanged,
  Gw as WebsocketCloseEventReceived,
  qw as WebsocketConnectionClosed,
  zw as WebsocketConnectionCreated,
  $w as WebsocketReconnectAttemptStarted,
  yn as ampli,
  Yw as groupIdentify
};
//# sourceMappingURL=index.js.map
